{
  "accept.action.button": "Acceptă",
  "accessDenied.message": "Nu ai acces la acest modul. Te rugăm contactează administratorul.",
  "accessDenied.okButton": "OK",
  "accessDenied.title": "Acces refuzat",
  "accession.entry": "Introducere număr accesare",
  "activityReportByPanel": "Raport activitate pe panel",
  "activityReportByTest": "Raport activitate pe test",
  "activityReportByTestSection": "Raport activitate pe secțiune test",
  "add.age.range": "Adaugă un alt interval de vârstă +",
  "add.aliquot": "Add Aliquot",
  "add.new.dictionary.menu": "Adaugă meniu dicționar nou",
  "address.search.label": "Quick Address Search",
  "adjustment.button": "Adjust Quantity",
  "adjustment.newQuantity": "New Quantity",
  "adjustment.notes": "Note",
  "adjustment.notes.placeholder": "Provide details about this adjustment",
  "adjustment.reason": "Reason for Adjustment",
  "adjustment.reason.select": "Select reason",
  "adjustment.success": "Lot quantity adjusted successfully",
  "adjustment.title": "Adjust Lot Quantity",
  "admin.dashboard.subtitle": "Choose an administration area to configure OpenELIS.",
  "admin.dashboard.title": "Admin dashboard",
  "admin.formEntryConfig": "Configurații generale",
  "admin.config.logo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "admin.config.logo.formats": "Formats: JPG, PNG, GIF (max 2MB)",
  "admin.label": "Administrare",
  "admin.labUnit.basicInfo.domain.clinical": "Clinical",
  "admin.labUnit.basicInfo.domain.environmental": "Environmental",
  "admin.labUnit.basicInfo.domain.label": "Domain",
  "admin.labUnit.basicInfo.domain.vector": "Vector",
  "admin.labUnit.domain.confirm.body": "Historical orders/results were evaluated against the prior domain's rules. New orders will use the new domain's rules.",
  "admin.labUnit.domain.confirm.heading": "Change Lab Unit Domain?",
  "admin.labUnit.edit.select": "Select Lab Unit",
  "admin.labUnit.edit.title": "Edit Lab Unit Domain",
  "admin.labUnit.list.filter.domain": "Filter by Domain",
  "admin.legacy": "Administrare veche",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Adaugă",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Dezactivează",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Ieșire",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modifică",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Salvează",
  "admin.page.configuration.formEntryConfigMenu.description": "Descriere",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Editează înregistrarea",
  "admin.page.configuration.formEntryConfigMenu.name": "Nume",
  "admin.page.configuration.formEntryConfigMenu.select": "Selectează",
  "admin.page.configuration.formEntryConfigMenu.value": "Valoare",
  "admin.labelPresets.title": "Label Presets",
  "admin.labelPresets.addButton": "Add Preset",
  "admin.labelPresets.search.placeholder": "Search presets...",
  "admin.labelPresets.col.name": "Nume",
  "admin.labelPresets.col.barcodeType": "Barcode Type",
  "admin.labelPresets.col.dimensions": "Dimensions",
  "admin.labelPresets.col.scope": "Scope",
  "admin.labelPresets.col.status": "Stare",
  "admin.labelPresets.col.actions": "Actions",
  "admin.labelPresets.systemTag": "System",
  "admin.labelPresets.status.active": "Activ",
  "admin.labelPresets.status.inactive": "Inactive",
  "admin.labelPresets.scope.order": "Comandă",
  "admin.labelPresets.scope.sample": "Probă",
  "admin.labelPresets.action.edit": "Editează",
  "admin.labelPresets.action.duplicate": "Duplicate",
  "admin.labelPresets.action.activate": "Activate",
  "admin.labelPresets.action.deactivate": "Dezactivează",
  "admin.labelPresets.duplicateName": "Copy of {name}",
  "admin.labelPresets.duplicated": "Preset duplicated",
  "admin.labelPresets.duplicateFailed": "Duplicate failed",
  "admin.labelPresets.activated": "Preset activated",
  "admin.labelPresets.deactivated": "Preset deactivated",
  "admin.labelPresets.toggleFailed": "Status change failed",
  "admin.labelPresets.saveFailed": "Salvarea a eșuat",
  "admin.labelPresets.editor.titleAdd": "Add Label Preset",
  "admin.labelPresets.editor.titleEdit": "Edit Label Preset",
  "admin.labelPresets.editor.section.basicInfo": "Basic Info",
  "admin.labelPresets.editor.section.dimensions": "Dimensions (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Barcode Settings",
  "admin.labelPresets.editor.section.printScope": "Print Scope & Quantities",
  "admin.labelPresets.field.name": "Preset Name",
  "admin.labelPresets.field.isActive": "Activ",
  "admin.labelPresets.field.heightMm": "Height (mm)",
  "admin.labelPresets.field.widthMm": "Width (mm)",
  "admin.labelPresets.field.barcodeType": "Barcode Type",
  "admin.labelPresets.field.defaultPerOrder": "Default per Order",
  "admin.labelPresets.field.maxPerOrder": "Max per Order",
  "admin.labelPresets.field.defaultPerSample": "Default per Sample",
  "admin.labelPresets.field.maxPerSample": "Max per Sample",
  "admin.labelPresets.validation.name.required": "Name is required",
  "admin.labelPresets.validation.name.toolong": "Name must not exceed 120 characters",
  "admin.labelPresets.validation.dimension.range": "Dimension must be between 5 and 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Barcode type is required",
  "admin.labelPresets.validation.scope.required": "At least one print scope (Order or Sample) must be selected",
  "admin.labelPresets.validation.max.lte": "Max must be greater than or equal to default",
  "advanced.search": "Căutare avansată",
  "alert.expired.title": "Expired Items",
  "alert.expiring.title": "Expiring Soon",
  "alert.lowStock.title": "Low Stock Alert",
  "alerts.acknowledge.button": "Acknowledge",
  "alerts.acknowledge.comment": "Resolution Comment",
  "alerts.acknowledge.comment.placeholder": "Describe how this alert was addressed...",
  "alerts.acknowledge.comment.required": "Resolution comment is required for critical alerts",
  "alerts.acknowledge.error": "Failed to acknowledge alert",
  "alerts.acknowledge.success": "Alert acknowledged successfully",
  "alerts.acknowledge.title": "Acknowledge Alert",
  "alerts.autoRefresh": "Auto-refresh every 60 seconds",
  "alerts.dashboard.title": "Alerts Dashboard",
  "alerts.empty": "No alerts to display",
  "alerts.eqaDeadlineSummary.critical": "Critical",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} upcoming deadlines",
  "alerts.eqaDeadlineSummary.subtitle": "Upcoming EQA submission deadlines grouped by provider",
  "alerts.eqaDeadlineSummary.title": "EQA Deadline Summary",
  "alerts.eqaDeadlineSummary.viewAll": "View All",
  "alerts.filter.myAlerts": "My Alerts",
  "alerts.filter.search": "Search alerts...",
  "alerts.filter.severity": "Severitate",
  "alerts.filter.status": "Stare",
  "alerts.filter.type": "Alert Type",
  "alerts.severity.critical": "Critical",
  "alerts.severity.warning": "Warning",
  "alerts.status.acknowledged": "Acknowledged",
  "alerts.status.open": "Open",
  "alerts.status.resolved": "Resolved",
  "alerts.summary.critical": "Critical Alerts",
  "alerts.summary.eqaDeadlines": "EQA Deadlines",
  "alerts.summary.sampleExpiration": "Samples Expiring",
  "alerts.summary.statOverdue": "Overdue STAT Orders",
  "alerts.summary.totalOpen": "Total Open",
  "alerts.table.actions": "Actions",
  "alerts.table.created": "Created",
  "alerts.table.message": "Mesaj",
  "alerts.table.severity": "Severitate",
  "alerts.table.status": "Stare",
  "alerts.table.type": "Type",
  "alerts.type.critical_unacknowledged": "Unacknowledged Critical",
  "alerts.type.eqa_deadline": "EQA Deadline",
  "alerts.type.required_by_deadline": "Required By Deadline",
  "alerts.type.sample_expiration": "Sample Expiration",
  "alerts.type.stat_overdue": "STAT Overdue",
  "alerts.type.stat_upcoming": "STAT Upcoming",
  "aliquot": "Aliquot",
  "aliquot.analyses.count": "Analyses: {count}",
  "aliquot.id": "Aliquot ID",
  "aliquot.quantity": "Aliquot Quantity",
  "aliquot.quantity.not.balanced": "Quantity not balanced for sample type",
  "aliquot.save.error": "Error saving aliquoting data.",
  "aliquot.save.success": "Aliquoting data saved successfully.",
  "aliquot.tests.not.assigned": "Tests not assigned for sample type",
  "aliquot.validation.errors": "Validation Errors",
  "aliquoting": "Aliquoting",
  "aliquoting.section": "Aliquoting Section",
  "all.label": "Toate",
  "all.tests.assigned": "All tests assigned",
  "allocated.to.aliquots": "Allocated to Aliquots",
  "analysis.count": "Analysis Count",
  "analysis.details": "Analysis Details",
  "analyzer.action.add": "Add Analyzer",
  "analyzer.action.copyMappings": "Copy Mappings",
  "analyzer.action.delete": "Delete",
  "analyzer.action.edit": "Editează",
  "analyzer.action.fieldMappings": "Field Mappings",
  "analyzer.action.qcRules": "QC Rules",
  "analyzer.action.testConnection": "Test Connection",
  "analyzer.combinationName.notification": "Combinația dintre analizor și numele testului trebuie să fie unică",
  "analyzer.copyMappings.confirmation.message": "Are you sure you want to copy {count} mappings? Existing mappings will be overwritten.",
  "analyzer.copyMappings.confirmation.title": "Confirm Copy Mappings",
  "analyzer.copyMappings.copy": "Copy Mappings",
  "analyzer.copyMappings.error": "Error copying mappings",
  "analyzer.copyMappings.error.noSourceMappings": "Source analyzer has no active mappings to copy",
  "analyzer.copyMappings.loading": "Copying mappings...",
  "analyzer.copyMappings.source": "Source Analyzer",
  "analyzer.copyMappings.source.name": "Nume",
  "analyzer.copyMappings.source.type": "Type",
  "analyzer.copyMappings.subtitle": "Copy field mappings from {source} to {target}",
  "analyzer.copyMappings.success": "Successfully copied {count} mappings",
  "analyzer.copyMappings.success.viewTarget": "View Target Analyzer",
  "analyzer.copyMappings.summary": "Mapping Summary",
  "analyzer.copyMappings.summary.breakdown": "Field mappings: {fieldCount}, Unit conversions: {unitCount}, Qualitative mappings: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} mappings will be copied",
  "analyzer.copyMappings.target": "Target Analyzer",
  "analyzer.copyMappings.target.placeholder": "Select target analyzer",
  "analyzer.copyMappings.target.required": "Target Analyzer *",
  "analyzer.copyMappings.title": "Copy Field Mappings",
  "analyzer.copyMappings.warning": "This will copy all field mappings including unit conversions and qualitative value mappings. Existing mappings will be overwritten.",
  "analyzer.delete.cancel": "Anulează",
  "analyzer.delete.delete": "Delete",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Analyzer ID is required",
  "analyzer.delete.error.unknown": "An unknown error occurred while deleting the analyzer",
  "analyzer.delete.message": "Are you sure you want to delete '{name}'? This action cannot be undone and will remove all associated field mappings.",
  "analyzer.delete.success": "Analyzer deleted",
  "analyzer.delete.title": "Delete Analyzer",
  "analyzer.delete.unknown": "Unknown Analyzer",
  "analyzer.errorDashboard.acknowledgeAll": "Acknowledge All",
  "analyzer.errorDashboard.action.acknowledge": "Acknowledge",
  "analyzer.errorDashboard.action.menu": "Error actions",
  "analyzer.errorDashboard.action.viewDetails": "View Details",
  "analyzer.errorDashboard.errorType.connection": "Connection",
  "analyzer.errorDashboard.errorType.mapping": "Mapping",
  "analyzer.errorDashboard.errorType.protocol": "Protocol",
  "analyzer.errorDashboard.errorType.timeout": "Timeout",
  "analyzer.errorDashboard.errorType.validation": "Validare",
  "analyzer.errorDashboard.filter.analyzer": "Analizor",
  "analyzer.errorDashboard.filter.analyzer.all": "Toate",
  "analyzer.errorDashboard.filter.search": "Search errors...",
  "analyzer.errorDashboard.filter.severity": "Severitate",
  "analyzer.errorDashboard.filter.severity.all": "All Severities",
  "analyzer.errorDashboard.filter.type": "Error Type",
  "analyzer.errorDashboard.filter.type.all": "All Types",
  "analyzer.errorDashboard.severity.critical": "Critical",
  "analyzer.errorDashboard.severity.error": "Error",
  "analyzer.errorDashboard.severity.warning": "Warning",
  "analyzer.errorDashboard.stats.critical": "Critical",
  "analyzer.errorDashboard.stats.last24Hours": "Last 24 Hours",
  "analyzer.errorDashboard.stats.total": "Total Errors",
  "analyzer.errorDashboard.stats.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.status.acknowledged": "Acknowledged",
  "analyzer.errorDashboard.status.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.subtitle": "View and manage analyzer errors and alerts",
  "analyzer.errorDashboard.table.analyzer": "Analizor",
  "analyzer.errorDashboard.table.message": "Mesaj",
  "analyzer.errorDashboard.table.severity": "Severitate",
  "analyzer.errorDashboard.table.status": "Stare",
  "analyzer.errorDashboard.table.timestamp": "Timestamp",
  "analyzer.errorDashboard.table.type": "Type",
  "analyzer.errorDashboard.title": "Error Dashboard",
  "analyzer.errorDetails.acknowledged": "Acknowledged",
  "analyzer.errorDetails.acknowledgedBy": "By {user} on {date}",
  "analyzer.errorDetails.analyzer": "Analizor",
  "analyzer.errorDetails.analyzerId": "Analyzer ID",
  "analyzer.errorDetails.close": "Close",
  "analyzer.errorDetails.copy": "Copy",
  "analyzer.errorDetails.createMapping": "Create Mapping",
  "analyzer.errorDetails.download": "Download",
  "analyzer.errorDetails.errorId": "Error ID",
  "analyzer.errorDetails.errorMessage": "Error Message",
  "analyzer.errorDetails.errorType": "Error Type",
  "analyzer.errorDetails.logs": "Analyzer Logs ({count} entries)",
  "analyzer.errorDetails.recommendedActions": "Recommended Actions",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Check IP address and port configuration in analyzer settings",
  "analyzer.errorDetails.recommendedActions.createMapping": "Create a mapping for the unmapped field to resolve this error",
  "analyzer.errorDetails.recommendedActions.testConnection": "Test connection using the 'Test Connection' feature",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verify analyzer is powered on and network cable is connected",
  "analyzer.errorDetails.severity": "Severitate",
  "analyzer.errorDetails.subtitle": "Detailed information and analyzer logs for error {id}",
  "analyzer.errorDetails.timestamp": "Timestamp",
  "analyzer.errorDetails.title": "Error Details",
  "analyzer.fhirImport.error.importFailed": "FHIR bundle import failed",
  "analyzer.fhirImport.error.invalidBundleType": "Bundle type must be 'transaction' or 'batch', got: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "Bundle contains no Observation resources with results",
  "analyzer.fieldCreation.acceptedUnits.label": "Accepted Units",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Select accepted units",
  "analyzer.fieldCreation.cancel": "Anulează",
  "analyzer.fieldCreation.confirmation": "I understand this field will be available for mapping immediately after creation",
  "analyzer.fieldCreation.create": "Create Field",
  "analyzer.fieldCreation.createNew": "Create New Field",
  "analyzer.fieldCreation.description.label": "Description (Optional)",
  "analyzer.fieldCreation.description.placeholder": "Enter field description",
  "analyzer.fieldCreation.entityType.label": "Entity Type",
  "analyzer.fieldCreation.entityType.placeholder": "Select entity type",
  "analyzer.fieldCreation.error.generic": "Failed to create field",
  "analyzer.fieldCreation.error.title": "Error creating field",
  "analyzer.fieldCreation.fieldName.label": "Field Name",
  "analyzer.fieldCreation.fieldName.placeholder": "Enter field name",
  "analyzer.fieldCreation.fieldType.label": "Field Type",
  "analyzer.fieldCreation.fieldType.placeholder": "Select field type",
  "analyzer.fieldCreation.loincCode.label": "LOINC Code (Optional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Enter LOINC code",
  "analyzer.fieldCreation.modal.subtitle": "Create a new field that will be available for mapping immediately",
  "analyzer.fieldCreation.modal.title": "Create New OpenELIS Field",
  "analyzer.fieldCreation.success.message": "Field is now available for mapping",
  "analyzer.fieldCreation.success.title": "Field created successfully",
  "analyzer.fieldCreation.validation.entityType.required": "Entity type is required",
  "analyzer.fieldCreation.validation.fieldName.required": "Field name is required",
  "analyzer.fieldCreation.validation.unique": "A field with this name already exists",
  "analyzer.fieldCreation.validation.units.required": "Accepted units are required for numeric fields",
  "analyzer.fieldMapping.activationModal.activate": "Activate Changes",
  "analyzer.fieldMapping.activationModal.cancel": "Anulează",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "I understand these changes will apply to new messages only",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Mapping changes detected. Another user has modified mappings for this analyzer. Please reload the page to see latest changes.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Cannot activate: Required mappings missing",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Missing required fields: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Reload Page",
  "analyzer.fieldMapping.activationModal.subtitle": "Confirm activation of mapping changes for analyzer '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Activate Mapping Changes",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "View Pending Messages",
  "analyzer.fieldMapping.activationModal.warning": "You are about to activate mapping changes for analyzer '{name}'. These changes will apply to all new messages received after activation. Existing results will not be affected.",
  "analyzer.fieldMapping.activationModal.warningActive": "This analyzer is currently active. Activating changes may affect incoming results.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "This analyzer has {count} pending messages in the error queue. Activating mapping changes may affect how these messages are reprocessed. Consider resolving errors first.",
  "analyzer.fieldMapping.back": "Înapoi",
  "analyzer.fieldMapping.fieldType.controlTest": "Control Test",
  "analyzer.fieldMapping.fieldType.custom": "Custom",
  "analyzer.fieldMapping.fieldType.dateTime": "Date/Time",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Melting Point",
  "analyzer.fieldMapping.fieldType.numeric": "Numeric",
  "analyzer.fieldMapping.fieldType.qualitative": "Qualitative",
  "analyzer.fieldMapping.fieldType.text": "Text",
  "analyzer.fieldMapping.page.subtitle": "Configure field mappings between analyzer and OpenELIS",
  "analyzer.fieldMapping.page.title": "Field Mappings",
  "analyzer.fieldMapping.panel.mapping.active": "Activ",
  "analyzer.fieldMapping.panel.mapping.retired": "Retired",
  "analyzer.fieldMapping.panel.retire": "Retire Mapping",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Cannot retire: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} fields available",
  "analyzer.fieldMapping.panel.source.search": "Search fields...",
  "analyzer.fieldMapping.panel.source.title": "Analyzer Fields ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Mapped",
  "analyzer.fieldMapping.panel.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.panel.statusFilter.active": "Active Only",
  "analyzer.fieldMapping.panel.statusFilter.all": "All Fields",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Draft Only",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filter by Status",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Mapped Only",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Unmapped Only",
  "analyzer.fieldMapping.panel.target.cancel": "Anulează",
  "analyzer.fieldMapping.panel.target.edit": "Editează",
  "analyzer.fieldMapping.panel.target.remove": "Șterge",
  "analyzer.fieldMapping.panel.target.saveActivate": "Save and Activate",
  "analyzer.fieldMapping.panel.target.saveDraft": "Save as Draft",
  "analyzer.fieldMapping.panel.target.selectField": "Select a field from the left panel to view or create mappings.",
  "analyzer.fieldMapping.panel.target.summary": "Mappings Summary",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Unmapped Field - This field has no mapping configured",
  "analyzer.fieldMapping.pendingCodes.actions": "Actions",
  "analyzer.fieldMapping.pendingCodes.code": "Analyzer Code",
  "analyzer.fieldMapping.pendingCodes.empty": "No pending unmapped analyzer codes.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Ignoră",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Mark Mapped",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Seen",
  "analyzer.fieldMapping.pendingCodes.status": "Stare",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Review and resolve unmapped analyzer test codes.",
  "analyzer.fieldMapping.pendingCodes.title": "Pending Unmapped Codes",
  "analyzer.fieldMapping.pluginConfig.title": "Plugin Configuration Snapshot",
  "analyzer.fieldMapping.queryAnalyzer": "Query Analyzer",
  "analyzer.fieldMapping.retirementModal.cancel": "Anulează",
  "analyzer.fieldMapping.retirementModal.confirmation": "Are you sure you want to retire this mapping? Historical messages will still reference it for audit purposes.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Cannot retire: {count} pending messages use this mapping",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Retirement Reason (Optional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Optional: Reason for retiring this mapping",
  "analyzer.fieldMapping.retirementModal.retire": "Retire Mapping",
  "analyzer.fieldMapping.retirementModal.subtitle": "Confirm retirement of field mapping",
  "analyzer.fieldMapping.retirementModal.title": "Retire Mapping",
  "analyzer.fieldMapping.save": "Save Mappings",
  "analyzer.fieldMapping.stats.pendingCodes": "Pending Codes",
  "analyzer.fieldMapping.stats.required": "Required Mappings",
  "analyzer.fieldMapping.stats.total": "Total Mappings",
  "analyzer.fieldMapping.stats.unmapped": "Unmapped Fields",
  "analyzer.fieldMapping.status.active": "Activ",
  "analyzer.fieldMapping.status.draft": "Draft",
  "analyzer.fieldMapping.status.retired": "Retired",
  "analyzer.fieldMapping.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.testMapping": "Test Mapping",
  "analyzer.fieldMapping.warning.missingRequired": "Required mappings are missing",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Some required fields are not mapped. Please map all required fields before activating.",
  "analyzer.filter.lifecycleStage.all": "All Lifecycle Stages",
  "analyzer.filter.lifecycleStage.label": "Lifecycle Stage",
  "analyzer.filter.status": "Stare",
  "analyzer.filter.status.all": "All Statuses",
  "analyzer.filter.status.label": "Stare",
  "analyzer.filter.testUnit": "Unitate testare",
  "analyzer.filter.type": "Analyzer Type",
  "analyzer.form.activeStatus": "Active Status",
  "analyzer.form.activeStatus.description": "Enable this analyzer for data collection",
  "analyzer.form.addTitle": "Add New Analyzer",
  "analyzer.form.cancel": "Anulează",
  "analyzer.form.communicationMode": "Communication Mode",
  "analyzer.form.communicationMode.analyzerInitiated": "Analyzer → LIS (analyzer connects to OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidirectional (both directions)",
  "analyzer.form.communicationMode.help": "Who initiates the connection. Most analyzers use Analyzer → LIS.",
  "analyzer.form.communicationMode.lisInitiated": "LIS → Analyzer (OpenELIS connects to analyzer)",
  "analyzer.form.createdBy": "Created By",
  "analyzer.form.createdDate": "Created Date/Time",
  "analyzer.form.defaults.error": "Failed to load default configuration",
  "analyzer.form.defaults.loaded": "Default configuration loaded",
  "analyzer.form.defaults.loaded.subtitle": "Template for {name} has been loaded. Customize as needed before saving.",
  "analyzer.form.editTitle": "Edit Analyzer",
  "analyzer.form.error.invalidCommunicationMode": "Invalid communication mode: {value}. Valid values: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Invalid protocol version: {value}. Valid values: {validValues}",
  "analyzer.form.error.save": "Failed to save analyzer",
  "analyzer.form.error.unknown": "An unknown error occurred",
  "analyzer.form.fileProtocol.description": "This analyzer imports results from files. File import settings will be configured after saving.",
  "analyzer.form.fileProtocol.title": "File Import Protocol",
  "analyzer.form.identifierPattern": "Identifier Pattern",
  "analyzer.form.identifierPattern.helperText": "Regex pattern to match incoming message identifiers for routing",
  "analyzer.form.identifierPattern.placeholder": "e.g., ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "IP Address",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Last Modified Date/Time",
  "analyzer.form.loadDefaultConfig": "Load Analyzer Profile",
  "analyzer.form.loadDefaultConfig.helperText": "Quick setup using built-in analyzer profile templates",
  "analyzer.form.loadDefaultConfig.placeholder": "Select a built-in analyzer profile",
  "analyzer.form.name": "Analyzer Name",
  "analyzer.form.name.placeholder": "e.g., Hematology Analyzer 1",
  "analyzer.form.pluginType": "Plugin Type",
  "analyzer.form.pluginType.helperText": "The analyzer plugin that will handle incoming messages",
  "analyzer.form.pluginType.placeholder": "Select plugin type...",
  "analyzer.form.port": "Port Number",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Protocol Version",
  "analyzer.form.save": "Salvează",
  "analyzer.form.status": "Stare",
  "analyzer.form.status.helperText": "Status transitions automatically based on analyzer state. Manual override to INACTIVE, SETUP, or VALIDATION only.",
  "analyzer.form.subtitle": "Configure analyzer connection settings and test units",
  "analyzer.form.success.save": "Analyzer saved successfully",
  "analyzer.form.testConnection": "Test Connection",
  "analyzer.form.testConnection.error": "Connection Failed",
  "analyzer.form.testUnits": "Test Unit Assignment",
  "analyzer.form.testUnits.helper": "Select one or more test units for this analyzer",
  "analyzer.form.testUnits.placeholder": "Select test units...",
  "analyzer.form.type": "Analyzer Type",
  "analyzer.form.type.other": "Other",
  "analyzer.form.type.placeholder": "Select analyzer type",
  "analyzer.form.validation.ipAddress.invalid": "Invalid IP address format",
  "analyzer.form.validation.name.required": "Analyzer name is required",
  "analyzer.form.validation.type.required": "Analyzer type is required",
  "analyzer.hl7.insertError": "HL7 insert error",
  "analyzer.hl7.parseError": "HL7 parse error",
  "analyzer.hl7.unknownAnalyzer": "Unable to identify analyzer from HL7 MSH (sending application/facility)",
  "analyzer.list.subtitle": "Manage laboratory analyzers and field mappings",
  "analyzer.list.title": "Analyzers",
  "analyzer.navigation.analyzerTypes": "Analyzer Types",
  "analyzer.navigation.analyzers": "Analyzers",
  "analyzer.navigation.analyzersList": "Analyzers List",
  "analyzer.navigation.errorDashboard": "Error Dashboard",
  "analyzer.navigation.fieldMappings": "Field Mappings",
  "analyzer.navigation.qc": "Quality Control",
  "analyzer.navigation.qcDashboard": "QC Dashboard",
  "analyzer.navigation.qcAlerts": "QC Alerts & Violations",
  "analyzer.navigation.qcCorrectiveActions": "Corrective Actions",
  "analyzerType.page.title": "Analyzer Types",
  "analyzerType.column.name": "Nume",
  "analyzerType.column.description": "Descriere",
  "analyzerType.column.protocol": "Protocol",
  "analyzerType.column.pluginClass": "Plugin Class",
  "analyzerType.column.genericPlugin": "Generic Plugin",
  "analyzerType.column.identifierPattern": "Identifier Pattern",
  "analyzerType.column.pluginLoaded": "Plugin Loaded",
  "analyzerType.column.instances": "Instances",
  "analyzerType.column.status": "Stare",
  "analyzerType.search.placeholder": "Search analyzer types...",
  "analyzerType.button.create": "Create New Analyzer Type",
  "analyzerType.button.creating": "Creating...",
  "analyzerType.button.cancel": "Anulează",
  "analyzerType.modal.createTitle": "Create New Analyzer Type",
  "analyzerType.field.name": "Nume",
  "analyzerType.field.description": "Descriere",
  "analyzerType.field.protocol": "Protocol",
  "analyzerType.field.selectProtocol": "Select protocol",
  "analyzerType.field.pluginClassName": "Plugin Class Name",
  "analyzerType.field.identifierPattern": "Identifier Pattern",
  "analyzerType.field.identifierPatternHelper": "Regex pattern for matching sample identifiers (e.g. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Generic Plugin",
  "analyzerType.field.isActive": "Activ",
  "analyzerType.error.nameRequired": "Name is required",
  "analyzerType.notification.createSuccess": "Analyzer type created successfully",
  "analyzerType.notification.createError": "Failed to create analyzer type",
  "analyzer.navigation.qcControlLots": "Control Lots",
  "analyzer.navigation.qcRuleConfig": "Rule Configuration",
  "analyzer.page.addButton": "Add Analyzer",
  "analyzer.page.hierarchy.list": "Analyzer List",
  "analyzer.page.hierarchy.mappings": "Field Mappings",
  "analyzer.page.hierarchy.root": "Analyzers",
  "analyzer.page.title": "Analyzers",
  "analyzer.plugin.missing": "Plugin Missing",
  "analyzer.qc.alerts.message": "Alerts and violations features are coming soon.",
  "analyzer.qc.alerts.title": "QC Alerts & Violations",
  "analyzer.qc.corrective.message": "Corrective actions features are coming soon.",
  "analyzer.qc.corrective.title": "Corrective Actions",
  "analyzer.qc.placeholder.message": "Quality Control features are coming soon.",
  "analyzer.qc.placeholder.title": "Quality Control",
  "analyzer.qualitativeMapping.isDefault": "Default",
  "analyzer.qualitativeMapping.mappings": "Value Mappings",
  "analyzer.qualitativeMapping.noValues": "No analyzer values available for mapping",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Select OpenELIS code",
  "analyzer.qualitativeMapping.subtitle": "Map qualitative values for {fieldName}",
  "analyzer.qualitativeMapping.title": "Qualitative Value Mapping",
  "analyzer.qualitativeMapping.validation.error": "Validation Error",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.qualitativeMapping.validation.noDefault": "No Default Value",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "At least one mapping should be marked as default",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "OpenELIS code is required",
  "analyzer.query.button": "Query Analyzer",
  "analyzer.query.cancel": "Anulează",
  "analyzer.query.modal.logs": "Connection Logs",
  "analyzer.query.modal.noLogs": "No logs yet.",
  "analyzer.query.modal.progress": "Progress",
  "analyzer.query.modal.state": "State",
  "analyzer.query.modal.subtitle": "Retrieve available fields from analyzer",
  "analyzer.query.modal.title": "Query Analyzer",
  "analyzer.query.progress": "{percent}% complete",
  "analyzer.search.label": "Caută",
  "analyzer.search.placeholder": "Search analyzers...",
  "analyzer.stat.active": "Activ",
  "analyzer.stat.inactive": "Inactive",
  "analyzer.stat.pluginWarnings": "Plugin Warnings",
  "analyzer.stat.total": "Total Analyzers",
  "analyzer.stats.active": "Active Analyzers",
  "analyzer.stats.inactive": "Inactive Analyzers",
  "analyzer.stats.total": "Total Analyzers",
  "analyzer.status.active": "Activ",
  "analyzer.status.deleted": "Deleted",
  "analyzer.status.error_pending": "Error Pending",
  "analyzer.status.inactive": "Inactive",
  "analyzer.status.offline": "Offline",
  "analyzer.status.pending_registration": "Pending Registration",
  "analyzer.status.setup": "Setup",
  "analyzer.status.validation": "Validare",
  "analyzer.success.save": "Analyzer saved successfully",
  "analyzer.table.actions": "Actions",
  "analyzer.table.connection": "Connection",
  "analyzer.table.header.connection": "Connection",
  "analyzer.table.header.lastModified": "Last Modified",
  "analyzer.table.header.name": "Nume",
  "analyzer.table.header.status": "Stare",
  "analyzer.table.header.testUnits": "Test Units",
  "analyzer.table.header.type": "Type",
  "analyzer.table.lastModified": "Last Modified",
  "analyzer.table.name": "Nume",
  "analyzer.table.status": "Stare",
  "analyzer.table.testUnits": "Test Units",
  "analyzer.table.type": "Type",
  "analyzer.testConnection.bridge.healthCheckFailed": "Cannot reach bridge health endpoint at {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge returned HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge is not configured",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge returned an unparseable response",
  "analyzer.testConnection.bridge.unreachable": "Cannot reach bridge: {detail}",
  "analyzer.testConnection.close": "Close",
  "analyzer.testConnection.logs": "Connection Logs",
  "analyzer.testConnection.requestBuildFailed": "Failed to build request: {detail}",
  "analyzer.testConnection.success": "Connection Successful",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "Bridge is not configured, so analyzer reachability cannot be tested",
  "analyzer.testConnection.testAgain": "Test Again",
  "analyzer.testConnection.testing": "Testing connection...",
  "analyzer.testConnection.title": "Test Connection",
  "analyzer.testMapping.activeMappings": "{count} active mappings",
  "analyzer.testMapping.analyzerInfo": "Analyzer Information",
  "analyzer.testMapping.analyzerName": "Analyzer Name",
  "analyzer.testMapping.analyzerType": "Analyzer Type",
  "analyzer.testMapping.appliedMappings": "Applied Mappings",
  "analyzer.testMapping.entityPreview": "OpenELIS Entity Preview",
  "analyzer.testMapping.errors": "Errors",
  "analyzer.testMapping.loading": "Processing preview...",
  "analyzer.testMapping.messageInput": "Sample ASTM Message",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} characters",
  "analyzer.testMapping.messageInput.helper": "Enter a sample ASTM message to preview how it will be interpreted",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Sample ASTM Message *",
  "analyzer.testMapping.noResults": "No preview results yet. Enter a sample ASTM message and click Preview Mapping.",
  "analyzer.testMapping.parsedFields": "Parsed Fields",
  "analyzer.testMapping.parsedFields.astmRef": "ASTM Ref",
  "analyzer.testMapping.parsedFields.fieldName": "Field Name",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretation",
  "analyzer.testMapping.parsedFields.mappedTo": "Mapped To",
  "analyzer.testMapping.parsedFields.rawValue": "Raw Value",
  "analyzer.testMapping.pluginConfigSnapshot": "Plugin Config Snapshot",
  "analyzer.testMapping.previewOptions": "Preview Options",
  "analyzer.testMapping.previewOptions.detailedParsing": "Show detailed parsing steps",
  "analyzer.testMapping.previewOptions.validateAll": "Validate all mappings",
  "analyzer.testMapping.results": "Preview Results",
  "analyzer.testMapping.saveTestCase": "Save as Test Case",
  "analyzer.testMapping.submit": "Preview Mapping",
  "analyzer.testMapping.subtitle": "Preview how sample ASTM messages will be interpreted",
  "analyzer.testMapping.testAnother": "Test Another Message",
  "analyzer.testMapping.title": "Test Field Mappings",
  "analyzer.testMapping.validation.invalidFormat": "Invalid ASTM message format",
  "analyzer.testMapping.validation.messageRequired": "ASTM message is required",
  "analyzer.testMapping.validation.messageTooLarge": "ASTM message exceeds maximum size of 10KB",
  "analyzer.testMapping.warnings": "Warnings",
  "analyzer.unitMapping.analyzerUnit": "Source Unit (Analyzer)",
  "analyzer.unitMapping.analyzerUnit.helper": "Unit reported by the analyzer",
  "analyzer.unitMapping.conversionFactor": "Conversion Factor",
  "analyzer.unitMapping.conversionFactor.helper": "Factor to convert from {from} to {to} (e.g., 0.0555 for mg/dL to mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Target Unit (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Canonical unit used in OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Select target unit",
  "analyzer.unitMapping.rejectIfMismatch": "Reject if Units Don't Match",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Reject messages if units don't match and no conversion factor is provided",
  "analyzer.unitMapping.subtitle": "Configure unit mapping for {fieldName}",
  "analyzer.unitMapping.title": "Unit Mapping",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Source unit is required",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "Conversion factor must be a positive number",
  "analyzer.unitMapping.validation.conversionFactor.required": "Conversion factor is required when units differ",
  "analyzer.unitMapping.validation.error": "Validation Error",
  "analyzer.unitMapping.validation.error.subtitle": "Please correct the errors below",
  "analyzer.unitMapping.validation.openelisUnit.required": "Target unit is required",
  "analyzer.qcRules.modal.title": "QC Sample Identification Rules — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "QC Sample Identification Rules",
  "analyzer.qcRules.orSemantics": "Rules use OR semantics: a sample is flagged as QC if ANY active rule matches.",
  "analyzer.qcRules.addRule": "Adaugă regulă",
  "analyzer.qcRules.deleteRule": "Delete Rule",
  "analyzer.qcRules.noRules": "No QC rules configured. Add at least one rule before activating this analyzer.",
  "analyzer.qcRules.ruleType": "Rule Type",
  "analyzer.qcRules.targetField": "Field Reference",
  "analyzer.qcRules.targetField.placeholder": "e.g., O.12, QC_TASK",
  "analyzer.qcRules.operand": "Match Value",
  "analyzer.qcRules.operand.placeholder": "e.g., Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Failed to load QC rules",
  "analyzer.qcRules.error.saveFailed": "Failed to save QC rule",
  "analyzer.qcRules.error.deleteFailed": "Failed to delete QC rule",
  "analyzerTestName.header.analyzerName": "Analyzer - Analyzer Test Name",
  "analyzerTestName.modal.add.heading": "Add Analyzer Test Name",
  "analyzerTestName.modal.update.heading": "Update Analyzer Test Name",
  "assigned.cytopathologist.label": "Citopatolog asignat",
  "assigned.pathologist.label": "Patolog asignat",
  "assigned.technician.label": "Tehnician asignat",
  "audittrail.table.heading.action": "Acțiune",
  "audittrail.table.heading.identifier": "Identificator",
  "audittrail.table.heading.item": "Element",
  "audittrail.table.heading.newvalue": "Valoare nouă",
  "audittrail.table.heading.oldvalue": "Valoare veche",
  "audittrail.table.heading.time": "Oră",
  "audittrail.table.heading.user": "Utilizator",
  "audittrail.table.title.patientResults": "Patient Results",
  "availabletests.title": "Teste disponibile",
  "back.action.button": "Înapoi",
  "banner.menu.administration": "Administrare",
  "banner.menu.alerts": "Alerts",
  "banner.menu.alerts.tooltip": "Alerts and quality assurance dashboard",
  "banner.menu.aliquot": "Aliquot",
  "banner.menu.aliquot.tooltip": "Sample Aliquot",
  "banner.menu.billing": "Facturare",
  "banner.menu.billing.tooltip": "Facturare",
  "banner.menu.createDouble": "Introducere dublă",
  "banner.menu.createInitial": "Introducere inițială",
  "banner.menu.eorders": "Comenzi primite",
  "banner.menu.eqa": "EQA",
  "banner.menu.eqa.distribution": "EQA Distributions",
  "banner.menu.eqa.distribution.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.management": "EQA Programs",
  "banner.menu.eqa.management.tooltip": "Create and manage EQA programs",
  "banner.menu.eqa.mgmt": "EQA Management",
  "banner.menu.eqa.mgmt.distributions": "Distributions",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Create and manage EQA distributions",
  "banner.menu.eqa.mgmt.participants": "Participants",
  "banner.menu.eqa.mgmt.participants.tooltip": "Manage organization enrollment in EQA programs",
  "banner.menu.eqa.mgmt.programs": "Programs",
  "banner.menu.eqa.mgmt.programs.tooltip": "Create and manage EQA programs",
  "banner.menu.eqa.mgmt.results": "Results & Analysis",
  "banner.menu.eqa.mgmt.results.tooltip": "EQA results collection and statistical analysis",
  "banner.menu.eqa.mgmt.tooltip": "Manage EQA programs, participants, and distributions",
  "banner.menu.eqa.tests": "EQA Tests",
  "banner.menu.eqa.tests.myPrograms": "My Programs",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Manage self-enrollment in external EQA programs",
  "banner.menu.eqa.tests.orders": "Orders",
  "banner.menu.eqa.tests.orders.tooltip": "View and manage EQA test orders",
  "banner.menu.eqa.tests.tooltip": "EQA test orders and program enrollment",
  "banner.menu.eqa.tooltip": "External Quality Assurance",
  "banner.menu.generic.sample": "Generic Sample",
  "banner.menu.generic.sample.edit": "Editați comanda",
  "banner.menu.generic.sample.import": "Import Samples",
  "banner.menu.generic.sample.order": "Create Order",
  "banner.menu.generic.sample.results": "Enter Results",
  "banner.menu.help": "Ajutor",
  "banner.menu.help.about": "Tutoriale video",
  "banner.menu.help.contact": "Note de lansare",
  "banner.menu.help.documents": "Documentație procese",
  "banner.menu.help.formDBS": "Formular DBS",
  "banner.menu.help.formVL": "Formular VL",
  "banner.menu.help.usermanual": "Manual utilizator",
  "banner.menu.home": "Acasă",
  "banner.menu.inventory": "Inventory",
  "banner.menu.inventory.catalog": "Manage Catalog",
  "banner.menu.inventory.dashboard": "Tablou de bord",
  "banner.menu.inventory.list": "Inventory Items",
  "banner.menu.inventory.reports": "Rapoarte",
  "banner.menu.nonconformity": "Neconformități",
  "banner.menu.nonconformity.correctiveActions": "Acțiuni corective",
  "banner.menu.nonconformity.dashboard": "All NCEs",
  "banner.menu.nonconformity.report": "Raportează eveniment neconform",
  "banner.menu.nonconformity.view": "Vezi evenimente neconforme noi",
  "banner.menu.patient": "Pacient",
  "banner.menu.patient.Create": "Studiu",
  "banner.menu.patient.addOrEdit": "Adaugă/Editează pacient",
  "banner.menu.patient.merge": "Merge Patient",
  "banner.menu.patient.merge.tooltip": "Merge duplicate patient records",
  "banner.menu.patientConsult": "Vizualizează",
  "banner.menu.patientEdit": "Editează",
  "banner.menu.patienthistory": "Istoric pacient",
  "banner.menu.printBarcode": "Cod de bare",
  "banner.menu.referredOut": "Trimiteri externe",
  "banner.menu.report.validation.backlog": "Validare întârziată",
  "banner.menu.reports": "Rapoarte",
  "banner.menu.reports.routine": "Rutină",
  "banner.menu.reports.study": "Studiu",
  "banner.menu.results": "Rezultate",
  "banner.menu.results.CobasIntegra400": "Biochimie: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Imunologie: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Imunologie: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Imunologie: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Biochimie: Fully Analyzer",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyzer",
  "banner.menu.results.SysmeXT": "Hematologie: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "Sysmex XNL Analyzer",
  "banner.menu.results.SysmexXNLanalyzer": "Sysmex XNL Analyzer",
  "banner.menu.results.SysmexXPAnalyzer": "Sysmex XP Analyzer",
  "banner.menu.results.SysmexXPanalyzer": "Sysmex XP Analyzer",
  "banner.menu.results.accession": "După comandă",
  "banner.menu.results.analyzer": "Analizor",
  "banner.menu.results.cobasc111analyzer": "Biochimie: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "După unitate",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Order Programs",
  "banner.menu.results.patient": "După pacient",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "După test, dată sau stare",
  "banner.menu.results.sysmexanalyzer": "Hematologie: Sysmex XT 2000i",
  "banner.menu.results.sysmexxtanalyzer": "Hematologie: Sysmex XT",
  "banner.menu.results.taqman48dbsanalyzer": "Virologie: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "După data testului",
  "banner.menu.results.unified": "Results Entry",
  "banner.menu.results.unified.tooltip": "Unified results entry worklist",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validare",
  "banner.menu.resultvalidation.bacteria": "Bacteriologie",
  "banner.menu.resultvalidation.bench": "După banc",
  "banner.menu.resultvalidation.biochemistry": "Biochimie",
  "banner.menu.resultvalidation.cytobacteriology": "Citobacteriologie",
  "banner.menu.resultvalidation.dnapcr": "ADN PCR",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endocrinologie",
  "banner.menu.resultvalidation.genotyping": "Genotipare",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-Imunologie",
  "banner.menu.resultvalidation.hematology": "Hematologie",
  "banner.menu.resultvalidation.immunology": "Imunologie",
  "banner.menu.resultvalidation.immunology.Haiti": "Imunologie-Virologie",
  "banner.menu.resultvalidation.immunologyHematology": "Imunologie - Hematologie",
  "banner.menu.resultvalidation.liquidBio": "Biologie lichidă",
  "banner.menu.resultvalidation.malaria": "Malarie",
  "banner.menu.resultvalidation.molecularBio": "Biologie moleculară",
  "banner.menu.resultvalidation.mycobacteriology": "Micobacteriologie",
  "banner.menu.resultvalidation.mycology": "Micologie",
  "banner.menu.resultvalidation.parasitology": "Parazitologie",
  "banner.menu.resultvalidation.serology": "Serologie",
  "banner.menu.resultvalidation.serology-immunology": "Serologie-Imunologie",
  "banner.menu.resultvalidation.viralload": "Încărcătură virală",
  "banner.menu.resultvalidation.virology": "Virologie",
  "banner.menu.resultvalidation_routine": "Rutină",
  "banner.menu.resultvalidation_study": "Studiu",
  "banner.menu.sample": "Comandă",
  "banner.menu.sample.shipment": "Sample Shipment",
  "banner.menu.sampleAdd": "Adaugă comandă",
  "banner.menu.sampleBatchEntry": "Introducere comenzi în lot",
  "banner.menu.sampleConsult": "Vizualizează",
  "banner.menu.sampleCreate": "Studiu",
  "banner.menu.sampleEdit": "Editează comandă",
  "banner.menu.sampleManagement": "Sample Management",
  "banner.menu.sampleManagement.tooltip": "Sample Management Menu",
  "banner.menu.storage": "Storage",
  "banner.menu.storage.tooltip": "Sample Storage Management",
  "banner.menu.study.eorders": "Comenzi electronice",
  "banner.menu.workplan": "Plan de lucru",
  "banner.menu.workplan.bench": "După unitate",
  "banner.menu.workplan.panel": "După panel",
  "banner.menu.workplan.priority": "După prioritate",
  "banner.menu.workplan.test": "După tip test",
  "banner.menu.workplan.unit": "După secțiunea de test",
  "barcode.additionalInvalidLevels.message": "The barcode contains levels beyond the valid portion. Only valid levels are pre-filled.",
  "barcode.additionalInvalidLevels.warning": "Additional invalid levels detected",
  "barcode.autoOpenForm": "Opening location form with valid hierarchy",
  "barcode.debounce.warning": "Please wait before scanning another barcode",
  "barcode.error": "Invalid barcode",
  "barcode.firstMissingLevel": "First missing level: {level}",
  "barcode.format": "Format cod de bare",
  "barcode.header": "Cod(uri) de bare",
  "barcode.invalidFormat": "Invalid barcode format. Expected: ROOM-DEVICE or ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "Block label",
  "barcode.label.freezer": "Freezer label",
  "barcode.label.helper.text": "Introduceți valorile în: mm",
  "barcode.label.order": "Order label",
  "barcode.label.slide": "Slide label",
  "barcode.label.specimen": "Specimen label",
  "barcode.label.info.blockCaseNumber": "Block Case Number",
  "barcode.label.info.blockId": "Block ID",
  "barcode.label.info.blockNumber": "Block Number",
  "barcode.label.info.boxid": "Box ID",
  "barcode.label.info.caseNumber": "Case Number",
  "barcode.label.info.collectedBy": "Recoltat de",
  "barcode.label.info.collectionDate": "Data recoltării",
  "barcode.label.info.collectionDateTime": "Dată și oră recoltare",
  "barcode.label.info.created": "Created",
  "barcode.label.info.destination": "Destination",
  "barcode.label.info.expiryDate": "Expiry Date",
  "barcode.label.info.labNumber": "Număr accesare",
  "barcode.label.info.patientDobFull": "Data nașterii pacientului",
  "barcode.label.info.patientId": "ID pacient",
  "barcode.label.info.patientName": "Nume pacient",
  "barcode.label.info.patientSexFull": "Sex pacient",
  "barcode.label.info.samplecount": "Samples",
  "barcode.label.info.siteId": "Site ID",
  "barcode.label.info.slideId": "Slide ID",
  "barcode.label.info.slideNumber": "Slide Number",
  "barcode.label.info.specimenType": "Specimen Type",
  "barcode.label.info.stainType": "Stain Type",
  "barcode.label.info.storageLocation": "Storage Location",
  "barcode.label.info.temperature": "Temperature",
  "barcode.label.info.tests": "Teste",
  "barcode.labels.order.row": "Order labels",
  "barcode.labels.running.total": "Running total",
  "barcode.labels.sample.row": "Specimen labels sample {sampleNumber}",
  "barcode.labels.section.title": "Label quantities",
  "barcode.locationNotFound": "Location not found",
  "barcode.notification.save": "Configurațiile codurilor de bare au fost salvate.",
  "barcode.partialMatch": "Partial match - some components valid",
  "barcode.print.button": "Print",
  "barcode.print.dialog.quantityFor": "Quantity to print for {label}",
  "barcode.print.dialog.title": "Print labels",
  "barcode.print.done": "Done",
  "barcode.print.individual.button": "Tipărește etichetă",
  "barcode.print.later": "Skip — Print Later",
  "barcode.print.preprint": "Pre-tipărire coduri de bare",
  "barcode.print.preprint.button": "Pre-tipărește etichete",
  "barcode.print.preprint.note": "NOTĂ: Dacă este adăugată o instituție și/sau probă și test, acestea vor fi tipărite pe FIECARE etichetă",
  "barcode.print.reprint.dialog": "Reprint labels",
  "barcode.print.section.set": "Tipărește seturi",
  "barcode.print.set.button": "Tipărește set",
  "barcode.print.set.instruction": "Tipărește set de etichete (2 etichete comandă + 1 per probă)",
  "barcode.print.skip": "Skip",
  "barcode.print.title": "Tipărește etichete cod de bare",
  "barcode.ready": "Ready to scan",
  "barcode.scan": "Scan barcode",
  "barcode.scan.error": "Order not found",
  "barcode.scan.placeholder": "Scan barcode or enter lab number...",
  "barcode.scan.success": "Order loaded successfully",
  "barcode.scanning": "Scanning...",
  "barcode.scanOrType": "Scan barcode or type location",
  "barcode.success": "Location found",
  "barcode.validHierarchyPrefilled": "Valid hierarchy levels pre-filled",
  "barcode.validation.altPrefix": "Input should be alphanumeric and have a maximum length of 4 characters.",
  "barcode.validationFailed": "Barcode validation failed",
  "barcodeconfiguration.browse.title": "Configurație coduri de bare",
  "breadcrumb.home": "Acasă",
  "breadcrumb.caseView": "Case View",
  "breadcrums.admin.managment": "Management administrativ",
  "calendar.management.title": "Calendar Management",
  "calendar.management.description": "Manage public holidays and weekend configuration for working time TAT calculations",
  "calendar.management.addHoliday": "Add Holiday",
  "calendar.management.editHoliday": "Edit Holiday",
  "calendar.management.deleteConfirm": "Are you sure you want to delete this holiday?",
  "calendar.management.holidayName": "Holiday Name",
  "calendar.management.date": "Date",
  "calendar.management.recurring": "Recurring",
  "calendar.management.annual": "Annual",
  "calendar.management.oneTime": "One-time",
  "calendar.management.active": "Activ",
  "calendar.management.inactive": "Inactive",
  "calendar.management.weekend": "Weekend",
  "calendar.management.weekendDays": "Weekend Days (excluded from Working Time)",
  "calendar.management.weekendSaved": "Weekend configuration saved",
  "calendar.management.importCsv": "Import CSV",
  "calendar.management.exportCsv": "Export CSV",
  "calendar.management.importPreview": "Import Preview",
  "calendar.management.year": "Year",
  "calendar.management.noHolidays": "No holidays configured for {year}. Click \"Add Holiday\" to get started.",
  "calendar.management.duplicateDate": "A holiday already exists for this date",
  "calendar.management.imported": "{count} holidays imported",
  "calendar.management.skipped": "{count} holidays skipped",
  "calendar.management.holidayCount": "{count} holidays configured for {year}",
  "calendar.management.saveError": "Error saving holiday",
  "calendar.management.loadError": "Error loading holidays",
  "calendar.management.save": "Salvează",
  "calendar.management.cancel": "Anulează",
  "calendar.management.actions": "Actions",
  "calendar.management.status": "Stare",
  "calendar.management.column.date": "Date",
  "calendar.management.column.holidayName": "Holiday Name",
  "calendar.management.column.recurring": "Recurring",
  "calendar.management.column.status": "Stare",
  "calendar.management.column.actions": "Actions",
  "calendar.management.day.sun": "Sun",
  "calendar.management.day.mon": "Mon",
  "calendar.management.day.tue": "Tue",
  "calendar.management.day.wed": "Wed",
  "calendar.management.day.thu": "Thu",
  "calendar.management.day.fri": "Fri",
  "calendar.management.day.sat": "Sat",
  "calendar.management.chooseFile": "Choose CSV file",
  "calendar.management.csvColumns": "Columns: date, name, recurring (true/false)",
  "calendar.management.rowsFound": "{count} rows found",
  "calendar.management.column.csvDate": "Date",
  "calendar.management.column.csvName": "Nume",
  "calendar.management.column.csvRecurring": "Recurring",
  "calendar.management.importing": "Importing...",
  "column.qc.accession": "QC Sample",
  "column.qc.detail": "Detail",
  "column.qc.result": "Rezultat",
  "column.qc.test": "Analiză",
  "column.qc.type": "Type",
  "compliance.dashboard.chart.comparison.title": "Site Comparison — Current Period Compliance %",
  "compliance.dashboard.chart.drilldown.title": "Site Drill-Down — Per-Parameter Trend",
  "compliance.dashboard.chart.trend.title": "Compliance Rate Trend — All Sites",
  "compliance.dashboard.descriptive.excluded": "Descriptive parameters excluded from trend chart",
  "compliance.dashboard.drilldown.placeholder": "Select a site…",
  "compliance.dashboard.empty": "No data matches the selected filters",
  "compliance.dashboard.export.pdf": "Export PDF",
  "compliance.dashboard.filter.allStandards": "All Standards",
  "compliance.dashboard.filter.dateRange": "Date Range",
  "compliance.dashboard.filter.dateRangeEnd": "End date",
  "compliance.dashboard.filter.drilldownSite": "Drill down by site",
  "compliance.dashboard.filter.sites": "Sampling Sites",
  "compliance.dashboard.filter.standard": "Compliance Standard",
  "compliance.dashboard.kpi.complianceRate": "Compliance Rate",
  "compliance.dashboard.kpi.exceedances": "Total Exceedances",
  "compliance.dashboard.kpi.sitesMonitored": "Sites Monitored",
  "compliance.dashboard.kpi.totalOrders": "Total Orders",
  "compliance.dashboard.loading.comparison": "Loading comparison…",
  "compliance.dashboard.loading.drilldown": "Loading drill-down…",
  "compliance.dashboard.loading.exceedances": "Loading exceedances…",
  "compliance.dashboard.loading.generating": "Generating…",
  "compliance.dashboard.loading.trend": "Loading trend…",
  "compliance.dashboard.lowData": "Low data (< 3 orders)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Date",
  "compliance.dashboard.table.col.labNumber": "Lab #",
  "compliance.dashboard.table.col.parameter": "Parameter",
  "compliance.dashboard.table.col.result": "Rezultat",
  "compliance.dashboard.table.col.site": "Site",
  "compliance.dashboard.table.col.status": "Stare",
  "compliance.dashboard.table.col.threshold": "Threshold",
  "compliance.dashboard.table.exceedances.title": "Exceedance Summary",
  "compliance.dashboard.title": "Environmental Compliance Dashboard",
  "error.referOut.emailFormat": "Enter a valid email address (e.g. lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Handoff Date/Time is required to dispatch.",
  "error.referOut.maxLength": "Maximum {max} characters.",
  "error.referOut.phoneFormat": "Enter a valid phone number with country code prefix (e.g. +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Select a referring lab.",
  "error.validation.qc.ackFailed": "Failed to record QC acknowledgment. Please try again.",
  "holding.time.exceeded.message": "The SOP max holding time has been exceeded for: {tests}",
  "holding.time.exceeded.note": "WARNING: Result entered after SOP max holding time was exceeded.",
  "holding.time.exceeded.title": "Holding Time Exceeded",
  "instructions.results.entry.unified.route": "When enabled, the unified Results Entry worklist replaces the legacy result entry pages: the Results menu shows a single Results Entry item and the old result entry links redirect to it. Disable to restore the legacy pages.",
  "label.button.edit.details": "Edit details",
  "label.expand.poolDetails": "Expand pool details",
  "label.pool.collapse": "Hide individual specimens",
  "label.pool.expand": "Show individual specimens",
  "label.pool.expansion.next": "Următor",
  "label.pool.expansion.page": "Page {page} of {total}",
  "label.pool.expansion.prev": "Înapoi",
  "label.pool.expansion.title": "{animal} specimens ({count})",
  "label.qc.fail": "Fail",
  "label.qc.pass": "Pass",
  "label.referOut.action.dispatch": "Dispatch",
  "label.referOut.action.edit": "Editează",
  "label.referOut.action.referOut": "Refer Out",
  "label.referOut.action.save": "Save Referral",
  "label.referOut.action.view": "Vizualizează",
  "label.referOut.column.actions": "Actions",
  "label.referOut.column.referringLab": "Referring Lab",
  "label.referOut.column.sampleId": "Sample ID",
  "label.referOut.column.sampleType": "Tip probă",
  "label.referOut.column.status": "Subcontract Status",
  "label.referOut.column.tests": "Teste",
  "label.referOut.dispatch.error": "Failed to dispatch referral.",
  "label.referOut.dispatch.notSaved": "Save the referral before dispatching.",
  "label.referOut.dispatch.success": "Referral dispatched.",
  "label.referOut.empty.subtitle": "Samples appear here once they are saved. Save the order first to refer specimens out.",
  "label.referOut.empty.title": "No samples available for referral",
  "label.referOut.field.agreementReference": "Agreement Reference",
  "label.referOut.field.cocContactEmail": "Chain-of-Custody Contact Email",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Chain-of-Custody Contact Name",
  "label.referOut.field.cocContactPhone": "Chain-of-Custody Contact Phone",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Expected Return Date",
  "label.referOut.field.handoffDate": "Handoff Date",
  "label.referOut.field.handoffDatetime": "Handoff Date/Time",
  "label.referOut.field.handoffTime": "Handoff Time",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Note",
  "label.referOut.field.referringLab": "Referring Lab",
  "label.referOut.field.referringLab.placeholder": "Select a referring lab",
  "label.referOut.save.error": "Failed to save referral.",
  "label.referOut.save.success": "Referral saved.",
  "label.referOut.section.description": "Refer specimens to an external lab. Each sample carries its full chain-of-custody metadata.",
  "label.referOut.section.title": "Refer Out / Subcontract",
  "label.referOut.status.cancelled": "Cancelled",
  "label.referOut.status.closed": "Closed",
  "label.referOut.status.completed": "Completed",
  "label.referOut.status.dispatched": "Dispatched",
  "label.referOut.status.draft": "Draft",
  "label.referOut.status.inProgress": "In progress",
  "label.referOut.status.notReferred": "In-house",
  "label.referOut.status.received": "Received",
  "label.referOut.status.rejected": "Rejected",
  "label.referOut.status.requested": "Requested",
  "label.referOut.status.resultsReturned": "Results Returned",
  "label.sampleKind.blank": "BLANK",
  "label.sampleKind.client": "Client sample",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICATE",
  "label.sampleKind.qc": "QC",
  "label.validation.qc.ack.checkbox": "I have reviewed the QC failures and assessed their impact on the result release",
  "label.validation.qc.ack.heading": "Required Acknowledgment",
  "label.validation.qc.banner.subtitle": "Review and acknowledge below before releasing results.",
  "label.validation.qc.banner.title": "QC failures detected — {count} QC sample(s) failed acceptance criteria",
  "label.validation.qc.failedSamples": "Failed QC Samples",
  "label.validation.qc.justification": "Justification",
  "laporanHasil.action.generatePdf": "Generate PDF",
  "laporanHasil.action.regeneratePdf": "Re-generate PDF",
  "laporanHasil.col.actions": "Actions",
  "laporanHasil.col.collectionDate": "Data recoltării",
  "laporanHasil.col.compliance": "Compliance",
  "laporanHasil.col.labNumber": "Număr laborator",
  "laporanHasil.col.lastGenerated": "Last Generated",
  "laporanHasil.col.site": "Site",
  "laporanHasil.col.standard": "Standard",
  "laporanHasil.col.tests": "Teste",
  "laporanHasil.detail.ambientTemp": "Ambient Temp",
  "laporanHasil.detail.collectionDateTime": "Collection Date/Time",
  "laporanHasil.detail.collectionMethod": "Collection Method",
  "laporanHasil.detail.complianceSummary": "Compliance Summary",
  "laporanHasil.detail.conditions": "Collection Conditions",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Lab Analyst",
  "laporanHasil.detail.labManager": "Lab Manager",
  "laporanHasil.detail.parameter": "Parameter",
  "laporanHasil.detail.ppNo": "PP No.",
  "laporanHasil.detail.preservation": "Preservation",
  "laporanHasil.detail.result": "Rezultat",
  "laporanHasil.detail.signatures": "Signatures",
  "laporanHasil.detail.site": "Site",
  "laporanHasil.detail.siteInfo": "Informații locație",
  "laporanHasil.detail.standard": "Standard",
  "laporanHasil.detail.status": "Stare",
  "laporanHasil.detail.threshold": "Threshold",
  "laporanHasil.detail.waterTemp": "Water Temp",
  "laporanHasil.detail.weather": "Weather",
  "laporanHasil.empty": "No orders found for the selected filters.",
  "laporanHasil.error": "Failed to load report. Please try again.",
  "laporanHasil.filter.all": "Toate",
  "laporanHasil.filter.allSites": "All Sites",
  "laporanHasil.filter.allStandards": "All Standards",
  "laporanHasil.filter.complianceStatus": "Compliance Status",
  "laporanHasil.filter.dateFrom": "Date From",
  "laporanHasil.filter.dateTo": "Date To",
  "laporanHasil.filter.generated": "Generated",
  "laporanHasil.filter.generationStatus": "Generation Status",
  "laporanHasil.filter.notGenerated": "Not Yet Generated",
  "laporanHasil.filter.samplingSite": "Sampling Site",
  "laporanHasil.filter.standard": "Compliance Standard",
  "laporanHasil.loading": "Loading compliance report...",
  "laporanHasil.status.borderline": "Borderline",
  "laporanHasil.status.compliant": "Compliant",
  "laporanHasil.status.ineligible": "No standard linked",
  "laporanHasil.status.nonCompliant": "Non-Compliant",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Generate compliance certificates for validated environmental orders",
  "laporanHasil.tile.generated": "Generated",
  "laporanHasil.tile.ineligible": "Ineligible",
  "laporanHasil.tile.ineligible.desc": "Not validated or no standard linked",
  "laporanHasil.tile.notGenerated": "Not Yet Generated",
  "laporanHasil.title": "Compliance Report",
  "lhu.amendment.error.generic": "Failed to reissue the report. Please try again.",
  "lhu.amendment.modal.description": "You are reissuing LHU for lab number {labNumber}. The reissued report will be identified as an amendment to the previously released certificate.",
  "lhu.amendment.modal.heading": "Reissue LHU with Amendment",
  "lhu.amendment.modal.submit": "Reissue & Download PDF",
  "lhu.amendment.reason.helper": "State why the original report is being amended (required for ISO 17025 §7.8.8 compliance).",
  "lhu.amendment.reason.label": "Amendment reason",
  "lhu.amendment.reason.placeholder": "e.g. Incorrect pH result — instrument was not calibrated",
  "lhu.amendment.reason.required": "Amendment reason is required",
  "lhu.amendment.reissue": "Reissue with Amendment",
  "lhu.amendment.submitting": "Reissuing…",
  "nce.close.error": "Failed to close NCE",
  "nce.close.success": "NCE closed successfully",
  "nce.correctiveAction.error": "Failed to advance NCE status",
  "nce.correctiveAction.success": "NCE moved to Corrective Action",
  "notificationtrigger.activetriggers.heading": "Active Triggers",
  "notificationtrigger.activetriggers.subtitle": "Each row controls one notification event type. Toggle On to activate. Channel and recipient settings only apply when the trigger is enabled.",
  "notificationtrigger.channel.email": "Email",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.column.channels": "Channels",
  "notificationtrigger.column.enabled": "Enabled",
  "notificationtrigger.column.eventcode": "Event Code",
  "notificationtrigger.column.override": "Per-Lab-Unit Override",
  "notificationtrigger.column.recipients": "Recipients",
  "notificationtrigger.column.trigger": "Trigger",
  "notificationtrigger.config.subtitle": "Enable or disable notification triggers, select delivery channels, and configure recipient types per event.",
  "notificationtrigger.config.title": "Notification Trigger Configuration",
  "notificationtrigger.disabled.hint": "Enable this trigger to configure its channels and recipients.",
  "notificationtrigger.override.comingsoon": "Per-lab-unit override is not available yet.",
  "notificationtrigger.override.configure": "Configure",
  "notificationtrigger.recipient.coccontact": "CoC Contact",
  "notificationtrigger.recipient.orderingprovider": "Ordering Provider",
  "notificationtrigger.recipient.submittinguser": "Submitting User",
  "notificationtrigger.referralout.defaultoff": "Defaults OFF — must be enabled explicitly.",
  "notificationtrigger.referralout.description": "Sent when a sample is referred to an external laboratory.",
  "notificationtrigger.referralout.firesoncenote": "Fires once per saved referral. If one order has referrals to two different labs, two notifications are sent.",
  "notificationtrigger.referralout.name": "Referral Out",
  "notificationtrigger.sentmessages.action.resend": "Resend",
  "notificationtrigger.sentmessages.action.viewlog": "View Log",
  "notificationtrigger.sentmessages.channel.failed": "failed",
  "notificationtrigger.sentmessages.channel.sent": "sent",
  "notificationtrigger.sentmessages.column.actions": "Actions",
  "notificationtrigger.sentmessages.column.channels": "Channels",
  "notificationtrigger.sentmessages.column.datetime": "Date / Time",
  "notificationtrigger.sentmessages.column.recipient": "Recipient",
  "notificationtrigger.sentmessages.column.reference": "Reference",
  "notificationtrigger.sentmessages.column.status": "Stare",
  "notificationtrigger.sentmessages.column.type": "Type",
  "notificationtrigger.sentmessages.count": "{count} of {total} messages",
  "notificationtrigger.sentmessages.empty.heading": "No notifications have been sent yet.",
  "notificationtrigger.sentmessages.filter.status.all": "All Statuses",
  "notificationtrigger.sentmessages.filter.status.failed": "Failed",
  "notificationtrigger.sentmessages.filter.status.label": "Stare",
  "notificationtrigger.sentmessages.filter.status.sent": "Sent",
  "notificationtrigger.sentmessages.filter.type.all": "All Types",
  "notificationtrigger.sentmessages.filter.type.label": "Type",
  "notificationtrigger.sentmessages.heading": "Sent Messages",
  "notificationtrigger.sentmessages.resend.disclaimer": "Resending replays the original message bytes and recipient address. To send to a different address, edit the patient record and trigger a new event.",
  "notificationtrigger.sentmessages.resend.failure": "Resend failed. See server logs for details.",
  "notificationtrigger.sentmessages.resend.success": "Notification resent.",
  "notificationtrigger.sentmessages.status.failed": "Failed",
  "notificationtrigger.sentmessages.status.sent": "Sent",
  "notificationtrigger.sentmessages.subtitle": "All outbound notifications dispatched by OpenELIS, across all trigger types and channels.",
  "notificationtrigger.sentmessages.viewlog.channels": "Channel Outcomes",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Attempts",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Channel",
  "notificationtrigger.sentmessages.viewlog.column.error": "Error",
  "notificationtrigger.sentmessages.viewlog.column.status": "Stare",
  "notificationtrigger.sentmessages.viewlog.heading": "Notification Log",
  "notificationtrigger.sentmessages.viewlog.message": "Message Body",
  "notificationtrigger.sentmessages.viewlog.subject": "Subiect",
  "notificationtrigger.status.new": "NEW",
  "notificationtrigger.subcontractdispatched.description": "Sent when a sample has been physically dispatched to the receiving laboratory.",
  "notificationtrigger.subcontractdispatched.name": "Subcontract Dispatched",
  "notificationtrigger.tabs.sentmessages": "Sent Messages",
  "notificationtrigger.tabs.sentmessages.placeholder": "Sent messages — coming in a future milestone.",
  "notificationtrigger.tabs.templates": "Templates",
  "notificationtrigger.tabs.templates.placeholder": "Template editor — coming in a future milestone.",
  "notificationtrigger.tabs.triggers": "Triggers",
  "notificationtrigger.templates.body.help": "Free text with merge fields. This template is not managed by i18n — edit it directly.",
  "notificationtrigger.templates.body.label": "Message Body",
  "notificationtrigger.templates.button.reset": "Reset to Default",
  "notificationtrigger.templates.button.save": "Save Template",
  "notificationtrigger.templates.channel.help": "Each channel has its own template fields. Switch channels to edit separately.",
  "notificationtrigger.templates.channel.label": "Channel",
  "notificationtrigger.templates.heading": "Notification Template Configuration",
  "notificationtrigger.templates.mergefields.heading": "Available Merge Fields",
  "notificationtrigger.templates.mergefields.help": "Fields below are specific to the {eventCode} event. Click a field to insert it at the cursor position.",
  "notificationtrigger.templates.mergefields.optionalnote": "If [expectedReturn] is not set on the referral, it renders blank — no error.",
  "notificationtrigger.templates.preview.label": "Rendered Preview",
  "notificationtrigger.templates.referralout.description": "Sent to the customer contact (Ordering Provider) and/or internal staff (Submitting User) when a referral is saved.",
  "notificationtrigger.templates.subcontractdispatched.description": "Sent to the receiving lab's CoC contact and the customer when a sample is physically dispatched to the receiving laboratory.",
  "notificationtrigger.templates.subject.label": "Subiect",
  "notificationtrigger.templates.subtitle": "Compose message templates for each notification event type. Templates are free text with merge fields.",
  "order.clinicalInfo.helper": "Optional context to guide test selection and reporting — not recorded as a confirmed diagnosis.",
  "order.complete.processing.description": "{labNumber} is now in {status} status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.description.plain": "{labNumber} is now in Processing status and will appear in the V-03 Vector Identification worklist.",
  "order.complete.processing.title": "Order Complete — Processing",
  "order.context.poolOf": "Pool of {count} {animal}",
  "order.paymentStatus.helper": "How payment will be handled for this order.",
  "order.priority.helper": "ROUTINE: standard turnaround. STAT: process immediately.",
  "order.referral.sampleType.ambiguous": "This referred order requested {items}, but the sample type could not be determined automatically. Please select a sample type below and choose the requested test(s).",
  "order.requester.section.helper": "Select the facility that ordered the tests and the responsible provider.",
  "panel.domain.clinical": "Clinical",
  "panel.domain.environmental": "Environmental",
  "panel.domain.eqa": "EQA",
  "panel.domain.vector": "Vector",
  "panel.filter.domain": "Domain",
  "panel.organism.flea": "Flea",
  "panel.organism.fly": "Fly",
  "panel.organism.mosquito": "Mosquito",
  "panel.organism.rodent": "Rodent",
  "panel.organism.selectPlaceholder": "Select Organism Group",
  "panel.organism.tick": "Tick",
  "patient.search.section.helper": "Search by any combination of fields — partial matches accepted. 'External Search' queries the Client Registry and requires at minimum a name and date of birth.",
  "placeholder.validation.qc.justification": "Required (max 500 chars)",
  "provider.add.new": "+ Add new provider \"{name}\"",
  "provider.email.field": "Email medic",
  "provider.fax.field": "Provider Fax",
  "provider.firstName.field": "Prenume",
  "provider.lastName.field": "Nume",
  "provider.new.helper": "Will be created as a new provider when this order is saved.",
  "provider.new.tag": "New",
  "provider.no.match": "No matching provider found.",
  "provider.phone.field": "Phone",
  "qc.add.blank": "+ Blank QC",
  "qc.add.control": "+ Control QC",
  "qc.add.duplicate": "+ Duplicate QC",
  "qc.collect.inheritsFromParent": "Collection details inherited from parent sample",
  "qc.expectedValue.placeholder": "e.g. 50.0",
  "qc.samples.label": "QC samples:",
  "qc.samples.numericOnly": "QC is currently supported only for tests with numeric results. The selected tests are coded — pick a numeric test to attach QC.",
  "qc.samples.thresholdsMissing": "Configure QC thresholds for {tests} in Administration → Test Configuration before adding QC samples.",
  "qc.type.blank": "QC: Blank",
  "qc.type.control": "QC: Control",
  "qc.type.duplicate": "QC: Duplicate",
  "referral.accept.error": "Could not accept the result. Please try again.",
  "referral.action.accept": "Acceptă",
  "referral.action.acceptToAnalysis": "Accept to Analysis",
  "referral.action.clearFilters": "Clear filters",
  "referral.action.enterResult": "Enter result",
  "referral.action.markLost": "Mark Lost",
  "referral.action.notifyReferenceLab": "Notify reference lab",
  "referral.action.openResultEntry": "Open in Result Entry",
  "referral.action.reject": "Respinge",
  "referral.banner.filterToStuck": "Filter to stuck only",
  "referral.banner.stuckReferralsSubtitle": "{count} referral(s) have been at a reference lab for more than {threshold} day(s).",
  "referral.banner.stuckReferralsTitle": "Stuck referrals detected",
  "referral.box.cannotReconcileMessage": "Cannot reconcile box — {count} samples still awaiting result reconciliation. See Reference Lab Results.",
  "referral.box.viewBlockedReferrals": "View in Reference Lab Results",
  "referral.breadcrumb.referenceLabResults": "Reference Lab Results",
  "referral.chip.ariaLabel": "Reference lab results view",
  "referral.chip.history": "History",
  "referral.chip.outstanding": "Outstanding",
  "referral.chip.returned": "Returned — needs action",
  "referral.column.actions": "Actions",
  "referral.column.boxId": "Box ID",
  "referral.column.closedDate": "Closed date",
  "referral.column.daysOutstanding": "Days outstanding",
  "referral.column.daysTotal": "Days total",
  "referral.column.labNumber": "Număr laborator",
  "referral.column.outcome": "Outcome",
  "referral.column.patient": "Pacient",
  "referral.column.priority": "Prioritate",
  "referral.column.referenceLab": "Laborator de referință",
  "referral.column.requestor": "Original requestor",
  "referral.column.resultSummary": "Result summary",
  "referral.column.returnedDate": "Returned Date",
  "referral.column.sentDate": "Dată trimitere",
  "referral.column.status": "Stare",
  "referral.column.tests": "Teste",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} other {# years}}",
  "referral.expand.detail.boxId": "Box ID",
  "referral.expand.detail.boxReceivedDate": "Received at reference lab",
  "referral.expand.detail.collected": "Collected",
  "referral.expand.detail.currentStatus": "Current status",
  "referral.expand.detail.daysOutstanding": "Days outstanding",
  "referral.expand.detail.dispatched": "Dispatched",
  "referral.expand.detail.fhirTask": "FHIR Task",
  "referral.expand.detail.labNumber": "Număr laborator",
  "referral.expand.detail.patient": "Pacient",
  "referral.expand.detail.priority": "Prioritate",
  "referral.expand.detail.referenceLab": "Laborator de referință",
  "referral.expand.detail.requestor": "Original requestor",
  "referral.expand.detail.sampleType": "Sample type",
  "referral.expand.detail.tests": "Teste",
  "referral.expand.noResultPayload": "No structured result was returned by the reference lab.",
  "referral.expand.originalOrderContext": "Original order context",
  "referral.expand.outcomeDetail": "Outcome detail",
  "referral.expand.receptionAction": "Reception action",
  "referral.expand.receptionHint": "Review the returned result below, then Accept it to post to the patient record, or Reject it if the result cannot be used.",
  "referral.expand.referenceLabTransit": "Reference lab transit",
  "referral.expand.result": "Rezultat",
  "referral.expand.statusDetail": "Status detail",
  "referral.filter.allPriorities": "All priorities",
  "referral.filter.allRefLabs": "All reference labs",
  "referral.filter.dateRange": "Date range",
  "referral.filter.daysOutstandingBucket": "Days outstanding",
  "referral.filter.daysOutstandingBucket.stuck": "Stuck (> {threshold} days)",
  "referral.filter.priority": "Prioritate",
  "referral.filter.referenceLab": "Laborator de referință",
  "referral.markLost.cancelButton": "Anulează",
  "referral.markLost.confirmButton": "Mark as lost",
  "referral.markLost.description": "This marks the referral as lost in transit and removes it from Outstanding. The clinical team will need to re-collect and re-refer the sample.",
  "referral.markLost.modalTitle": "Mark referral as lost",
  "referral.markLost.reasonLabel": "Reason",
  "referral.markLost.reasonPlaceholder": "e.g. Courier confirmed loss. Box never arrived at the reference lab.",
  "referral.markLost.reasonRequired": "Reason is required.",
  "referral.metric.outstanding": "Outstanding",
  "referral.metric.reconciledToday": "Reconciled today",
  "referral.metric.rejectedThisWeek": "Rejected this week",
  "referral.metric.returned": "Returned — needs action",
  "referral.notification.accepted": "Result accepted to the patient record.",
  "referral.notification.rejected": "Result rejected. The clinician has been notified to re-collect.",
  "referral.notify.errorRetry": "Failed to notify reference lab. Try again.",
  "referral.notify.toast": "Reference lab notified.",
  "referral.page.title": "Reference Lab Results",
  "referral.reject.cancelButton": "Anulează",
  "referral.reject.confirmButton": "Reject and notify clinician",
  "referral.reject.description": "Rejecting closes the originating test terminally and notifies the clinician to re-collect and re-refer the sample.",
  "referral.reject.error": "Could not reject the result. Please try again.",
  "referral.reject.modalTitle": "Reject returned result",
  "referral.reject.reason.clotted": "Clotted",
  "referral.reject.reason.damagedContainer": "Damaged container",
  "referral.reject.reason.hemolyzed": "Hemolyzed",
  "referral.reject.reason.insufficientVolume": "Insufficient volume",
  "referral.reject.reason.mislabeled": "Mislabeled",
  "referral.reject.reason.other": "Other",
  "referral.reject.reason.temperatureDeviation": "Temperature deviation",
  "referral.reject.reason.wrongSampleType": "Wrong sample type",
  "referral.reject.reasonLabel": "Reason",
  "referral.reject.reasonTextLabel": "Details",
  "referral.reject.reasonTextPlaceholder": "Describe why this returned result cannot be used.",
  "referral.reject.reasonTextRequired": "Details are required.",
  "referral.reject.warningTitle": "This action cannot be undone",
  "referral.result.interp.Abnormal": "Abnormal",
  "referral.result.interp.Critical": "Critical",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Cancelled",
  "referral.status.completed": "Result returned",
  "referral.status.draft": "Draft",
  "referral.status.inProgress": "In progress at reference lab",
  "referral.status.received": "At reference lab",
  "referral.status.reconciled": "Reconciled",
  "referral.status.rejected": "Rejected by reference lab",
  "referral.status.requested": "Sent — awaiting acceptance",
  "referral.table.count": "{count, plural, =0 {No referrals} one {# referral} other {# referrals}}",
  "referral.table.history.title": "History",
  "referral.table.outstanding.title": "Outstanding referrals",
  "referral.table.returned.title": "Returned — needs action",
  "referral.tag.manuallyEntered": "Manually entered",
  "reports.tat.title": "Turn Around Time Report",
  "reports.tat.description": "Analyze laboratory turnaround times across workflow milestones",
  "reports.tat.generateReport": "Generează raport",
  "reports.tat.clearFilters": "Clear Filters",
  "reports.tat.segment.orderToCollection": "Order to Collection",
  "reports.tat.segment.collectionToReceipt": "Collection to Receipt",
  "reports.tat.segment.receiptToTesting": "Receipt to Testing Started",
  "reports.tat.segment.receiptToResult": "Receipt to Result Entry",
  "reports.tat.segment.receiptToValidation": "Receipt to Validation",
  "reports.tat.segment.resultToValidation": "Result Entry to Validation",
  "reports.tat.segment.overall": "Overall TAT",
  "reports.tat.calendarTime": "Calendar Time",
  "reports.tat.workingTime": "Working Time",
  "reports.tat.workingTimeInfo": "Working Time mode: Excluding {weekendDays} and {holidayCount} public holidays in the selected date range",
  "reports.tat.configuredWeekends": "configured weekends",
  "reports.tat.noHolidaysWarning": "No public holidays configured. Configure holidays in Admin > Calendar Management.",
  "reports.tat.manageCalendar": "Manage Calendar",
  "reports.tat.totalResults": "Total Results",
  "reports.tat.meanTat": "Mean TAT",
  "reports.tat.medianTat": "Median TAT",
  "reports.tat.percentile90": "90th Percentile",
  "reports.tat.minTat": "Min TAT",
  "reports.tat.maxTat": "Max TAT",
  "reports.tat.stdDeviation": "Std Deviation",
  "reports.tat.distribution": "TAT Distribution",
  "reports.tat.breakdownBy": "Breakdown by",
  "reports.tat.clickRowHint": "Click a row to view individual results",
  "reports.tat.summary": "Summary",
  "reports.tat.detailList": "Detail List",
  "reports.tat.trends": "Tendințe",
  "reports.tat.noResults": "No results found for the selected filters. Try adjusting the date range or filter criteria.",
  "reports.tat.insufficientData": "Insufficient data",
  "reports.tat.loadError": "Error loading report data",
  "reports.tat.dateRange": "Date Range",
  "reports.tat.labUnit": "Lab Unit",
  "reports.tat.testPanel": "Test / Panel",
  "reports.tat.priority.all": "Toate",
  "reports.tat.priority.routine": "Rutină",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": "Tip probă",
  "reports.tat.orderingSite": "Ordering Site",
  "reports.tat.priority": "Prioritate",
  "reports.tat.includeCancelled": "Include cancelled/rejected",
  "reports.tat.export": "Exportă",
  "reports.tat.exportCsv": "Export CSV",
  "reports.tat.exportPdf": "Export PDF",
  "reports.tat.labNumber": "Număr laborator",
  "reports.tat.patient": "Pacient",
  "reports.tat.test": "Analiză",
  "reports.tat.orderCreated": "Order Created",
  "reports.tat.collected": "Collected",
  "reports.tat.received": "Received",
  "reports.tat.testingStarted": "Testing Started",
  "reports.tat.resultEntered": "Result Entered",
  "reports.tat.validated": "Validated",
  "reports.tat.selectedTat": "Selected TAT",
  "reports.tat.overallTat": "Overall TAT",
  "reports.tat.columns": "Columns",
  "reports.tat.rowsPerPage": "Rows per page",
  "reports.tat.showing": "Showing {from}-{to} of {total} results",
  "reports.tat.trend": "Trend",
  "reports.tat.aggregation": "Aggregation",
  "reports.tat.daily": "Daily",
  "reports.tat.weekly": "Weekly",
  "reports.tat.monthly": "Monthly",
  "reports.tat.compareBy": "Compare by",
  "reports.tat.showVolume": "Show order volume",
  "reports.tat.mean": "Mean",
  "reports.tat.median": "Median",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Date Range (From)",
  "reports.tat.dateRangeTo": "Date Range (To)",
  "reports.tat.tatSegment": "TAT Segment",
  "reports.tat.metrics": "Metrics",
  "reports.tat.compareNone": "Niciuna",
  "reports.tat.comparePriority": "Prioritate",
  "reports.tat.column.labNumber": "Număr laborator",
  "reports.tat.column.test": "Analiză",
  "reports.tat.column.labUnit": "Lab Unit",
  "reports.tat.column.priority": "Prioritate",
  "reports.tat.column.ordered": "Ordered",
  "reports.tat.column.collected": "Collected",
  "reports.tat.column.received": "Received",
  "reports.tat.column.started": "Started",
  "reports.tat.column.resulted": "Resulted",
  "reports.tat.column.validated": "Validated",
  "reports.tat.column.selectedTat": "Selected TAT",
  "reports.tat.column.overallTat": "Overall TAT",
  "reports.tat.column.name": "Nume",
  "reports.tat.column.count": "Count",
  "reports.tat.column.mean": "Mean",
  "reports.tat.column.median": "Median",
  "reports.tat.column.p90": "90th %ile",
  "reports.tat.column.max": "Max",
  "reports.tat.home": "Acasă",
  "reports.tat.all": "Toate",
  "reports.tat.preset.today": "Today",
  "reports.tat.preset.7days": "Last 7 Days",
  "reports.tat.preset.30days": "Last 30 Days",
  "reports.tat.preset.90days": "Last 90 Days",
  "reports.tat.preset.thisMonth": "This Month",
  "reports.tat.preset.lastMonth": "Last Month",
  "reports.tat.preset.thisQuarter": "This Quarter",
  "button.cancel": "Anulează",
  "button.activate": "Activate",
  "button.adjust": "Adjust",
  "button.deactivate": "Dezactivează",
  "button.dispose": "Dispose",
  "button.edit": "Editează",
  "button.generate": "Generează",
  "button.label.genarateReport": "Generează raport",
  "button.label.loadnext": "Încarcă următorul pachet",
  "button.label.loadprevious": "Încarcă pachetul anterior",
  "button.label.showHidePram": "Afișează/Ascunde parametri raport",
  "button.record": "Record",
  "button.save": "Salvează",
  "button.save.draft": "Save Draft",
  "button.save.next": "Save & Next",
  "button.save.stay": "Salvează",
  "button.send": "Trimite",
  "button.update": "Update",
  "calculatedTests": "Teste calculate",
  "catalog.item.activate.success": "Catalog item activated successfully",
  "catalog.item.category": "Categorie",
  "catalog.item.compatibleAnalyzers": "Compatible Analyzers",
  "catalog.item.deactivate.confirm.button": "Dezactivează",
  "catalog.item.deactivate.confirm.message": "Are you sure you want to deactivate {itemName}?",
  "catalog.item.deactivate.confirm.title": "Confirm Deactivation",
  "catalog.item.deactivate.implications.1": "This item will no longer appear in active item lists",
  "catalog.item.deactivate.implications.2": "Existing lots for this item will remain accessible",
  "catalog.item.deactivate.implications.3": "You can reactivate this item later if needed",
  "catalog.item.deactivate.implications.title": "Implications:",
  "catalog.item.deactivate.label": "Deactivate Item",
  "catalog.item.deactivate.success": "Item deactivated successfully",
  "catalog.item.form.title.add": "Add New Catalog Item",
  "catalog.item.form.title.edit": "Edit Catalog Item",
  "catalog.item.lowStockThreshold": "Low Stock Threshold",
  "catalog.item.manufacturer": "Manufacturer",
  "catalog.item.minimumStock": "Minimum Stock Level",
  "catalog.item.name": "Item Name",
  "catalog.item.reorderLevel": "Reorder Level",
  "catalog.item.reorderQuantity": "Reorder Quantity",
  "catalog.item.save.error": "Error saving catalog item",
  "catalog.item.save.success": "Catalog item saved successfully",
  "catalog.item.stabilityAfterOpening": "Stability After Opening (days)",
  "catalog.item.status": "Stare",
  "catalog.item.storageRequirements": "Storage Requirements",
  "catalog.item.testTypes": "Test Types",
  "catalog.item.testsPerCartridge": "Tests Per Cartridge",
  "catalog.item.testsPerKit": "Tests Per Kit",
  "catalog.item.type": "Item Type",
  "catalog.item.units": "Units",
  "catalog.search.placeholder": "Search by item name",
  "choose.availablepanel": "Alege panel disponibil",
  "coldStorage.action.createSuccess": "Corrective action created successfully",
  "coldStorage.action.retractSuccess": "Corrective action retracted successfully",
  "coldStorage.action.updateSuccess": "Corrective action updated successfully",
  "coldStorage.actions": "Actions",
  "coldStorage.activated": "activated",
  "coldStorage.addDevicesMessage": "Please add devices in Device Management to configure temperature thresholds.",
  "coldStorage.addNewDevice": "Add New Device",
  "coldStorage.alert.equipment": "Equipment Failure",
  "coldStorage.alert.equipment.description": "Alerts for equipment malfunctions or connectivity issues",
  "coldStorage.alert.inventory": "Inventory Alerts",
  "coldStorage.alert.inventory.description": "Alerts for low inventory or stock management",
  "coldStorage.alert.saveFailed": "Failed to save notification preferences: ",
  "coldStorage.alert.saveSuccess": "Notification preferences saved successfully. Each alert type will use its configured notification methods.",
  "coldStorage.alert.temperature": "Temperature Alerts",
  "coldStorage.alert.temperature.description": "Alerts triggered when freezer temperature exceeds defined thresholds",
  "coldStorage.alert.type": "Alert Type",
  "coldStorage.alertConfiguration": "Alert Configuration",
  "coldStorage.autoEscalate": "Automatically escalate unresolved alerts",
  "coldStorage.bacnetUdpPort": "BACnet UDP Port",
  "coldStorage.button.delete": "Delete",
  "coldStorage.config.saveSuccess": "System configuration saved successfully",
  "coldStorage.configMoved": "Configuration Moved to Admin Panel",
  "coldStorage.configMovedDesc": "System-wide settings should be managed in the Admin UI where all global configurations are centralized. This page is read-only and will be removed in a future release.",
  "coldStorage.configuredDevices": "Configured Devices",
  "coldStorage.criticalThreshold": "Critical Threshold (°C)",
  "coldStorage.databaseVersion": "Database Version",
  "coldStorage.deactivated": "deactivated",
  "coldStorage.description": "Descriere",
  "coldStorage.device.activate": "Activate device",
  "coldStorage.device.activateMessage": "Activating this device will enable monitoring and data collection.",
  "coldStorage.device.changeStatus": "Change Device Status",
  "coldStorage.device.changeStatusOf": "Change the status of {name}:",
  "coldStorage.device.created": "Device created successfully",
  "coldStorage.device.createdSuccess": "Device \"{name}\" has been created successfully",
  "coldStorage.device.deactivate": "Deactivate device",
  "coldStorage.device.deactivateMessage": "Deactivating this device will stop monitoring and data collection. Historical data will be preserved.",
  "coldStorage.device.delete": "Delete Device",
  "coldStorage.device.deleteConfirm": "Are you sure you want to delete {name}?",
  "coldStorage.device.deleteWarning": "This will mark the device as inactive and remove it from active monitoring. Historical data will be preserved.",
  "coldStorage.device.deleted": "Device \"{name}\" has been deleted successfully",
  "coldStorage.device.deviceStatus": "Device Status",
  "coldStorage.device.edit": "Edit device",
  "coldStorage.device.id": "Device ID",
  "coldStorage.device.ipAddress": "IP Address",
  "coldStorage.device.port": "Port",
  "coldStorage.device.protocol": "Protocol",
  "coldStorage.device.roomFacility": "Room/Facility",
  "coldStorage.device.statusChanged": "Device \"{name}\" has been {status} successfully",
  "coldStorage.device.type": "Type",
  "coldStorage.device.updated": "Device updated successfully",
  "coldStorage.email": "Email",
  "coldStorage.emailSmsNotifications": "Email Notifications & SMS Notifications",
  "coldStorage.error.createAction": "Failed to create corrective action. Please try again.",
  "coldStorage.error.createDevice": "Failed to create device: ",
  "coldStorage.error.createRoom": "Failed to create room: ",
  "coldStorage.error.deleteDevice": "Failed to delete device: ",
  "coldStorage.error.loadActions": "Failed to load corrective actions. Please try again.",
  "coldStorage.error.loadConfig": "Failed to load system configuration: ",
  "coldStorage.error.loadDevices": "Failed to load devices: ",
  "coldStorage.error.loadLocations": "Failed to load locations: ",
  "coldStorage.error.loadUsers": "Failed to load user list. Please try again later.",
  "coldStorage.error.retractAction": "Failed to retract corrective action. Please try again.",
  "coldStorage.error.saveConfig": "Failed to save system configuration: ",
  "coldStorage.error.saveThreshold": "Failed to save threshold configuration: ",
  "coldStorage.error.toggleStatus": "Failed to toggle device status: ",
  "coldStorage.error.updateAction": "Failed to update corrective action. Please try again.",
  "coldStorage.error.updateDevice": "Failed to update device: ",
  "coldStorage.escalationDelay": "Escalation Delay (minutes)",
  "coldStorage.escalationDelayHelper": "Time to wait before escalating an unresolved alert",
  "coldStorage.escalationRules": "Escalation Rules",
  "coldStorage.filter.activeOnly": "Active Only",
  "coldStorage.filter.all": "All Devices",
  "coldStorage.filter.inactiveOnly": "Inactive Only",
  "coldStorage.granularNotificationControl": "Granular Notification Control",
  "coldStorage.granularNotificationControlDesc": "Configure email and SMS notifications for each alert type independently. Enable the notification methods you want for each specific alert category.",
  "coldStorage.howNotificationsWork": "How Notifications Work",
  "coldStorage.howNotificationsWorkDesc": "When an alert is triggered (temperature threshold violation, equipment failure, etc.), the system will:",
  "coldStorage.lastUpdate": "Last Update",
  "coldStorage.loadingConfig": "Loading system configuration...",
  "coldStorage.loadingDevices": "Loading devices...",
  "coldStorage.loadingPrefs": "Loading notification preferences...",
  "coldStorage.modbusTcpPort": "Modbus TCP Port",
  "coldStorage.name": "Nume",
  "coldStorage.noConfigFound": "No Configuration Found",
  "coldStorage.noDevicesConfigured": "No Devices Configured",
  "coldStorage.notification.createRecord": "Create an alert record in the system (visible in Dashboard)",
  "coldStorage.notification.logAttempt": "Log the notification attempt for audit trail purposes",
  "coldStorage.notification.sendEmail": "Send EMAIL notifications if enabled (to configured recipients)",
  "coldStorage.notification.sendSms": "Send SMS notifications if enabled (to configured phone numbers)",
  "coldStorage.pollInterval": "Poll Interval (seconds)",
  "coldStorage.protocolConfiguration": "Protocol Configuration",
  "coldStorage.readOnlyMode": "Read-Only Mode",
  "coldStorage.readOnlyModeDesc": "To modify these settings, please navigate to Admin → System Configuration",
  "coldStorage.room.addNew": "Add New Room",
  "coldStorage.room.create": "Create Room",
  "coldStorage.room.created": "Room created successfully",
  "coldStorage.room.description": "Descriere",
  "coldStorage.room.descriptionPlaceholder": "Enter room description (optional)",
  "coldStorage.room.name": "Room Name *",
  "coldStorage.room.namePlaceholder": "Enter room name (e.g., Lab Storage Room A)",
  "coldStorage.saveNotificationPrefs": "Save Notification Preferences",
  "coldStorage.saveThresholdConfig": "Save Threshold Configuration",
  "coldStorage.saving": "Saving...",
  "coldStorage.search.placeholder": "Search by Device ID or Name",
  "coldStorage.securitySettings": "Security Settings",
  "coldStorage.sessionTimeout": "Session Timeout",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Stare",
  "coldStorage.status.active": "ACTIVE",
  "coldStorage.status.inactive": "INACTIVE",
  "coldStorage.supervisorEmail": "Supervisor Email",
  "coldStorage.supervisorEmailHelper": "Email address to send escalated alerts",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.systemConfiguration": "System Configuration",
  "coldStorage.systemInformation": "System Information",
  "coldStorage.systemVersion": "System Version",
  "coldStorage.targetTemperature": "Target Temperature (°C)",
  "coldStorage.threshold.saveSuccess": "Threshold configuration saved successfully",
  "coldStorage.thresholdConfiguration": "Temperature Threshold Configuration",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Uptime",
  "coldStorage.usingDefaults": "Using default notification settings. Save to create configuration.",
  "coldStorage.validation.error": "Validation Error",
  "coldStorage.validation.retractionReason": "Please provide a reason for retraction",
  "coldStorage.validation.selectActionType": "Please select an action type",
  "coldStorage.validation.selectDevice": "Please select a device",
  "coldStorage.validation.selectRoom": "Please select a room/location for the device",
  "coldStorage.warningThreshold": "Warning Threshold (°C)",
  "collect.addSample.button": "Adaugă probă",
  "collect.assign.addToSample": "Add to existing sample",
  "collect.assign.button": "Assign Tests",
  "collect.assign.description": "Assign requested tests to sample tubes",
  "collect.assign.newSample": "Create new sample",
  "collect.assign.newSampleHelp": "Select sample type for the new tube",
  "collect.assign.noExisting": "No existing samples available",
  "collect.assign.title": "Alocare teste",
  "collect.multiSampleExample.description": "When multiple sample types are needed",
  "collect.multiSampleExample.result": "Creates separate tubes for each type",
  "collect.multiSampleExample.title": "Multi-Sample Collection Example",
  "collect.noSampleYet": "No samples collected yet",
  "collect.noTestsOrdered": "No tests have been ordered",
  "collect.noTestsWarning.subtitle": "Add samples with tests in Step 1 before proceeding",
  "collect.noTestsWarning.title": "No tests to collect",
  "collect.printMoreLabels.button": "Print More Labels",
  "collect.printMoreLabels.helper": "Print additional labels for this sample",
  "collect.requestedTests.info": "Tests requested for this order",
  "collect.requestedTests.title": "Requested Tests",
  "collect.sample.assignedTests": "Assigned Tests",
  "collect.sample.collectionConditions": "Collection Conditions",
  "collect.sample.collectionConditions.placeholder": "Note any special conditions...",
  "collect.sample.collectionDate": "Data recoltării",
  "collect.sample.collectionDate.helper": "Date when the sample was collected",
  "collect.sample.collectionTime": "Ora recoltării",
  "collect.sample.collector": "Recoltator",
  "collect.sample.header": "Sample {number}",
  "collect.sample.labPerformedSampling": "Lab performed sampling",
  "collect.sample.nce.link": "Raportează eveniment neconform",
  "collect.sample.noTests": "No tests assigned to this sample",
  "collect.sample.printLabels": "Print Labels",
  "collect.sample.quantity": "Quantity",
  "collect.sample.receivedAtLab": "Received at Lab",
  "collect.sample.receivedAtLab.helper": "Check if sample has been received at the laboratory",
  "collect.sample.receivedDate": "Dată primire",
  "collect.sample.receivedTime": "Received Time",
  "collect.sample.remove": "Șterge probă",
  "collect.samples.title": "Samples",
  "collect.table.compatibleTypes": "Compatible Sample Types",
  "collect.table.sampleAssignments": "Sample Assignments",
  "collect.table.testPanel": "Test/Panel",
  "heading.informedConsent.sectionTitle": "Informed Consent",
  "heading.informedConsent.auditRecord": "Consent Audit Record",
  "label.informedConsent.consentGiven": "Patient has provided signed consent",
  "label.informedConsent.formReference": "Consent Form Reference No.",
  "label.informedConsent.recordedBy": "Recorded by",
  "label.informedConsent.recordedAt": "Recorded on",
  "label.informedConsent.statusTag": "Consent Recorded",
  "label.informedConsent.notRecorded": "Not recorded",
  "placeholder.informedConsent.formReference": "e.g. CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "e.g. Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "Consent form reference must be 100 characters or fewer",
  "error.informedConsent.formReferenceInvalidChars": "Only letters, numbers, hyphens, and spaces are allowed",
  "coldstorage.label.dashboard": "Cold Storage Dashboard",
  "collection.date": "Data recoltării",
  "collector": "Recoltator",
  "collector.label": "Recoltator",
  "column.actions": "Actions",
  "column.name.accept": "Acceptă",
  "column.name.analyzerResult": "Rezultat analizor",
  "column.name.currentResult": "Rezultat curent",
  "column.name.ignore": "Ignoră",
  "column.name.normalRange": "Interval normal",
  "column.name.notes": "Note",
  "column.name.pastNotes": "Note anterioare",
  "column.name.qcDetail": "Detail",
  "column.name.qcStatus": "QC Status",
  "column.name.reject": "Respinge",
  "column.name.result": "Rezultat",
  "column.name.retest": "Retestează",
  "column.name.sampleInfo": "Informații probă",
  "column.name.sampleKind": "Sample Kind",
  "column.name.save": "Salvează",
  "column.name.statusPerRegulation": "Status — Per Regulation",
  "column.name.testDate": "Data testului",
  "column.name.testId": "ID test",
  "column.name.testName": "Nume test",
  "column.name.uncertainty": "U (k=2)",
  "common.properties.title": "Common Properties",
  "configuration.batch.test.reassignment": "Realocare și anulare teste în lot",
  "configuration.method": "Gestionează metode",
  "configuration.method.create": "Creează metodă nouă",
  "configuration.method.explain": "Creează, activează sau dezactivează metode",
  "configuration.method.rename": "Redenumește metode existente",
  "configuration.method.rename.explain": "Folosit pentru corectarea numelor metodelor",
  "configuration.panel.assign": "Alocare teste",
  "configuration.panel.assign.explain": "Selectează testele de reasociat la un alt panel făcând clic pe numele testului; acestea sunt afișate sub panelul curent.",
  "configuration.panel.confirmation.explain": "Acest panel nu va fi activ până când nu i se vor atribui teste.",
  "configuration.panel.create": "Creează panel nou",
  "configuration.panel.create.duplicate": "Există deja un panel cu acest nume. Anulați sau alegeți un nume diferit.",
  "configuration.panel.manage": "Gestionează paneluri",
  "configuration.panel.manage.explain": "Creează, ordonează și alocă teste la paneluri",
  "configuration.panel.order": "Setează ordinea panelurilor",
  "configuration.panel.order.explain": "Reordonează panelurile prin tragere.",
  "configuration.panel.order.explain.limits": "Doar panelurile cu teste atribuite pot fi ordonate. Pentru paneluri noi, atribuie teste înainte de a le ordona.",
  "configuration.panel.rename": "Redenumește paneluri existente",
  "configuration.panel.rename.explain": "Folosit pentru corectarea numelor panelurilor.",
  "configuration.sampleType.assign.explain": "Selectează testele de reasociat la un alt tip de probă făcând clic pe numele testului; acestea sunt afișate sub tipul curent.",
  "configuration.sampleType.assign.new.type": "Atribuie la tipul de probă",
  "configuration.sampleType.confirmation.explain": "Acest tip de probă nu va fi activ până când nu i se vor atribui teste.",
  "configuration.sampleType.create": "Creează tip de probă",
  "configuration.sampleType.create.duplicate": "Există deja un tip de probă cu acest nume. Te rugăm să anulezi sau să folosești un alt nume.",
  "configuration.sampleType.manage": "Gestionează tipuri de probe",
  "configuration.sampleType.manage.explain": "Folosiți pentru creare, ordonare și alocare teste la tipuri de probe",
  "configuration.sampleType.order": "Setează ordinea tipurilor de probe",
  "configuration.sampleType.order.explain": "Reordonează tipurile de probe prin tragere.",
  "configuration.sampleType.order.explain.limits": "Doar tipurile de probă cu teste atribuite pot fi ordonate. Pentru tipuri noi, atribuie teste înainte de a le ordona.",
  "configuration.selectList.add": "Adaugă listă rezultate",
  "configuration.selectList.add.alert": "Pentru modificarea denumirilor actuale, folosește Redenumește opțiuni rezultate",
  "configuration.selectList.add.explain": "Creează liste de selecție pentru rezultate",
  "configuration.selectList.assign.description": "Noua opțiune poate fi atribuită testelor sau salvată fără atribuiri. Selectează unul sau mai multe teste, apoi ajustează ordinea afișării. Dacă această opțiune este valoarea normală, bifează 'Normal'. Dacă dorești ca tehnicianul să introducă text suplimentar, bifează 'Calificabil'. De exemplu, dacă opțiunile sunt o listă de organisme și ultima este 'Altul', se poate introduce un organism care nu se află în listă.",
  "configuration.selectList.assign.header": "Atribuie noua opțiune testului",
  "configuration.selectList.assign.new": "Opțiune nouă listă selectabilă",
  "configuration.selectList.confirmChange": "Valoarea normală va fi schimbată din %oldvalue% în %newvalue%. Sigur dorești să continui?",
  "configuration.selectList.description": "Introdu traducerea în engleză și franceză pentru opțiunea nouă. Dacă nu cunoști traducerea, se va folosi termenul introdus pentru ambele limbi.",
  "configuration.selectList.header": "Creează opțiune nouă de selecție rezultat",
  "configuration.selectList.rename": "Redenumește opțiuni existente ale listei de rezultate",
  "configuration.selectList.rename.explain": "Redenumește opțiuni existente în lista de rezultate",
  "configuration.test.activate": "Activează/Dezactivează teste",
  "configuration.test.activate.explain": "Folosește pentru activarea sau dezactivarea unui test existent.",
  "configuration.test.add": "Adaugă teste noi",
  "configuration.test.add.explain": "Adaugă teste noi în sistem. Modificările testelor existente se fac în secțiunile dedicate.",
  "configuration.test.catalog": "Vizualizează catalog teste",
  "configuration.test.catalog.explain": "Vizualizează catalogul actual de teste",
  "configuration.test.management.ocl": "OCL Concept Import",
  "configuration.test.management.organization": "Organizarea testelor",
  "configuration.test.management.spelling": "Corectarea denumirilor",
  "configuration.test.modify": "Modifică teste",
  "configuration.test.modify.explain": "Modifică teste existente în sistem.",
  "configuration.test.modify.tab.configuration": "Configuration",
  "configuration.test.modify.tab.compliance": "Compliance Thresholds",
  "configuration.test.modify.filter.instruction": "Select a Sample Type or Test Section to display tests.",
  "configuration.test.modify.filter.noTestsFound": "No tests found matching the selected criteria.",
  "configuration.test.modify.filter.selectToBegin": "Please select a Sample Type or Test Section to begin viewing tests.",
  "configuration.test.orderable": "Activează/dezactivează posibilitatea de comandare a testului",
  "configuration.test.orderable.explain": "Testele comandabile pot fi alese la recepție. Altele pot fi generate doar ca reflex.",
  "configuration.test.rename": "Redenumește teste existente",
  "configuration.test.rename.explain": "Redenumește testele doar pentru afișare, fără a le modifica.",
  "configuration.testSection.rename": "Redenumește secțiuni de test",
  "configuration.testSection.rename.explain": "Folosit pentru corectarea denumirii secțiunilor de test.",
  "configuration.testUnit.assign.new.unit": "Atribuie la secțiunea de test",
  "configuration.testUnit.confirmation.explain": "Această unitate de testare nu va fi activă până când nu i se vor atribui teste.",
  "configuration.testUnit.create": "Creează unitate de testare",
  "configuration.testUnit.create.duplicate": "Există deja o unitate de testare cu acest nume. Te rugăm să anulezi sau să folosești un alt nume.",
  "configuration.testUnit.manage": "Gestionează unitățile de testare",
  "configuration.testUnit.manage.explain": "Creează, ordonează și alocă teste unităților de testare",
  "configuration.testUnit.order": "Setează ordinea unităților de testare",
  "configuration.testUnit.order.explain": "Reordonează unitățile de laborator prin drag & drop.",
  "configuration.testUnit.order.explain.limits": "Doar secțiunile de testare cu teste atribuite pot fi ordonate. Pentru secțiuni noi, atribuie teste înainte de a le ordona.",
  "configuration.type.rename": "Redenumește tipuri de probe",
  "configuration.type.rename.explain": "Folosit pentru corectarea numelor panelurilor existente.",
  "heading.sampleType.management": "Sample Type Editor",
  "heading.sampleType.subtitle": "Configure sample types, display order, test associations, and domain classification.",
  "heading.sampleType.editing": "Editing: {name}",
  "label.sampleType.domain": "Sample Domain",
  "label.domain.CLINICAL": "Clinical",
  "label.domain.ENVIRONMENTAL": "Environmental",
  "label.domain.VECTOR": "Vector",
  "label.sampleType.domain.clinical": "Clinical",
  "label.sampleType.domain.environmental": "Environmental",
  "label.sampleType.domain.helper": "Determines which workflow mode (Clinical or Environmental) this sample type appears in.",
  "label.sampleType.filterDomain": "Filter by domain",
  "label.sampleType.testCount": "Teste",
  "label.sampleType.actions": "Actions",
  "label.sampleType.status": "Stare",
  "placeholder.sampleType.search": "Search sample types...",
  "placeholder.sampleType.filter.domain": "All domains",
  "button.sampleType.add": "Add Sample Type",
  "configuration.uom.create": "Creează unitate de măsură",
  "configuration.uom.manage": "Gestionează unități de măsură",
  "configuration.uom.manage.explain": "Folosește pentru a crea unități de măsură",
  "configuration.uom.rename": "Redenumește unități de măsură existente",
  "configuration.uom.rename.explain": "Folosit pentru corectarea numelor unităților de măsură.",
  "configure.labNumber.title": "Management număr laborator",
  "confirmation.rename": "Confirmă modificările de mai sus.",
  "currentests.title": "Teste curente",
  "customFieldType.page.hierarchy.management": "Custom Field Types",
  "customFieldType.page.hierarchy.root": "System Administration",
  "cytology.label.cellabnomality": "Anomalii celule epiteliale",
  "cytology.label.confirmSelect": "Dacă selectezi această opțiune, toate informațiile actuale despre diagnostic vor fi eliminate",
  "cytology.label.dashboard": "Tablou de bord Citologie",
  "cytology.label.glandular": "Glandulare",
  "cytology.label.negative": "Negativ pentru leziuni intraepiteliale sau malignitate",
  "cytology.label.neoplastic": "Variații celulare non-neoplazice",
  "cytology.label.organisms": "Organisme",
  "cytology.label.other": "Alte neoplasme maligne",
  "cytology.label.otherResult": "Alte rezultate de diagnostic",
  "cytology.label.reactive": "Modificări celulare reactive",
  "cytology.label.review": "În așteptarea revizuirii citopatologului",
  "cytology.label.specimen": "Adecvare specimen",
  "cytology.label.squamous": "Celule scuamoase",
  "cytology.label.title": "Citologie",
  "dashboard.avg.turn.around.label": "Timp mediu de răspuns",
  "dashboard.avg.turn.around.reception.to.result.label": "Reception To Result Average Time",
  "dashboard.avg.turn.around.reception.to.validation.label": "Reception To Validation Average Time",
  "dashboard.avg.turn.around.result.to.validation.label": "Result To Validation Average Time",
  "dashboard.avg.turn.around.subtitle.label": "Recepție până la validare",
  "dashboard.complete.orders.label": "Comenzi finalizate astăzi",
  "dashboard.in.progress.label": "În desfășurare",
  "dashboard.in.progress.subtitle.label": "În așteptarea introducerii rezultatului",
  "dashboard.partially.completed.label": "Finalizat parțial astăzi",
  "dashboard.partially.completed.subtitle.label": "Awaiting Remaining Tests",
  "dashboard.rejected.orders": "Comenzi respinse",
  "dashboard.turn.around.label": "Timp de răspuns întârziat",
  "dashboard.turn.around.subtitle.label": "Peste 96 de ore",
  "dashboard.unprints.results.label": "Rezultate neimprimate",
  "dashboard.user.orders.label": "Comenzi introduse de utilizatori",
  "dashboard.user.orders.today.label": "Comenzi introduse de utilizatori azi",
  "dashboard.validation.ready.label": "Gata pentru validare",
  "dashboard.validation.ready.subtitle.label": "În așteptarea revizuirii",
  "dataexport.status.actions": "Actions",
  "dataexport.status.attempt.duration": "Duration",
  "dataexport.status.attempt.endTime": "End Time",
  "dataexport.status.attempt.startTime": "Start Time",
  "dataexport.status.attempt.status": "Stare",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No FHIR subscribers are configured. Set org.openelisglobal.fhir.subscriber in common.properties and restart the server to register one.",
  "dataexport.status.endpoint": "Endpoint",
  "dataexport.status.failed24h": "Failed / Total (24h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Retry Interval",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Last Attempt",
  "dataexport.status.lastRefreshed": "Last refreshed",
  "dataexport.status.lastStatus": "Last Status",
  "dataexport.status.lastSuccess": "Last Success",
  "dataexport.status.loadingAttempts": "Loading attempt history…",
  "dataexport.status.never": "Never",
  "dataexport.status.noAttempts": "No attempts yet",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Refresh",
  "dataexport.status.retry": "Retry now",
  "dataexport.status.retryInFlight": "Triggering…",
  "dataexport.status.title": "FHIR Data Export Status",
  "datasubmission.siteid": "ID site",
  "database.clean": "Database Cleaning",
  "database.clean.button": "Clean Database",
  "database.clean.confirm.message": "Are you sure you want to clean the database? This will remove all patient and test data.",
  "database.clean.confirm.title": "Confirm Database Cleaning",
  "database.clean.confirm.warning": "This action cannot be undone!",
  "database.clean.error": "Failed to clean the database.",
  "database.clean.not.training": "Database cleaning is only available on training installations.",
  "database.clean.success": "Database cleaned successfully.",
  "database.clean.warning": "This will permanently delete all patient data, sample data, and results from the database.",
  "date.created": "Date Created",
  "datepicker.placeholder.dmy": "dd/mm/yyyy",
  "datepicker.placeholder.mdy": "mm/dd/yyyy",
  "delete.error.msg": "Eroare la ștergere",
  "delete.success.msg": "Șters cu succes",
  "description.active": "Dacă testul este activ poate fi comandat. Altfel, nu poate fi comandat sau inclus în algoritmi",
  "description.ageRange": "Dacă vârsta (în luni) influențează valorile, se va menționa aici",
  "description.name": "Numele testului așa cum va apărea în openELIS. Se afișează atât în engleză cât și în franceză",
  "description.normalRange": "Orice rezultat numeric în acest interval este considerat normal pentru o persoană sănătoasă",
  "description.note": "n/a înseamnă indisponibil. Valoarea nu este specificată",
  "description.orderable": "Dacă testul este activ și comandabil, va fi în formular. Dacă este doar activ, se face doar ca reflex",
  "description.panel": "Dacă testul face parte dintr-un panel, acesta va fi afișat aici",
  "description.referenceValue": "Valoare considerată normală pentru o persoană sănătoasă (doar la liste de selecție)",
  "description.reportName": "Numele testului în rapoarte. Se afișează în engleză și franceză",
  "description.resultLimits": "Limitele normalului și validității pentru teste numerice, pot depinde de vârstă și sex",
  "description.resultType": "Tipul rezultatului testului:",
  "description.resultType.alphanumeric": "A - Alfanumeric:",
  "description.resultType.alphanumericDesc": "Acceptă text sau numere. Nu se evaluează față de interval",
  "description.resultType.cascadingMultiSelectList": "C - Listă multi-select în cascadă:",
  "description.resultType.cascadingMultiSelectListDesc": "Similar cu multi-select, dar pe grupe multiple",
  "description.resultType.kind": "Tipul rezultatului testului:",
  "description.resultType.multiSelectList": "M - Listă multi-select:",
  "description.resultType.multiSelectListDesc": "Se pot selecta mai multe opțiuni. Fără valoare de referință",
  "description.resultType.numeric": "N - Numeric:",
  "description.resultType.numericDesc": "Acceptă doar numere. Se poate evalua dacă este în intervalul normal/valid",
  "description.resultType.selectList": "D - Listă selectabilă:",
  "description.resultType.selectListDesc": "Utilizatorul alege din listă. Valoarea de referință este definită",
  "description.resultType.textArea": "R - Text liber:",
  "description.resultType.textAreaDesc": "Acceptă până la 200 caractere. Nu se evaluează",
  "description.sampleType": "Tipul de probă pe care se poate efectua testul. Dacă poate fi selectat de utilizator, va fi marcat ca atare",
  "description.selectValues": "Pentru liste de selecție, valorile disponibile. Dacă este calificabilă, se poate introduce text adițional",
  "description.sex": "Dacă sexul influențează valorile, se va specifica aici",
  "description.significantDigits": "Număr de zecimale semnificative afișate în rezultat și interval",
  "description.testUnit": "Secțiunea laboratorului care efectuează testul",
  "description.uom": "Unitatea de măsură a rezultatului (doar pentru valori numerice/alfa)",
  "description.validRange": "Orice rezultat numeric în afara acestui interval poate indica un test efectuat incorect",
  "dictionary.category.isActive": "Este activ",
  "dictionary.category.label": "Dictionary Category",
  "dictionary.category.localAbbreviation": "Abreviere locală",
  "dictionary.category.name": "Categorie",
  "dictionary.dictEntry": "Intrare în dicționar",
  "dictionary.label.modify": "Meniu dicționar",
  "dictionary.loincCode": "Cod LOINC",
  "dictionary.loincCode.help": "Introduceți identificatorul LOINC standard",
  "dictionary.loincCode.helpText": "Identificator standard pentru observații de laborator",
  "dictionary.loincCode.invalid": " Format LOINC invalid (exemplu valid: 12345-6 sau LP12345-6)",
  "dictionary.loincCode.placeholder": "ex: 12345-6",
  "dictionary.menu.deactivate.fail": "Dezactivarea meniului dicționarului a eșuat",
  "dictionary.menu.deactivate.success": "Meniul dicționarului a fost dezactivat cu succes",
  "dictionary.modal.add.heading": "Add Dictionary",
  "dictionary.modal.edit.heading": "Edit Dictionary",
  "dictionary.number.label": "Dictionary Number",
  "disposal.button": "Dispose Lot",
  "disposal.notes": "Disposal Notes",
  "disposal.notes.placeholder": "Provide details about disposal (disposal method, witness, etc.)",
  "disposal.reason": "Disposal Reason",
  "disposal.reason.select": "Select reason",
  "disposal.success": "Lot disposed successfully",
  "disposal.title": "Dispose Lot",
  "disposal.warning.message": "This action cannot be undone. The lot will be marked as disposed and removed from active inventory.",
  "disposal.warning.title": "Warning",
  "edit.add.program.title": "Adaugă/Editează program",
  "emergencyContactInfo.title": "Informații contact de urgență",
  "english.current": "ENGLEZĂ curent",
  "english.label": "Engleză",
  "enterText.label": "Introdu text",
  "eorder.allInfo": "Toate informațiile",
  "eorder.button.editOrder": "Editați comanda",
  "eorder.button.enterOrder": "Introduceți comanda",
  "eorder.buttons": " ",
  "eorder.date.end": "Data de sfârșit",
  "eorder.date.start": "Data de început",
  "eorder.facility.requesting": "Instituție solicitantă",
  "eorder.header": "Căutare cereri de teste primite",
  "eorder.id.national": "CNP",
  "eorder.id.subjectNumber": "Număr subiect",
  "eorder.instructions.enter1": "Cererile de testare care se potrivesc - În meniul ",
  "eorder.instructions.enter2": " adăugați un număr de laborator și selectați ",
  "eorder.instructions.enter3": " pentru a accepta comanda așa cum este sau selectați ",
  "eorder.instructions.enter4": " pentru a face modificări",
  "eorder.labNumber": "Număr laborator",
  "eorder.labnumber.referring": "Număr laborator trimitere",
  "eorder.name.first": "Prenume",
  "eorder.name.last": "Nume",
  "eorder.passport.number": "Număr pașaport",
  "eorder.priority": "Prioritate",
  "eorder.requestDate": "Data solicitării",
  "eorder.search.noresults": "Nu există comenzi electronice",
  "eorder.search1.text": "Căutare după numele de familie, CNP, număr laborator trimitere sau număr pașaport",
  "eorder.search2.text": "Căutare după dată și stare. Introduceți intervalul de date pentru cererile de testare. Se va căuta după data trimiterii sau data comenzii electronice",
  "eorder.searchValue": "Valoare căutare",
  "eorder.status": "Stare",
  "eorder.test.name": "Nume test",
  "eqa.action.deactivate": "Dezactivează",
  "eqa.action.edit": "Editează",
  "eqa.action.enterResults": "Enter Results",
  "eqa.action.enterViewResults": "Enter/View Results",
  "eqa.action.reactivate": "Reactivate",
  "eqa.action.viewOrder": "View Order",
  "eqa.action.viewResults": "View Results",
  "eqa.admin.addProgram": "Add Program",
  "eqa.admin.col.actions": "Actions",
  "eqa.admin.col.category": "Categorie",
  "eqa.admin.col.frequency": "Frequency",
  "eqa.admin.col.participants": "Enrolled Participants",
  "eqa.admin.col.programName": "Nume program",
  "eqa.admin.col.provider": "Furnizor",
  "eqa.admin.delete": "Delete",
  "eqa.admin.form.addHeading": "Add New EQA Program",
  "eqa.admin.form.category.placeholder": "Select category",
  "eqa.admin.form.description.placeholder": "Program description and objectives...",
  "eqa.admin.form.editHeading": "Edit EQA Program",
  "eqa.admin.form.frequency.placeholder": "Select frequency",
  "eqa.admin.form.name.placeholder": "e.g., TB Culture & Sensitivity",
  "eqa.admin.form.provider.placeholder": "Select provider",
  "eqa.admin.form.subtitle": "Enroll in a new external quality assessment program",
  "eqa.admin.programs.subtitle": "Manage enrolled EQA programs and providers",
  "eqa.admin.programs.title": "EQA Programs",
  "eqa.admin.provider.placeholder": "e.g., WHO, CDC, CAP",
  "eqa.admin.subtitle": "Manage EQA programs, users, and system settings",
  "eqa.admin.systemSettings.placeholder": "System settings coming soon.",
  "eqa.admin.tab.participants": "Participants",
  "eqa.admin.tab.programs": "EQA Programs",
  "eqa.admin.tab.systemSettings": "System Settings",
  "eqa.admin.tab.userManagement": "Management utilizatori",
  "eqa.admin.tile.acrossAllPrograms": "Across all programs",
  "eqa.admin.tile.activePrograms": "Active Programs",
  "eqa.admin.tile.canManageEqa": "Can manage EQA",
  "eqa.admin.tile.enrolledParticipants": "Enrolled Participants",
  "eqa.admin.tile.systemUsers": "System Users",
  "eqa.admin.tile.totalParticipants": "Total Participants",
  "eqa.admin.tile.totalPrograms": "{count} total programs",
  "eqa.admin.title": "Program Administration",
  "eqa.admin.userManagement.placeholder": "User management coming soon.",
  "eqa.column.actions": "Actions",
  "eqa.deadline.label": "Testing Deadline",
  "eqa.distribution.action.continue": "Continue",
  "eqa.distribution.action.ship": "Ship",
  "eqa.distribution.action.track": "Track",
  "eqa.distribution.action.viewReport": "Vezi raportul",
  "eqa.distribution.advance": "Advance Status",
  "eqa.distribution.backToDashboard": "Back to Distributions",
  "eqa.distribution.barcodes": "Generate Barcodes",
  "eqa.distribution.col.actions": "Actions",
  "eqa.distribution.col.deadline": "Deadline",
  "eqa.distribution.col.participants": "Participants",
  "eqa.distribution.col.program": "Program",
  "eqa.distribution.col.responses": "Responses",
  "eqa.distribution.col.round": "Round",
  "eqa.distribution.col.samples": "Samples",
  "eqa.distribution.col.shipmentId": "Shipment ID",
  "eqa.distribution.col.status": "Stare",
  "eqa.distribution.create": "Create Distribution",
  "eqa.distribution.createError": "Failed to create distribution.",
  "eqa.distribution.createShipment": "Create New Shipment",
  "eqa.distribution.createSuccess": "Distribution created successfully.",
  "eqa.distribution.dashboard.subtitle": "Distribute EQA samples to participating laboratories",
  "eqa.distribution.dashboard.title": "EQA Distribution",
  "eqa.distribution.deadline": "Submission Deadline",
  "eqa.distribution.detail.title": "Distribution Details",
  "eqa.distribution.empty": "No distributions found",
  "eqa.distribution.filter.allShipments": "All Shipments",
  "eqa.distribution.filter.program": "Filter by Program",
  "eqa.distribution.filter.status": "Filter by Status",
  "eqa.distribution.list.title": "EQA Distributions",
  "eqa.distribution.manageParticipants": "Manage Participants",
  "eqa.distribution.name": "Distribution Name",
  "eqa.distribution.name.placeholder": "e.g., Round 1 - Chemistry 2026",
  "eqa.distribution.network.active": "Active Participants",
  "eqa.distribution.network.active.sub": "Currently enrolled",
  "eqa.distribution.network.responseRate": "Average Response Rate",
  "eqa.distribution.network.responseRate.sub": "Last 4 quarters",
  "eqa.distribution.network.subtitle": "Overview of enrolled participating laboratories",
  "eqa.distribution.network.title": "Participant Network",
  "eqa.distribution.network.total": "Total Participants",
  "eqa.distribution.network.total.sub": "Across all countries",
  "eqa.distribution.participants": "Participant Organizations",
  "eqa.distribution.participants.min": "At least 2 participant organizations are required",
  "eqa.distribution.participants.none": "No organizations are currently enrolled in the selected programme. Enrol participants before creating a distribution.",
  "eqa.distribution.participants.select": "Select organizations",
  "eqa.distribution.program": "EQA Program",
  "eqa.distribution.program.select": "Select a program",
  "eqa.distribution.responseRate": "response rate",
  "eqa.distribution.shipments.subtitle": "Track distributed EQA samples and participant responses",
  "eqa.distribution.shipments.title": "EQA Shipments",
  "eqa.distribution.shipped": "Shipped",
  "eqa.distribution.status.completed": "Completed",
  "eqa.distribution.status.draft": "Draft",
  "eqa.distribution.status.prepared": "Prepared",
  "eqa.distribution.status.shipped": "Shipped",
  "eqa.distribution.step.confirmation": "Confirmare",
  "eqa.distribution.step.details": "Program & Details",
  "eqa.distribution.step.participants": "Participants",
  "eqa.distribution.summary.completed": "Completed",
  "eqa.distribution.summary.completed.sub": "All responses received",
  "eqa.distribution.summary.draft": "Draft Shipments",
  "eqa.distribution.summary.draft.sub": "Being prepared",
  "eqa.distribution.summary.participants": "Participants",
  "eqa.distribution.summary.participants.sub": "Enrolled",
  "eqa.distribution.summary.shipped": "Shipped",
  "eqa.distribution.summary.shipped.sub": "Awaiting responses",
  "eqa.enrollment.allStatuses": "All Statuses",
  "eqa.enrollment.alreadyEnrolled": "Already Enrolled",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organization(s) already enrolled",
  "eqa.enrollment.confirmWithdraw": "Confirm Withdrawal",
  "eqa.enrollment.created.success": "Program enrollment created successfully",
  "eqa.enrollment.deactivated": "Program enrollment deactivated",
  "eqa.enrollment.description": "Descriere",
  "eqa.enrollment.district": "District",
  "eqa.enrollment.editing": "Editing: {name}",
  "eqa.enrollment.empty": "No enrollments found for this program",
  "eqa.enrollment.enroll": "Enroll",
  "eqa.enrollment.enrollParticipant": "Enroll Participant",
  "eqa.enrollment.enrollSelected": "Enroll Selected",
  "eqa.enrollment.enrollmentDate": "Enrollment Date",
  "eqa.enrollment.labUnits": "Lab Units",
  "eqa.enrollment.new": "New EQA Program Enrollment",
  "eqa.enrollment.organizationCode": "Organization Code",
  "eqa.enrollment.organizationName": "Organization Name",
  "eqa.enrollment.panels": "Paneluri",
  "eqa.enrollment.programName": "Nume program",
  "eqa.enrollment.programName.placeholder": "Enter program name",
  "eqa.enrollment.provider": "Furnizor",
  "eqa.enrollment.provider.placeholder": "Enter provider name",
  "eqa.enrollment.reactivate": "Reactivate",
  "eqa.enrollment.reactivated": "Program enrollment reactivated",
  "eqa.enrollment.save": "Save Enrollment",
  "eqa.enrollment.saveChanges": "Save Changes",
  "eqa.enrollment.searchOrgs": "Search organizations...",
  "eqa.enrollment.searchPlaceholder": "Search by organization name or code...",
  "eqa.enrollment.selectLabUnits": "Select lab units...",
  "eqa.enrollment.selectOrg": "Select an organization...",
  "eqa.enrollment.selectOrgsPrompt": "Select organizations to enroll",
  "eqa.enrollment.selectPanels": "Select panels...",
  "eqa.enrollment.selectProgram": "Select Program",
  "eqa.enrollment.selectProgramPrompt": "Select a program to view enrollments",
  "eqa.enrollment.selectTests": "Select tests...",
  "eqa.enrollment.selected": "selected",
  "eqa.enrollment.status": "Stare",
  "eqa.enrollment.status.active": "Activ",
  "eqa.enrollment.status.suspended": "Suspended",
  "eqa.enrollment.status.withdrawn": "Withdrawn",
  "eqa.enrollment.success": "Enrollment successful",
  "eqa.enrollment.suspend": "Suspend",
  "eqa.enrollment.tests": "Teste",
  "eqa.enrollment.thisLab": "This Lab",
  "eqa.enrollment.updated.success": "Program enrollment updated successfully",
  "eqa.enrollment.withdraw": "Withdraw",
  "eqa.enrollment.withdrawReason": "Reason for Withdrawal",
  "eqa.enrollment.withdrawReasonPlaceholder": "Provide a reason for withdrawing this participant...",
  "eqa.filter.allPriorities": "All Priorities",
  "eqa.filter.allPrograms": "All Programs",
  "eqa.filter.allStatuses": "All Statuses",
  "eqa.filter.eqaOnly": "EQA Samples Only",
  "eqa.filter.priority": "Prioritate",
  "eqa.filter.program": "Program",
  "eqa.filter.status": "Stare",
  "eqa.management.action.enterResults": "Enter Results",
  "eqa.management.action.submit": "Trimite",
  "eqa.management.bulkUpload": "Bulk Upload Results",
  "eqa.management.col.accession": "Accession #",
  "eqa.management.col.actions": "Actions",
  "eqa.management.col.deadline": "Deadline",
  "eqa.management.col.progress": "Progress",
  "eqa.management.col.provider": "Provider/Program",
  "eqa.management.col.sampleId": "Sample ID",
  "eqa.management.col.status": "Stare",
  "eqa.management.daysLeft": "days left",
  "eqa.management.distributions.title": "Distributions",
  "eqa.management.filter.allSamples": "All Samples",
  "eqa.management.overdue": "Overdue",
  "eqa.management.participants.subtitle": "Manage organization enrollment in EQA programs",
  "eqa.management.participants.title": "Participants",
  "eqa.management.performance.onTime": "On-Time Submission",
  "eqa.management.performance.participation": "Participation Rate",
  "eqa.management.performance.participation.sub": "All programs enrolled",
  "eqa.management.performance.subtitle": "Your laboratory's EQA performance metrics",
  "eqa.management.performance.title": "Performance Summary",
  "eqa.management.performance.zScore": "Average Z-Score",
  "eqa.management.performance.zScore.sub": "Within acceptable range",
  "eqa.management.programs.subtitle": "Manage programs distributed by this laboratory",
  "eqa.management.programs.title": "EQA Programs",
  "eqa.management.results.title": "Results & Analysis",
  "eqa.management.samples.empty": "No EQA samples found",
  "eqa.management.samples.subtitle": "Manage received EQA samples and submit results",
  "eqa.management.samples.title": "EQA Samples",
  "eqa.management.status.completed": "Completed",
  "eqa.management.status.completed.sub": "Ready to submit",
  "eqa.management.status.inProgress": "În desfășurare",
  "eqa.management.status.inProgress.sub": "Testing in progress",
  "eqa.management.status.in_progress": "În desfășurare",
  "eqa.management.status.overdue": "Overdue",
  "eqa.management.status.pending": "Pending",
  "eqa.management.status.pending.sub": "Not started",
  "eqa.management.status.submitted": "Submitted",
  "eqa.management.status.submitted.sub": "Results sent",
  "eqa.management.subtitle": "Receive and manage EQA samples from external providers",
  "eqa.management.title": "EQA Management",
  "eqa.management.viewPerformance": "View Performance",
  "eqa.myProgram.helperText": "Selecting an enrollment pre-populates tests and panels",
  "eqa.myProgram.label": "My Program Enrollment",
  "eqa.myProgram.prePopulated.subtitle": "{tests} tests and {panels} panels pre-selected from enrollment",
  "eqa.myProgram.prePopulated.title": "Tests/panels pre-populated",
  "eqa.myProgram.select": "Select enrollment to pre-populate tests...",
  "eqa.myPrograms.action.deactivate": "Dezactivează",
  "eqa.myPrograms.action.edit": "Editează",
  "eqa.myPrograms.action.reactivate": "Reactivate",
  "eqa.myPrograms.description": "Descriere",
  "eqa.myPrograms.enrollButton": "Enroll in Program",
  "eqa.myPrograms.enrollInProgram": "Enroll in Program",
  "eqa.myPrograms.labUnits": "Lab Unit(s)",
  "eqa.myPrograms.panels": "Paneluri",
  "eqa.myPrograms.programName": "Nume program",
  "eqa.myPrograms.provider": "Furnizor",
  "eqa.myPrograms.search.placeholder": "Search programs...",
  "eqa.myPrograms.status": "Stare",
  "eqa.myPrograms.status.active": "Activ",
  "eqa.myPrograms.status.inactive": "Inactive",
  "eqa.myPrograms.subtitle": "Programs this laboratory participates in",
  "eqa.myPrograms.testMapping": "Test Mapping (Optional)",
  "eqa.myPrograms.testMappingHint": "Select tests and panels to pre-populate Order Entry when this program is selected",
  "eqa.myPrograms.tests": "Teste",
  "eqa.myPrograms.title": "My EQA Programs",
  "eqa.order.deadline": "Result Deadline",
  "eqa.order.form.title": "EQA Sample Information",
  "eqa.order.participantId": "Participant ID",
  "eqa.order.priority": "EQA Priority",
  "eqa.order.programme": "Programme",
  "eqa.order.provider": "Furnizor",
  "eqa.order.providerSampleId": "Provider Sample ID",
  "eqa.orders.completedThisMonth": "Completed This Month",
  "eqa.orders.enterNewTest": "Enter New EQA Test",
  "eqa.orders.inProgress": "În desfășurare",
  "eqa.orders.overdue": "Overdue",
  "eqa.orders.pending": "Pending",
  "eqa.orders.search.placeholder": "Search by lab number or program...",
  "eqa.participant.id": "Participant ID",
  "eqa.priority.critical": "Critical",
  "eqa.priority.label": "Prioritate",
  "eqa.priority.standard": "Standard",
  "eqa.priority.urgent": "Urgent",
  "eqa.program.activate": "Activate",
  "eqa.program.active": "Activ",
  "eqa.program.addProgram": "Add Program",
  "eqa.program.cancel": "Anulează",
  "eqa.program.create": "Create Program",
  "eqa.program.createTitle": "Create EQA Program",
  "eqa.program.deactivate": "Dezactivează",
  "eqa.program.description": "Descriere",
  "eqa.program.description.placeholder": "Describe the EQA program...",
  "eqa.program.edit": "Edit Program",
  "eqa.program.editTitle": "Edit EQA Program",
  "eqa.program.empty": "No EQA programs found",
  "eqa.program.inactive": "Inactive",
  "eqa.program.label": "EQA Program",
  "eqa.program.management.title": "EQA Program Management",
  "eqa.program.name": "Nume program",
  "eqa.program.name.placeholder": "e.g., Chemistry Proficiency Testing",
  "eqa.program.name.required": "Program name is required",
  "eqa.program.provider.required": "Provider is required",
  "eqa.program.participantCount": "Enrolled Participants",
  "eqa.program.provider": "Furnizor",
  "eqa.program.required": "EQA Program is required when registering an EQA sample",
  "eqa.program.save": "Save Program",
  "eqa.program.select": "Select EQA Program",
  "eqa.program.status": "Stare",
  "eqa.program.tests": "Assigned Tests",
  "eqa.program.tests.assign": "Assign Tests",
  "eqa.program.tests.select": "Select tests to assign",
  "eqa.provider.label": "EQA Provider Organization",
  "eqa.provider.sampleId": "Provider Sample ID",
  "eqa.provider.select": "Select EQA Provider",
  "eqa.results.acceptable": "Acceptable",
  "eqa.results.batch.import": "Batch Import",
  "eqa.results.col.deadline": "Deadline",
  "eqa.results.col.labNumber": "Număr laborator",
  "eqa.results.col.priority": "Prioritate",
  "eqa.results.col.programme": "Programme",
  "eqa.results.col.provider": "Furnizor",
  "eqa.results.col.status": "Stare",
  "eqa.results.import.confirm": "Confirm Import",
  "eqa.results.import.errors": "{count} rows had errors",
  "eqa.results.import.success": "{count} results imported successfully",
  "eqa.results.import.upload": "Upload CSV File",
  "eqa.results.manual.entry": "Manual Result Entry",
  "eqa.results.mean": "Mean",
  "eqa.results.minimum.participants": "Minimum 5 participants required for statistical analysis",
  "eqa.results.noResults": "No EQA test results found.",
  "eqa.results.organization": "Organization",
  "eqa.results.organization.select": "Select organization",
  "eqa.results.participant.count": "Participant Count",
  "eqa.results.performance": "Performance",
  "eqa.results.questionable": "Questionable",
  "eqa.results.report.downloading": "Downloading report...",
  "eqa.results.report.generate": "Generează raport",
  "eqa.results.search.placeholder": "Search by lab number, programme, or provider...",
  "eqa.results.standardDeviation": "Standard Deviation",
  "eqa.results.statistics": "Statistics",
  "eqa.results.submit": "Submit Result",
  "eqa.results.test": "Analiză",
  "eqa.results.test.select": "Select test",
  "eqa.results.title": "EQA Results & Analysis",
  "eqa.results.unacceptable": "Unacceptable",
  "eqa.results.value": "Result Value",
  "eqa.results.zscore": "Z-Score",
  "eqa.sample.badge": "EQA",
  "eqa.sample.checkbox": "EQA Sample",
  "eqa.sample.checkbox.helper": "Check if this is an External Quality Assurance sample",
  "eqa.sample.demographics.disabled": "Demographics disabled for EQA samples",
  "eqa.sample.patient.readonly.body": "Patient demographic fields are automatically set for EQA samples and cannot be edited.",
  "eqa.sample.patient.readonly.title": "EQA Sample — Patient Info Locked",
  "eqa.section.title": "EQA Sample Details",
  "eqa.settings.integration.apiKey": "API Key",
  "eqa.settings.integration.apiUrl": "API Base URL",
  "eqa.settings.integration.fhir": "FHIR API Integration",
  "eqa.settings.integration.fhir.desc": "Enable FHIR R4 API for external EQA data exchange",
  "eqa.settings.integration.subtitle": "Configure external system integrations",
  "eqa.settings.integration.title": "Integration Settings",
  "eqa.settings.loading": "Loading settings...",
  "eqa.settings.notifications.email": "Email Notifications",
  "eqa.settings.notifications.email.desc": "Send email notifications for critical alerts and deadlines",
  "eqa.settings.notifications.eqaDeadline": "EQA Deadline Alerts",
  "eqa.settings.notifications.eqaDeadline.desc": "Receive alerts when EQA submission deadlines are approaching",
  "eqa.settings.notifications.stat": "STAT Order Alerts",
  "eqa.settings.notifications.stat.desc": "Alert when STAT orders are overdue",
  "eqa.settings.notifications.subtitle": "Configure alert and notification preferences",
  "eqa.settings.notifications.threshold": "Alert Threshold (days before deadline)",
  "eqa.settings.notifications.title": "Notification Settings",
  "eqa.settings.performance.autoZScore": "Automatic Z-Score Calculation",
  "eqa.settings.performance.autoZScore.desc": "Automatically calculate Z-Scores when results are submitted",
  "eqa.settings.performance.generateReports": "Generate Performance Reports",
  "eqa.settings.performance.generateReports.desc": "Automatically generate performance reports after each round",
  "eqa.settings.performance.subtitle": "Configure EQA performance analysis parameters",
  "eqa.settings.performance.title": "Performance Analysis",
  "eqa.settings.performance.zScoreMax": "Maximum Acceptable Z-Score",
  "eqa.settings.performance.zScoreMin": "Minimum Acceptable Z-Score",
  "eqa.settings.saveError": "Failed to save settings",
  "eqa.settings.saveSuccess": "Settings saved successfully",
  "eqa.settings.saving": "Saving...",
  "eqa.status.active": "Activ",
  "eqa.status.completed": "Completed",
  "eqa.status.inProgress": "În desfășurare",
  "eqa.status.inactive": "Inactive",
  "eqa.status.inprogress": "În desfășurare",
  "eqa.status.overdue": "Overdue",
  "eqa.status.pending": "Pending",
  "eqa.submission.audit": "Submission Audit Trail",
  "eqa.submission.date": "Submission Date",
  "eqa.submission.error": "Submission failed",
  "eqa.submission.fhir": "Submit via FHIR",
  "eqa.submission.fhir.description": "Submit results to external EQA provider via FHIR R4",
  "eqa.submission.late.approve": "Approve Late Submission",
  "eqa.submission.late.justification": "Justification for Late Submission",
  "eqa.submission.late.justification.placeholder": "Provide reason for late submission...",
  "eqa.submission.late.supervisor": "Supervisor User ID",
  "eqa.submission.late.warning": "Submission deadline has passed. Supervisor approval is required.",
  "eqa.submission.method": "Submission Method",
  "eqa.submission.success": "Results submitted successfully",
  "eqa.submission.title": "Result Submission",
  "eqa.tests.action.enterResults": "Enter Results",
  "eqa.tests.action.viewOrder": "View Order",
  "eqa.tests.action.viewResults": "View Results",
  "eqa.tests.dateEntered": "Date Entered",
  "eqa.tests.deadline": "Deadline",
  "eqa.tests.enterNew": "Enter New EQA Test",
  "eqa.tests.labNumber": "Număr laborator",
  "eqa.tests.orders.subtitle": "Proficiency testing orders for this laboratory",
  "eqa.tests.orders.title": "EQA Orders",
  "eqa.tests.priority": "Prioritate",
  "eqa.tests.program": "EQA Program",
  "eqa.tests.provider": "Furnizor",
  "eqa.tests.searchPlaceholder": "Search by accession #, program, or provider...",
  "eqa.tests.status": "Stare",
  "eqa.tests.status.completed": "Completed",
  "eqa.tests.status.inProgress": "În desfășurare",
  "eqa.tests.status.overdue": "Overdue",
  "eqa.tests.status.pending": "Pending",
  "eqa.tests.summary.completedThisMonth": "Completed This Month",
  "eqa.tests.summary.inProgress": "În desfășurare",
  "eqa.tests.summary.overdue": "Overdue",
  "eqa.tests.summary.pending": "Pending",
  "eqa.validation.deadline.required": "Testing Deadline is required",
  "eqa.validation.program.required": "EQA Program is required",
  "eqa.validation.provider.required": "EQA Provider Organization is required",
  "error.add.edited.msg": "Eroare la adăugare/modificare",
  "error.barcode.dimension.positive": "Label dimension must be a positive number",
  "error.barcode.labelcount.default.lte.max": "Default label count must not exceed maximum for this label type",
  "error.delete.msg": "Eroare la ștergere",
  "error.duplicate.calculationname": "Nume de calcul duplicat sau eroare la salvare",
  "error.fetch.boxDetails": "Failed to fetch box details",
  "error.fetch.boxes": "Failed to fetch shipping boxes",
  "error.fetch.facilities": "Failed to fetch facilities",
  "error.fetch.unassignedSamples": "Failed to fetch unassigned samples",
  "error.field.required": "Acest câmp este obligatoriu",
  "error.import.patient": "Eroare la importul pacientului în OpenELIS",
  "error.invalid.email": "Email invalid",
  "error.invalidcredentials": "Nume utilizator sau parolă incorecte",
  "error.locale.format": "Invalid format. Use: en, fr, es, or en-US, fr-CA, etc.",
  "error.no.patient.data": "Nu există date pacient de importat",
  "error.nonconform.report": "Introduceți valoarea",
  "error.report.csv.date": "Selectați tipul datei.",
  "error.report.csv.study": "Selectați tipul studiului.",
  "error.report.status": "Eroare la generarea raportului",
  "error.required.destination": "Destination facility is required",
  "error.results.loadFailed": "The results worklist could not be loaded",
  "error.results.loadFailed.detail": "This is not an empty worklist — the request failed, so any pending work here is not shown. Try again, and tell an administrator if it keeps failing.",
  "error.results.precision": "This test reports to {0} decimal place(s). Enter the value at that precision, or the record and the reported value will differ.",
  "error.results.staleSave": "This result was updated by {0} at {1} — refresh to see the latest value",
  "error.save.failed": "Failed to save",
  "error.save.msg": "Eroare la salvare",
  "error.save.order": "Error while saving order",
  "error.save.patient": "Eroare la salvarea pacientului",
  "error.title": "Error",
  "errorBoundary.reload": "Reîncarcă",
  "errorBoundary.route.patientResultsViewer.message": "Something went wrong while showing this patient's results. Reload to try again.",
  "errorBoundary.route.patientResultsViewer.title": "Patient results could not be loaded",
  "errorBoundary.route.resultsSearch.message": "Something went wrong on the results page. Reload to try again.",
  "errorBoundary.route.resultsSearch.title": "Results could not be loaded",
  "errorBoundary.route.samplePatientEntry.message": "Something went wrong on the sample entry page. Reload to try again.",
  "errorBoundary.route.samplePatientEntry.title": "Sample entry could not be loaded",
  "errorBoundary.route.storage.message": "Something went wrong on this page. Reload to try again, or use the menu to go elsewhere.",
  "errorBoundary.route.storage.title": "Storage could not be loaded",
  "errorBoundary.route.analyzers.message": "Something went wrong loading this page. Reload to try again.",
  "errorBoundary.route.analyzers.title": "Analyzer module could not be loaded",
  "errorBoundary.route.analyzerResults.message": "Something went wrong loading results. Reload to try again.",
  "errorBoundary.route.analyzerResults.title": "Analyzer results could not be loaded",
  "esig.button.certify": "Certify & Continue",
  "esig.button.reject": "Respinge",
  "esig.button.saveAndSign": "Salvează",
  "esig.button.sign": "Sign",
  "esig.button.validate": "Validate",
  "esig.certification.acknowledge": "I have read and understand the above statement",
  "esig.certification.intro": "Before you can use electronic signatures, you must certify that your electronic signature is the legally binding equivalent of your handwritten signature.",
  "esig.error.disabled": "Electronic signatures are not enabled",
  "esig.error.generic": "An error occurred",
  "esig.error.invalidCredentials": "Invalid credentials",
  "esig.error.keycloakNotSupported": "Keycloak authentication is not yet supported for electronic signatures",
  "esig.error.loadingStatus": "Failed to load signature status",
  "esig.error.mustAcknowledge": "You must acknowledge the certification statement",
  "esig.error.passwordRequired": "Password is required",
  "esig.error.rejectionReasonRequired": "Rejection reason is required",
  "esig.error.title": "Error",
  "esig.error.usernameRequired": "Username is required",
  "esig.info.fullAuth": "This is your first signature in this session. Please enter your username and password to authenticate.",
  "esig.info.legalBinding": "By entering your credentials, you are creating a legally binding electronic signature per 21 CFR Part 11.",
  "esig.info.passwordOnly": "You have an active signing session. Enter your password to continue.",
  "esig.label.context": "Action:",
  "esig.label.meaning": "Signature Meaning:",
  "esig.label.password": "Parolă",
  "esig.label.rejectionReason": "Rejection Reason",
  "esig.label.signingAs": "Signing as: {userName}",
  "esig.label.username": "Nume utilizator",
  "esig.meaning.authored": "Authored",
  "esig.meaning.modified": "Modified",
  "esig.meaning.rejected": "Rejected",
  "esig.meaning.validatedAndReleased": "Validated and Released",
  "esig.placeholder.password": "Enter your password to confirm",
  "esig.placeholder.rejectionReason": "Enter the reason for rejection",
  "esig.placeholder.username": "Enter your username",
  "esig.title.certification": "Electronic Signature Certification",
  "esig.title.signature": "Electronic Signature",
  "example": "Exemplu",
  "external.id": "External ID",
  "external.referrals.report": "Raport trimiteri externe",
  "externalReferredOutTests.title": "Raport trimiteri externe",
  "externalconnections.active": "Activ",
  "externalconnections.add.title": "Add External Connection",
  "externalconnections.authtype": "Authentication Type",
  "externalconnections.authtype.basic.password": "Parolă",
  "externalconnections.authtype.basic.username": "Nume utilizator",
  "externalconnections.browse.title": "External Connections",
  "externalconnections.deactivate.success": "External connection(s) deactivated successfully.",
  "externalconnections.description": "Descriere",
  "externalconnections.edit.title": "Edit External Connection",
  "externalconnections.name": "Nume",
  "externalconnections.name.placeholder": "Enter connection name",
  "externalconnections.programmedconnection": "Connection Type",
  "externalconnections.save.success": "External connection saved successfully.",
  "externalconnections.search": "Search external connections",
  "externalconnections.search.placeholder": "Search by name or type",
  "externalconnections.select": "Selectează",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "e.g. https://server:port",
  "false.label": "Fals",
  "field.active": "Activ/Inactiv",
  "field.ageRange": "Interval de vârstă",
  "field.dictionaryValues": "Valori dicționar",
  "field.loinc": "LOINC",
  "field.name": "Nume",
  "field.normalRange": "Interval normal",
  "field.note": "Notă",
  "field.orderable": "Comandabil/Nu poate fi comandat",
  "field.panel": "Panel",
  "field.referenceValue": "Valoare de referință",
  "field.reportName": "Nume raport",
  "field.resultLimits": "Limite rezultate",
  "field.resultType": "Tip rezultat",
  "field.sampleType": "Tip probă",
  "field.select.testSection": "Select Test Section",
  "field.selectValues": "Valori selectabile",
  "field.sex": "Sex",
  "field.significantDigits": "Zecimale semnificative",
  "field.testSection": "Secțiune test",
  "field.testUnit": "Unitate testare",
  "field.uom": "Unitate de măsură",
  "field.validRange": "Interval valid",
  "file.import.configuration.active": "Activ",
  "file.import.configuration.analyzer": "Analizor",
  "file.import.configuration.analyzer.emptyState": "No file import plugins installed",
  "file.import.configuration.analyzer.placeholder": "Select analyzer",
  "file.import.configuration.cancel": "Anulează",
  "file.import.configuration.columnMappings": "Column Mappings",
  "file.import.configuration.columnMappings.helperText": "JSON mapping of CSV columns to OpenELIS fields (e.g., {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Delimiter",
  "file.import.configuration.delimiter.helperText": "CSV delimiter character (default: comma)",
  "file.import.configuration.error.save": "Failed to save file import configuration",
  "file.import.configuration.error.unknown": "An unknown error occurred",
  "file.import.configuration.fileFormat": "File Format",
  "file.import.configuration.fileFormat.placeholder": "Select file format",
  "file.import.configuration.filePattern": "File Pattern",
  "file.import.configuration.filePattern.helperText": "Glob pattern for matching files (e.g., *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Has Header Row",
  "file.import.configuration.importDirectory": "Import Directory",
  "file.import.configuration.importDirectory.helperText": "Directory to watch for new files",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Salvează",
  "file.import.configuration.success.created": "File import configuration created successfully",
  "file.import.configuration.success.updated": "File import configuration updated successfully",
  "file.import.configuration.title.add": "Add File Import Configuration",
  "file.import.configuration.title.edit": "Edit File Import Configuration",
  "file.import.configuration.validation.analyzerId.required": "Analyzer is required",
  "file.import.configuration.validation.columnMappings.invalid": "Invalid JSON format for column mappings",
  "file.import.configuration.validation.importDirectory.required": "Import directory is required",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filtre",
  "freezer.nav.corrective": "Corrective Actions",
  "freezer.nav.corrective.tooltip": "Manage corrective actions",
  "freezer.nav.dashboard": "Tablou de bord",
  "freezer.nav.dashboard.tooltip": "View cold storage monitoring dashboard",
  "freezer.nav.reports": "Rapoarte",
  "freezer.nav.reports.tooltip": "Generate cold storage reports",
  "freezer.nav.settings": "Settings",
  "freezer.nav.settings.tooltip": "Configure cold storage settings",
  "freezer.nav.trends": "Historical Trends",
  "freezer.nav.trends.tooltip": "View temperature trends over time",
  "french.current": "FRANCEZĂ curent",
  "french.label": "Franceză",
  "from.title": "De la",
  "genericSample.edit.success": "Sample updated successfully",
  "genericSample.edit.title": "Edit Sample",
  "genericSample.field.by": "By",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Date",
  "genericSample.field.from": "De la",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Lab person received",
  "genericSample.field.project": "Proiect",
  "genericSample.field.storageLocation": "Storage freezer # & location",
  "genericSample.field.type": "Type",
  "genericSample.notebook.selection.title": "Notebook Selection (Optional)",
  "genericSample.order.error.labNoRequired": "Please generate a Lab Number before saving.",
  "genericSample.order.generateLabNo": "Generate Lab Number",
  "genericSample.order.labNo.placeholder": "Click 'Generate Lab Number' to create",
  "genericSample.order.success.details": "Sample Details",
  "genericSample.order.success.message": "Sample order created successfully with accession number: {accessionNumber}",
  "genericSample.order.title": "Receive Sample",
  "gps.accuracy.display": "±{accuracy}m accuracy",
  "gps.accuracy.warning.message": "GPS accuracy is {accuracy}m, which exceeds the required {required}m threshold. Consider capturing the location again in a better position.",
  "gps.accuracy.warning.title": "GPS Accuracy Warning",
  "gps.button.clear": "Curăță",
  "gps.button.getting.location": "Getting Location...",
  "gps.button.location.captured": "Location Captured",
  "gps.button.use.my.location": "Use My Location",
  "gps.collapse": "Collapse GPS section",
  "gps.config.accuracy.helper": "Maximum acceptable GPS accuracy in meters. Set to 0 to disable accuracy checking.",
  "gps.config.accuracy.label": "Required Accuracy (meters)",
  "gps.config.enabled.description": "When enabled, GPS coordinate fields will appear in the Order Entry workflow to capture sample collection locations.",
  "gps.config.enabled.label": "Enable GPS Coordinates",
  "gps.config.error.load": "Failed to load GPS configuration",
  "gps.config.save.error": "Failed to save GPS configuration",
  "gps.config.save.success": "GPS configuration saved successfully",
  "gps.config.saving": "Saving...",
  "gps.config.section.general": "GPS Settings",
  "gps.config.timeout.helper": "Maximum time to wait for GPS location in seconds.",
  "gps.config.timeout.label": "Timeout (seconds)",
  "gps.config.title": "GPS Coordinates Configuration",
  "gps.config.unsaved.changes": "You have unsaved changes. Are you sure you want to leave?",
  "gps.config.unsaved.subtitle": "Remember to save your changes before navigating away.",
  "gps.config.unsaved.title": "Unsaved Changes",
  "gps.config.validation.accuracy.negative": "Required accuracy cannot be negative",
  "gps.config.validation.accuracy.too.high": "Required accuracy cannot exceed 10,000 meters",
  "gps.config.validation.timeout.too.high": "Timeout cannot exceed 120 seconds",
  "gps.config.validation.timeout.too.low": "Timeout must be at least 1 second",
  "gps.coordinates.captured.via": "Captured via {method}",
  "gps.coordinates.current": "Current coordinates",
  "gps.error.not.supported": "GPS is not supported by this browser",
  "gps.error.permission.denied": "GPS access was denied. Please enable location permissions and try again.",
  "gps.error.position.unavailable": "GPS position is unavailable. Please check your device's location settings.",
  "gps.error.timeout": "GPS request timed out. Please try again.",
  "gps.error.title": "GPS Error",
  "gps.error.unknown": "An unknown GPS error occurred. Please try again.",
  "gps.info.description": "GPS coordinates record the geographic location where the sample was collected. This supports epidemiological surveillance and disease mapping.",
  "gps.info.title": "GPS Coordinates",
  "gps.latitude.helper": "Degrees North (+) or South (-), between -90 and 90",
  "gps.latitude.invalid": "Latitude must be between -90 and 90 degrees",
  "gps.latitude.label": "Latitude",
  "gps.latitude.placeholder": "e.g., -1.286389",
  "gps.longitude.helper": "Degrees East (+) or West (-), between -180 and 180",
  "gps.longitude.invalid": "Longitude must be between -180 and 180 degrees",
  "gps.longitude.label": "Longitude",
  "gps.longitude.placeholder": "e.g., 36.817223",
  "gps.manual.entry.off": "Off",
  "gps.manual.entry.on": "On",
  "gps.manual.entry.title": "Enter coordinates manually",
  "gps.manual.entry.toggle": "Manual coordinate entry",
  "gps.not.captured": "Not captured",
  "gps.section.description": "Capture the geographic location where this sample was collected for epidemiological tracking",
  "gps.section.title": "Collection Location (GPS)",
  "gps.status.captured": "Captured",
  "gps.status.optional": "Optional",
  "gps.tile.collapse": "Collapse GPS section",
  "gps.tile.expand": "Expand to add GPS coordinates",
  "gps.warning.partial.coordinates": "Both latitude and longitude should be provided for a valid location.",
  "header.ID": "ID",
  "header.assign": "Asignează",
  "header.cancel.test": "Anulează test",
  "header.formname": "Nume formular",
  "header.icon.help": "Ajutor",
  "header.icon.lang": "Language",
  "header.icon.menu.close": "Close menu",
  "header.icon.menu.open": "Open menu",
  "header.icon.menu.pin": "Pin menu",
  "header.icon.menu.unpin": "Unpin menu",
  "header.icon.notifications": "Notifications",
  "header.icon.search": "Caută",
  "header.icon.user": "Utilizator",
  "header.label.ARV": "ARV-ințial",
  "header.label.EID": "Diagnostic copii cu DBS-PCR",
  "header.label.changeLab": "Selectează laborator",
  "header.label.followup": "ARV-Urmărire",
  "header.label.intialFollowup": "ARV -->Inițial-Urmărire-VL",
  "header.label.logout": "Deconectare",
  "header.label.nonconformityByDate": "Raport neconformitate după dată",
  "header.label.selectLab": "Selectează laboratorul",
  "header.label.selectlocale": "Selectează limbă",
  "header.label.specialRequest": "Cerere specială",
  "header.label.study.ciexport": "Export fișier CSV după dată",
  "header.label.study.vlloadtrends": "Raport export date încărcare virală",
  "header.label.version": "Versiune:",
  "header.reject": "Respinge",
  "header.rejection.reason": "Motiv respingere",
  "header.results.recorded": "Rezultate înregistrate",
  "hide.aliquoting": "Hide Aliquoting",
  "holder.choose.availabletest": "Alege test disponibil",
  "home.label": "Acasă",
  "immunohistochemistry.label.addreport": "Adaugă raport",
  "immunohistochemistry.label.averageChrom": "Media semnalelor cromozomului 17 per nucleu",
  "immunohistochemistry.label.averageHer2": "Media HER2 per nucleu",
  "immunohistochemistry.label.cellIntensity": "intensitate. scor Allred",
  "immunohistochemistry.label.cellPercent": "% celule cu colorare nucleară cu",
  "immunohistochemistry.label.dashboard": "Tablou de bord Imunohistochimie",
  "immunohistochemistry.label.her2Assesment": "Evaluarea proteinei HER2 este",
  "immunohistochemistry.label.her2Pattern": "Tipar colorare CerbB2/HER2",
  "immunohistochemistry.label.her2ScoreOf": "cu un scor de",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnostic histologic",
  "immunohistochemistry.label.ihcRatio": "Raport Her2/neu vs. Cromozom 17",
  "immunohistochemistry.label.ihcScore": "IHC (Scor Cerb2)",
  "immunohistochemistry.label.mibName": "MiB 1(ki-67) (Indice proliferativ):",
  "immunohistochemistry.label.molecularType": "Subtip molecular",
  "immunohistochemistry.label.numberOfCancer": "Număr nuclei canceroși",
  "immunohistochemistry.label.outOf8": "din 8",
  "immunohistochemistry.label.report": "Raport",
  "immunohistochemistry.label.reports": "Rapoarte",
  "immunohistochemistry.label.review": "În așteptarea revizuirii imunohistochimice",
  "immunohistochemistry.label.title": "Imunohistochimie",
  "immunohistochemistry.label.tumorCells": "din celulele tumorale pozitive (prag 20%)",
  "import.autoGenerated": "Auto-generated",
  "import.created": "Created",
  "import.error.failed": "Import failed",
  "import.error.importFile": "Failed to import file",
  "import.error.selectFile": "Please select a file first",
  "import.error.validateFile": "Failed to validate file",
  "import.error.validateFirst": "Please validate the file first and fix any errors",
  "import.error.validationFailed": "Validation failed. Please check the errors below.",
  "import.failed": "Import Failed",
  "import.failedCount": "Failed",
  "import.header.collectionDate": "Data recoltării",
  "import.header.errorMessage": "Error Message",
  "import.header.field": "Field",
  "import.header.from": "De la",
  "import.header.labNo": "Nr. laborator",
  "import.header.quantity": "Quantity",
  "import.header.row": "Row",
  "import.header.sampleType": "Tip probă",
  "import.header.samplesToCreate": "Samples to Create",
  "import.importing": "Importing...",
  "import.invalidRows": "Invalid Rows",
  "import.selectFile": "Select file",
  "import.status.invalid": "Invalid",
  "import.status.valid": "Valid",
  "import.success": "Import Successful",
  "import.totalRows": "Total Rows",
  "import.totalSamplesToCreate": "Total Samples to Create",
  "import.uploadFile": "Upload File",
  "import.uploadFileDesc": "Upload CSV or Excel file ({types})",
  "import.validRows": "Valid Rows",
  "import.validating": "Validating...",
  "import.validationStatus": "Validation Status",
  "input.error.same.panel.type": "Există deja un panel cu acest nume. Te rugăm să anulezi sau să folosești un alt nume.",
  "input.placeholder.labNo": "Introduceți numărul laboratorului",
  "input.placeholder.patientFirstName": "Introduceți prenumele pacientului",
  "input.placeholder.patientId": "Introduceți ID pacient",
  "input.placeholder.patientLastName": "Introduceți numele de familie al pacientului",
  "input.placeholder.prevLabNumber": "Introduceți numărul de laborator anterior",
  "input.placeholder.providerEmail": "Introduceți emailul solicitantului",
  "input.placeholder.providerFax": "Introduceți faxul solicitantului",
  "input.placeholder.providerWorkPhone": "Introduceți telefonul solicitantului",
  "input.placeholder.provisionalClinicalDiagnosis": "Enter Provisional Clinical Diagnosis",
  "input.placeholder.requesterFirstName": "Introduceți prenumele solicitantului",
  "input.placeholder.requesterLastName": "Introduceți numele de familie al solicitantului",
  "input.placeholder.searchTestName": "Search testName Here",
  "input.placeholder.selectPanel": "Selectați tipul panelului",
  "input.placeholder.selectPriority": "Selectați prioritatea",
  "input.placeholder.selectTest": "Selectați tipul testului",
  "input.placeholder.selectTestSection": "Selectați tipul unității",
  "instructions.copy.labnum": "Copiază număr laborator",
  "instructions.order.entry.eqa.enabled": "When enabled, a checkbox will appear on the Order Entry screen allowing staff to mark a sample as an EQA (External Quality Assurance) sample. Patient demographics will be auto-populated with N/A and locked.",
  "instructions.order.entry.requester": "When enabled, Search Requester and Requester First Name and Requester Last Name become required fields on the Add Order screen. When disabled (default), all three fields are optional.",
  "instructions.test.activation": "Teste active: bifa indică test activ. Debifarea îl dezactivează. Tipurile de probe fără teste active apar ca inactive în josul listei.",
  "instructions.test.activation.confirm": "Verifică dacă acestea sunt modificările dorite. Dacă sunt corecte, salvează. Dacă nu, folosește butonul Înapoi pentru corectare.",
  "instructions.test.activation.sort": "Ordine afișare: Listele tipurilor de probe care au teste recent activate. Sortează testele pentru a indica ordinea în ecranul de comandă. Sortarea se face prin tragere în poziția dorită.",
  "instructions.test.order": "Testele bifate sunt comandabile, cele nebifate nu sunt. Modifică bifările pentru a schimba statusul. Pentru ca un test să poată fi comandat la recepție, trebuie să fie activ și comandabil. Testele active dar necomandabile pot fi cerute doar ca reflex.",
  "invalid.json": "JSON invalid",
  "inventory.add.button": "Add New Lot",
  "inventory.addItem.button": "Add Catalog Item",
  "inventory.dashboard.title": "Inventory Dashboard",
  "inventory.export.button": "Exportă",
  "inventory.filter.all": "Toate",
  "inventory.filter.status": "Filter by Status",
  "inventory.filter.type": "Filter by Type",
  "inventory.list.title": "Inventory Items",
  "inventory.metrics.expired": "Expired",
  "inventory.metrics.expiringSoon": "Expiring Soon",
  "inventory.metrics.lowStock": "Low Stock",
  "inventory.metrics.totalLots": "Total Lots",
  "inventory.search.placeholder": "Search by item name or lot number",
  "inventory.tab.catalog": "Catalog",
  "inventory.tab.dashboard": "Tablou de bord",
  "inventory.tab.reports": "Rapoarte",
  "inventory.title": "Inventory Management",
  "label.action": "Acțiune",
  "labNumber.format.current": "Format curent",
  "labNumber.format.new": "Format nou",
  "labNumber.prefix": "Prefix",
  "labNumber.type": "Tip număr laborator",
  "labNumber.usePrefix": "Folosește prefix",
  "label.actions": "Actions",
  "label.active": "Activ",
  "label.actualTestName": "Nume real test",
  "label.add": "Adaugă",
  "label.add.notification": "Adaugă notificare popup utilizatorului",
  "label.all": "Toate",
  "label.analysisNotStarted": "Analiza nu a început",
  "label.any": "Oricare",
  "label.audittrail": "Nr. laborator",
  "label.audittrail.Reports": "Rapoarte jurnal audit",
  "label.audittrail.labNo.invalidaccessionnumber": "Număr de acces invalid",
  "label.audittrail.labNo.missing": "Nr. laborator este obligatoriu!",
  "label.audittrailreport.nextvisitdate": "Dată vizită următoare",
  "label.audittrailreport.priority": "Prioritate",
  "label.audittrailreport.program": "Program",
  "label.audittrailreport.receiveddate": "Dată primire",
  "label.audittrailreport.requestdate": "Dată cerere",
  "label.audittrailreport.requester": "Solicitant",
  "label.audittrailreport.requester.firstname": "Prenume solicitant",
  "label.audittrailreport.requester.lastname": "Nume solicitant",
  "label.audittrailreport.sitename": "Nume locație",
  "label.autoFilledFromServer": "Auto-filled from server",
  "label.barcode": "Cod de bare",
  "label.barcode.labelsets": "Număr seturi etichete",
  "label.barcode.orderlabel": "Număr etichete comandă per set",
  "label.barcode.specimenlabel": "Număr etichete probă per set",
  "label.barcode.totallabel": "Total etichete de imprimat",
  "label.button.action": "Acțiune",
  "label.button.add": "Adaugă",
  "label.button.add.question": "Adaugă întrebare nouă",
  "label.button.cancel": "Anulează",
  "label.button.close": "Close",
  "label.button.changepassword": "Schimbă parola",
  "label.button.clear": "Curăță",
  "label.button.confirm": "Confirmă",
  "label.button.confirmAction": "Confirmă acțiunea",
  "label.button.confirmDelete": "Confirmă ștergerea",
  "label.button.confirmTitle": "Ești sigur?",
  "label.button.delete": "Delete",
  "label.button.descritpion": "Descriere",
  "label.button.edit": "Editează",
  "label.button.exit": "Ieșire",
  "label.button.externalsearch": "Căutare externă",
  "label.button.field": "Field",
  "label.button.finish": "Finalizare",
  "label.button.finished": "Finalizat",
  "label.button.generatePrintableVersion": "Generează versiune imprimabilă",
  "label.button.import": "Import",
  "label.button.login": "Autentificare",
  "label.button.login.sso": "Autentificare unică",
  "label.button.newEntry": "New Entry",
  "label.button.ok": "Ok",
  "label.button.previous": "Înapoi",
  "label.button.range": "Interval",
  "label.button.remove": "Șterge",
  "label.button.remove.block": "Șterge bloc",
  "label.button.remove.report": "Șterge raport",
  "label.button.remove.slide": "Șterge lamă",
  "label.button.reset": "Reset",
  "label.button.sample": "Probă",
  "label.button.save": "Salvează",
  "label.button.saveconfig": "Save Configuration",
  "label.button.search": "Caută",
  "label.button.select": "Selectează",
  "label.button.select.pathologist": "Selectează patolog",
  "label.button.select.status": "Selectează status",
  "label.button.select.technician": "Selectează tehnician",
  "label.button.select.test": "Selectează test",
  "label.button.start": "Start",
  "label.button.submit": "Trimite",
  "label.button.update": "Update",
  "label.button.uploadfile": "Încarcă fișier",
  "label.button.validate": "Validate",
  "label.button.viewReport": "Vezi raportul",
  "label.cancel": "Anulează",
  "label.cancel.test.no.replace": "Anulează testul pentru numerele selectate, fără înlocuire",
  "label.checkedWillBeModified": "Numerele bifate vor fi modificate",
  "label.clear": "Clear Filters",
  "label.content": "Label Content",
  "label.confirm": "Confirmă",
  "label.created.samples": "Created Samples",
  "label.critical.range": "Interval critic",
  "label.currentTest": "Test curent",
  "label.days": "days",
  "label.default.result": "Rezultat implicit",
  "label.delete": "Delete",
  "label.description": "Descriere",
  "label.edit": "Editează",
  "label.electronic.orders": "Comenzi electronice",
  "label.equals": "egal",
  "label.error": "Error",
  "label.existing.methods": "Metode existente",
  "label.existing.test.sets": "Seturi de teste existente",
  "label.filters.mycases": "Cazurile mele",
  "label.filters.status": "Stare",
  "label.field.required": "Acest câmp este obligatoriu",
  "label.status": "Stare",
  "label.form.searchby": "Caută după",
  "label.id": "ID",
  "label.import.errors": "Import Errors",
  "label.inactive": "Inactive",
  "label.inactive.methods": "Metode inactive. Asociază teste pentru activare.",
  "label.includeInactiveTests": "Include teste inactive",
  "label.inside.normalrange": "este în intervalul normal",
  "label.lastPrinted": "Last printed: {date} {time} by {user}",
  "label.loading": "Se încarcă...",
  "label.loinc": "LOINC",
  "label.management.title": "Label Management",
  "label.no": "Nu",
  "label.no.options.available": "No options available",
  "label.none": "None (no filter)",
  "label.notValidated": "Nevalidat",
  "label.notequals": "nu este egal",
  "label.order.labNrPrefix": "Lab Nr",
  "label.order.patientPrefix": "Pacient",
  "label.order.scan.text": "Scanează SAU Introdu manual SAU",
  "label.orderable": "Comandabil",
  "label.outside.normalrange": "este în afara intervalului normal",
  "label.page.patientHistory": "Istoric pacient",
  "label.preview.data": "Preview Data",
  "label.print": "Tipărește etichetă",
  "label.print.error": "Error generating label. Please try again.",
  "label.print.error.popupBlocked": "Popup blocked. Please allow popups for this site to print labels.",
  "label.print.generating": "Generating...",
  "label.print.success": "Label printed successfully",
  "label.print.description": "Print labels for orders and samples",
  "label.print.helper": "Select the type and quantity of labels to print",
  "label.print.success.count": "{count} labels printed successfully",
  "label.print.title": "Print Labels",
  "label.printAll": "Print All Labels",
  "label.printAll.success": "All labels printed successfully",
  "label.printConfirmation.message": "Print label for {name}{code}?",
  "label.printConfirmation.title": "Tipărește etichetă",
  "label.printHistory": "Print History",
  "label.printHistory.byUser": "By {user}",
  "label.printHistory.count": "{count} labels",
  "label.printHistory.loading": "Loading print history...",
  "label.printHistory.never": "Never printed",
  "label.printHistory.unknownUser": "Unknown",
  "label.printHistory.viewAll": "View History",
  "label.printLabel": "Tipărește etichetă",
  "label.program": "Program",
  "label.qualifiers": "Calificative",
  "label.quantity": "Quantity",
  "label.readonly": "Read Only",
  "label.reference.value": "Valoare de referință",
  "label.refertest.referencelab": "Trimite testul la un laborator de referință",
  "label.rejectedByBiologist": "Respins de biolog",
  "label.rejectedByTechnician": "Respins de tehnician",
  "label.remove": "Șterge",
  "label.replaceWith": "Înlocuiește cu",
  "label.report.byNationalId": "După CNP / ID unic de sănătate",
  "label.reporting.range": "Interval raportare",
  "label.result.order": "Ordine rezultat",
  "label.resultSelectList": "Listă selecție rezultat",
  "label.results.actions": "Actions",
  "label.results.anotherUser": "another user",
  "label.results.date": "Test date",
  "label.results.domain": "Clinical",
  "label.results.domain.env": "Water Quality",
  "label.results.domain.vector": "Vector Surveillance",
  "label.results.edit": "Editează",
  "label.results.inReviewBy": "In review by {0}",
  "label.results.labUnit": "Lab Unit",
  "label.results.load": "Load results",
  "label.results.range": "Reference Range",
  "label.results.range.env": "Regulatory Limit",
  "label.results.range.vector": "Interpretation",
  "label.results.reflexTriggered": "Reflex/calculated tests added for:",
  "label.results.refresh": "Refresh",
  "label.results.result": "Rezultat",
  "label.results.resultFor": "Result for {0}",
  "label.results.retry": "Try again",
  "label.results.save": "Salvează",
  "label.results.search": "Search by lab number",
  "label.results.status": "Stare",
  "label.results.status.all": "Toate",
  "label.results.subject": "Sample / Patient",
  "label.results.subject.env": "Sample / Site",
  "label.results.subject.vector": "Sample / Trap",
  "label.results.table.caption": "Results worklist",
  "label.results.test": "Analiză",
  "label.results.method": "Method",
  "label.results.analyzer": "Analizor",
  "label.results.analyzer.none": "Not from an instrument",
  "label.results.fromAnalyzer": "from analyzer",
  "label.results.methodAnalyzerHint": "Method is the analyzer type; Analyzer is the specific instrument.",
  "label.results.expandRow": "Expand row",
  "label.results.collapseRow": "Collapse row",
  "label.results.referredOut": "Referred out",
  "label.results.notes": "Note",
  "label.results.note.context": "Context",
  "label.results.note.context.entry": "Entry",
  "label.results.note.context.modification": "Modification",
  "label.results.note.context.auto": "Set automatically from what you are doing.",
  "label.results.note.visibility": "Visibility",
  "label.results.note.internal": "In lab only",
  "label.results.note.external": "Send with result",
  "label.results.note.analysisLevel": "Analysis-level",
  "label.results.note.externalWarning": "This note will appear on the patient report.",
  "label.results.note.placeholder": "Add a note…",
  "label.results.dilution.measured": "Measured value",
  "label.results.dilution.factor": "Dilution factor",
  "label.results.dilution.reported": "Reported value: {0}",
  "label.results.saveHint": "Saving records your e-signature. Critical acknowledgment never blocks Save.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Abnormal",
  "label.results.flag.critical": "Critical",
  "label.results.flag.invalid": "Invalid",
  "label.results.sample": "Probă",
  "label.results.flag": "Flag",
  "label.results.order.clinician": "Ordering clinician",
  "label.results.order.phone": "Phone",
  "label.results.order.site": "Requesting site",
  "label.results.order.priority": "Prioritate",
  "label.results.order.collection": "Collection",
  "label.results.section.program": "Program info",
  "label.results.program.name": "Program",
  "label.results.program.eqa": "EQA",
  "label.results.program.readonly": "Program fields are read-only here — edit on the originating order.",
  "label.results.section.storage": "Storage & sample disposal",
  "label.results.storage.location": "Locație",
  "label.results.storage.position": "Position",
  "label.results.storage.notes": "Note",
  "label.results.storage.unassigned": "No storage assignment",
  "label.results.storage.assignLocation": "Assign Location",
  "label.results.storage.moveLocation": "Move to Location",
  "label.results.program.capturedData": "Programme data",
  "label.results.sampleStatus.title": "Sample status",
  "label.results.sampleStatus.volume": "Volume: {0} remaining of {1} · status {2}.",
  "label.results.sampleStatus.noVolume": "Status {0}.",
  "label.results.sampleStatus.available": "available",
  "label.results.sampleStatus.usedUp": "used up (exhausted)",
  "label.results.sampleStatus.disposed": "disposed",
  "label.results.sampleStatus.recordUse": "Record amount used",
  "label.results.sampleStatus.markUsedUp": "Mark used up",
  "label.results.sampleStatus.startDisposal": "Start disposal",
  "label.results.sampleStatus.amountUsed": "Amount used this test",
  "label.results.sampleStatus.record": "Record",
  "label.results.sampleStatus.recordHint": "Decrements remaining volume — the sample is not disposed until exhausted or explicitly marked used up.",
  "label.results.sampleStatus.usedUpNote": "The sample is exhausted and queued for the disposal workflow. Disposal records who, when, and method.",
  "label.results.sampleStatus.disposalReason": "Disposal reason",
  "label.results.sampleStatus.disposalMethod": "Disposal method",
  "label.results.sampleStatus.disposalNotes": "Note",
  "label.results.sampleStatus.confirmDisposal": "Confirm disposal",
  "label.results.sampleStatus.reason.expired": "Expired",
  "label.results.sampleStatus.reason.contaminated": "Contaminated",
  "label.results.sampleStatus.reason.patient_request": "Patient Request",
  "label.results.sampleStatus.reason.testing_complete": "Testing Complete",
  "label.results.sampleStatus.reason.other": "Other",
  "label.results.sampleStatus.method.autoclave": "Biohazard Autoclave",
  "label.results.sampleStatus.method.neutralization": "Chemical Neutralization",
  "label.results.sampleStatus.method.incineration": "Incineration",
  "label.results.sampleStatus.method.other": "Other",
  "label.results.sampleStatus.footnote": "Partial use records the amount consumed against the sample item's remaining volume; full exhaustion (or Mark used up) triggers disposal.",
  "label.results.section.reagents": "Reagents, QC & Controls",
  "label.results.reagents.summary.analyzer": "analyzer-reported lot",
  "label.results.reagents.summary.manual": "manual capture",
  "label.results.reagents.mode.analyzer": "capture mode: analyzer-reported",
  "label.results.reagents.mode.manual": "capture mode: manual (optional)",
  "label.results.reagents.analyzerNote": "Reported by {0} in its result payload — read-only.",
  "label.results.reagents.lotsUsed": "Reagent lots used",
  "label.results.reagents.noneLinked": "No reagents linked to this test — links are configured in the Test Catalog.",
  "label.results.reagents.noLots": "No available lots in inventory for this reagent.",
  "label.results.reagents.perTest": "{0} {1} per test",
  "label.results.reagents.fefo": "FEFO Suggested",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} remaining",
  "label.results.reagents.quantityUsed": "Quantity used",
  "label.results.reagents.recordUse": "Record use",
  "label.results.reagents.recorded": "Recorded {0} {1} — consumed FEFO across lots.",
  "label.results.reagents.recordFailed": "Could not record reagent use.",
  "label.results.reagents.amountInvalid": "Quantity used must be a positive number.",
  "label.results.reagents.consumeNote": "Recording use decrements inventory (FEFO) and writes a consumption transaction linked to this analysis.",
  "label.results.control.title": "Control result",
  "label.results.control.noneConfigured": "No control lots configured for this test and analyzer.",
  "label.results.control.viewResults": "View control results",
  "label.results.control.manualBlocked": "Manual control capture is not yet available — QC results are numeric-only and written by the analyzer pipeline. Configure control lots and review runs on the QC dashboard.",
  "label.results.dilution.title": "Dilution",
  "label.results.section.attachments": "Attachments",
  "label.results.attachments.summary": "{0} file(s)",
  "label.results.attachments.none": "none",
  "label.results.attachments.empty": "No attachments on this order yet.",
  "label.results.attachments.add": "Add attachment",
  "label.results.attachments.tooLarge": "File exceeds the 10 MB limit.",
  "label.results.attachments.uploadFailed": "Upload failed — PDF, JPG, PNG, or TIFF up to 10 MB.",
  "label.results.attachments.resultsScope": "Rezultate",
  "label.results.attachments.orderScope": "Order Entry",
  "label.results.attachments.view": "Vizualizează",
  "label.results.attachments.download": "Download",
  "label.results.section.interpretation": "Interpretation",
  "label.results.interpretation.summary": "enter via rule or free text",
  "label.results.interpretation.ruleFired": "rule fired ({0}) · auto-open",
  "label.results.interpretation.autoOpen": "rule fired · auto-open",
  "label.results.interpretation.ruleBanner": "Rule match (configured on the test): the entered value {0} falls in {1}. Pick a category to apply its interpretation text, then edit as needed.",
  "label.results.interpretation.match": "matches value",
  "label.results.interpretation.freeText": "Interpretation (free text)",
  "label.results.interpretation.footnote": "Interpretation can be set by a rule configured on the test (the categorical buckets, auto-matched to the value) or free text. Rule text is a non-binding suggestion until applied or edited. Saving sends it with the result to the report.",
  "label.results.nce.disposition": "Result disposition",
  "label.results.nce.disposition.hint": "Applied when the NCE is submitted. Refer-out is a separate row action, not a disposition.",
  "label.results.nce.disposition.none": "Niciuna",
  "label.results.nce.disposition.none.detail": "File the NCE without changing the result.",
  "label.results.nce.disposition.cancel": "Cancel result",
  "label.results.nce.disposition.cancel.detail": "Voided. No value reported. Common for pre-analytical NCEs.",
  "label.results.nce.disposition.reject": "Reject + reason",
  "label.results.nce.disposition.reject.detail": "Clears the value and records the reason. Applied by your e-signature Save.",
  "label.results.nce.disposition.retest": "Retestează",
  "label.results.nce.disposition.retest.detail": "Orders the same test again on this sample; the repeat appears as pending.",
  "label.results.nce.disposition.rejectArmed": "Rejection armed on the row — Save (e-signature) to apply it.",
  "label.results.nce.disposition.cancelled": "Result cancelled.",
  "label.results.nce.disposition.retested": "Retest ordered.",
  "label.results.critical.range": "Critical",
  "label.results.critical.banner.title": "Critical value — physician notification required",
  "label.results.critical.banner.body": "The responsible clinician must be notified. Acknowledgment is recorded on the Alerts dashboard and never blocks Save.",
  "label.results.critical.acknowledge": "I Acknowledge",
  "label.results.critical.acknowledged": "Acknowledged",
  "label.results.critical.comment": "Acknowledgment comment",
  "label.results.critical.comment.placeholder": "e.g. Physician notified by phone",
  "label.results.section.history": "History (this analysis)",
  "label.results.history.summary": "{0} events",
  "label.results.history.summary.unloaded": "revisions · status · retests",
  "label.results.history.when": "When",
  "label.results.history.event": "Event",
  "label.results.history.detail": "Detail",
  "label.results.history.by": "By",
  "label.results.history.event.CREATED": "Created",
  "label.results.history.event.STATUS": "Stare",
  "label.results.history.event.RESULT": "Rezultat",
  "label.results.history.event.NOTE": "Notă",
  "label.results.history.event.RETEST": "Retestează",
  "label.results.history.event.REFLEX": "Reflex",
  "label.results.history.event.OTHER": "Event",
  "label.results.history.empty": "No recorded events yet for this analysis.",
  "label.results.history.footnote": "This analysis only — revisions, status transitions, retests, corrections, notes and audit entries. Patient trends live on the patient record; Westgard rules on the QC dashboard.",
  "label.results.nce.report": "Report Non-Conformity",
  "label.results.reject.result": "Reject result",
  "label.results.reject.reason": "Rejection reason",
  "label.results.reject.hint": "Saving with a rejection clears the value, records the reason, and marks the analysis Technical Rejected.",
  "label.results.referral.refer": "Refer this test",
  "label.results.referral.editing": "Referral pending — edit",
  "label.results.referral.organization": "Reference laboratory",
  "label.results.referral.reason": "Referral reason",
  "label.results.referral.date": "Referral date",
  "label.results.referral.hint": "The referral is recorded when you Save this row and hands off to the Referrals dashboard.",
  "label.results.referral.cancel": "Discard",
  "label.results.section.aliquots": "Aliquots",
  "label.results.aliquots.summary": "{0} aliquots",
  "label.results.aliquots.summary.unloaded": "list · create",
  "label.results.aliquots.labNo": "Nr. laborator",
  "label.results.aliquots.quantity": "Quantity",
  "label.results.aliquots.createdDate": "Created",
  "label.results.aliquots.empty": "No aliquots yet for this sample item.",
  "label.results.aliquots.count": "Number of aliquots",
  "label.results.aliquots.totalQuantity": "Total quantity to transfer",
  "label.results.aliquots.notes": "Note",
  "label.results.aliquots.create": "Create aliquots",
  "label.results.aliquots.created": "Aliquots created.",
  "label.results.aliquots.failed": "Could not create aliquots.",
  "label.results.aliquots.remaining": "Parent remaining quantity",
  "label.results.history.event.REFERRAL": "Referred",
  "label.results.history.event.NCE": "Non-conformity",
  "label.results.referenceZone": "Reference & context",
  "label.results.layoutRemembered": "Layout remembered",
  "label.results.resetLayout": "Reset layout",
  "label.results.section.orderInfo": "Order info",
  "label.results.sampleType": "Sample type",
  "label.results.testDate": "Test date",
  "label.results.receivedDate": "Received",
  "label.results.technician": "Technician",
  "label.routine.Reports": "Rapoarte de rutină",
  "label.sample.types.activate": "Următoarele tipuri de probe vor fi activate:",
  "label.sample.types.deactivate": "Următoarele tipuri de probe vor fi dezactivate deoarece nu au teste:",
  "label.save": "Salvează",
  "label.saving": "Saving...",
  "label.search.available.targetest": "Caută teste disponibile",
  "label.search.availablepanel": "Caută panel disponibil",
  "label.search.labno.family": "Caută după Nr. laborator sau nume familie",
  "label.search.patient": "Caută pacient",
  "label.select": "Selectează",
  "label.select.dateRange": "Selectează intervalul de date pentru raport",
  "label.select.list.options": "Opțiuni listă selecție",
  "label.selectTestSectionCatalog": "Selectează secțiunea de test pentru a vizualiza catalogul",
  "label.sex.dependent": "Dependent de sex",
  "label.shortCode": "Short Code",
  "label.shortCode.error.invalidChars": "Short code can only contain letters, numbers, hyphens, and underscores",
  "label.shortCode.error.maxLength": "Short code must be 10 characters or less",
  "label.shortCode.error.network": "Could not verify uniqueness. Please check manually.",
  "label.shortCode.error.save": "Error saving short code: {error}",
  "label.shortCode.error.startChar": "Short code must start with a letter or number",
  "label.shortCode.helper": "Max 10 characters, alphanumeric, hyphen, underscore",
  "label.shortCode.optional.helper": "Optional (code will be used if ≤10 chars). Max 10 characters, alphanumeric with hyphens/underscores",
  "label.shortCode.required.helper": "Required when code > 10 characters. Max 10 characters, alphanumeric with hyphens/underscores",
  "label.shortCode.update.success": "Short code updated successfully",
  "label.shortCodeRequired": "Short code is required for label printing. Please set short code in Edit form first.",
  "label.shortCodeWarning": "Changing short code will invalidate existing labels",
  "label.showChildren": "Afișează elementele copil",
  "label.study.Reports": "Rapoarte studiu",
  "label.test.activate": "Următoarele teste vor fi activate:",
  "label.test.add": "Adaugă test la comandă",
  "label.test.batch.cancel.finish": "Această acțiune este ireversibilă.",
  "label.test.batch.cancel.start": "Ați selectat anularea testului",
  "label.test.batch.no.change.finish": "teste nu vor fi modificate.",
  "label.test.batch.replace.start": "Următoarele",
  "label.test.deactivate": "Următoarele teste vor fi dezactivate:",
  "label.test.display.order": "Ordine de afișare a testului",
  "label.test.order.confirm": "Verificare: Activează/dezactivează comandabilitatea testului",
  "label.test.orderable": "Următoarele teste vor fi comandabile din formularul de comandă.",
  "label.test.results": "Rezultate test",
  "label.test.resultsData": "Date rezultate test",
  "label.test.unorderable": "Următoarele teste nu vor fi comandabile din formularul de comandă. Vor putea fi comandate doar ca teste reflexe.",
  "label.testActivate": "Activare teste",
  "label.testName": "Nume test",
  "label.text.generate": "generează",
  "label.total.tests": "Total teste",
  "label.type": "Label Type",
  "label.type.order": "Order Label",
  "label.type.pool": "Pool of {count} {animal}",
  "label.type.sample": "Sample Label",
  "label.unit": "Unit",
  "label.user.notestsection": "Utilizatorul curent nu are nicio unitate de laborator asignată. Contactați administratorul",
  "label.validation.errors": "Validation Errors",
  "label.validation.results": "Validation Results",
  "label.view": "Vizualizează",
  "label.viewtestCatalog": "Catalog teste",
  "label.warning": "Warning",
  "label.yes": "Da",
  "labno.alt.prefix.instruction": "Prefix pentru etichete cod de bare preimprimate (4 caractere):",
  "labno.alt.prefix.note": "NOTĂ: Dacă acest prefix a fost deja folosit, numerotarea va continua de la ultimul număr generat.",
  "labno.alt.prefix.use": "Folosește același format de număr accesare și același set de numere disponibile ca și pentru generarea comenzilor.",
  "language.select.label": "Română",
  "legend.search.availabletests": "Caută în testele disponibile",
  "loading": "Se încarcă...",
  "loading.boxes": "Loading boxes...",
  "loading.description": "Se încarcă...",
  "location.collection.title": "Collection Location",
  "location.environmentalConditions": "Environmental Conditions",
  "location.environmentalConditions.placeholder": "e.g. 25°C, clear weather",
  "location.gps.error": "Unable to get location",
  "location.gps.getCurrent": "Get Current Location",
  "location.gps.getting": "Getting location...",
  "location.gps.latitude": "GPS Latitude",
  "location.gps.longitude": "GPS Longitude",
  "location.gps.notSupported": "Geolocation is not supported by your browser",
  "location.gps.permissionDenied": "Location permission denied",
  "location.gps.timeout": "Location request timed out",
  "location.gps.unavailable": "Location information unavailable",
  "location.helper": "Location hierarchy (Region / District / Town-Village) uses the existing system of Location structure. Environmental workflow profiles allow some rows to be unlabeled to provide simpler or shorter row sets for setup as required.",
  "location.requesterReference": "Requester Reference",
  "location.requesterReference.placeholder": "e.g. EPA Method 524.2",
  "location.select.placeholder": "Select {levelName}...",
  "location.siteDescription": "Collection Site Description",
  "location.siteDescription.placeholder": "e.g. Municipal water supply intake point",
  "locale.active": "Activ",
  "locale.add": "Add Language",
  "locale.add.title": "Add Language",
  "locale.code": "Locale Code",
  "locale.code.helper": "e.g., en, fr, es, pt",
  "locale.create.success": "Language created successfully",
  "locale.delete.confirm.message": "Are you sure you want to delete this language? This action cannot be undone.",
  "locale.delete.confirm.title": "Delete Language",
  "locale.delete.error": "Failed to delete language",
  "locale.delete.fallback.error": "Cannot delete the fallback language. Set another language as fallback first.",
  "locale.delete.success": "Language deleted successfully",
  "locale.displayName": "Display Name",
  "locale.displayName.helper": "e.g., English, Français, Español",
  "locale.edit.title": "Edit Language",
  "locale.fallback": "Fallback",
  "locale.fallback.error": "Failed to set fallback language",
  "locale.fallback.success": "Fallback language updated",
  "locale.management.description": "Manage supported languages for metadata translations.",
  "locale.management.title": "Language Management",
  "locale.setFallback": "Set as Fallback",
  "locale.sortOrder": "Sort Order",
  "locale.status": "Stare",
  "locale.update.success": "Language updated successfully",
  "log.submitting.aliquot.data": "Submitting aliquot data:",
  "log.submitting.aliquot.data2": "Submitting aliquot data (JSON):",
  "logging.management.apply": "Apply Log Level",
  "logging.management.description": "Change the backend logging level at runtime. This is useful for debugging issues without restarting the server. Changes take effect immediately but do not persist across server restarts.",
  "logging.management.label": "Logging Configuration",
  "logging.management.level": "Log Level",
  "logging.management.logger": "Logger Name",
  "logging.management.logger.helper": "e.g., org.openelisglobal, root",
  "logging.management.success": "Log level set to {level} for {logger}",
  "login.account.disabled": "Cont dezactivat",
  "login.account.locked": "Cont blocat",
  "login.complexity.message": "Parola trebuie să: ",
  "login.complexity.message.1": "Aibă cel puțin 7 caractere",
  "login.complexity.message.2": "Poată conține litere mari și mici sau cifre",
  "login.complexity.message.3": "Conțină cel puțin unul dintre următoarele caractere: *, $, #, !",
  "login.complexity.message.4": "Nu conțină alte caractere",
  "login.complexity.new.message": "Noua parolă trebuie să: ",
  "login.complexity.new.message.1": "Nu fie identică cu parola actuală",
  "login.error.account.disable": "Your account has been disabled. Please contact system administrator.",
  "login.error.password.current.incorrect": "The current password you entered is incorrect. Please try again.",
  "login.error.password.expired": "Your password has expired. Please contact system administrator.",
  "login.error.update.message": "Update password failed. Please try again.",
  "login.login.": "Repetă parola",
  "login.login.current.password": "Parola actuală",
  "login.login.first": "Prenume",
  "login.login.last": "Nume",
  "login.login.name": "Nume utilizator",
  "login.login.new.password": "Parolă nouă",
  "login.login.password": "Parolă",
  "login.login.repeat.password": "Repetă parola",
  "login.msg.password": "Parolă",
  "login.msg.password.missing": "Este necesară o parolă",
  "login.msg.username": "Nume utilizator",
  "login.msg.username.missing": "Este necesar un nume de utilizator",
  "login.notice.message": "Atenție: Accesul la acest serviciu este permis doar personalului autorizat. Dacă nu ai autorizația expresă a administratorului, trebuie să ieși acum. Această organizație interzice accesul neautorizat, divulgarea, copierea, modificarea, redirecționarea, distrugerea, pierderea, utilizarea greșită sau furtul informațiilor sale.",
  "login.password.expired.date": "Data expirării parolei",
  "login.password.expired.date.placeholder": "(zz/ll/aaaa)",
  "login.redirecting.sso": "Redirecting to single sign-on...",
  "login.subtitle": "Autentificare",
  "login.timeout": "Timp de inactivitate utilizator (minute)",
  "login.timeout.placeholder": "Introduceți în ms",
  "login.title": "Autentificare",
  "lot.barcode": "Cod de bare",
  "lot.calculatedExpiry": "Calculated Expiry",
  "lot.currentQuantity": "Current Quantity",
  "lot.dateOpened": "Date Opened",
  "lot.details.no.transactions": "No transactions recorded for this lot",
  "lot.details.no.usage": "No usage history for this lot",
  "lot.details.section.basic": "Basic Information",
  "lot.details.section.dates": "Important Dates",
  "lot.details.section.quantities": "Quantities",
  "lot.details.section.storage": "Storage Location",
  "lot.details.section.transactions": "Transaction History",
  "lot.details.section.usage": "Usage History",
  "lot.details.tab.info": "Information",
  "lot.details.tab.transactions": "Transactions",
  "lot.details.tab.usage": "Usage History",
  "lot.details.title": "Lot Details",
  "lot.details.view": "View Details",
  "lot.expirationDate": "Expiration Date",
  "lot.form.title.add": "Receive New Inventory Lot",
  "lot.form.title.edit": "Edit Inventory Lot",
  "lot.initialQuantity": "Initial Quantity",
  "lot.number": "Lot Number",
  "lot.qcStatus": "QC Status",
  "lot.receiptDate": "Receipt Date",
  "lot.save.error": "Error saving lot",
  "lot.save.success": "Lot saved successfully",
  "lot.selectItem": "Select Catalog Item",
  "lot.selectLocation": "Select Storage Location",
  "lot.status": "Stare",
  "lot.storageLocation": "Storage Location",
  "manage.testing.algorithms.add.reflex.tests": "Gestionează algoritmi de testare și teste reflex",
  "master.lists.page": "Pagină liste master",
  "master.lists.page.analyzer": "Meniu Nume test analizor",
  "master.lists.page.barcode": "Configurare cod de bare",
  "master.lists.page.batchtest": "Realocare și anulare teste în lot",
  "master.lists.page.external.connections": "Meniu conexiuni externe",
  "master.lists.page.field": "Configurare validare câmpuri",
  "master.lists.page.list": "Liste pluginuri",
  "master.lists.page.menu": "Configurare meniu",
  "master.lists.page.notification": "Configurare notificări teste",
  "master.lists.page.order.entry": "Configurare introducere comandă",
  "master.lists.page.org": "Meniu organizație",
  "master.lists.page.patient": "Configurare introducere pacient",
  "master.lists.page.printed": "Configurare rapoarte tipărite",
  "master.lists.page.provider": "Furnizor",
  "master.lists.page.report.result": "Configurare raportare rezultate",
  "master.lists.page.result": "Configurare introducere rezultate",
  "master.lists.page.site": "Informații locație",
  "master.lists.page.test.management": "Management teste",
  "master.lists.page.user": "Management utilizatori",
  "master.lists.page.work.plan": "Configurare plan de lucru",
  "menu.accession.validation": "După comandă",
  "menu.accession.validation.range": "După interval de comenzi",
  "menu.billing.active": "Meniu facturare activ",
  "menu.billing.address": "URL facturare",
  "menu.billing.title": "Management meniu facturare",
  "menu.genericSample": "Generic Sample",
  "menu.genericSample.edit": "Editați comanda",
  "menu.genericSample.import": "Import",
  "menu.genericSample.order": "Comandă",
  "menu.global.title": "Management meniu global",
  "menu.label.filter": "Filtre:",
  "menu.label.filter.active": "Doar activi",
  "menu.label.filter.admin": "Doar administratori",
  "menu.label.filter.role": "După roluri unitate laborator",
  "menu.nonconform.active": "Meniu neconformități activ",
  "menu.nonconform.title": "Management meniu neconformități",
  "menu.patient.active": "Meniu pacient activ",
  "menu.patient.title": "Management meniu pacient",
  "menu.results.range": "După intervalul numerelor de comandă",
  "menu.sidenav.active": "Navigare laterală activă",
  "menu.study.active": "Meniu studii activ",
  "menu.study.title": "Configurare meniu studii",
  "menu.validation.date": "După dată",
  "message.method.activation": "Această metodă nu va fi activă până când cel puțin un test nu este asociat.",
  "message.noPluginFound": "Nu au fost găsite pluginuri",
  "message.propertiesupdate.success": "Properties updated successfully",
  "method.browse.title": "Secțiune metodă",
  "method.methodName": "Nume metodă",
  "method.modal.add.heading": "Adaugă metodă nouă",
  "modal.add.method": "Adaugă metodă nouă",
  "move.back": "Move Back",
  "move.to.aliquot": "Move to Aliquot",
  "new.patient.label": "Pacient nou",
  "new.program.label": "Program nou",
  "next.action.button": "Următor",
  "nextLabel.action.button": "Etichetă următoare",
  "no.aliquots": "No aliquots available",
  "no.analysis.found": "No analyses found",
  "no.data.found": "Nu s-au găsit date",
  "no.option": "Nu",
  "noTestsFound.matching": "Nu s-a găsit niciun test corespunzător",
  "nonconform.add.new.date": "Adaugă o nouă dată",
  "nonconform.corrective.action": "Acțiune corectivă planificată sau recomandată:",
  "nonconform.corrective.actionType": "Tip acțiune",
  "nonconform.corrective.comment": "Comentarii",
  "nonconform.corrective.control": "Acțiune preventivă sau de control planificată sau recomandată:",
  "nonconform.corrective.title": "Acțiuni corective pentru Evenimente Neconforme",
  "nonconform.date.completed": "Data finalizării",
  "nonconform.date.discussion.nce": "Data discuției cu personalul NCE",
  "nonconform.date.event": "Dată eveniment",
  "nonconform.description.nce": "Descrierea NCE",
  "nonconform.field.date": "Dată NCE",
  "nonconform.field.reporting.data": "Data raportării",
  "nonconform.goToNceForm": "Mergi la formularul de raportare NCE",
  "nonconform.lab.componenet.nce": "Componenta de laborator unde a avut loc NCE",
  "nonconform.label.highseverity": "9 = severitate foarte mare – este necesară o acțiune imediată",
  "nonconform.label.lowseverity": "1 = severitate foarte mică – nu este necesară o acțiune imediată",
  "nonconform.label.prescibernamesite": "Nume și locație prescriptor",
  "nonconform.label.proposed.action": "Acțiune propusă",
  "nonconform.label.reportingunit": "Unitate raportare",
  "nonconform.label.suspected.cause.nce": "Cauza suspectată a NCE",
  "nonconform.nce.concurrent.control.action": "acțiune de control concurentă",
  "nonconform.nce.number": "Număr NCE",
  "nonconform.nce.preventive.action": "acțiune preventivă",
  "nonconform.nce.resolution": "Rezolvare NCE",
  "nonconform.nce.resolution.description": "Au fost acțiunile corective și controalele preventive/concurente eficiente în rezolvarea evenimentului neconform și prevenirea reapariției acestuia?",
  "nonconform.nce.turnaround.time": "Timp de procesare",
  "nonconform.order.save.fail": "Salvarea a eșuat",
  "nonconform.order.save.success": "Salvarea a fost efectuată cu succes",
  "nonconform.person.reporting.different": "Nume persoană raportare (dacă este diferită)",
  "nonconform.person.responsible": "Persoana responsabilă",
  "nonconform.report": "Raportare Eveniment Neconform (NCE)",
  "nonconform.report.field.date": "Dată raportare",
  "nonconform.severity.score": "Scor severitate",
  "nonconform.view.comments": "Comentarii",
  "nonconform.view.corrective.action.description": "Descriere acțiune corectivă",
  "nonconform.view.event.date": "Dată eveniment",
  "nonconform.view.event.description": "Descriere eveniment",
  "nonconform.view.lab.component": "Componentă laborator",
  "nonconform.view.nce.category": "Categorie NCE",
  "nonconform.view.nce.likely.occur": "Cât de probabil este să se repete NCE?",
  "nonconform.view.nce.severity": "Severitate",
  "nonconform.view.nce.type": "Tip NCE",
  "nonconform.view.preventive.description": "Dacă este cazul, descriere acțiune preventivă sau de control",
  "nonconform.view.report": "Vizualizare Eveniment Neconform Nou",
  "nonconform.view.reporting.person": "Persoana care raportează",
  "nonconform.view.severe.consequences": "Cât de severe sunt consecințele sau impactul NCE?",
  "nonconform.view.specimen": "Probă(e)",
  "nce.attachment.dropzone": "Drag and drop files here or click to upload",
  "nce.attachment.error.maxFiles": "Maximum {maxFiles} files allowed",
  "nce.attachment.error.size": "File size exceeds maximum of {maxSize}",
  "nce.attachment.error.type": "File type not allowed. Accepted types: {types}",
  "nce.attachment.error.upload": "Error uploading file",
  "nce.attachment.files": "files",
  "nce.attachment.hint": "(Optional - max {maxFiles} files, 10MB each)",
  "nce.attachment.uploading": "Uploading...",
  "nce.category.administrative": "Administrative",
  "nce.category.analytical": "Analytical",
  "nce.category.postanalytical": "Post-analytical",
  "nce.category.preanalytical": "Pre-analytical",
  "nce.field.attachments": "Attachments",
  "nce.field.notes": "Note",
  "nce.field.description.placeholder": "Describe what happened, when it was detected, and any relevant context...",
  "nce.field.immediateAction": "Immediate Action Taken",
  "nce.field.immediateAction.placeholder": "What corrective steps were taken immediately...",
  "nce.field.linkedItems": "Linked Samples/Results",
  "nce.field.severity": "Severitate",
  "nce.field.title": "Title",
  "nce.field.title.placeholder": "Brief description of the event...",
  "nce.severity.critical": "Critical",
  "nce.severity.critical.description": "Patient safety risk, regulatory violation",
  "nce.severity.major": "Major",
  "nce.severity.major.description": "Significant quality or operational impact",
  "nce.severity.minor": "Minor",
  "nce.severity.minor.description": "Limited impact, easily corrected",
  "nce.severity.low": "Low",
  "nce.severity.low.description": "Minimal impact, no corrective action required",
  "nce.status.open": "Open",
  "nce.status.underInvestigation": "Under Investigation",
  "nce.status.correctiveAction": "Corrective Action",
  "nce.status.closed": "Closed",
  "nce.tree.empty": "No orders found. Search for a lab number to begin.",
  "nce.tree.loading": "Loading orders...",
  "nce.tree.order": "Comandă",
  "nce.tree.search": "Filter by test or sample...",
  "nce.tree.selected": "{sampleCount} samples, {resultCount} results selected",
  "nce.trigger.order_cancellation": "Order cancellation may require NCE documentation",
  "nce.trigger.partial_sample_rejection": "Partial sample rejection requires NCE documentation",
  "nce.trigger.pathology_rejection": "Pathology case rejection may require NCE documentation",
  "nce.trigger.premature_disposal": "Premature disposal may require NCE documentation",
  "nce.trigger.qc_invalidation": "QC invalidation requires NCE documentation",
  "nce.trigger.referral_rejection": "Referral rejection requires NCE documentation",
  "nce.trigger.result_rejection_no_retest": "Result rejection without retest requires NCE documentation",
  "nce.trigger.result_rejection_retest": "Result rejection with retest may require NCE documentation",
  "nce.trigger.sample_rejection": "Sample rejection requires NCE documentation",
  "nce.trigger.test_cancel_no_results": "Test cancellation may require NCE documentation",
  "nce.trigger.test_cancel_with_results": "Test cancellation with results requires NCE documentation",
  "nce.type.calibration_failure": "Calibration failure",
  "nce.type.communication_failure": "Communication failure",
  "nce.type.contamination": "Contamination",
  "nce.type.documentation_error": "Documentation error",
  "nce.type.equipment_malfunction": "Equipment malfunction",
  "nce.type.labeling_error": "Labeling error",
  "nce.type.patient_id_mismatch": "Patient ID mismatch",
  "nce.type.policy_violation": "Policy violation",
  "nce.type.procedure_deviation": "Procedure deviation",
  "nce.type.qc_failure": "QC failure",
  "nce.type.reagent_issue": "Reagent issue",
  "nce.type.report_delay": "Report delay",
  "nce.type.report_distribution_error": "Report distribution error",
  "nce.type.requisition_incomplete": "Requisition incomplete",
  "nce.type.resource_shortage": "Resource shortage",
  "nce.type.result_interpretation_error": "Result interpretation error",
  "nce.type.sample_collection_error": "Sample collection error",
  "nce.type.staff_competency_issue": "Staff competency issue",
  "nce.type.storage_error": "Storage error",
  "nce.type.system_error": "System error",
  "nce.type.training_gap": "Training gap",
  "nce.type.transcription_error": "Transcription error",
  "nce.type.transport_issue": "Transport issue",
  "nce.type.request_form_error": "Request form error",
  "nce.type.equipment_failure": "Equipment failure",
  "nce.type.procedure_error": "Procedure error",
  "nce.type.calibration_error": "Calibration error",
  "nce.type.cross_contamination": "Cross-contamination",
  "nce.type.result_transcription_error": "Result transcription error",
  "nce.type.report_delivery_error": "Report delivery error",
  "nce.type.critical_value_not_reported": "Critical value not reported",
  "nce.type.delayed_result": "Delayed result",
  "nce.type.result_amendment": "Result amendment",
  "nce.type.training_issue": "Training issue",
  "nce.button.createNce": "Create NCE",
  "nce.button.skip": "Skip",
  "nce.creating": "Creating NCE...",
  "nce.description.placeholder": "Describe the non-conforming event...",
  "nce.error.create.failed": "Failed to create NCE",
  "nce.error.severity.required": "Severity is required",
  "nce.trigger.mandatory.message": "You must create an NCE before proceeding with this action.",
  "nce.trigger.mandatory.title": "NCE Required",
  "nce.trigger.order_cancellation.message": "Order cancellation may require documentation of a non-conforming event.",
  "nce.trigger.order_cancellation.title": "Order Cancellation - NCE",
  "nce.trigger.partial_sample_rejection.message": "Partial sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.partial_sample_rejection.title": "Partial Sample Rejection - NCE Required",
  "nce.trigger.pathology_rejection.message": "Pathology case rejection may require documentation of a non-conforming event.",
  "nce.trigger.pathology_rejection.title": "Pathology Rejection - NCE",
  "nce.trigger.premature_disposal.message": "Premature disposal may require documentation of a non-conforming event.",
  "nce.trigger.premature_disposal.title": "Premature Disposal - NCE",
  "nce.trigger.qc_invalidation.message": "QC invalidation requires documentation of a non-conforming event.",
  "nce.trigger.qc_invalidation.title": "QC Invalidation - NCE Required",
  "nce.trigger.referral_rejection.message": "Referral rejection requires documentation of a non-conforming event.",
  "nce.trigger.referral_rejection.title": "Referral Rejection - NCE Required",
  "nce.trigger.result_rejection_no_retest.message": "Result rejection without retest requires documentation of a non-conforming event.",
  "nce.trigger.result_rejection_no_retest.title": "Result Rejection - NCE Required",
  "nce.trigger.result_rejection_retest.message": "Result rejection with retest may require documentation of a non-conforming event.",
  "nce.trigger.result_rejection_retest.title": "Result Rejection - NCE",
  "nce.trigger.sample_rejection.message": "Sample rejection requires documentation of a non-conforming event.",
  "nce.trigger.sample_rejection.title": "Sample Rejection - NCE Required",
  "nce.trigger.test_cancel_no_results.message": "Test cancellation may require documentation of a non-conforming event.",
  "nce.trigger.test_cancel_no_results.title": "Test Cancellation - NCE",
  "nce.trigger.test_cancel_with_results.message": "Test cancellation with existing results requires documentation of a non-conforming event.",
  "nce.trigger.test_cancel_with_results.title": "Test Cancellation - NCE Required",
  "nce.admin.trigger.config.title": "NCE Trigger Configuration",
  "nce.admin.trigger.config.description": "Configure when Non-Conforming Events are automatically created or prompted.",
  "nce.admin.trigger.behaviors.title": "Trigger Behaviors",
  "nce.admin.rejection.mappings.title": "Rejection Reason Mappings",
  "nce.admin.rejection.mappings.description": "Map rejection reasons to NCE categories for automatic population.",
  "nce.trigger.behavior.mandatory": "Mandatory",
  "nce.trigger.behavior.prompted": "Prompted",
  "nce.trigger.behavior.disabled": "Disabled",
  "nce.trigger.column.type": "Trigger Type",
  "nce.trigger.column.description": "Descriere",
  "nce.trigger.column.behavior": "Behavior",
  "nce.trigger.column.active": "Activ",
  "nce.trigger.type.sampleRejection": "Sample Rejection",
  "nce.trigger.type.resultRejection": "Result Rejection",
  "nce.trigger.type.qaEvent": "QA Event",
  "nce.trigger.type.manual": "Manual",
  "nce.trigger.update.success": "Trigger configuration updated",
  "nce.trigger.update.error": "Failed to update trigger configuration",
  "nce.mapping.add": "Add Mapping",
  "nce.mapping.edit": "Edit Mapping",
  "nce.mapping.column.rejectionReason": "Rejection Reason",
  "nce.mapping.column.category": "Categorie NCE",
  "nce.mapping.column.type": "Tip NCE",
  "nce.mapping.column.severity": "Default Severity",
  "nce.mapping.column.active": "Activ",
  "nce.mapping.noData": "No rejection mappings configured",
  "nce.mapping.validation.error": "Rejection reason and category are required",
  "nce.mapping.save.success": "Mapping saved successfully",
  "nce.mapping.active": "Activ",
  "nce.field.category": "Categorie",
  "nce.field.type": "Type",
  "nce.select.category": "Select a category",
  "nce.select.type": "Select a type",
  "nce.error.dateOfEvent.required": "Date of event is required",
  "nce.error.reportingUnit.required": "Reporting unit is required",
  "nce.error.description.required": "Description is required",
  "nce.error.suspectedCauses.required": "Suspected causes are required",
  "nce.error.proposedAction.required": "Proposed action is required",
  "nce.error.category.required": "Category is required",
  "nce.attachment.saveFirst": "Save the NCE event to enable file attachments",
  "nce.attachment.error.noEvent": "Please save the NCE event first before uploading attachments",
  "nce.attachment.download": "Download",
  "nce.attachment.delete": "Delete",
  "requester.add.new.restricted": "Adding a new organization has been disabled by your administrator.",
  "requester.add.new.restricted.organization.contact": "Entering contact info for a new organization has been disabled by your administrator. Search for an existing organization above.",
  "requester.add.new.restricted.provider": "Adding a new provider has been disabled by your administrator.",
  "requester.add.new.restricted.provider.contact": "Entering contact info for a new provider has been disabled by your administrator. Search for an existing provider above.",
  "requester.add.new.restricted.requestor": "Adding a new requestor has been disabled by your administrator. Search for an existing requestor above.",
  "requester.contact.search": "Requestor Search",
  "requester.contact.search.helper": "Search for the contact person requesting these tests, or enter a new one below. At least one of Requesting Organization or Requestor is required.",
  "requester.organization.add.new": "+ Add new organization \"{name}\"",
  "requester.organization.email": "Organization Email",
  "requester.organization.fax": "Organization Fax",
  "requester.organization.new.helper": "Will be created as a new organization when this order is saved.",
  "requester.organization.new.tag": "New",
  "requester.organization.no.match": "No matching organization found.",
  "requester.organization.phone": "Organization Phone",
  "requester.organization.search": "Requesting Organization Search",
  "requestor.add.new": "+ Add new requestor \"{name}\"",
  "requestor.add.new.restricted": "Adding a new requestor has been disabled by your administrator.",
  "requestor.department": "Department",
  "requestor.email": "Email",
  "requestor.fax": "Fax",
  "requestor.firstName": "Prenume",
  "requestor.lastName": "Nume",
  "requestor.name": "Requestor Name",
  "requestor.name.placeholder": "Enter requestor name",
  "requestor.new.helper": "Will be created as a new requestor when this order is saved.",
  "requestor.new.tag": "New",
  "requestor.no.match": "No matching requestor found.",
  "requestor.phone": "Phone",
  "requestor.search.helper": "Type at least 2 characters to auto-search.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "All lots",
  "result.pool.filter.allPools": "All pools",
  "result.pool.filter.clear": "Clear filter",
  "result.pool.filter.count": "Showing {shown} of {total} results",
  "result.pool.filter.lot": "Filter by lot",
  "result.pool.filter.pool": "Filter by pool",
  "result.pool.intake": "Intake pool",
  "result.pool.subpool": "Sub-pool {n}",
  "result.vectorPool.label": "Pool of {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "Uncertainty must be a non-negative number.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Probă",
  "sample.referToReferenceLab.helper": "Mark if this sample requires testing at an external reference laboratory.",
  "sampleAcceptance.action.moveDown": "Move down",
  "sampleAcceptance.action.moveUp": "Move up",
  "sampleAcceptance.banner.resampledFrom": "This is a replacement created by a resample of sample #{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Replacement sample",
  "sampleAcceptance.banner.resampledTo": "This sample was rejected and resampled. Replacement order: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Resampled",
  "sampleAcceptance.button.addItem": "Add item",
  "sampleAcceptance.col.active": "Activ",
  "sampleAcceptance.col.label": "Label",
  "sampleAcceptance.col.order": "Comandă",
  "sampleAcceptance.col.statusForDomain": "Status for this domain",
  "sampleAcceptance.domain.all": "All domains",
  "sampleAcceptance.domain.clinical": "Clinical",
  "sampleAcceptance.domain.environmental": "Environmental",
  "sampleAcceptance.domain.vector": "Vector",
  "sampleAcceptance.enforcement.help": "Enforcement is set per domain, not per lab unit — a reception clerk spans many lab units.",
  "sampleAcceptance.enforcement.label": "Checklist enforcement — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Mandatory — block Step 3 until complete",
  "sampleAcceptance.enforcement.off": "Off — hide the checklist",
  "sampleAcceptance.enforcement.optional": "Optional — record but don't block",
  "sampleAcceptance.gate.blocked": "Intake acceptance is mandatory for this domain — accept every specimen (or report an NCE / resample) before this order can proceed.",
  "sampleAcceptance.labWide.heading": "Lab-wide items (apply unless a domain overrides)",
  "sampleAcceptance.labWide.inherited": "Lab-wide items — inherited (active fallback)",
  "sampleAcceptance.labWide.superseded": "Lab-wide items — superseded here (edit from “All domains”)",
  "sampleAcceptance.notify.enforcementSaved": "Enforcement updated",
  "sampleAcceptance.notify.itemAdded": "Checklist item added",
  "sampleAcceptance.notify.itemSaved": "Checklist item saved",
  "sampleAcceptance.notify.recordFailed": "Failed to record acceptance",
  "sampleAcceptance.notify.rejectFailed": "Failed to reject",
  "sampleAcceptance.notify.resampleFailed": "Failed to resample",
  "sampleAcceptance.ownItems.empty": "No items yet — this domain falls back to the lab-wide list below.",
  "sampleAcceptance.ownItems.heading": "{domain} items",
  "sampleAcceptance.qa.accepted.success": "Acceptance recorded",
  "sampleAcceptance.qa.answer.fail": "Fail",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Pass",
  "sampleAcceptance.qa.button.accept": "Accept sample",
  "sampleAcceptance.qa.button.reject": "Respinge",
  "sampleAcceptance.qa.button.resample": "Resample",
  "sampleAcceptance.qa.context.collected": "Collected",
  "sampleAcceptance.qa.context.longTransit": "long transit — your call",
  "sampleAcceptance.qa.context.note": "Transit is shown for reference only — it does not auto-grade anything. Active list: {domain}.",
  "sampleAcceptance.qa.context.received": "Received",
  "sampleAcceptance.qa.context.transit": "Transit time",
  "sampleAcceptance.qa.empty": "No acceptance checklist is configured for this domain.",
  "sampleAcceptance.qa.failHint": "This sample has failed checks — report an NCE or resample instead of accepting.",
  "sampleAcceptance.qa.noSample": "Save collection to run intake acceptance for this specimen.",
  "sampleAcceptance.qa.note.label": "Note (optional)",
  "sampleAcceptance.qa.note.placeholder": "Optional — note any observed condition",
  "sampleAcceptance.qa.status.accepted": "Accepted",
  "sampleAcceptance.qa.status.pending": "Pending",
  "sampleAcceptance.qa.status.rejected": "Rejected",
  "sampleAcceptance.qa.status.review": "Review",
  "sampleAcceptance.qa.subtitle": "Complete the acceptance checklist for this sample",
  "sampleAcceptance.qa.subtitle.rejected": "This specimen was rejected and resampled — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "This catch was rejected — read-only.",
  "sampleAcceptance.qa.title": "Intake acceptance",
  "sampleAcceptance.reject.commit": "Commit reject",
  "sampleAcceptance.reject.info": "Reject this catch as unusable. This cannot be re-collected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.reject.reason.required": "A reason is required",
  "sampleAcceptance.reject.success": "Sample rejected.",
  "sampleAcceptance.reject.title": "Reject — {labNumber}",
  "sampleAcceptance.resample.commit": "Commit resample",
  "sampleAcceptance.resample.info": "Reject this sample and create a new collection order for re-collection. The requester will be notified.",
  "sampleAcceptance.resample.reason.label": "Reason (pre-filled from failed items — editable)",
  "sampleAcceptance.resample.reason.required": "A reason is required",
  "sampleAcceptance.resample.success": "Resample created — new order {accession}. Requester notified.",
  "sampleAcceptance.resample.title": "Resample — {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Eligibility",
  "sampleAcceptance.review.col.labNo": "Lab #",
  "sampleAcceptance.review.col.sampleType": "Sample type",
  "sampleAcceptance.review.col.transit": "Transit",
  "sampleAcceptance.review.noSamples": "No collected specimens to review yet.",
  "sampleAcceptance.review.subtitle": "Select a sample to complete its acceptance checklist",
  "sampleAcceptance.review.title": "Intake Acceptance",
  "sampleAcceptance.status.active": "Activ",
  "sampleAcceptance.status.inactive": "Inactive",
  "sampleAcceptance.status.inheritedActive": "Active (inherited)",
  "sampleAcceptance.status.superseded": "Superseded",
  "sampleAcceptance.title": "Sample Acceptance Checklist",
  "sidenav.label.admin.nceTriggerConfig": "Trigger Configuration",
  "sidenav.label.admin.nceCategoryType": "Categories & Types",
  "sidenav.label.admin.nceConfig": "NCE Configuration",
  "nce.admin.categorytype.title": "NCE Categories & Types Configuration",
  "nce.admin.categorytype.description": "Manage the categories and types available for Non-Conforming Events.",
  "nce.admin.tab.categories": "Categories",
  "nce.admin.tab.types": "Types",
  "nce.admin.category.add": "Add Category",
  "nce.admin.category.edit": "Edit Category",
  "nce.admin.category.name.required": "Category name is required",
  "nce.admin.category.save.success": "Category saved successfully",
  "nce.admin.category.save.error": "Failed to save category",
  "nce.admin.type.add": "Add Type",
  "nce.admin.type.edit": "Edit Type",
  "nce.admin.type.validation.error": "Type name and category are required",
  "nce.admin.type.save.success": "Type saved successfully",
  "nce.admin.type.save.error": "Failed to save type",
  "nce.admin.column.name": "Nume",
  "nce.admin.column.displayKey": "Display Key",
  "nce.admin.column.typesCount": "Types Count",
  "nce.admin.column.category": "Categorie",
  "nce.admin.column.actions": "Actions",
  "nce.admin.field.name": "Nume",
  "nce.admin.field.displayKey": "Display Key (for i18n)",
  "nce.admin.field.displayKey.helper": "Optional. Used for translations.",
  "nce.admin.field.category": "Categorie",
  "nce.admin.delete.confirm.title": "Confirmă ștergerea",
  "nce.admin.delete.confirm.message": "Are you sure you want to delete '{name}'? This action cannot be undone.",
  "nce.admin.delete.success": "Deleted successfully",
  "nce.inline.title": "Report Non-Conformity Event",
  "nce.inline.context": "CONTEXT (Auto-populated)",
  "nce.dashboard.title": "All NCEs",
  "nce.dashboard.subtitle": "All open NCEs across the laboratory",
  "nce.button.reportNce": "Report NCE",
  "nce.search.placeholder": "Search NCEs...",
  "nce.filter.allStatus": "All Status",
  "nce.filter.allCategories": "All Categories",
  "nce.filter.allSeverities": "All Severities",
  "nce.filter.clearAll": "Clear All",
  "nce.summary.critical": "Critical",
  "nce.summary.major": "Major",
  "nce.summary.minor": "Minor",
  "nce.summary.overdue": "Overdue",
  "nce.tag.overdue": "Overdue",
  "nce.tab.eventDetails": "Event Details",
  "nce.tab.investigation": "Investigation",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "History",
  "nce.field.suspectedCauses": "Suspected Causes",
  "nce.field.proposedAction": "Acțiune propusă",
  "nce.field.trigger": "Trigger",
  "nce.capa.noItems": "No corrective/preventive actions recorded yet.",
  "nce.history.noItems": "No history available.",
  "nce.history.system": "System",
  "nce.action.acknowledge": "Acknowledge",
  "nce.action.assignTo": "Assign To",
  "nce.action.addNote": "Add Note",
  "nce.action.close": "Close NCE",
  "nce.action.startCorrectiveAction": "Start Corrective Action",
  "nce.link.duplicate.warning": "These specimens are already linked to this NCE",
  "nce.list.empty": "No NCEs found matching your criteria.",
  "nce.modal.addNote": "Add Note",
  "nce.modal.addNoteDescription": "Add a note to NCE {nceNumber}",
  "nce.modal.notePlaceholder": "Enter your note...",
  "nce.modal.assign": "Assign NCE",
  "nce.modal.assignDescription": "Assign NCE {nceNumber} to a user",
  "nce.modal.selectUser": "Select User",
  "nce.modal.searchUser": "Search for a user...",
  "nce.assign.selectUser": "Please select a user to assign",
  "nce.assign.success": "NCE assigned successfully",
  "nce.assign.error": "Failed to assign NCE",
  "nce.acknowledge.success": "NCE acknowledged successfully",
  "nce.acknowledge.error": "Failed to acknowledge NCE",
  "nce.note.empty": "Please enter a note",
  "nce.note.success": "Note added successfully",
  "nce.note.error": "Failed to add note",
  "nce.attachment.downloadError": "Failed to download attachment",
  "nce.attachment.viewError": "Failed to view attachment",
  "not.available": "Not available",
  "not.specified": "Not specified",
  "notAuthenticated": "Neautentificat",
  "notebook.attachments.title": "Attachments",
  "notebook.attachments.uploadPrompt": "click to upload files",
  "notebook.auditTrail.action.archived": "Archived",
  "notebook.auditTrail.action.created": "Created",
  "notebook.auditTrail.action.finalized": "Finalized",
  "notebook.auditTrail.action.locked": "Locked",
  "notebook.auditTrail.action.submitted": "Submitted",
  "notebook.auditTrail.action.updated": "Updated",
  "notebook.auditTrail.comingSoon": "Audit trail functionality will be available soon.",
  "notebook.auditTrail.none.subtitle": "No audit trail entries found for this notebook.",
  "notebook.auditTrail.none.title": "No Audit Trail Available",
  "notebook.auditTrail.title": "Jurnal audit",
  "notebook.button.edit": "Editează",
  "notebook.button.editResults": "Edit Results",
  "notebook.button.enterResults": "Enter Results",
  "notebook.button.newLabNotebook": "Proiect",
  "notebook.button.view": "Vizualizează",
  "notebook.comments.add.button": "Add Comment",
  "notebook.comments.add.label": "Add a comment",
  "notebook.comments.none.subtitle": "No comments have been added yet.",
  "notebook.comments.none.title": "No Comments",
  "notebook.comments.title": "Comentarii",
  "notebook.error.notAssigned": "You are not assigned to this project",
  "notebook.heading.allEntries": "All Entries",
  "notebook.heading.notebooks": "Projects",
  "notebook.icon.edit": "Editează",
  "notebook.instruments.title": "Instruments",
  "notebook.label.addpage": "Add Page",
  "notebook.label.author": "Author",
  "notebook.label.basicinfo": "Basic Information",
  "notebook.label.content": "Main Content",
  "notebook.label.dashboard": "Notebook Dashboard",
  "notebook.label.drafts": "Drafts",
  "notebook.label.entry": "Notebook Entry",
  "notebook.label.entryFiles": "Entry Files",
  "notebook.label.instanceEntry": "Notebook Instance Entry",
  "notebook.label.entryTags": "Entry Tags",
  "notebook.label.experimentDoc": "Experiment Documentation",
  "notebook.label.experimentType": "Experiment Type",
  "notebook.label.filter.types": "Experiment Types",
  "notebook.label.finalized": "Finalized This Week",
  "notebook.label.formEntry": "NoteBook Form Entry",
  "notebook.label.objective": "Objective",
  "notebook.label.pages": "WorkFlow Pages",
  "notebook.label.pending": "Pending Review",
  "notebook.label.project": "Proiect",
  "notebook.label.project.title": "Project Title",
  "notebook.label.projectFiles": "Project Files",
  "notebook.label.projectTags": "Project Tags",
  "notebook.label.protocol": "Protocol ID",
  "notebook.label.questionnaire": "Questionnaire",
  "notebook.label.sampleManagement": "Sample Management",
  "notebook.label.status": "Stare",
  "notebook.label.technician": "Technician",
  "notebook.label.title": "Entry Title",
  "notebook.label.total": "Total Entries",
  "notebook.page.completed": "Completed",
  "notebook.page.content": "Content:",
  "notebook.page.instructions": "Instrucțiuni:",
  "notebook.page.markComplete": "Mark as Complete",
  "notebook.page.modal.add.errorRequired": "Title and Content are required.",
  "notebook.page.modal.add.title": "Add New Page",
  "notebook.page.modal.content.label": "Content",
  "notebook.page.modal.edit.title": "Edit Page",
  "notebook.page.modal.instructions.label": "Instructions",
  "notebook.page.modal.title.label": "Title",
  "notebook.page.title": "Notebook",
  "notebook.pages.none.subtitle": "Click to add Pages",
  "notebook.pages.none.title": "No Pages Added",
  "notebook.project.definition.form.title": "Project Definition Form",
  "notebook.project.entry.form.title": "Project Entry Form",
  "notebook.results.modal.title": "Results for {accession}",
  "notebook.results.noAccession": "No accession number available for this sample",
  "notebook.results.none.subtitle": "No results found for the provided accession number.",
  "notebook.results.none.title": "No Results Found",
  "notebook.results.title": "Rezultate",
  "notebook.sample.result.dateCreated": "Date Created",
  "notebook.samples.available": "Available Samples",
  "notebook.samples.none.subtitle": "Search Samples By Patient or Accession Number",
  "notebook.samples.none.subtitle.selected": "Click to add samples",
  "notebook.samples.none.title": "No samples Available",
  "notebook.samples.none.title.selected": "No Samples Selected",
  "notebook.samples.resultsRecorded": "Results Recorded:",
  "notebook.samples.selected": "Selected Samples",
  "notebook.search.byAccession": "Search By Accession",
  "notebook.search.byPatient": "Caută după pacient",
  "notebook.select.label": "Select Notebook",
  "notebook.status.archived": "Archive Entry",
  "notebook.status.assignment.title": "Status and Assignment",
  "notebook.status.draft": "Save Draft",
  "notebook.status.finalized": "Finalize Entry",
  "notebook.status.locked": "Lock Entry",
  "notebook.status.metadata.title": "Status & Metadata",
  "notebook.status.submitted": "Submit for Review",
  "notebook.tab.attachments": "Attachments",
  "notebook.tab.auditTrail": "Jurnal audit",
  "notebook.tab.comments": "Comentarii",
  "notebook.tab.content": "Content",
  "notebook.tab.entryDetails": "Entry Details",
  "notebook.tab.metadata": "MetaData",
  "notebook.tab.results": "Rezultate",
  "notebook.tab.samples": "Samples",
  "notebook.tab.workflow": "Workflow",
  "notebook.table.header.entries": "Entries",
  "notebook.tag.placeholder": "Enter Tags",
  "notebook.tags.add": "Add Tag",
  "notebook.tags.modal.add.errorRequired": "Tag is required.",
  "notebook.tags.modal.add.label": "Tag",
  "notebook.tags.modal.add.title": "Add New Tag",
  "notebook.tags.title": "Tags",
  "notebook.validation.content.required": "Main Content is required.",
  "notebook.validation.objective.required": "Objective is required.",
  "notebook.validation.project.required": "Project is required.",
  "notebook.validation.protocol.required": "Protocol ID is required.",
  "notebook.validation.title.required": "Title is required.",
  "notebook.validation.type.required": "Experiment Type is required.",
  "notification.error": "Error",
  "notification.info": "Information",
  "notification.invalid.confirm.password": "Parolele introduse nu se potrivesc.",
  "notification.invalid.loginName": "Introduceți doar caractere alfanumerice fără spații.",
  "notification.invalid.name": "Introduceți doar caractere alfanumerice.",
  "notification.invalid.password": "Introduceți o parolă conform instrucțiunilor.",
  "notification.login.generic.error": "Eroare la autentificare",
  "notification.login.syntax.error": "Eroare la autentificare – Nu s-a putut interpreta răspunsul ca JSON",
  "notification.organization.post.delete.success": "Organizația a fost dezactivată cu succes.",
  "notification.organization.post.internetAddress": "Introduceți un URL valid al organizației.",
  "notification.organization.post.save.success": "Informațiile organizației au fost adăugate cu succes.",
  "notification.organization.post.success": "Informațiile organizației au fost actualizate cu succes.",
  "notification.password.change.fail": "Schimbarea parolei a eșuat",
  "notification.password.change.success": "Parola a fost schimbată cu succes",
  "notification.response.syntax.error": "Eroare – Nu s-a putut interpreta răspunsul ca JSON",
  "notification.slideover.button.hideread": "Ascunde citite",
  "notification.slideover.button.markallasread": "Marchează toate ca citite",
  "notification.slideover.button.markasread": "Marchează ca citit",
  "notification.slideover.button.reload": "Reîncarcă",
  "notification.slideover.button.showread": "Afișează citite",
  "notification.slideover.button.subscribe": "Abonează-te pe acest dispozitiv",
  "notification.slideover.button.subscribe.fail": "Abonarea a eșuat",
  "notification.slideover.button.subscribe.success": "Abonare realizată cu succes",
  "notification.slideover.button.unsubscribe": "Dezabonare",
  "notification.slideover.button.unsubscribe.fail": "Dezabonarea a eșuat",
  "notification.slideover.button.unsubscribe.success": "Dezabonare realizată cu succes",
  "notification.slideover.empty.header": "Ești la zi",
  "notification.sliderover.empty.message": "Nu ai nicio notificare în acest moment.",
  "notification.title": "Mesaj notificare",
  "notification.user.post.delete.success": "Utilizatorul a fost dezactivat cu succes.",
  "notification.user.post.save.success": "Informațiile utilizatorului au fost adăugate cu succes.",
  "notify.error": "Utilizatorul și mesajul sunt obligatorii",
  "notify.main.title": "Notificare utilizator",
  "notify.message": "Mesaj",
  "notify.user.by": "Utilizator de notificat",
  "notify.user.success.notification": "Notificare trimisă cu succes",
  "of": "din",
  "openreports.activity.title": "Rapoarte activitate",
  "openreports.aggregate.title": "Rapoarte agregate",
  "openreports.all.test.summary.title": "Sumar raport teste",
  "openreports.all.tests.aggregate": "Sumar toate testele",
  "openreports.hiv.aggregate": "Sumar teste HIV",
  "openreports.management.title": "Rapoarte de management",
  "openreports.mgt.nonconformity.date": "Raport neconformități după dată",
  "openreports.mgt.nonconformity.section": "Raport neconformități după unitate și motiv",
  "openreports.mgt.rejection": "Raport respingeri",
  "openreports.patient.EID.version1": "EID - Versiunea 1",
  "openreports.patient.EID.version2": "EID - Versiunea 2",
  "openreports.patient.VL.version1": "Încărcătură virală - Versiune națională",
  "openreports.patientTestStatus": "Raport stare pacient",
  "openreports.patientreports.title": "Raport stare pacient",
  "openreports.stat.aggregate": "Raport statistic",
  "order.accept": "Acceptă",
  "order.accept.error": "Failed to accept order",
  "order.additionalInfo": "Informații suplimentare",
  "order.additionalInfo.helper": "Optional notes about this order",
  "order.clinicalInfo": "Clinical Information",
  "order.continue": "Continue",
  "order.current.time": "Ora curentă (hh:mm)",
  "order.dashboard.empty": "No orders found",
  "order.dashboard.title": "Order Dashboard",
  "order.department.label": "secție/departament/unitate:",
  "order.diagnosis.helper": "Working diagnosis — guides test selection. Not recorded as a confirmed diagnosis.",
  "order.diagnosis.placeholder": "Enter diagnosis or clinical notes",
  "order.entry.setup": "Configurare introducere comenzi în lot",
  "order.external": "External",
  "order.facility": "Instituție",
  "order.filter.priority": "Filter by Priority",
  "order.filter.status": "Filter by Status",
  "order.fixIssue": "Fix Issue",
  "order.form.label": "Formular:",
  "order.form.select": "Selectează formular",
  "order.generate.barcode": "Generează cod de bare și salvează",
  "order.generate.barcode.history": "Număr de accesare folosit anterior",
  "order.if.other.label": "dacă altul, specificați:",
  "order.invalid.requester.name.label": "nume solicitant invalid",
  "order.invalid.site.name": "Nume locație invalid",
  "order.labNumber": "Număr laborator",
  "order.labNumber.generate": "Generate Lab Number",
  "order.labNumber.helper": "Unique identifier for this order",
  "order.attachment.action.delete": "Delete attachment",
  "order.attachment.action.download": "Download attachment",
  "order.attachment.action.view": "View attachment",
  "order.attachment.column.actions": "Actions",
  "order.attachment.column.fileName": "File name",
  "order.attachment.column.fileSize": "Size",
  "order.attachment.column.fileType": "Type",
  "order.attachment.column.uploadedAt": "Uploaded at",
  "order.attachment.delete.confirm.body": "Are you sure you want to delete \"{fileName}\"? This cannot be undone.",
  "order.attachment.delete.confirm.title": "Delete attachment",
  "order.attachment.delete.failed": "Could not delete the attachment. Please try again.",
  "order.attachment.dropzone": "Drag and drop files here, or click to browse",
  "order.attachment.empty": "No attachments yet.",
  "order.attachment.error.maxFiles": "You can attach at most {maxFiles} files.",
  "order.attachment.error.size": "Each file must be {maxSize} or smaller.",
  "order.attachment.error.type": "Allowed file types: {types}",
  "order.attachment.heading": "Attachments",
  "order.attachment.hint": "Optional. Up to {maxFiles} files, 10MB each. Allowed: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "One or more attachments could not be uploaded.",
  "order.labNumber.placeholder": "Enter or generate lab number",
  "order.label.add": "Adaugă comandă",
  "order.label.modify": "Modifică comandă",
  "order.legend.EDTATube": "Tub EDTA",
  "order.legend.commonFields": "Câmpuri comune",
  "order.legend.configureBarcode": "Configurează introducerea codului de bare",
  "order.legend.dryBloodSpot": "Picătură de sânge uscat",
  "order.legend.dryTube": "Tub uscat",
  "order.legend.facility": "Instituție",
  "order.legend.onDemand": "La cerere",
  "order.legend.optionalFields": "Câmpuri opționale",
  "order.legend.patient": "Informații pacient",
  "order.legend.preDemand": "Pre-tipărit",
  "order.legend.sample": "Probă",
  "order.legend.selectMethod": "Selectează metodă",
  "order.legend.siteName": "Nume locație",
  "order.legend.specimen.collected": "Specimen recoltat",
  "order.legend.tests": "Teste",
  "order.legend.viralLoadTest": "Test încărcătură virală",
  "order.lastUpdated": "Last Updated",
  "order.load.error": "Failed to load order",
  "order.location": "Locație",
  "order.new": "New Order",
  "order.payment.status.label": "Stare plată pacient:",
  "order.paymentStatus": "Payment Status",
  "order.previousLabNumber": "Număr laborator anterior",
  "order.previousLabNumber.placeholder": "Enter previous lab number if applicable",
  "order.printLabels": "Print Labels",
  "order.printLabels.info": "Print barcodes for this order",
  "order.priority": "Prioritate",
  "order.progress": "Progress",
  "order.provisionalDiagnosis": "Provisional Diagnosis",
  "order.received.time": "Ora recepției (hh:mm)",
  "order.reception.time": "Ora recepției (hh:mm) :",
  "order.remember.site.and.requester.label": "Reține locația și solicitantul",
  "order.readonly.message": "This order is in read-only mode",
  "order.requester": "Solicitant",
  "order.requester.email.label": "Email solicitant:",
  "order.requester.fax.label": "Fax solicitant:",
  "order.requester.firstName.label": "Prenume solicitant:",
  "order.requester.lastName.label": "Nume solicitant:",
  "order.requester.phone.label": "Telefon solicitant:",
  "order.requester.provisionalDiagnosis.label": "Provisional Clinical Diagnosis:",
  "order.result.reporting.heading": "RAPORTARE REZULTATE",
  "order.sampleCategory": "Sample Category",
  "order.sampleCategory.helper": "Select the category of sample to collect",
  "order.sampling.performed.label": "Prelevare efectuată pentru analiză:",
  "order.search.requester.label": "Caută solicitant",
  "order.saveStatus.error": "Salvarea a eșuat",
  "order.saveStatus.saved": "Saved",
  "order.saveStatus.saving": "Saving...",
  "order.saveStatus.unsaved": "Unsaved changes",
  "order.save.incomplete": "Please add a patient (or sampling site) and at least one sample type before saving.",
  "order.saved.draft": "Draft saved",
  "order.search.placeholder": "Search orders...",
  "order.search.site.name": "Caută nume locație",
  "order.send.toAnalyzer": "Send to analyzer",
  "order.send.modal.title": "Send order to analyzer",
  "order.send.modal.confirm": "Trimite",
  "order.send.modal.cancel": "Anulează",
  "order.send.modal.analyzerLabel": "Target analyzer",
  "order.send.modal.accession": "Order accession: {accession}",
  "order.send.modal.noAnalyzers": "No analyzers are configured for LIS-initiated dispatch.",
  "order.send.success": "Order dispatched",
  "order.send.error": "Failed to dispatch order",
  "order.send.unknownError": "Unknown bridge error",
  "order.send.missingAccession": "Order has no accession number to correlate the result.",
  "order.site.name": "Nume locație:",
  "order.step.collect": "Collect",
  "order.step.complete": "Complet",
  "order.step.enter": "Introduceți comanda",
  "order.step.label": "Label & Store",
  "order.step.patient.info": "Informații pacient",
  "order.step.program.selection": "Selectare program",
  "order.step.qa": "QA Review",
  "order.start.new": "Start New Order",
  "order.submit.labNumber": "Submit with Lab Number",
  "order.submit.success": "Order submitted successfully",
  "order.submitted.success.msg": "Order has been submitted successfully",
  "order.summary.accessionNumber": "Număr accesare",
  "order.summary.collectionDate": "Data recoltării",
  "order.summary.patientName": "Nume pacient",
  "order.summary.sampleType": "Tip probă",
  "order.summary.title": "Order Summary",
  "order.test.request.heading": "Solicitare test",
  "order.title": "COMANDĂ",
  "ordertests.title": "Comandă teste",
  "organization.add.placeholder": "Valori alfanumerice",
  "organization.add.placeholder.active": "Y sau N",
  "organization.add.placeholder.internetAddress": "https://denumireorg.com",
  "organization.add.placeholder.parent": "Organizație părinte",
  "organization.add.title": "Adaugă organizație",
  "organization.city": "Oraș",
  "organization.clia.number": "Număr CLIA",
  "organization.edit.title": "Editează organizație",
  "organization.internetaddress": "Adresă internet",
  "organization.isActive": "Este activ",
  "organization.main.title": "Management organizație",
  "organization.next": "Pagina următoare",
  "organization.organizationName": "Nume organizație",
  "organization.parent": "Organizație părinte",
  "organization.previous": "Pagina anterioară",
  "organization.search.byorgname": "Caută după nume organizație",
  "organization.search.parent.name": "Nume organizație părinte",
  "organization.search.placeHolder": "Caută după nume organizație...",
  "organization.select": "Selectează",
  "organization.short.CI": "Prefix organizație",
  "organization.streetAddress": "Adresă stradală",
  "organization.type.CI": "Tip activitate",
  "organization.type.CI.description": "Tip activitate: Descriere",
  "organization.type.CI.name": "Tip activitate: Nume",
  "organization.type.CI.select": "Tip activitate: Selectează",
  "otherMalignant.placeholder": "Alt tip malign",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Înapoi",
  "pagination.backward": "Pagina anterioară",
  "pagination.forward": "Pagina următoare",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": "{min}-{max} din {total} elemente",
  "pagination.items-per-page": "Elemente pe pagină",
  "pagination.itemsPerPage": "Items per page:",
  "pagination.nextPage": "Next page",
  "pagination.page": "pagina {page}",
  "pagination.page-number": "Număr pagină",
  "pagination.page-range": "din {total} {total, plural, one {pagină} other {pagini}}",
  "pagination.previousPage": "Previous page",
  "panel.existing": "Paneluri existente",
  "panel.existing.inactive": "Paneluri inactive (Atribuie teste pentru activare)",
  "panel.new": "Panel nou",
  "panel.panelName": "Nume panel",
  "pathology.label.addblock": "Adaugă bloc(uri)",
  "pathology.label.addslide": "Adaugă lamă(e)",
  "pathology.label.block": "Bloc",
  "pathology.label.block.add.number": "Număr blocuri de adăugat",
  "pathology.label.block.number": "Număr bloc",
  "pathology.label.blocks": "Blocuri",
  "pathology.label.casesInProgress": "Cazuri în curs",
  "pathology.label.complete": "Complet",
  "pathology.label.conclusion": "Concluzie",
  "pathology.label.dashboard": "Tablou de bord Patologie",
  "pathology.label.grossexam": "Examinare macroscopică",
  "pathology.label.location": "Locație",
  "pathology.label.microexam": "Examinare microscopică",
  "pathology.label.printlabel": "Tipărește eticheta",
  "pathology.label.refer": "Trimite la ImunoHistochimie",
  "pathology.label.release": "Gata pentru eliberare",
  "pathology.label.report": "Raport patologic",
  "pathology.label.request": "Cereri",
  "pathology.label.requests": "Cereri suplimentare de patologie",
  "pathology.label.review": "În așteptarea revizuirii patologice",
  "pathology.label.slide": "Lamă",
  "pathology.label.slide.add.number": "Număr lame de adăugat",
  "pathology.label.slide.number": "număr lamă",
  "pathology.label.slides": "Lame",
  "pathology.label.stage": "Stadiu",
  "pathology.label.techniques": "Tehnici utilizate",
  "pathology.label.textconclusion": "Concluzie text",
  "pathology.label.title": "Patologie",
  "pathology.label.view": "Vezi fișierul",
  "patient.address.camp": "Cartier/Comună",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Hamlet / Lot",
  "patient.address.healthdistrict": "District",
  "patient.address.healthregion": "Regiune",
  "patient.address.province": "Province",
  "patient.address.street": "Stradă",
  "patient.address.town": "Oraș",
  "patient.age.days": "Zile",
  "patient.age.months": "Luni",
  "patient.age.years": "Vârstă/ani",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nume sursă date",
  "patient.dob": "Data nașterii",
  "patient.eduction": "Educație",
  "patient.emergency.additional.camp": "Introdu cartierul/comuna",
  "patient.emergency.additional.district": "Introdu districtul",
  "patient.emergency.additional.education": "Introdu nivelul de educație",
  "patient.emergency.additional.maritalstatus": "Introdu starea civilă",
  "patient.emergency.additional.nationnality": "Introdu naționalitatea",
  "patient.emergency.additional.othernationality": "Introdu altă naționalitate",
  "patient.emergency.additional.region": "Introdu regiunea",
  "patient.emergency.additional.street": "Introdu strada",
  "patient.emergency.additional.town": "Introdu orașul",
  "patient.emergency.email": "Introdu emailul persoanei de urgență",
  "patient.emergency.firstname": "Introdu prenumele persoanei de urgență",
  "patient.emergency.lastname": "Introdu numele persoanei de urgență",
  "patient.emergency.phone": "Introdu telefonul persoanei de urgență",
  "patient.externalId": "CNP",
  "patient.female": "Feminin",
  "patient.first.name": "Prenume",
  "patient.gender": "Gen",
  "patient.gps.latitude": "GPS Latitude",
  "patient.gps.latitude.placeholder": "e.g., -18.879190 (range -90 to 90)",
  "patient.gps.longitude": "GPS Longitude",
  "patient.gps.longitude.placeholder": "e.g., 47.507905 (range -180 to 180)",
  "patient.id": "ID pacient",
  "patient.information.age": "Introdu vârsta",
  "patient.information.days": "Introdu zile",
  "patient.information.email": "Enter Patient Email",
  "patient.information.firstname": "Introdu prenumele pacientului",
  "patient.information.healthid": "Introdu ID-ul unic de sănătate",
  "patient.information.lastname": "Introdu numele de familie al pacientului",
  "patient.information.months": "Introdu luni",
  "patient.information.nationalid": "Introdu CNP-ul",
  "patient.information.primaryphone": "Introdu numărul principal al pacientului",
  "patient.label": "Pacient",
  "patient.label.additionalInfo": "Informații suplimentare",
  "patient.label.age": "Vârstă",
  "patient.label.customNotes": "Custom Notes",
  "patient.label.diseaseProgramme": "Target Disease Programme",
  "patient.label.occupation": "Occupation",
  "patient.label.contactphone": "Telefon contact:{PHONE_FORMAT}",
  "patient.label.email": "Email",
  "patient.label.info": "Informații pacient",
  "patient.label.modify": "Adaugă sau modifică pacient",
  "patient.label.name": "Nume",
  "patient.label.nopatientid": "Nu există informații despre pacient",
  "patient.label.primaryphone": "Telefon principal:{PHONE_FORMAT}",
  "patient.label.sex": "Sex",
  "patient.last.name": "Nume",
  "phone.format.international.label": "International",
  "phone.format.local.label": "Local",
  "patient.male": "Masculin",
  "patient.maritalstatus": "Stare civilă",
  "patient.merge.activeOrders": "Active Orders",
  "patient.merge.address": "Address",
  "patient.merge.addressesDiffer": "Address differs: {primary} vs {secondary}",
  "patient.merge.auditEntries": "Audit Entries (will retain original patient)",
  "patient.merge.back": "Înapoi",
  "patient.merge.cancelButton": "Anulează",
  "patient.merge.clinicalSummary": "Clinical Summary",
  "patient.merge.confirmButton": "Confirm Merge",
  "patient.merge.confirmCheckbox": "I understand this action cannot be undone and have verified the correct patients are being merged",
  "patient.merge.confirmMerge": "Confirm Patient Merge",
  "patient.merge.conflictNote": "(Primary patient demographics will be used)",
  "patient.merge.conflictingInfo": "Conflicting Information Detected",
  "patient.merge.contactInfo": "Contact Information",
  "patient.merge.county": "County/State",
  "patient.merge.dataToConsolidate": "Data to be Consolidated",
  "patient.merge.demographics": "Demographics",
  "patient.merge.dob": "DOB",
  "patient.merge.email": "Email",
  "patient.merge.emailsDiffer": "Email differs: {primary} vs {secondary}",
  "patient.merge.error.alreadyMerged": "Patient has already been merged",
  "patient.merge.error.executionFailed": "Merge execution failed",
  "patient.merge.error.noPermission": "Only Global Administrators can merge patients",
  "patient.merge.error.patientNotFound": "Patient not found",
  "patient.merge.error.samePatient": "Cannot merge a patient with itself",
  "patient.merge.error.selectBoth": "Please select both patients to continue",
  "patient.merge.error.selectPrimary": "Please select which patient should be the primary record",
  "patient.merge.error.validationFailed": "Merge validation failed",
  "patient.merge.externalIds": "External IDs",
  "patient.merge.gender": "Gen",
  "patient.merge.identifiers": "Identifiers",
  "patient.merge.identifiersToPreserve": "Identifiers to Preserve (both patients)",
  "patient.merge.mergeSummary": "Merge Summary",
  "patient.merge.mergingFrom": "Merging From",
  "patient.merge.mergingLabel": "Merging",
  "patient.merge.name": "Nume",
  "patient.merge.nationalId": "CNP",
  "patient.merge.nationalIds": "National IDs",
  "patient.merge.nextStep": "Next Step",
  "patient.merge.noIdentifiers": "No identifiers recorded",
  "patient.merge.noPatientSelected": "No patient selected",
  "patient.merge.notRecorded": "Not recorded",
  "patient.merge.orders": "Orders",
  "patient.merge.ordersCount": "{count} ({active} active)",
  "patient.merge.patientId": "ID pacient",
  "patient.merge.patientIds": "Patient IDs",
  "patient.merge.patientResults": "Patient Results",
  "patient.merge.phone": "Phone",
  "patient.merge.phonesDiffer": "Phone Numbers differ: {primary} vs {secondary}",
  "patient.merge.postalCode": "Postal Code",
  "patient.merge.primaryLabel": "Primary",
  "patient.merge.primaryPatient": "Primary Patient",
  "patient.merge.reason": "Reason for Merge (required)",
  "patient.merge.reasonPlaceholder": "Enter reason for merging these patient records...",
  "patient.merge.recordsReassigned": "{count} records reassigned",
  "patient.merge.samples": "Samples",
  "patient.merge.searchDifferent": "Search for different patient",
  "patient.merge.selectFirstPatient": "Select First Patient",
  "patient.merge.selectPrimaryDescription": "Which patient should become the primary record?",
  "patient.merge.selectPrimaryRecord": "Select Primary Patient Record",
  "patient.merge.selectSecondPatient": "Select Second Patient",
  "patient.merge.step.compare": "Select Primary",
  "patient.merge.step.confirm": "Confirm Merge",
  "patient.merge.step.select": "Select Patients",
  "patient.merge.streetAddress": "Adresă stradală",
  "patient.merge.success": "Patient merge completed successfully",
  "patient.merge.successMessage": "Patient {mergedId} has been merged into patient {primaryId}. Audit ID: {auditId}",
  "patient.merge.testResults": "Rezultate test",
  "patient.merge.title": "Merge Patient Records",
  "patient.merge.totalContacts": "Contacts",
  "patient.merge.totalRelations": "Relations",
  "patient.merge.totalResults": "Total Results",
  "patient.merge.totalSamples": "Samples",
  "patient.merge.town": "Town/City",
  "patient.merge.tryDifferentSearch": "Try adjusting your search criteria or using different patient identifiers.",
  "patient.merge.warning.dataLink": "All future data will be linked to the primary patient. The non-selected patient will be marked as merged and inactive.",
  "patient.merge.warning.irreversible": "This action CANNOT be undone. All data will be permanently consolidated.",
  "patient.merge.warning.samePatient": "Same patient selected",
  "patient.merge.warning.samePatientDescription": "You have selected the same patient for both records. Please select two different patients to merge.",
  "patient.natioanalid": "CNP",
  "patient.nationalid": "CNP",
  "patient.nationality": "Naționalitate",
  "patient.nationality.other": "Specifică altă naționalitate",
  "patient.photo.active.camera": "Click to activate camera",
  "patient.photo.add": "Add Photo",
  "patient.photo.browse": "Click to browse files",
  "patient.photo.camera.permission.denied": "Camera permission denied. Please check your browser settings.",
  "patient.photo.cancel": "Anulează",
  "patient.photo.capture": "Capture Photo",
  "patient.photo.captured": "Captured Photo:",
  "patient.photo.change": "Change Image",
  "patient.photo.confirm": "Confirmă",
  "patient.photo.dragndrop": "Drag and drop an image here",
  "patient.photo.error.fileTooLarge": "Image is too large. Maximum size is 2MB.",
  "patient.photo.formats": "Formats: JPG, PNG (max 2MB)",
  "patient.photo.import": "Import",
  "patient.photo.label": "Patient Photo",
  "patient.photo.modal.heading": "Select Patient Photo",
  "patient.photo.modal.options": "Image Selection Options",
  "patient.photo.preview": "Preview:",
  "patient.photo.preview.alt": "Patient photo preview",
  "patient.photo.preview.captured.alt": "Captured patient photo",
  "patient.photo.retake": "Retake",
  "patient.photo.start.camera": "Start Camera",
  "patient.photo.take": "Take Photo",
  "patient.photo.view": "View Photo",
  "patient.idDoc.title": "Identification Documents",
  "patient.idDoc.addDocument": "Add Document",
  "patient.idDoc.selectImage": "Select Image",
  "patient.idDoc.documentType": "Document Type",
  "patient.idDoc.description": "Descriere",
  "patient.idDoc.description.placeholder": "Enter document description",
  "patient.idDoc.category.nationalId": "CNP",
  "patient.idDoc.category.insuranceCard": "Insurance Card",
  "patient.idDoc.category.other": "Other",
  "patient.idDoc.view": "Vizualizează",
  "patient.idDoc.edit": "Editează",
  "patient.idDoc.delete": "Delete",
  "patient.idDoc.remove": "Șterge",
  "patient.idDoc.pending": "Unsaved",
  "patient.idDoc.empty": "No identification documents uploaded",
  "patient.idDoc.viewDocument": "View Document",
  "patient.idDoc.editDocument": "Edit Document",
  "patient.idDoc.confirmDelete": "Delete Document",
  "patient.idDoc.deleteWarning": "Are you sure you want to delete this document? This action cannot be undone.",
  "patient.idDoc.upload": "Upload",
  "patient.idDoc.dragndrop": "Drag and drop a file here",
  "patient.idDoc.browse": "or click to browse files",
  "patient.idDoc.formats": "Formats: JPEG, PNG, PDF (max 10MB)",
  "patient.idDoc.useCamera": "Use Camera",
  "patient.idDoc.pdfSelected": "PDF document selected",
  "patient.idDoc.error.invalidFormat": "Invalid file format. Accepted formats: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "File is too large. Maximum size is 10MB.",
  "patient.prev.lab.no": "Număr laborator anterior",
  "patient.report.associated.name": "Raport pacient asociat",
  "patient.report.collection.name": "Raport pacienți ARV colectați",
  "patient.search.nopatient": "Niciun pacient găsit după termenii de căutare",
  "patient.st.number": "ST Number",
  "patient.subject.number": "ID unic de sănătate",
  "patient.yrs": "ani",
  "patientcontact.person.email": "Email contact",
  "patientcontact.person.firstname": "Prenume contact",
  "patientcontact.person.lastname": "Nume contact",
  "placeholder.accession.number": "Enter Accession No.",
  "plugin.files": "Fișiere plugin",
  "plugin.name": "Plugin Name",
  "print.barcode": "Tipărește cod de bare",
  "process.testAdd.pressNext.ageRangeSelectiong": "Apasă butonul Următor. Pasul Selectare Interval de Vârstă nu este necesar!",
  "process.testAdd.pressNext.selectGroupDictionary": "Apasă butonul Următor. Pasul Selectare Grup Dicționar nu este necesar!",
  "program.name.label": "Nume program",
  "program.name.code": "Program Code",
  "project.ARVFollowupStudy.name": "Urmărire ARV",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV inițial",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indeterminat",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Testare recență",
  "project.SequencingStudy.name": "Secvențiere",
  "project.SpecialRequestStudy.name": "Cerere specială",
  "project.VLStudy.name": "Încărcătură virală",
  "project.add.subtitle": "Adaugă proiect",
  "project.add.title": "Adaugă proiect",
  "project.browse.title": "Proiect",
  "project.completedDate": "Data finalizării",
  "project.desc.short": "Descriere scurtă proiect",
  "project.description": "Descriere proiect",
  "project.edit.subtitle": "Editează proiect",
  "project.edit.title": "Editează proiect",
  "project.external.reference": "Referință externă",
  "provider.browse.title": "Management furnizori",
  "provider.email": "Email",
  "provider.fax": "Fax",
  "provider.isActive": "Este activ",
  "provider.modal.add.heading": "Add Provider",
  "provider.modal.update.heading": "Update Provider",
  "provider.providerFirstName": "Prenumele furnizorului",
  "provider.providerLastName": "Numele furnizorului",
  "provider.search": "Caută furnizor",
  "provider.search.placeholder": "Caută numele furnizorului...",
  "provider.select": "Selectează furnizor",
  "provider.telephone": "Telefon",
  "qa.checklist.incomplete": "QA checklist is incomplete",
  "qa.checklist.instructions": "Complete all required checks before submitting",
  "qa.checklist.samplingSiteCorrect": "Sampling site information is correct",
  "qa.checklist.title": "QA Checklist",
  "qa.summary.noSamples": "No samples to review",
  "qa.summary.noTests": "No tests selected",
  "qa.summary.order": "Order Details",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Informații pacient",
  "qa.summary.poolOf": "Pool of {count} {animal}",
  "qa.summary.samples": "Sample Summary",
  "qa.summary.samplingSite": "Sampling Site",
  "qa.summary.siteCode": "Site Code",
  "qa.summary.siteName": "Nume locație",
  "qc.comments.add": "Add Comment",
  "qc.comments.empty": "No comments yet",
  "qc.comments.placeholder": "Enter QC comment...",
  "qc.comments.title": "QC Comments",
  "qc.expectedValue": "Expected Value",
  "qc.frequency.compliance": "Compliance Metrics",
  "qc.frequency.config": "QC Frequency Configuration",
  "qc.frequency.daily": "Daily Startup",
  "qc.frequency.everyHours": "Every N Hours",
  "qc.frequency.everySamples": "Every N Samples",
  "qc.frequency.manual": "Manual Trigger Only",
  "qc.frequency.notConfigured": "Not configured",
  "qc.frequency.perShift": "Per Shift",
  "qc.frequency.save": "Save Configuration",
  "qc.frequency.type": "Frequency Type",
  "qc.frequency.value": "Frequency Value",
  "qc.leveyJennings.mean": "Mean",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 SD",
  "qc.leveyJennings.noData": "No QC data available",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Levey-Jennings Control Chart",
  "qc.notes": "QC Notes",
  "qc.notes.placeholder": "Enter QC notes and observations",
  "qc.parentSample": "Parent Sample",
  "qc.signature.comment": "Comment (optional)",
  "qc.signature.comment.placeholder": "Add a comment...",
  "qc.signature.ipAddress": "IP Address",
  "qc.signature.noSignatures": "No signatures yet",
  "qc.signature.sign": "Sign Report",
  "qc.signature.signedAt": "Signed At",
  "qc.signature.success": "Report signed successfully",
  "qc.signature.title": "Electronic Signatures",
  "qc.signature.userId": "User ID",
  "qc.status": "QC Status",
  "qc.status.failed": "Failed",
  "qc.status.notRequired": "Not Required",
  "qc.status.passed": "Passed",
  "qc.status.pending": "Pending QC",
  "qc.status.select": "Select QC status",
  "qc.status.update.button": "Update QC Status",
  "qc.status.update.success": "QC status updated successfully",
  "qc.status.update.title": "Update QC Status",
  "qc.status.warning.message": "Marking this lot as 'Failed' will prevent it from being used until QC status is updated.",
  "qc.status.warning.title": "QC Failure Warning",
  "qc.westgard.noViolations": "No violations detected",
  "qc.westgard.rule.disabled": "Disabled",
  "qc.westgard.rule.enabled": "Enabled",
  "qc.westgard.rules": "Westgard Rules",
  "qc.westgard.rules.description": "Configure Westgard multi-rule QC evaluation",
  "qc.westgard.violations": "Violations",
  "quantity": "Quantity",
  "quantity.balanced": "Quantity balanced",
  "quantity.not.balanced": "Quantity not balanced",
  "quick.entry.accession.number": "Număr accesare",
  "referTest.referralLabel": "Trimite test la laborator de referință",
  "referral.button.labSearch": "Caută trimiteri după număr laborator",
  "referral.button.patientSearch": "Caută pacient",
  "referral.button.unitTestSearch": "Caută trimiteri după unitate/unități și test/teste",
  "referral.date.end": "Dată sfârșit (zz/ll/aaaa)",
  "referral.date.start": "Dată început (zz/ll/aaaa)",
  "referral.emptyState": "No referrals found for the selected filters.",
  "referral.error": "Nu există trimiteri care să corespundă criteriilor",
  "referral.input": "Scanează sau introdu manual",
  "referral.label.institute": "Instituție",
  "referral.label.reason": "Motiv trimitere",
  "referral.label.referredOutTests": "Teste trimise",
  "referral.label.sentdate": "Data trimiterii",
  "referral.label.testmethod": "Metode",
  "referral.label.testtoperform": "Test de efectuat",
  "referral.main.button": "Caută trimiteri după pacient",
  "referral.matching.search": "Teste trimise care corespund căutării",
  "referral.out.head": "Trimiteri",
  "referral.out.note": "Notă: dacă se caută după data rezultatului, doar testele cu rezultate vor apărea.",
  "referral.out.request": "Rezultate după dată / test / unitate Tip dată:",
  "referral.print.selected.patient.reports": "Tipărește rapoartele pacienților selectați",
  "referral.print.selected.patient.reports.selectall.button": "Selectează tot",
  "referral.print.selected.patient.reports.selectnone.button": "Deselectează tot",
  "referral.result.labNumber": "Rezultate după număr laborator",
  "referral.result.referenceRange": "Reference range",
  "referral.search": "Caută",
  "referral.search.column.analysisId": "ID analiză",
  "referral.search.column.referenceLab": "Laborator de referință",
  "referral.search.column.resultDate": "Dată rezultat",
  "referral.search.column.sentDate": "Dată trimitere",
  "referral.test": "Teste",
  "referral.testresult.pastnote": "Note anterioare",
  "referral.units": "Unități",
  "referrer.label": "Trimitere",
  "reflexTests": "Teste reflex",
  "reject.action.button": "Respinge",
  "reject.order.sample.notification": "Respingi o probă. Aceasta va fi respinsă și nu va apărea în planurile de lucru după salvare, nu se pot introduce rezultate pentru această comandă.",
  "remaining.quantity": "Remaining Quantity:",
  "remove.aliquot": "Remove Aliquot",
  "report.enter.labNumber.headline": "Generează un raport sau un interval de rapoarte după număr comandă / număr laborator",
  "report.enter.patient.headline": "Generează toate rapoartele pentru un pacient",
  "report.enter.patient.headline.description": "Caută pacientul folosind numărul de laborator anterior, ID pacient (care poate fi fie ID unic de sănătate, fie CNP) sau alte câmpuri.",
  "report.enter.site.headline": "Generează rapoarte pe locație",
  "report.labe.byLabNumber": "Raport după număr laborator",
  "report.labe.byPatient": "Raport după pacient",
  "report.labe.date": "Raport după dată",
  "report.labe.site": "Raport după locație",
  "report.label.site.dateType": "Tip dată",
  "report.label.site.onlyResults": "Doar rapoarte cu rezultate",
  "report.patient.site.description": "Generează rapoarte după data rezultatului sau data comenzii. Data rezultatului va afișa doar rapoartele cu rezultate. Dacă selectezi doar rapoarte cu rezultate, toate rapoartele în care toate testele sunt în curs nu vor fi generate.",
  "report.select.site": "Selectează locația",
  "report.select.studttype": "Selectați tipul studiului",
  "reporting.label.testName": "Nume test pentru raportare",
  "reports.auditTrail": "Jurnal audit",
  "reports.systemAuditTrail": "System Audit Trail",
  "reports.button": "Generează raport",
  "reports.dateRange": "Date Range",
  "reports.endDate": "Data de sfârșit",
  "reports.error.dateRangeRequired": "Date range is required for this report type",
  "reports.error.generationFailed": "Failed to generate report. Please try again.",
  "reports.error.invalidDateRange": "End date must be after start date",
  "reports.export": "Exportă",
  "reports.export.byDate": "Exportă după dată",
  "reports.export.byDate_routine": "Raport CSV rutină",
  "reports.export.general": "Export general",
  "reports.export.specific": "Export date încărcătură virală",
  "reports.export.valid": "Valid",
  "reports.export.whonet": "Raport WHONET",
  "reports.followupRequired.byLocation": "Urmărire necesară",
  "reports.format": "Export Format",
  "reports.format.select": "Select format",
  "reports.generate.title": "Generate Inventory Report",
  "reports.generating": "Generating...",
  "reports.generation.success": "Report generated and downloaded successfully",
  "reports.groupByLocation": "Group by storage location",
  "reports.groupByType": "Group by item type",
  "reports.grouping": "Grouping Options",
  "reports.help.description": "Use these reports to analyze your inventory data:",
  "reports.help.tip1": "Use date ranges for trend analysis",
  "reports.help.tip2": "Group by type or location for better insights",
  "reports.help.tip3": "Export to Excel for further analysis",
  "reports.help.title": "Report Tips",
  "reports.includeExpired": "Include expired lots",
  "reports.includeInactive": "Include inactive items",
  "reports.info.message": "Select report type and options below. Reports may take a few moments to generate.",
  "reports.info.title": "Report Generation",
  "reports.label.cistudyexport": "Raport general",
  "reports.label.indicator": "Indicator",
  "reports.label.indicator.performance": "Performanță secțiune",
  "reports.label.referred.out": "Raport teste trimise extern",
  "reports.label.trends": "Tendințe",
  "reports.menu.covid": "Raport Covid",
  "reports.nonConformity.byDate.report": "După dată",
  "reports.nonConformity.byLabno.report": "După număr laborator",
  "reports.nonConformity.bySectionReason.report": "După unitate și motiv",
  "reports.nonConformity.bySectionReason.title": "Raport neconformitate după unitate și motiv",
  "reports.nonConformity.menu": "Rapoarte neconformitate",
  "reports.nonConformity.notification.report": "Notificare neconformitate",
  "reports.nonConformity.notification.report.instructions": "Dacă un serviciu este selectat, toate notificările de neconformitate care nu au fost tipărite vor fi tipărite. Dacă nu sunt listate servicii, toate notificările au fost deja tipărite. Introducerea unui număr de laborator va tipări notificarea chiar dacă a fost deja tipărită. Nu este necesar să fie selectat un serviciu.",
  "reports.options": "Filter Options",
  "reports.patient.ARV.version1": "ARV - Versiunea 1",
  "reports.patient.ARV.version1 ": "ARV - Versiunea 1",
  "reports.patient.ARVFollowup.version1": "ARV urmărire - Versiunea 1",
  "reports.patient.ARVFollowup.version2": "ARV urmărire - Versiunea 2",
  "reports.patient.ARVInitial.version1": "ARV inițial - Versiunea 1",
  "reports.patient.ARVInitial.version2": "ARV inițial - Versiunea 2",
  "reports.patient.Indeterminate.location": "Indeterminat după serviciu",
  "reports.patient.Indeterminate.version1": "Indeterminat - Versiunea 1",
  "reports.patient.Indeterminate.version2": "Indeterminat - Versiunea 2",
  "reports.startDate": "Data de început",
  "reports.type": "Report Type",
  "reports.type.expirationForecast": "Expiration Forecast",
  "reports.type.expirationForecast.description": "Items expiring within specified date range",
  "reports.type.lotTraceability": "Lot Traceability",
  "reports.type.lotTraceability.description": "Complete traceability of lot movements and usage",
  "reports.type.lowStock": "Low Stock Alert",
  "reports.type.lowStock.description": "Items currently below minimum stock level",
  "reports.type.select": "Select report type",
  "reports.type.stockLevels": "Stock Levels Report",
  "reports.type.stockLevels.description": "Current stock levels for all inventory items",
  "reports.type.transactionHistory": "Transaction History",
  "reports.type.transactionHistory.description": "All transactions within date range",
  "reports.type.usageTrends": "Usage Trends",
  "reports.type.usageTrends.description": "Usage patterns and consumption trends over time",
  "request.samesite.order": "Plasează comandă pentru aceeași locație",
  "requester.label": "Solicitant",
  "required.invalidtext": "Acest câmp este obligatoriu",
  "result.acceptasis.warning": "Bifarea acestei opțiuni indică faptul că accepți rezultatul necondiționat.\nUtilizări posibile:\n1. Testul a fost refăcut și rezultatul este același.\n2. Nu există rezultat dar nu dorești să anulezi testul.\n3. Rezultatul a fost modificat și tehnicianul dorește să permită biologului să adauge o notă în timpul validării.\nÎn oricare dintre cazuri, lasă o notă explicativă pentru acțiunea ta.\n",
  "result.acceptasis.trigger": "Acceptă",
  "result.acceptasis.reason.label": "Reason for unconditional acceptance",
  "result.acceptasis.reason.placeholder": "Required — e.g. retested twice with same result, or no result available",
  "result.acceptasis.confirm": "Confirm acceptance",
  "result.acceptasis.cancel": "Anulează",
  "result.acceptasis.committed": "Accepted",
  "result.acceptasis.undo": "Undo",
  "result.entry.error.accessionRequired": "Please enter an accession number",
  "result.entry.error.title": "Error",
  "result.entry.info.title": "Information",
  "result.entry.label": "Result Entry",
  "result.entry.noResults": "No sample found for accession number {accessionNumber}",
  "result.entry.noTestsFound": "No tests with pending results found for accession number {accessionNumber}",
  "result.entry.results.accessionNumber": "Număr accesare",
  "result.entry.results.sampleCount": "Samples",
  "result.entry.results.testCount": "Teste",
  "result.entry.results.title": "Tests Pending Results",
  "result.entry.saveSuccess": "Result saved for {testName}",
  "result.entry.search.accessionLabel": "Număr accesare",
  "result.entry.search.accessionPlaceholder": "Enter accession number...",
  "result.entry.search.button": "Caută",
  "result.entry.search.searching": "Searching...",
  "result.entry.search.title": "Search by Accession Number",
  "result.entry.success.title": "Success",
  "result.entry.table.action": "Acțiune",
  "result.entry.table.header.sampleId": "Sample ID",
  "result.entry.table.header.sampleType": "Tip probă",
  "result.entry.table.header.testCount": "Teste",
  "result.entry.table.noSamples": "No samples with tests found",
  "result.entry.table.noTests": "No tests for this sample",
  "result.entry.table.result": "Rezultat",
  "result.entry.table.resultPlaceholder": "Enter result",
  "result.entry.table.save": "Salvează",
  "result.entry.table.saving": "Saving...",
  "result.entry.table.status": "Stare",
  "result.entry.table.testName": "Nume test",
  "result.entry.table.testsTitle": "Tests ({count})",
  "result.entry.title": "Result Entry",
  "result.noTestsFound": "Nu au fost găsite teste potrivite.",
  "result.nonconforming.item": "Proba sau comanda este neconformă SAU testul a fost respins",
  "result.outOfValidRange.msg": "Valoarea introdusă (câmp roșu) este în afara valorilor permise. Verificați valoarea",
  "result.reject.warning": "Respingerea rezultatului va șterge definitiv rezultatul testului\nRezultatele nu vor mai fi disponibile.",
  "result.report.queue.size": "Dimensiunea cozii:",
  "result.search.noresult": "Niciun rezultat găsit",
  "resultreporting.browse.title": "Configurație raportare rezultate",
  "resultreporting.config.url": "URL-ul site-ului către care vor fi trimise rezultatele. De exemplu http://192.168.56.101/unSite",
  "resultreporting.config.url.placeholder": "https://denumireorg.com/unSite",
  "results.label.refer": "Trimite testul către un laborator de referință",
  "routine.reports": "Rapoarte de rutină",
  "rulebuilder.error.invalidNumeric": "Valoare numerică invalidă",
  "rulebuilder.error.invalidTest": "Test invalid",
  "rulebuilder.label.add.externaltrigger": "Adaugă mesaj extern `declanșat de`",
  "rulebuilder.label.add.internaltrigger": "Adaugă mesaj intern `declanșat de`",
  "rulebuilder.label.addAction": "Adaugă acțiune",
  "rulebuilder.label.addCondition": "Adaugă condiție",
  "rulebuilder.label.addExternalNote": "Adaugă notă externă",
  "rulebuilder.label.addInternalNote": "Adaugă notă internă",
  "rulebuilder.label.addPopup": "Adaugă popup",
  "rulebuilder.label.addRule": "Adaugă regulă",
  "rulebuilder.label.addRuleConditions": "Adaugă condiții reflex",
  "rulebuilder.label.confirmDelete": "Ești sigur că vrei să dezactivezi această regulă?",
  "rulebuilder.label.dictValue": "Valoare dicționar",
  "rulebuilder.label.noSuggestions": "Nu există sugestii disponibile",
  "rulebuilder.label.numericValue": "Valoare numerică",
  "rulebuilder.label.numericValue2": "Valoare numerică 2",
  "rulebuilder.label.overallOptions": "Opțiune generală",
  "rulebuilder.label.perfomActions": "Execută următoarele acțiuni",
  "rulebuilder.label.relation": "Relație",
  "rulebuilder.label.removeAction": "Elimină acțiunea",
  "rulebuilder.label.removeCondition": "Elimină condiția",
  "rulebuilder.label.removeRule": "Dezactivează regula",
  "rulebuilder.label.rule": "Regulă",
  "rulebuilder.label.ruleDetails": "View Rule",
  "rulebuilder.label.ruleName": "Nume regulă",
  "rulebuilder.label.searchTest": "Caută test",
  "rulebuilder.label.selectSample": "Selectează probă",
  "rulebuilder.label.textValue": "Valoare text",
  "rulebuilder.label.toggleRule": "Activează/Dezactivează regula",
  "sample.accession.number": "Sample Accession",
  "sample.add.action": "Adaugă probă",
  "sample.collection.date": "Data recoltării",
  "sample.collection.method": "Collection Method",
  "sample.collection.method.placeholder": "e.g., venipuncture, capillary, tubing",
  "sample.collection.time": "Ora recoltării",
  "sample.currentDate": "Data curentă",
  "sample.requiredBy": "Required By",
  "sample.specimen.origin": "Specimen Origin (referent lab)",
  "sample.specimen.origin.placeholder": "Referring laboratory name",
  "sample.temperature": "Sample Temperature",
  "sample.temperature.placeholder": "e.g., room temp, iced, refrigerated",
  "sample.entry.available.tests": "Teste disponibile",
  "sample.entry.nextVisit.date": "Data următoarei vizite",
  "sample.entry.panels": "Paneluri",
  "sample.entry.project.patient.and.testName": "Nume/Cod pacient {br} Nume test",
  "sample.entry.project.testName": "Nume test",
  "sample.entry.search.barcode": "Tipărește coduri de bare pentru comenzi existente",
  "sample.id": "Sample ID",
  "sample.item.info": "Sample Information",
  "sample.items.for.accession": "Sample items for accession number:",
  "sample.label.accessionNumber": "Număr accesare",
  "sample.label.collectionDate": "Data recoltării",
  "sample.label.dept": "Secție/Departament/Unitate",
  "sample.label.facility": "Instituție trimitere",
  "sample.label.labnumber": "Număr laborator",
  "sample.label.labnumber.generate": "Generează",
  "sample.label.labnumber.new": "Număr laborator nou",
  "sample.label.noorder": "Comanda nu există",
  "sample.label.orderdate": "Data comenzii",
  "sample.label.orderpanel": "Comandă paneluri",
  "sample.label.requester": "Solicitant",
  "sample.label.search.Order": "Caută comandă",
  "sample.label.search.labnumber": "Caută după număr accesare",
  "sample.label.search.patient": "Caută după pacient",
  "sample.label.typeOfSample": "Tip probă",
  "sample.label.types": "Sample Types",
  "sample.management.action.clearSelection": "Clear Selection",
  "sample.management.action.createAliquot": "Create Aliquot",
  "sample.management.action.selectAllAliquots": "Select All Aliquots",
  "sample.management.action.selectAllParents": "Select All Parents",
  "sample.management.addTests.button": "Add Tests",
  "sample.management.addTests.error.addFailed": "Failed to add tests. Please try again.",
  "sample.management.addTests.error.loadSampleTypes": "Error loading sample types",
  "sample.management.addTests.error.loadTests": "Error loading available tests",
  "sample.management.addTests.error.noEligibleSamples": "Cannot add tests: all selected samples have been fully dispensed",
  "sample.management.addTests.error.noTests": "Please select at least one test",
  "sample.management.addTests.modal.add": "Add Tests",
  "sample.management.addTests.modal.addCount": "Add {count} Test(s)",
  "sample.management.addTests.modal.adding": "Adding...",
  "sample.management.addTests.modal.aliquotsIncluded": "aliquot(s) included",
  "sample.management.addTests.modal.bulkAliquotNote": "Tests will be added to all selected samples including aliquots.",
  "sample.management.addTests.modal.cancel": "Anulează",
  "sample.management.addTests.modal.noEligibleSamples": "No Eligible Samples",
  "sample.management.addTests.modal.noTestsAvailable": "No tests available for this sample type.",
  "sample.management.addTests.modal.noTestsSelected": "No tests selected",
  "sample.management.addTests.modal.panels": "Paneluri",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Search tests...",
  "sample.management.addTests.modal.selectSampleType": "Tip probă",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Please select a sample type to view available panels and tests.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Select a sample type...",
  "sample.management.addTests.modal.selectTests": "Select Tests",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Search and select tests...",
  "sample.management.addTests.modal.selectedTests": "Selected Tests",
  "sample.management.addTests.modal.subtitle": "Add tests to {count} selected sample(s)",
  "sample.management.addTests.modal.tests": "Teste",
  "sample.management.addTests.modal.title": "Add Tests to Sample",
  "sample.management.addTests.resultItem": "{sampleId}: {added} added",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: {added} added, {skipped} skipped",
  "sample.management.addTests.success": "{count} test(s) added successfully",
  "sample.management.addTests.successDetailed": "{count} test(s) added to {samples} sample(s): {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} test(s) added to {samples} sample(s), {skipped} skipped: {details}",
  "sample.management.addTests.successWithSkipped": "{added} test(s) added, {skipped} skipped (already ordered)",
  "sample.management.addTests.title": "Add Tests",
  "sample.management.addTests.warning.dispensedSamples": "{count} sample(s) have no remaining volume and will be skipped. Tests will be added to {eligible} eligible sample(s).",
  "sample.management.addTests.warning.dispensedSamples.title": "Dispensed Samples Excluded",
  "sample.management.aliquot.error.createFailed": "Failed to create aliquot. Please try again.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "Number of aliquots must be between 1 and 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "Requested quantity ({requested}) exceeds remaining quantity ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "Quantity per aliquot ({quantityPerAliquot}) would be less than minimum (0.001)",
  "sample.management.aliquot.error.quantityPositive": "Quantity must be greater than 0",
  "sample.management.aliquot.error.quantityRequired": "Quantity is required",
  "sample.management.aliquot.error.title": "Error",
  "sample.management.aliquot.modal.cancel": "Anulează",
  "sample.management.aliquot.modal.create": "Create Aliquot",
  "sample.management.aliquot.modal.createMultiple": "Create {count} Aliquots",
  "sample.management.aliquot.modal.creating": "Creating...",
  "sample.management.aliquot.modal.notesLabel": "Notes (Optional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Add any notes about this aliquot...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Enter how many equal-volume aliquots to create (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Number of Aliquots",
  "sample.management.aliquot.modal.parentInfo": "Parent Sample Information",
  "sample.management.aliquot.modal.preview": "Preview",
  "sample.management.aliquot.modal.previewText": "Creating {count} aliquots with {quantityEach} {unit} each",
  "sample.management.aliquot.modal.quantityHelper": "Enter the quantity to transfer in {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Quantity to Transfer",
  "sample.management.aliquot.modal.quantityPlaceholder": "Enter quantity",
  "sample.management.aliquot.modal.subtitle": "Create aliquot from sample {externalId}",
  "sample.management.aliquot.modal.title": "Create Aliquot",
  "sample.management.aliquot.modal.totalQuantityHelper": "Enter the total quantity to divide among all aliquots in {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Total Quantity to Transfer",
  "sample.management.aliquot.success": "Aliquot {externalId} created successfully. Please search again to see the updated results.",
  "sample.management.aliquot.successMultiple": "{count} aliquots created successfully ({externalIds}). Please search again to see the updated results.",
  "sample.management.breadcrumb.title": "Sample Management",
  "sample.management.cancelTest.error": "Failed to cancel test. Please try again.",
  "sample.management.cancelTest.success": "Test \"{testName}\" cancelled successfully",
  "sample.management.description": "Search and manage sample items, create aliquots, and add tests",
  "sample.management.error.title": "Error",
  "sample.management.hierarchy.aliquotOf": "Aliquot of {parent}",
  "sample.management.hierarchy.aliquots": "aliquots",
  "sample.management.noResults.subtitle": "No sample items found for accession number: {accessionNumber}",
  "sample.management.noResults.title": "No Results Found",
  "sample.management.results.accessionNumber": "Număr accesare",
  "sample.management.results.aliquots": "aliquots",
  "sample.management.results.aliquotsSelected": "aliquots",
  "sample.management.results.item": "item",
  "sample.management.results.items": "items",
  "sample.management.results.selected": "Selected",
  "sample.management.results.title": "Sample Items",
  "sample.management.results.totalCount": "Total Samples",
  "sample.management.search.error.general": "Error loading sample results. Please try again.",
  "sample.management.search.label": "Search Samples",
  "sample.management.search.loading": "Searching...",
  "sample.management.search.placeholder": "Enter accession number to search...",
  "sample.management.search.title": "Search Samples",
  "sample.management.status.allVolumeDispensed": "All Volume Dispensed",
  "sample.management.status.available": "Available",
  "sample.management.status.consumed": "Consumed",
  "sample.management.status.inUse": "In Use",
  "sample.management.status.unknown": "Unknown",
  "sample.management.success.title": "Success",
  "sample.management.table.cancelTest": "Anulează test",
  "sample.management.table.cancelling": "Cancelling...",
  "sample.management.table.header.externalId": "Sample ID",
  "sample.management.table.header.hierarchy": "Hierarchy",
  "sample.management.table.header.originalQuantity": "Original Quantity",
  "sample.management.table.header.quantity": "Original Quantity",
  "sample.management.table.header.remainingQuantity": "Remaining Quantity",
  "sample.management.table.header.sampleType": "Tip probă",
  "sample.management.table.header.status": "Stare",
  "sample.management.table.header.tests": "Teste",
  "sample.management.table.noResults": "No sample items to display. Use the search above to find samples.",
  "sample.management.table.noTests": "No tests ordered for this sample",
  "sample.management.table.orderedDate": "Ordered",
  "sample.management.table.orderedTests": "Ordered Tests ({count})",
  "sample.management.title": "Sample Management",
  "sample.panel.label.text": "Caută panel disponibil",
  "sample.panel.placeholder": "Alege panel disponibil",
  "sample.panel.search.error.msg": "Nu s-a găsit niciun panel corespunzător",
  "sample.quantity.label": "Quantity",
  "sample.receivedDate": "Data recepției",
  "sample.reject.label": "Respinge proba",
  "sample.remove.action": "Șterge probă",
  "sample.requestDate": "Data solicitării",
  "sample.search.nosample": "No sample found for the provided accession number.",
  "sample.search.panel.legend.text": "Caută în paneluri disponibile",
  "sample.search.scanner.instructions": "Scanează sau introdu manual. Pentru un singur raport, lasă câmpul din dreapta gol",
  "sample.search.scanner.instructions.highaccession": "Pentru un singur raport, lasă câmpul din dreapta gol",
  "sample.search.scanner.instructions2": "Scanează sau introdu manual.",
  "sample.search.title": "Search Sample",
  "sample.select.type": "Selectează tipul probei",
  "sample.type": "Tip probă",
  "sample.type.and.test.sort.order": "Ordine tip probă și test",
  "sample.type.helper": "Select a specimen type — available panels and tests update after selection.",
  "sample.uom.label": "Sample Unit Of Measure",
  "sample.voided.title": "Sample is voided",
  "sampleManagement.actions": "Actions",
  "sampleManagement.addTests.button": "Add Tests",
  "sampleManagement.addTests.cancel": "Anulează",
  "sampleManagement.addTests.duplicate": "Test already ordered for {sampleId}",
  "sampleManagement.addTests.error": "Error adding tests",
  "sampleManagement.addTests.incompatible": "Test not compatible with sample type ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Select sample(s) to add tests",
  "sampleManagement.addTests.selectTests": "Select test(s) to add",
  "sampleManagement.addTests.skipped": "Skipped {count} duplicate(s)",
  "sampleManagement.addTests.submit": "Add Tests",
  "sampleManagement.addTests.success": "{count} test(s) added successfully",
  "sampleManagement.addTests.title": "Add Tests to Samples",
  "sampleManagement.aliquot.button": "Create Aliquot",
  "sampleManagement.aliquot.cancel": "Anulează",
  "sampleManagement.aliquot.error": "Error creating aliquot",
  "sampleManagement.aliquot.error.concurrentModification": "Another user modified this sample. Please refresh and try again.",
  "sampleManagement.aliquot.error.insufficientQuantity": "Cannot aliquot: requested {requested} exceeds remaining {remaining}",
  "sampleManagement.aliquot.error.noRemainingQuantity": "All volume dispensed: no remaining quantity available for aliquoting",
  "sampleManagement.aliquot.notes": "Notes (optional)",
  "sampleManagement.aliquot.notesPlaceholder": "Add notes about this aliquot...",
  "sampleManagement.aliquot.parentExternalId": "Parent External ID",
  "sampleManagement.aliquot.parentLabel": "Parent Sample",
  "sampleManagement.aliquot.quantityPlaceholder": "Enter quantity...",
  "sampleManagement.aliquot.quantityToTransfer": "Quantity to Transfer",
  "sampleManagement.aliquot.remainingQuantity": "Remaining Quantity",
  "sampleManagement.aliquot.submit": "Create Aliquot",
  "sampleManagement.aliquot.success": "Aliquot {externalId} created successfully",
  "sampleManagement.aliquot.title": "Create Aliquot",
  "sampleManagement.aliquot.unit": "Unit",
  "sampleManagement.aliquot.validation.exceeds": "Quantity exceeds remaining quantity",
  "sampleManagement.aliquot.validation.min": "Quantity must be at least 0.001",
  "sampleManagement.aliquot.validation.required": "Quantity to transfer is required",
  "sampleManagement.clearSelection": "Clear selection",
  "sampleManagement.hierarchy.children": "Aliquots:",
  "sampleManagement.hierarchy.collapse": "Collapse hierarchy",
  "sampleManagement.hierarchy.expand": "Expand hierarchy",
  "sampleManagement.hierarchy.level": "Level {level}",
  "sampleManagement.hierarchy.parent": "Parent:",
  "sampleManagement.notification.refreshResults": "Results have been refreshed",
  "sampleManagement.results.children": "Aliquots",
  "sampleManagement.results.collectionDate": "Data recoltării",
  "sampleManagement.results.count": "{count} sample(s) found",
  "sampleManagement.results.externalId": "External ID",
  "sampleManagement.results.originalQuantity": "Original Quantity",
  "sampleManagement.results.parent": "Parent",
  "sampleManagement.results.remainingQuantity": "Remaining Quantity",
  "sampleManagement.results.sampleType": "Tip probă",
  "sampleManagement.results.status": "Stare",
  "sampleManagement.results.tests": "Teste",
  "sampleManagement.results.title": "Search Results",
  "sampleManagement.search.button": "Caută",
  "sampleManagement.search.error": "Error searching for samples",
  "sampleManagement.search.label": "Search by Accession Number",
  "sampleManagement.search.loading": "Searching...",
  "sampleManagement.search.noResults": "No samples found with this accession number",
  "sampleManagement.search.placeholder": "Enter accession number...",
  "sampleManagement.selectSamples": "Select sample(s)",
  "sampleManagement.selectedCount": "{count} selected",
  "sampleManagement.test.name": "Nume test",
  "sampleManagement.test.orderedDate": "Ordered Date",
  "sampleManagement.test.status": "Stare",
  "sampleManagement.test.status.CANCELLED": "Cancelled",
  "sampleManagement.test.status.COMPLETED": "Completed",
  "sampleManagement.test.status.IN_PROGRESS": "În desfășurare",
  "sampleManagement.test.status.ORDERED": "Ordered",
  "sampleManagement.title": "Sample Management",
  "sampleManagement.validation.accessionNumberRequired": "Accession number is required",
  "sampleManagement.validation.parentSampleRequired": "Parent sample item is required",
  "sampleManagement.validation.samplesRequired": "At least one sample must be selected",
  "sampleManagement.validation.testsRequired": "At least one test must be selected",
  "sampleType.existing": "Tipuri de probă existente",
  "sampleType.existing.inactive": "Tipuri de probă inactive. Atribuie teste pentru activare.",
  "sampleType.new": "Tip de probă nou",
  "sampleType.typeName": "Nume tip probă",
  "save.aliquot.changes": "Save Aliquot Changes",
  "save.config.success.msg": "Configurarea a fost actualizată cu succes",
  "save.order.success.msg": "Comanda probei a fost salvată cu succes",
  "save.success": "Salvat cu succes",
  "saving": "Saving...",
  "search.by.dictionary.entry": "Caută după intrare în dicționar",
  "search.label": "Caută",
  "search.label.accession": "Introdu număr accesare",
  "search.label.analysis": "Selectează starea analizei",
  "search.label.collectiondate": "Introdu data recoltării",
  "search.label.fromaccession": "De la număr accesare",
  "search.label.loadnext": "Încarcă următoarele 99 înregistrări începând cu numărul laboratorului",
  "search.label.receiveddate": "Enter Received Date",
  "search.label.sample": "Selectează starea probei",
  "search.label.test": "Selectează numele testului",
  "search.label.testdate": "Introdu data testului",
  "search.label.testunit": "Selectează unitatea de test",
  "search.label.toaccession": "Până la număr accesare",
  "search.patient.label": "Caută pacient",
  "search.placeholder": "Search...",
  "searchTests.label": "Caută test disponibil",
  "searchTests.legend": "Caută în testele disponibile",
  "searchindexmanagement.description": "Indexul de căutare se actualizează automat la adăugarea sau modificarea datelor. Dacă este necesară o actualizare manuală, apasă butonul Pornește Reindexarea. Aceasta poate dura ceva timp.",
  "searchindexmanagement.label": "Management index de căutare",
  "searchindexmanagement.reindex": "Pornește Reindexarea",
  "searchindexmanagement.reindex.error": "Reindexarea a eșuat",
  "searchindexmanagement.reindex.success": "Reindexarea s-a finalizat cu succes",
  "select.aliquot": "Select Aliquot",
  "select.datarange.label": "Intervalul de date este pentru când au fost făcute trimiterile",
  "select.dateRange": "Selectează intervalul de date pentru sumarul de rapoarte test",
  "select.default.option.label": "Alege o opțiune",
  "select.end.date.referredTests": "Data de sfârșit (zz/ll/aaaa)",
  "select.labUnits": "Selectează unitățile de laborator pentru care vrei să creezi testul, poți selecta oricâte",
  "select.label.analyser": "Selectați analizorul",
  "select.priority.tests": "Selectează prioritatea testelor pe care vrei să le afișezi",
  "select.program": "Program",
  "select.referral.centre": "Centru de trimitere sau laborator",
  "select.referral.centre.is.required": "Centrul de trimitere sau laboratorul este necesar",
  "select.start.date.referredTests": "Data de început (zz/ll/aaaa)",
  "select.timeFrame": "Selectează intervalul pentru care să generezi rapoartele",
  "select.timeFrame.Note": "NOTĂ: toate datele și orele se bazează pe ora recepției. Exemplu: un test recepționat pe 31 ianuarie la ora 23:59 și rezultat pe 1 februarie la ora 09:30 va apărea ca fiind în afara orelor normale în ianuarie",
  "select.year.report": "Selectează anul pentru care să generezi rapoartele",
  "selectListRenameEntry.selectList": "Redenumire listă selecție",
  "selectListRenameEntry.selectListEdit": "Editare redenumire listă selecție",
  "selectReportValues.title": "Selectează valori raport",
  "selectResult.title": "Selectează rezultat",
  "serial.config.active.label": "Activ",
  "serial.config.baudRate.label": "Baud Rate",
  "serial.config.connect.button": "Connect",
  "serial.config.connect.error": "Error connecting serial port",
  "serial.config.connect.success": "Serial port connected successfully",
  "serial.config.create.title": "Create Serial Port Configuration",
  "serial.config.dataBits.label": "Data Bits",
  "serial.config.disconnect.button": "Disconnect",
  "serial.config.disconnect.error": "Error disconnecting serial port",
  "serial.config.disconnect.success": "Serial port disconnected successfully",
  "serial.config.edit.title": "Edit Serial Port Configuration",
  "serial.config.flowControl.label": "Flow Control",
  "serial.config.flowControl.none": "Niciuna",
  "serial.config.form.legend": "Serial Port Settings",
  "serial.config.parity.even": "Even",
  "serial.config.parity.label": "Parity",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "Niciuna",
  "serial.config.parity.odd": "Odd",
  "serial.config.parity.space": "Space",
  "serial.config.portName.label": "Port Name",
  "serial.config.save.error": "Error saving serial port configuration",
  "serial.config.save.success": "Serial port configuration saved successfully",
  "serial.config.status.label": "Connection Status",
  "serial.config.stopBits.label": "Stop Bits",
  "serial.config.validation.analyzerId.required": "Analyzer ID is required",
  "serial.config.validation.baudRate.invalid": "Baud rate must be between 9600 and 115200",
  "serial.config.validation.dataBits.invalid": "Data bits must be 7 or 8",
  "serial.config.validation.portName.required": "Port name is required",
  "server.error.msg": "Eroare server, contactează administratorul",
  "show.aliquoting": "Show Aliquoting",
  "showing": "Se afișează",
  "breadcrumb.label.addOrder": "Adaugă comandă",
  "sidenav.label.admin": "Administrare",
  "sidenav.label.admin.analyzerTest": "Nume test analizor",
  "sidenav.label.admin.backToMainMenu": "Back to main menu",
  "sidenav.label.admin.barcodeconfiguration": "Configurație coduri de bare",
  "sidenav.label.admin.labelPresets": "Label Presets",
  "sidenav.label.admin.commonproperties": "Proprietăți aplicație",
  "sidenav.label.admin.eqaProgram": "EQA Program Management",
  "sidenav.label.admin.formEntry.menustatementconfig": "Configurare meniu declarații",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Configurare neconformități",
  "sidenav.label.admin.formEntry.patientconfig": "Configurare introducere pacient",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Configurare rapoarte tipărite",
  "sidenav.label.admin.formEntry.resultConfig": "Configurare introducere rezultate",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Configurare introducere comandă",
  "sidenav.label.admin.formEntry.siteBranding": "Site Branding",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Informații locație",
  "sidenav.label.admin.formEntry.validationconfig": "Configurare validare",
  "sidenav.label.admin.formEntry.Workplanconfig": "Configurare plan de lucru",
  "sidenav.label.admin.labNumber": "Management numere laborator",
  "sidenav.label.admin.Listplugin": "Listă pluginuri",
  "sidenav.label.admin.localization": "Localization",
  "sidenav.label.admin.menu": "Configurare meniu",
  "sidenav.label.admin.menu.billing": "Configurare meniu facturare",
  "sidenav.label.admin.menu.global": "Configurare meniu global",
  "sidenav.label.admin.menu.nonconform": "Configurare meniu neconformități",
  "sidenav.label.admin.menu.patient": "Configurare meniu pacient",
  "sidenav.label.admin.menu.study": "Configurare meniu studii",
  "sidenav.label.admin.organizationmgt": "Management organizație",
  "sidenav.label.admin.pluginFile": "Fișiere plugin",
  "sidenav.label.admin.program": "Introducere program",
  "sidenav.label.admin.testmgt": "Configurare teste reflex",
  "sidenav.label.admin.testmgt.calculated": "Management teste cu valoare calculată",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Test Catalogue Editor",
  "sidenav.label.admin.testCatalog": "Test Catalogue Management",
  "sidenav.label.admin.testCatalog.backToList": "← All Tests",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Click a test to edit its sections",
  "sidenav.label.admin.testCatalog.editing": "Editing: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Editing test",
  "label.testCatalog.editor": "Test Catalogue Editor",
  "label.testCatalog.editor.empty": "Click a test to edit its sections",
  "label.testCatalog.editor.empty.helper": "Open a test from the Test Catalogue list to edit it.",
  "label.testCatalog.editor.loadError": "Unable to load this test. Please try again.",
  "label.testCatalog.editor.saveAsNew": "Save as new test…",
  "label.testCatalog.editor.save.pending": "Saving is available once the section editors ship.",
  "label.testCatalog.editor.clone.pending": "Save as new test is available once the editor sections ship.",
  "label.testCatalog.section.pending": "This section's editor ships in a later milestone.",
  "label.testCatalog.section.basic-info": "Basic Info",
  "label.testCatalog.section.sample-results": "Sample & Results",
  "label.testCatalog.section.methods": "Metode",
  "label.testCatalog.section.ranges": "Ranges",
  "label.testCatalog.section.storage": "Sample Storage",
  "label.testCatalog.section.panels": "Paneluri",
  "label.testCatalog.entity.panels": "Paneluri",
  "note.panel.domainUpgrade": "Panels now have a Domain; existing panels were set to Clinical.",
  "note.panel.domainLaterPhase": "Environmental and Vector domains are enabled in a later phase.",
  "label.panel.list.description": "Ordered bundles of tests; sample types derive from the member tests",
  "label.panel.list.empty": "No panels match the current filters.",
  "label.panel.search": "Search by name or LOINC",
  "button.panel.add": "Add Panel",
  "label.panel.col.name": "Nume panel",
  "label.panel.col.tests": "Teste",
  "label.panel.col.domain": "Domain",
  "label.panel.col.sampleTypes": "Sample Types (derived)",
  "label.panel.col.status": "Stare",
  "label.panel.backToList": "Back to list",
  "title.panel.new": "New panel",
  "label.panel.name": "Panel name",
  "placeholder.panel.name": "e.g. Anemia Workup",
  "label.panel.domain": "Domain",
  "helper.panel.domainGuard": "Only {domain}-domain tests can be added to this panel.",
  "helper.panel.loincIsIdentifier": "The panel's LOINC serves as its identifier.",
  "note.panel.sampleTypesDerived": "Sample types are derived from the tests in this panel.",
  "label.panel.description": "Descriere",
  "label.panel.active": "Activ",
  "helper.panel.needsTest": "Add at least one test before this panel can be activated.",
  "error.panel.save": "The panel could not be saved. Check the fields and try again.",
  "error.panel.nameRequired": "A panel name is required.",
  "label.panel.section.basic-info": "Basic Info",
  "label.panel.section.tests": "Teste",
  "label.panel.section.terminology": "Terminology",
  "label.panel.section.localization": "Localization",
  "label.panel.localization.intro": "Edit per-language translations for this panel's name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.panel.localization.empty": "This panel has no localizable name fields.",
  "label.panel.localization.loadError": "Unable to load translations for this panel.",
  "label.panel.localization.field.name": "Nume panel",
  "sidenav.label.admin.panel.editing": "Editing panel: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Click a panel to edit its sections",
  "sidenav.label.admin.panel.addingNew": "Adding a new panel",
  "label.panel.testsCount": "tests",
  "label.panel.addTest": "Add a test",
  "label.panel.tests.filterBySampleType": "Filter by sample type",
  "label.panel.tests.filterBySampleType.all": "All sample types",
  "placeholder.panel.addTest": "Search by name or code…",
  "helper.panel.membershipSync": "Membership writes keep order entry's panel list in sync.",
  "label.panel.col.order": "Comandă",
  "label.panel.col.testName": "Nume test",
  "label.panel.col.code": "Code",
  "label.panel.moveUp": "Move up",
  "label.panel.moveDown": "Move down",
  "empty.panel.tests": "No tests yet — search above to add the first one.",
  "helper.panel.loincRouting": "It is also a live routing key — FHIR e-orders match panels by this code at intake. The primary LOINC stays on the panel for list display and order entry.",
  "label.panel.terminology.primary": "Primary",
  "label.panel.terminology.empty": "No terminology mappings yet. The LOINC mapping is the panel's identifier.",
  "label.panel.terminology.saved": "Terminology mappings saved.",
  "label.panel.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.panel.terminology.saveError": "Could not save terminology mappings.",
  "note.panel.positionShared": "Position writes panel_item.sort_order — the same field the test-side Panels section edits.",
  "label.testCatalog.section.labels": "Labels",
  "label.testCatalog.section.terminology": "Terminology",
  "label.testCatalog.labels.col.preset": "Preset",
  "label.testCatalog.labels.col.defaultQty": "Default Qty",
  "label.testCatalog.labels.col.maxQty": "Max Qty",
  "label.testCatalog.labels.col.allowOverride": "Allow Override",
  "label.testCatalog.labels.col.actions": "Actions",
  "label.testCatalog.labels.addLabelType": "Add Label Type",
  "label.testCatalog.labels.addLabelType.placeholder": "Select a label preset…",
  "label.testCatalog.labels.empty": "No label types configured. Add label presets to automatically suggest labels when this test is ordered.",
  "label.testCatalog.labels.loadError": "Unable to load label configuration for this test.",
  "label.testCatalog.labels.saved": "Label configuration saved",
  "label.testCatalog.labels.saveError": "Could not save label configuration.",
  "label.testCatalog.labels.unsaved": "You have unsaved label changes. Click Save to apply them.",
  "label.testCatalog.labels.maxLtDefault": "Max Qty must be greater than or equal to Default Qty.",
  "label.testCatalog.labels.allowOverride.label": "Allow override at order entry",
  "label.testCatalog.labels.generationSettings": "Label Generation Settings",
  "label.testCatalog.labels.remove.action": "Șterge",
  "label.testCatalog.labels.remove.title": "Remove Label Type",
  "label.testCatalog.labels.remove.confirm": "Șterge",
  "label.testCatalog.labels.remove.body": "Remove {name} from this test's label configuration?",
  "label.testCatalog.section.reagents": "Reagents",
  "label.testCatalog.section.analyzers": "Analyzers",
  "label.testCatalog.section.alerts": "Alerts",
  "label.testCatalog.section.reflex-calc": "Reflex & Calc",
  "label.testCatalog.section.localization": "Localization",
  "label.testCatalog.section.display-order": "Display Order",
  "label.sampleType.section.basic-info": "Basic Info",
  "label.sampleType.section.associated-tests": "Associated Tests",
  "label.sampleType.section.terminology": "Terminology",
  "label.sampleType.section.localization": "Localization",
  "label.sampleType.localization.intro": "Edit per-language translations for this sample type's name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.sampleType.localization.empty": "This sample type has no localizable name fields.",
  "label.sampleType.localization.loadError": "Unable to load translations for this sample type.",
  "label.sampleType.localization.field.name": "Nume tip probă",
  "label.sampleType.terminology.intro": "Map this sample type to standard terminology codes for interoperability.",
  "label.sampleType.terminology.empty": "No terminology mappings yet.",
  "label.sampleType.terminology.saved": "Terminology mappings saved.",
  "label.sampleType.terminology.saveError": "Could not save terminology mappings.",
  "label.sampleType.terminology.saveInvalid": "Some mappings are invalid. Check source, code, and duplicates.",
  "label.sampleType.terminology.addHint": "Save this sample type first, then add terminology mappings.",
  "label.sampleType.localization.addHint": "Save this sample type first, then edit its translations.",
  "label.sampleType.name": "Nume",
  "label.sampleType.section.display-order": "Display Order",
  "label.sampleType.section.disposal": "Disposal",
  "label.sampleType.displayOrder": "Position in the Sample Type menu",
  "label.sampleType.displayOrder.intro": "Positions this sample type in the order-entry Sample Type menu. Type a position or use the arrows, then save — every sample type is renumbered.",
  "label.sampleType.displayOrder.current": "This sample type",
  "label.sampleType.displayOrder.loading": "Loading sample types...",
  "label.sampleType.displayOrder.saved": "Display order updated.",
  "label.sampleType.displayOrder.saveError": "Could not update display order.",
  "label.sampleType.displayOrder.addHint": "Save this sample type first, then set its menu position.",
  "label.sampleType.disposalInstructions": "Disposal instructions",
  "label.sampleType.disposal.intro": "Free-text reference guidance for disposing of this specimen type. The authoritative, structured handling stays on each test's Storage section and the specimen disposal workflow.",
  "label.sampleType.disposal.placeholder": "e.g. Autoclave before disposal via biohazard waste",
  "label.sampleType.disposal.loading": "Loading disposal instructions...",
  "label.sampleType.disposal.saved": "Disposal instructions saved.",
  "label.sampleType.disposal.saveError": "Could not save disposal instructions.",
  "label.sampleType.disposal.addHint": "Save this sample type first, then add disposal instructions.",
  "label.sampleType.tests.manageIntro": "Tests linked to this sample type. Search the catalog to add more, or remove existing links. The same link can also be managed from a test's Basic Info in the Test Catalog.",
  "label.sampleType.tests.search": "Search tests",
  "label.sampleType.tests.searchPlaceholder": "Search by test name...",
  "label.sampleType.tests.filterBySampleType": "Filter by sample type",
  "label.sampleType.tests.filterBySampleType.all": "Any sample type",
  "label.sampleType.tests.pick": "Test to add",
  "label.sampleType.tests.pickPlaceholder": "Select a test...",
  "label.sampleType.tests.add": "Add test",
  "label.sampleType.tests.addError": "Could not link the test to this sample type.",
  "label.sampleType.tests.remove": "Remove test",
  "label.sampleType.tests.removeError": "Could not unlink the test.",
  "label.sampleType.tests.loading": "Loading associated tests...",
  "label.sampleType.tests.none": "No tests are associated with this sample type.",
  "message.sampleType.edit.success": "Sample type updated successfully.",
  "label.sampleType.loading": "Loading sample type...",
  "warning.sampleType.deactivateInUse": "{count} active tests use this type; they won't be orderable while it's inactive.",
  "note.sampleType.associatedTests.viewOnly": "View only — a test's specimen is part of its identity. To run a test on this sample type, create a specimen variant in the Test Catalog.",
  "sidenav.label.admin.sampleType.backToList": "← All Sample Types",
  "sidenav.label.admin.sampleType.editing": "Editing: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Editing sample type",
  "sidenav.label.admin.sampleType.sectionsHelper": "Click a sample type to edit its sections",
  "sidenav.label.admin.sampleType.addingNew": "Adding new sample type",
  "label.testCatalog.localization.locale": "Locale",
  "label.testCatalog.localization.intro": "Edit per-language translations for this test's name and reporting name. Untranslated fields fall back to English. Manage all translations from the Translation Management admin page.",
  "label.testCatalog.localization.unsaved": "You have unsaved translation changes. Click Save to apply them.",
  "label.testCatalog.localization.loadError": "Unable to load translations for this test.",
  "label.testCatalog.localization.empty": "This test has no localizable name fields.",
  "label.testCatalog.localization.saved": "Translation saved",
  "label.testCatalog.localization.saveError": "Could not save the translation.",
  "label.testCatalog.localization.field.name": "Nume test",
  "label.testCatalog.localization.field.reportingName": "Reporting Name",
  "label.testCatalog.localization.fallback.en": "Fallback (en)",
  "label.testCatalog.localization.fallback.tooltip": "Showing the English value because no translation is configured for {locale}.",
  "label.testCatalog.reflexCalc.loadError": "Unable to load reflex and calculation cross-links for this test.",
  "label.testCatalog.reflexCalc.reflex.heading": "Teste reflex",
  "label.testCatalog.reflexCalc.reflex.helper": "Rules that automatically order additional tests based on this test's results. Manage in Master Lists → Reflex Rules.",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Nume regulă",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Trigger Condition",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Reflex Test(s) Ordered",
  "label.testCatalog.reflexCalc.reflex.empty": "No reflex rules configured. Reflex rules are managed in Master Lists → Reflex Rules.",
  "label.testCatalog.reflexCalc.reflex.manage": "Manage Reflex Rules",
  "label.testCatalog.reflexCalc.calc.heading": "Calculated Results",
  "label.testCatalog.reflexCalc.calc.helper": "Formulas that use this test's results or that produce this test as output. Manage in Master Lists → Calculated Results.",
  "label.testCatalog.reflexCalc.calc.feedsInto": "This test feeds into",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "This test is calculated by",
  "label.testCatalog.reflexCalc.calc.col.name": "Formula Name",
  "label.testCatalog.reflexCalc.calc.col.formula": "Formula",
  "label.testCatalog.reflexCalc.calc.col.output": "Output Test",
  "label.testCatalog.reflexCalc.calc.empty": "Niciuna",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "This test does not feed into any calculated result. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "This test is not calculated from other tests. Calculations are managed in Master Lists → Calculated Values.",
  "label.testCatalog.reflexCalc.calc.manage": "Manage Calculated Results",
  "label.testCatalog.alerts.addRule": "Adaugă regulă",
  "label.testCatalog.alerts.empty": "No alert rules configured. Add a rule to notify recipients when results match a condition.",
  "label.testCatalog.alerts.loadError": "Unable to load alert rules for this test.",
  "label.testCatalog.alerts.saved": "Alert rule saved",
  "label.testCatalog.alerts.saveError": "Could not save the alert rule.",
  "label.testCatalog.alerts.deleted": "Alert rule deleted",
  "label.testCatalog.alerts.deleteError": "Could not delete the alert rule.",
  "label.testCatalog.alerts.nameRequired": "Rule name is required.",
  "label.testCatalog.alerts.valueRequired": "A specific value is required for the Specific Value trigger.",
  "label.testCatalog.alerts.col.name": "Nume",
  "label.testCatalog.alerts.col.trigger": "Trigger",
  "label.testCatalog.alerts.col.channels": "Channels",
  "label.testCatalog.alerts.col.ack": "Ack Required",
  "label.testCatalog.alerts.col.enabled": "Enabled",
  "label.testCatalog.alerts.col.actions": "Actions",
  "label.testCatalog.alerts.trigger.ALL": "All Results",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Abnormal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Critical",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Specific Value",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Compliance Breach",
  "label.testCatalog.alerts.edit.action": "Editează",
  "label.testCatalog.alerts.delete.action": "Delete",
  "label.testCatalog.alerts.delete.title": "Delete Alert Rule",
  "label.testCatalog.alerts.delete.confirm": "Delete",
  "label.testCatalog.alerts.delete.body": "Delete alert rule {name}?",
  "label.testCatalog.alerts.modal.addTitle": "Add Alert Rule",
  "label.testCatalog.alerts.modal.editTitle": "Edit Alert Rule",
  "label.testCatalog.alerts.field.name": "Nume regulă",
  "label.testCatalog.alerts.field.trigger": "Alert when result is:",
  "label.testCatalog.alerts.field.specificValue": "Specific value",
  "label.testCatalog.alerts.field.channels": "Notification channels",
  "label.testCatalog.alerts.field.recipients": "Recipients",
  "label.testCatalog.alerts.field.ackRequired": "Require acknowledgment",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Email",
  "label.testCatalog.alerts.recipient.physician": "Ordering Physician",
  "label.testCatalog.alerts.recipient.patient": "Pacient",
  "label.testCatalog.alerts.recipient.facility": "Instituție trimitere",
  "label.testCatalog.alerts.recipient.customPhone": "Custom phone",
  "label.testCatalog.alerts.recipient.customEmail": "Custom email",
  "label.testCatalog.alerts.recipient.roleId": "Notify users with role",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Select a role",
  "label.testCatalog.reagents.col.name": "Reagent Name",
  "label.testCatalog.reagents.col.usage": "Usage Type",
  "label.testCatalog.reagents.col.qty": "Quantity per Test",
  "label.testCatalog.reagents.col.stock": "Stock Level",
  "label.testCatalog.reagents.col.actions": "Actions",
  "label.testCatalog.reagents.empty": "No reagents linked. Link reagents from inventory to track consumption per test.",
  "label.testCatalog.reagents.loadError": "Unable to load reagents for this test.",
  "label.testCatalog.reagents.linkButton": "Link Reagent",
  "label.testCatalog.reagents.linkError": "Unable to link one or more reagents. Please try again.",
  "label.testCatalog.reagents.modal.title": "Link Reagents",
  "label.testCatalog.reagents.modal.linkSelected": "Link Selected",
  "label.testCatalog.reagents.modal.select.label": "Reagents",
  "label.testCatalog.reagents.modal.select.placeholder": "Select reagents to link",
  "label.testCatalog.reagents.modal.allLinked": "All available reagents are already linked to this test.",
  "label.testCatalog.reagents.unitPlaceholder": "Unit",
  "label.testCatalog.reagents.updated": "Reagent updated",
  "label.testCatalog.reagents.saveError": "Could not save changes.",
  "label.testCatalog.reagents.unsaved": "You have unsaved reagent changes. Click Save to apply them.",
  "label.testCatalog.reagents.retry": "Retry",
  "label.testCatalog.reagents.unlink.action": "Unlink",
  "label.testCatalog.reagents.unlink.title": "Unlink Reagent",
  "label.testCatalog.reagents.unlink.confirm": "Unlink",
  "label.testCatalog.reagents.unlink.body": "Unlink {name} from this test? Existing results linked to this reagent are unaffected.",
  "label.testCatalog.reagents.unlinked": "Reagent unlinked",
  "label.testCatalog.reagents.unlinkError": "Could not unlink the reagent. Please try again.",
  "label.testCatalog.basicInfo.name": "Nume",
  "label.testCatalog.basicInfo.name.helper": "The display name is translated — edit it in the Localization section.",
  "label.testCatalog.basicInfo.reportingName": "Reporting name",
  "label.testCatalog.basicInfo.labUnit": "Lab Unit",
  "label.testCatalog.basicInfo.createInactiveHint": "The test is created Inactive. Configure its sections, then activate it to make it orderable.",
  "sidenav.label.environmental.compliance.tooltip": "Environmental Compliance Dashboard",
  "site.search.helper": "Type at least 2 characters to auto-search. Required for routing results back to the requesting site.",
  "storage.skipped.title": "Storage skipped for {count} sample(s)",
  "test.qc.blankThreshold": "Blank Threshold",
  "test.qc.recoveryWindowPct": "Recovery Window (%)",
  "test.qc.rpdThreshold": "RPD Threshold (%)",
  "test.qc.thresholds.description": "Optional thresholds for environmental/vector QC evaluation. Leave blank if not applicable.",
  "test.qc.thresholds.heading": "QC Acceptance Thresholds",
  "title.testCatalog.createTest": "Create new test",
  "label.testCatalog.testName": "Test name",
  "label.testCatalog.testCode": "Test code",
  "label.testCatalog.domain": "Domain",
  "label.testCatalog.specimenType": "Sample type",
  "label.testCatalog.basicInfo.sampleTypes": "Sample types",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Select every specimen this test runs on. Configuration is shared across them.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Select at least one sample type.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "This sample type's domain doesn't match the test's domain.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Specimen",
  "label.testCatalog.override.shared": "All specimens (shared)",
  "notice.testCatalog.intake.awaitingSpecimen": "Awaiting specimen — this test runs on several specimens; resolve at collection.",
  "tag.testCatalog.finding.noSampleTypeLink": "No sample-type link",
  "error.testCatalog.codeExists": "A test with this code already exists.",
  "notification.testCatalog.testCreated": "Test '{name}' created. Complete its configuration in the sections at left.",
  "label.testCatalog.basicInfo.code": "Code",
  "label.testCatalog.basicInfo.description": "Descriere",
  "label.testCatalog.basicInfo.domain": "Domain",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clinical",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Environmental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "Change test domain?",
  "label.testCatalog.basicInfo.domainModal.body": "Change this test's domain to {domain}? This affects how the test is categorized in the catalog.",
  "label.testCatalog.basicInfo.amr": "AMR surveillance test",
  "label.testCatalog.basicInfo.active": "Activ",
  "label.testCatalog.basicInfo.orderable": "Comandabil",
  "label.testCatalog.basicInfo.saved": "Basic info saved.",
  "label.testCatalog.sampleResults.saved": "Sample & results saved.",
  "label.testCatalog.sampleResults.empty": "No result components yet. Add one to define how this test's results are captured.",
  "label.testCatalog.sampleResults.newComponent": "(new component)",
  "label.testCatalog.sampleResults.code": "Component code",
  "label.testCatalog.sampleResults.isPrimary": "Primary component",
  "label.testCatalog.sampleResults.showOnReport": "Show on patient report",
  "label.testCatalog.sampleResults.label": "Component label",
  "label.testCatalog.sampleResults.resultType": "Tip rezultat",
  "label.testCatalog.sampleResults.resultType.N": "Numeric",
  "label.testCatalog.sampleResults.resultType.none": "No result type selected",
  "label.testCatalog.sampleResults.preview.noType": "Select a result type above to see how technicians will enter this result.",
  "label.testCatalog.sampleResults.resultType.D": "Single-select list (dictionary)",
  "label.testCatalog.sampleResults.resultType.R": "Free text",
  "label.testCatalog.sampleResults.resultType.M": "Multi-select list",
  "label.testCatalog.sampleResults.resultType.C": "Cascading multi-select",
  "label.testCatalog.sampleResults.resultType.T": "Titer",
  "label.testCatalog.sampleResults.resultType.A": "Alpha (validated text)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Common",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Advanced / legacy types",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Hide advanced / legacy types",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "A measured number with a unit (e.g. 12.3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "One value chosen from a fixed set (e.g. Detected / Not detected).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "A typed comment or description.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "One or more values from a list; no single reference value.",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Grouped options; select multiple groups.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "A dilution ratio such as 1:10 or 1:20 (common in serology).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Validated alphanumeric text (a code or short coded value).",
  "label.testCatalog.sampleResults.preview": "Result entry preview",
  "label.testCatalog.sampleResults.previewHelper": "This is what a technician will see when entering this result.",
  "label.testCatalog.sampleResults.purpose": "Define what a technician records for this test and how results are interpreted.",
  "label.testCatalog.sampleResults.labelRequired": "Each result component needs a label before it can be saved.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Select a result type for \"{component}\" before saving.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "Most tests record one result. Add a component only if this test produces several values (e.g. a differential).",
  "label.testCatalog.sampleResults.displayOrder": "Display order",
  "label.testCatalog.sampleResults.uom": "Unitate de măsură",
  "label.testCatalog.sampleResults.uom.none": "(none)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Add new unit…",
  "label.testCatalog.sampleResults.uom.newName": "Display name",
  "label.testCatalog.sampleResults.uom.newCode": "Code",
  "label.testCatalog.sampleResults.uom.newUcum": "UCUM code",
  "label.testCatalog.sampleResults.uom.newDescription": "Descriere",
  "label.testCatalog.sampleResults.uom.saveNew": "Create unit",
  "label.testCatalog.sampleResults.significantDigits": "Zecimale semnificative",
  "label.testCatalog.sampleResults.significantDigits.helper": "Number of digits to keep after the decimal point when a numeric result is entered. Leave blank for no rounding.",
  "label.testCatalog.sampleResults.defaultResult": "Rezultat implicit",
  "label.testCatalog.sampleResults.allowMultiple": "Allow multiple readings",
  "label.testCatalog.sampleResults.options": "Select-list options",
  "label.testCatalog.sampleResults.options.empty": "No options defined yet. Add at least one option so this result can be entered.",
  "label.testCatalog.sampleResults.option.value": "Valoare",
  "label.testCatalog.sampleResults.option.sortOrder": "Sort order",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Options are shown to technicians in ascending sort order — lower numbers appear first.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.addOption": "Add option",
  "label.testCatalog.sampleResults.addCustomOption": "Add custom option",
  "label.testCatalog.sampleResults.searchDictionary": "Search dictionary values…",
  "label.testCatalog.sampleResults.removeOption": "Remove option",
  "label.testCatalog.sampleResults.interpretations": "Interpretations",
  "label.testCatalog.sampleResults.interpretations.empty": "No interpretations defined. Add one to attach guidance or a severity flag to a result.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Value match",
  "label.testCatalog.sampleResults.interp.selectValue": "Choose a value…",
  "label.testCatalog.sampleResults.interp.numericHint": "e.g. >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretation",
  "label.testCatalog.sampleResults.interp.severity": "Severitate",
  "label.testCatalog.sampleResults.addInterpretation": "Add interpretation",
  "label.testCatalog.sampleResults.removeInterpretation": "Remove interpretation",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Abnormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Critical",
  "label.testCatalog.sampleResults.actions": "Actions",
  "label.testCatalog.sampleResults.addComponent": "Add component",
  "label.testCatalog.sampleResults.removeComponent": "Remove component",
  "label.testCatalog.sampleResults.moveUp": "Move component up",
  "label.testCatalog.sampleResults.moveDown": "Move component down",
  "label.testCatalog.sampleResults.copyFrom": "Copy configuration from test",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Select a test…",
  "label.testCatalog.sampleResults.copyFromButton": "Copy from test",
  "label.testCatalog.sampleResults.copied": "Configuration copied.",
  "label.testCatalog.ranges.activated": "Test activated.",
  "label.testCatalog.ranges.ackModal.title": "Activate with coverage gaps?",
  "label.testCatalog.ranges.ackModal.confirm": "Acknowledge and activate",
  "label.testCatalog.ranges.ackModal.warning": "This test has reference-range coverage gaps.",
  "label.testCatalog.ranges.ackModal.body": "The following age windows have no reference range — results there cannot be flagged against a range. Acknowledge to activate anyway.",
  "label.testCatalog.ranges.male": "Masculin",
  "label.testCatalog.ranges.female": "Feminin",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "days",
  "label.testCatalog.ranges.months": "months",
  "label.testCatalog.ranges.years": "years",
  "label.testCatalog.ranges.noUpperLimit": "no upper limit",
  "label.testCatalog.ranges.noLowerLimit": "no lower limit",
  "label.testCatalog.ranges.both": "Both",
  "label.testCatalog.ranges.add": "Add range",
  "label.testCatalog.ranges.empty": "No reference ranges defined yet.",
  "label.testCatalog.ranges.saved": "Reference ranges saved.",
  "label.testCatalog.ranges.loadError": "Could not load reference ranges.",
  "label.testCatalog.ranges.col.component": "Component",
  "label.testCatalog.ranges.allComponents": "All components",
  "label.testCatalog.ranges.col.sex": "Sex",
  "label.testCatalog.ranges.col.age": "Interval de vârstă",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Critical",
  "label.testCatalog.ranges.col.valid": "Valid",
  "label.testCatalog.ranges.col.actions": "Actions",
  "label.testCatalog.ranges.anyAge": "Any age",
  "label.testCatalog.ranges.coverage.title": "Coverage validation",
  "label.testCatalog.ranges.coverage.gapsHeading": "Uncovered age windows:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Fully covered",
  "label.testCatalog.ranges.coverage.status.GAP": "Has gaps",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Has overlaps",
  "label.testCatalog.ranges.coverage.status.EMPTY": "No ranges",
  "label.testCatalog.ranges.modal.titleAdd": "Add reference range",
  "label.testCatalog.ranges.modal.titleEdit": "Edit reference range",
  "label.testCatalog.ranges.modal.sex": "Applies to",
  "label.testCatalog.ranges.modal.component": "Result component",
  "label.testCatalog.ranges.modal.component.all": "All components",
  "label.testCatalog.ranges.modal.ageUnit": "Age unit",
  "label.testCatalog.ranges.modal.minAge": "From age",
  "label.testCatalog.ranges.modal.maxAge": "To age (blank = no upper bound)",
  "label.testCatalog.ranges.modal.lowNormal": "Normal low",
  "label.testCatalog.ranges.modal.highNormal": "Normal high",
  "label.testCatalog.ranges.modal.lowCritical": "Critical low",
  "label.testCatalog.ranges.modal.highCritical": "Critical high",
  "label.testCatalog.ranges.modal.lowValid": "Valid low",
  "label.testCatalog.ranges.modal.highValid": "Valid high",
  "label.testCatalog.ranges.modal.ageError": "“To age” must be greater than “From age”.",
  "label.testCatalog.ranges.modal.boundsError": "Bounds must nest outward: valid low ≤ critical low ≤ normal low ≤ normal high ≤ critical high ≤ valid high.",
  "label.testCatalog.storage.saved": "Sample storage saved.",
  "label.testCatalog.storage.loadError": "Could not load sample storage settings.",
  "label.testCatalog.storage.history.view": "View change history",
  "label.testCatalog.storage.history.title": "Sample Storage — Change History",
  "label.testCatalog.storage.history.loadError": "Unable to load change history.",
  "label.testCatalog.storage.history.empty": "No changes recorded.",
  "label.testCatalog.storage.history.filter": "Filter by field",
  "label.testCatalog.storage.history.col.changedAt": "Changed At",
  "label.testCatalog.storage.history.col.changedBy": "Changed By",
  "label.testCatalog.storage.history.col.field": "Field",
  "label.testCatalog.storage.history.col.old": "Valoare veche",
  "label.testCatalog.storage.history.col.new": "Valoare nouă",
  "label.testCatalog.storage.storageHeading": "Storage",
  "label.testCatalog.storage.disposalHeading": "Disposal",
  "label.testCatalog.storage.handlingHeading": "Special handling",
  "label.testCatalog.storage.condition": "Storage condition",
  "label.testCatalog.storage.conditionCustom": "Custom condition",
  "label.testCatalog.storage.duration": "Maximum storage duration",
  "label.testCatalog.storage.durationUnit": "Duration unit",
  "label.testCatalog.storage.stabilityNotes": "Stability notes",
  "label.testCatalog.storage.protectFromLight": "Protect from light",
  "label.testCatalog.storage.doNotFreeze": "Do not freeze",
  "label.testCatalog.storage.doNotRefrigerate": "Do not refrigerate",
  "label.testCatalog.storage.disposalMethod": "Disposal method",
  "label.testCatalog.storage.disposalTimeframe": "Disposal timeframe",
  "label.testCatalog.storage.disposalUnit": "Timeframe unit",
  "label.testCatalog.storage.specialInstructions": "Special instructions",
  "label.testCatalog.storage.overrideRestricted": "Restrict storage-duration override",
  "label.testCatalog.storage.none": "— none —",
  "label.testCatalog.storage.condition.AMBIENT": "Ambient / room temperature",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Controlled room temperature (20–25°C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Cool room (8–15°C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Cold room (2–8°C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerated (2–8°C)",
  "label.testCatalog.storage.condition.FROZEN": "Frozen (−20°C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Deep frozen (−70°C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Ultra-low freezer (−80°C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Warm incubator (35–37°C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineration",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Chemical disinfection",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Biohazard waste",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Sharps container",
  "label.testCatalog.storage.disposal.SEWER": "Sewer / drain disposal",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Return to sender",
  "label.testCatalog.storage.disposal.ARCHIVE": "Long-term archive",
  "label.testCatalog.storage.disposal.STANDARD": "Standard waste",
  "label.testCatalog.storage.unit.hours": "hours",
  "label.testCatalog.storage.unit.days": "days",
  "label.testCatalog.storage.unit.weeks": "weeks",
  "label.testCatalog.storage.unit.months": "months",
  "label.testCatalog.analyzers.infoCard": "Analyzers are linked to this test on the analyzer configuration screen. This list is read-only.",
  "label.testCatalog.analyzers.empty": "No analyzers are mapped to this test yet.",
  "label.testCatalog.analyzers.loadError": "Could not load analyzers for this test.",
  "label.testCatalog.analyzers.col.analyzer": "Analizor",
  "label.testCatalog.analyzers.col.testName": "Analyzer test name",
  "label.testCatalog.displayOrder.pickSampleType": "Sample type",
  "label.testCatalog.displayOrder.intro": "Reorder how tests appear within a sample type. Order is saved automatically.",
  "label.testCatalog.displayOrder.empty": "No tests are assigned to this sample type.",
  "label.testCatalog.displayOrder.loadError": "Could not load the display order.",
  "label.testCatalog.displayOrder.saved": "Display order saved.",
  "label.testCatalog.displayOrder.moveUp": "Move up",
  "label.testCatalog.displayOrder.moveDown": "Move down",
  "label.testCatalog.displayOrder.col.position": "Position",
  "label.testCatalog.displayOrder.col.test": "Analiză",
  "label.testCatalog.displayOrder.dragHandle": "Drag to reorder",
  "label.testCatalog.terminology.intro": "Map this test to standard terminology codes for interoperability.",
  "vector.collectedVolume.helper": "Number of organisms in this pool, e.g., number of mosquitoes.",
  "vector.complete.animal": "Animal",
  "vector.complete.cancel": "Anulează",
  "vector.complete.details.collectionDate": "Data recoltării",
  "vector.complete.details.collectionSite": "Collection Site",
  "vector.complete.details.collector": "Recoltator",
  "vector.complete.details.lifecycleStage": "Lifecycle Stage",
  "vector.complete.details.tests": "Teste",
  "vector.complete.details.title": "Order Details",
  "vector.complete.details.trapType": "Trap Type",
  "vector.complete.labNumber": "Număr laborator",
  "vector.complete.newOrder": "New Vector Order",
  "vector.complete.quantity": "Quantity",
  "vector.complete.quantity.value": "{count} organisms",
  "vector.complete.status": "Stare",
  "vector.complete.status.processing": "Processing",
  "vector.lifecycleStage.helper": "Developmental stage of the collected organism.",
  "vector.order.collectionContext.helper": "Optional — records ecological conditions at time of collection (bionomics).",
  "vector.order.collectionDate.heading": "Data recoltării",
  "vector.order.collectionDate.helper": "Date the lot was physically collected from the field. Applies to every sample on this order.",
  "vector.order.site.add.new": "+ Add new site \"{name}\"",
  "vector.order.site.add.new.restricted": "Adding a new sampling site has been disabled by your administrator.",
  "vector.order.site.new.helper": "Will be created as a new sampling site when this order is saved.",
  "vector.order.site.new.tag": "New",
  "vector.order.site.no.match": "No matching site found.",
  "vector.pool.noTests": "No tests recorded",
  "vector.pool.summary": "Pool of {count} {animal}",
  "vector.trapCount.helper": "Number of traps deployed — used with nights to compute density per trap-night.",
  "vector.trapNights.helper": "Number of nights the traps were active. Leave blank if effort was not recorded.",
  "vector.trapType.helper": "Capture method or device used — select a sample type first.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} assigned · {pools} pools",
  "vectorDec.button.back": "Înapoi",
  "vectorDec.button.discard": "Discard",
  "vectorDec.button.previewGrouping": "Preview Grouping",
  "vectorDec.button.savePools": "Save Pools",
  "vectorDec.button.splitIndividuals": "Split to individuals →",
  "vectorDec.button.splitIndividuals.tooltip": "Quick set: one specimen per pool",
  "vectorDec.button.view": "Vizualizează",
  "vectorDec.col.children": "Child Specimens",
  "vectorDec.col.positiveTest": "Positive Test",
  "vectorDec.col.results": "Rezultate",
  "vectorDec.col.status": "Stare",
  "vectorDec.empty": "No deconvolution tasks.",
  "vectorDec.error.initiateFailed": "Could not initiate deconvolution.",
  "vectorDec.error.loadWorklist": "Could not load deconvolution worklist.",
  "vectorDec.error.minPoolCount": "Number of pools must be at least 2.",
  "vectorDec.error.noAssignedSpecimens": "Drag at least one specimen into a pool before saving.",
  "vectorDec.error.noParent": "No parent SampleItem available to split.",
  "vectorDec.error.poolFloorByType": "Lot has {types} sample types ({names}) — minimum {types} pools required for Random distribution.",
  "vectorDec.error.unassignedSpecimens": "{count} specimens are still unassigned. Assign all specimens before saving.",
  "vectorDec.field.howManyPools": "How many pools?",
  "vectorDec.field.notes": "Note",
  "vectorDec.field.organismsPerPool": "Organisms per pool",
  "vectorDec.field.poolCount": "Number of pools",
  "vectorDec.field.strategy": "Assignment method",
  "vectorDec.filter.all": "Toate",
  "vectorDec.filter.status": "Filter by status",
  "vectorDec.heading.preview": "Proposed Pool Grouping",
  "vectorDec.heading.split": "Split into Sub-pools",
  "vectorDec.heading.worklist": "Pool Deconvolution",
  "vectorDec.individualMode.badge": "Individual mode",
  "vectorDec.locationOverride.help": "Override the inherited intake collection site for individual sub-pools. Use this when a single lot was collected from multiple sites.",
  "vectorDec.locationOverride.inherit": "Inherit from lot (default)",
  "vectorDec.locationOverride.notes": "Aliquot notes",
  "vectorDec.locationOverride.site": "Collection site",
  "vectorDec.locationOverride.title": "Per sub-pool collection location (optional)",
  "vectorDec.message.success": "{count} sub-pools created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress.",
  "vectorDec.message.successIndividual": "{count} individual aliquots created ({labRange}), {orders} test orders queued. Status → Deconvolution In Progress. VR-07 Sporozoite Confirmation will fire on confirmed positives.",
  "vectorDec.parent.label": "Parent",
  "vectorDec.parent.quantity": "Quantity: {qty}",
  "vectorDec.preview.body": "{count} pools using {strategy}. Drag specimens between pools to adjust before saving.",
  "vectorDec.preview.empty": "No specimens",
  "vectorDec.preview.organisms": "organisms",
  "vectorDec.preview.poolN": "Pool {n}",
  "vectorDec.preview.poolWithSpecies": "Pool {n} — {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} other {# specimens}}",
  "vectorDec.preview.title": "Proposed grouping",
  "vectorDec.preview.unassigned": "{count, plural, =0 {All specimens assigned} one {# unassigned} other {# unassigned}}",
  "vectorDec.preview.unassignedHint": "{count} unassigned — these stay in the original pool.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Reflex rules will fire on save",
  "vectorDec.reflexPreview.parentTests": "Parent test orders ({test}) — re-run on each child",
  "vectorDec.reflexPreview.screeningPanel": "screening panel",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Tip: Split to individual specimens to also fire {rules} — these rules only apply to pools with a single organism.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} specimens → ~{perPool} per pool{remainder, plural, =0 {} other {, remainder +1 to first {remainder}}}",
  "vectorDec.status.complete": "Decon Complete",
  "vectorDec.status.confirmed": "Confirmed",
  "vectorDec.status.inProgress": "În desfășurare",
  "vectorDec.status.pending": "Review Needed",
  "vectorDec.strategy.manual": "Assign manually — drag and drop specimens into pools",
  "vectorDec.strategy.manual.hint": "Drag and drop specimens into pools yourself",
  "vectorDec.strategy.manual.title": "Assign manually",
  "vectorDec.strategy.random": "Assign randomly — distribute specimens evenly across pools",
  "vectorDec.strategy.random.hint": "Evenly distribute specimens across pools",
  "vectorDec.strategy.random.title": "Assign randomly",
  "vectorDec.strategy.species": "Auto sub-pool by species — group matching specimens together",
  "vectorDec.strategy.species.hint": "Group specimens by species — requires species ID on specimens",
  "vectorDec.strategy.species.title": "Auto sub-pool by species",
  "vectorDec.totalOrganisms": "Total organisms",
  "vectorDec.warning.exceedsParent.body": "{total} organisms requested across child pools, but parent has {parent}. The system will still create {total} children.",
  "vectorDec.warning.exceedsParent.title": "Total exceeds parent quantity",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} other {# specimens selected}}",
  "vectorId.bloodMeal.add": "Add Panel to Order",
  "vectorId.bloodMeal.added": "Blood-Meal Identification Panel added to specimen test orders.",
  "vectorId.bloodMeal.addedSub": "Provenance: manual (lab tech accepted suggestion). Per BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "Blood-meal panel already attached ({skipped} tests).",
  "vectorId.bloodMeal.body": "Order the Mosquito Blood-Meal Identification Panel to identify the host species this specimen fed on.",
  "vectorId.bloodMeal.bulkAdd": "Add Panel to All ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Blood-meal panel processed for {count} specimens.",
  "vectorId.bloodMeal.bulkBody": "Add the Mosquito Blood-Meal Identification Panel to every selected specimen so the lab can identify which vertebrate host the mosquitoes fed on.",
  "vectorId.bloodMeal.bulkSummary": "Blood-meal panel: {added} added, {skipped} already attached, {rejected} rejected.",
  "vectorId.bloodMeal.bulkTitle": "Blood-fed females detected ({count} specimens)",
  "vectorId.bloodMeal.dismiss": "Dismiss",
  "vectorId.bloodMeal.error.add": "Could not add the Mosquito Blood-Meal Identification Panel.",
  "vectorId.bloodMeal.error.dismiss": "Could not record the dismissal.",
  "vectorId.bloodMeal.title": "Blood-fed female detected",
  "vectorId.bulk.applyToCount": "Apply to {count} specimens",
  "vectorId.bulk.heading": "Bulk Apply Species ID",
  "vectorId.bulk.notice.body": "Molecular detail fields (target gene, assay, accession) are not bulk-copied — record those per specimen.",
  "vectorId.bulk.notice.title": "Specimen-specific fields not copied",
  "vectorId.button.bulkApply": "🔖 Bulk Apply ({count})",
  "vectorId.button.cancel": "Anulează",
  "vectorId.button.close": "▲ Close",
  "vectorId.button.confirm": "Confirmă",
  "vectorId.button.confirmAll": "✓ Confirm for all vectors",
  "vectorId.button.confirmResult": "✓ Confirm: {test}",
  "vectorId.button.hideResults": "Hide results",
  "vectorId.button.identify": "▼ Identify",
  "vectorId.button.reviewResults": "Review results ({n})",
  "vectorId.button.save": "Save Identification",
  "vectorId.button.splitPool": "↗ Split",
  "vectorId.col.collectionDate": "Data recoltării",
  "vectorId.col.decon": "Decon",
  "vectorId.col.decon.help": "Deconvolution status — whether pool results have been entered and sub-pools are awaiting review.",
  "vectorId.col.idStatus": "ID Status",
  "vectorId.col.lotId": "Lot ID",
  "vectorId.col.organismGroup": "Group",
  "vectorId.col.progress": "Progress",
  "vectorId.col.site": "Sampling Site",
  "vectorId.completion.body": "{positive} of {total} sub-pools confirmed ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vectors confirmed",
  "vectorId.completion.body.partial": "Confirmed for all vectors in this pool:",
  "vectorId.completion.heading": "Deconvolution Complete",
  "vectorId.completion.heading.confirmed": "Result Confirmed",
  "vectorId.completion.heading.partial": "Results Partially Confirmed",
  "vectorId.completion.tag": "Decon Complete",
  "vectorId.completion.tag.confirmed": "Confirmed",
  "vectorId.completion.tag.partial": "Partially Confirmed",
  "vectorId.confidence.confirmed": "Confirmed",
  "vectorId.confidence.presumptive": "Presumptive",
  "vectorId.distribution.confirmed": "{count} Confirmed",
  "vectorId.distribution.heading": "Species Distribution",
  "vectorId.distribution.notIdentified": "{count} Not Identified",
  "vectorId.distribution.notYet": "Not yet identified",
  "vectorId.distribution.presumptive": "{count} Presumptive",
  "vectorId.empty": "No lots in this queue.",
  "vectorId.error.accessionFormat": "GenBank accession format: 1–2 letters followed by 5–8 digits (e.g. MW123456).",
  "vectorId.error.confidenceRequired": "Confidence is required.",
  "vectorId.error.loadSpecimens": "Could not load specimens for this lot.",
  "vectorId.error.loadWorklist": "Could not load worklist.",
  "vectorId.error.methodRequired": "Identification method is required.",
  "vectorId.error.notesTooLong": "Notes must be 500 characters or less.",
  "vectorId.error.requiredFields": "Species, method, and confidence are required.",
  "vectorId.error.saveFailed": "Could not save identification.",
  "vectorId.error.speciesRequired": "Species is required.",
  "vectorId.filter.complete": "Complet",
  "vectorId.filter.complete.sub": "All specimens identified.",
  "vectorId.filter.decon": "Deconvolution",
  "vectorId.filter.decon.sub": "Pool results entered, awaiting technician decision to split or confirm.",
  "vectorId.filter.label": "Stare",
  "vectorId.filter.notstarted": "Not Started",
  "vectorId.filter.notstarted.sub": "Received, 0 specimens identified.",
  "vectorId.filter.partialid": "Partial ID",
  "vectorId.filter.partialid.sub": "Identification in progress.",
  "vectorId.filter.pending": "Pending",
  "vectorId.filter.pending.sub": "All not-complete lots, including pools with results awaiting technician review.",
  "vectorId.form.assayName": "Assay Name",
  "vectorId.form.assayName.placeholder": "Multiplex RT-PCR",
  "vectorId.form.confidence": "Confidence",
  "vectorId.form.genbankAccession": "GenBank Accession",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Lifecycle Stage",
  "vectorId.form.linkedResult": "Link to Pathogen Result",
  "vectorId.form.linkedResultPlaceholder": "Select a result on this lot…",
  "vectorId.form.method": "Method",
  "vectorId.form.molecularDetails": "🔬 Molecular Details",
  "vectorId.form.notes": "Note",
  "vectorId.form.physState": "Physiological State",
  "vectorId.form.select": "Select…",
  "vectorId.form.species": "Species",
  "vectorId.form.speciesPlaceholder": "Search genus or species…",
  "vectorId.form.targetGene": "Target Gene",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, 28S rDNA",
  "vectorId.heading.worklist": "Vector Identification Worklist",
  "vectorId.loading": "Loading…",
  "vectorId.message.bulkSuccess": "Identification applied to {count} specimens.",
  "vectorId.message.saveSuccess": "Identification saved.",
  "vectorId.method.both": "Morphological + Molecular",
  "vectorId.method.molecular": "Molecular",
  "vectorId.method.morphological": "Morphological",
  "vectorId.notif.confirmAll.error": "Could not confirm result. Please try again.",
  "vectorId.notif.confirmAll.success": "Result confirmed for all vectors in this pool.",
  "vectorId.notif.deconNeeded.body": "A result has been entered for this pool. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.bodyWithTest": "One of the tests has a result. Split into sub-pools for further testing, or confirm the result applies to all vectors.",
  "vectorId.notif.deconNeeded.title": "Pool Result Awaiting Review",
  "vectorId.physState.blood_fed": "Blood-fed",
  "vectorId.physState.gravid": "Gravid",
  "vectorId.physState.half_gravid": "Half-gravid",
  "vectorId.physState.unfed": "Unfed",
  "vectorId.physState.unknown": "Unknown / not assessed",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Search lots…",
  "vectorId.specimen.col.confidence": "Confidence",
  "vectorId.specimen.col.idStatus": "ID Status",
  "vectorId.specimen.col.label": "Specimen",
  "vectorId.specimen.col.labNo": "Număr laborator",
  "vectorId.specimen.col.poolOrSpecimen": "Pool / Specimen",
  "vectorId.specimen.col.species": "Species",
  "vectorId.specimen.confirmed": "Confirmed",
  "vectorId.specimen.count": "specimens",
  "vectorId.specimen.empty": "No specimens for this lot.",
  "vectorId.specimen.label": "Specimen #{n}",
  "vectorId.specimen.notIdentified": "Not Identified",
  "vectorId.specimen.presumptive": "Presumptive",
  "vectorId.status.complete": "Complet",
  "vectorId.status.inProgress": "În desfășurare",
  "vectorId.status.notStarted": "Not Started",
  "vectorId.tag.deconComplete": "Complet",
  "vectorId.tag.deconInProgress": "Decon in progress",
  "vectorId.tag.deconNeeded": "⚠ Review Result",
  "vectorId.tag.subPoolPending": "{count} sub-pool with results",
  "vectorId.tree.organisms": "{count, plural, one {# organism} other {# organisms}}",
  "vectorReport.density.bySite": "Density by site and period",
  "vectorReport.density.effortNotRecorded": "Effort not recorded",
  "vectorReport.density.period": "Period",
  "vectorReport.density.perTrapNight": "Density (per trap-night)",
  "vectorReport.density.pools": "Pools",
  "vectorReport.density.site": "Site",
  "vectorReport.density.specimens": "Specimens",
  "vectorReport.density.title": "Specimen counts by site",
  "vectorReport.density.trapNights": "Trap-nights",
  "vectorReport.description": "Surveillance indices computed from recorded vector collections, species identifications, and pathogen results",
  "vectorReport.empty": "No data for the selected scope.",
  "vectorReport.exportPdf": "Export PDF",
  "vectorReport.fieldMap.description": "Reorder, hide, relabel, or portal-tag the metrics shown in the Manual Entry Helper.",
  "vectorReport.fieldMap.hidden": "Hidden",
  "vectorReport.fieldMap.label": "Label",
  "vectorReport.fieldMap.metric": "Metric",
  "vectorReport.fieldMap.order": "Comandă",
  "vectorReport.fieldMap.portalTag": "Portal tag",
  "vectorReport.fieldMap.title": "Manual Entry Field Map",
  "vectorReport.fieldMap.visibility": "Visibility",
  "vectorReport.fieldMap.visible": "Visible",
  "vectorReport.fieldMap.visibleLabel": "Visible in the Manual Entry Helper",
  "vectorReport.filter.allSites": "All sites",
  "vectorReport.filter.apply": "Aplică",
  "vectorReport.filter.dateRange": "Date range",
  "vectorReport.filter.from": "De la",
  "vectorReport.filter.site": "Sampling site",
  "vectorReport.filter.to": "Până la",
  "vectorReport.freshness": "Data freshness",
  "vectorReport.freshness.as": "Figures as of {time}",
  "vectorReport.freshness.unknown": "unknown",
  "vectorReport.generated": "Generated:",
  "vectorReport.home": "Acasă",
  "vectorReport.loadError": "Failed to load surveillance indices. Please try again.",
  "vectorReport.manualEntry.confirmBody": "Record an audit snapshot of this week's figures ({periodStart} – {periodEnd})? Re-submitting a week is recorded as a separate entry.",
  "vectorReport.manualEntry.confirmSubmit": "Confirmă",
  "vectorReport.manualEntry.copied": "Copied to clipboard",
  "vectorReport.manualEntry.copy": "Copy value",
  "vectorReport.manualEntry.empty": "No metrics configured for this period",
  "vectorReport.manualEntry.loading": "Loading week's numbers...",
  "vectorReport.manualEntry.lowConfidence": "Confidence reduced (pool deconvolution below 95%)",
  "vectorReport.manualEntry.markSubmitted": "Mark week submitted",
  "vectorReport.manualEntry.submitError": "Could not record submission",
  "vectorReport.manualEntry.submitted": "Week marked submitted",
  "vectorReport.manualEntry.title": "Manual Entry Helper",
  "vectorReport.manualEntry.week": "Reporting week",
  "vectorReport.mir.classic": "MIR (classical)",
  "vectorReport.mir.observed": "Infection rate (observed)",
  "vectorReport.mir.pathogen": "Pathogen",
  "vectorReport.mir.positivePools": "Positive pools",
  "vectorReport.mir.resolution": "Positive resolution",
  "vectorReport.mir.species": "Species",
  "vectorReport.mir.sporozoite": "Sporozoite rate",
  "vectorReport.mir.sporozoiteNote": "Confidence is reduced when pool deconvolution resolution is below 95%.",
  "vectorReport.mir.title": "Minimum Infection Rate by species",
  "vectorReport.mir.totalSpecimens": "Total specimens",
  "vectorReport.mir.withheld": "Withheld",
  "vectorReport.positivity.notConfigured": "Positivity classification is not configured for this deployment, so infection-rate, positivity, and sporozoite figures are unavailable. Configure result significance in the test catalog to enable them.",
  "vectorReport.positivity.pathogen": "Pathogen",
  "vectorReport.positivity.pct": "Positivity",
  "vectorReport.positivity.poolsPositive": "Pools positive",
  "vectorReport.positivity.poolsTested": "Pools tested",
  "vectorReport.positivity.title": "Pathogen positivity",
  "vectorReport.positivity.unrecognized": "Some results carry a significance value that is not a recognized classification (POSITIVE, NEGATIVE, or INDETERMINATE) and are excluded from positivity counts. Review the test catalog so these results can be counted.",
  "vectorReport.prompt": "Select a date range and site, then choose Apply to view surveillance indices.",
  "vectorReport.qc.detail": "{passed} of {total} analyses passed",
  "vectorReport.qc.passed": "Analyses passed",
  "vectorReport.qc.passRate": "Pass rate",
  "vectorReport.qc.title": "QC pass-rate",
  "vectorReport.qc.total": "Analyses total",
  "vectorReport.species.genus": "Genus",
  "vectorReport.species.pct": "Share",
  "vectorReport.species.species": "Species",
  "vectorReport.species.specimens": "Specimens",
  "vectorReport.species.title": "Species distribution",
  "vectorReport.sporozoite.title": "Sporozoite rate (Anopheles)",
  "vectorReport.title": "Vector Surveillance",
  "vfs.abj": "ABJ (Larva-Free Rate)",
  "vfs.abj.target.below": "✗ ABJ below the 95% Kemenkes target",
  "vfs.abj.target.met": "✓ ABJ meets the 95% Kemenkes target",
  "vfs.bi": "Breteau Index (per 100 houses)",
  "vfs.ci": "Container Index (CI)",
  "vfs.containersExamined": "Containers examined",
  "vfs.containersPositive": "Containers positive",
  "vfs.err.containersExceeded": "Cannot exceed containers examined.",
  "vfs.err.examinedMin": "Must be ≥ 1 when larval data is entered.",
  "vfs.err.housesExceeded": "Cannot exceed houses examined.",
  "vfs.err.negative": "Cannot be negative.",
  "vfs.err.populationMin": "Must be ≥ 1 when pupal data is entered.",
  "vfs.hi": "House Index (HI)",
  "vfs.housesExamined": "Houses examined",
  "vfs.housesPositive": "Houses positive",
  "vfs.indices.title": "Computed indices (preview)",
  "vfs.larval.title": "Larval Survey — Mode C",
  "vfs.populationAtRisk": "Population at risk",
  "vfs.ppi": "Pupae Per Person (PPI)",
  "vfs.pupaeCount": "Pupae count",
  "vfs.pupal.title": "Pupal Survey — Mode D",
  "vfs.surveyMethod": "Survey method",
  "vfs.surveyMethod.placeholder": "Alege o opțiune",
  "warning.testCatalog.noLoinc": "This test has no LOINC. Analyzer and electronic-order results cannot be imported to it.",
  "warning.testCatalog.duplicateLoinc": "LOINC {code} is also used by {testName}. Incoming results for this code route to only one test (first match) — results may be sent to the wrong test.",
  "label.testCatalog.terminology.col.source": "Source",
  "label.testCatalog.terminology.col.code": "Code",
  "label.testCatalog.terminology.col.displayName": "Display name",
  "label.testCatalog.terminology.displayName.placeholder": "e.g. Glucose [Mass/volume] in Serum or Plasma",
  "label.testCatalog.terminology.col.relationship": "Relationship",
  "label.testCatalog.terminology.col.appliesTo": "Applies to",
  "label.testCatalog.terminology.appliesTo.test": "Whole test",
  "label.testCatalog.terminology.col.actions": "Actions",
  "label.testCatalog.terminology.source": "Terminology source",
  "label.testCatalog.terminology.code": "Code",
  "label.testCatalog.terminology.relationship": "Relationship",
  "label.testCatalog.terminology.addMapping": "Add mapping",
  "label.testCatalog.terminology.remove": "Remove mapping",
  "label.testCatalog.terminology.empty": "No terminology mappings yet.",
  "label.testCatalog.terminology.loadError": "Could not load terminology mappings.",
  "label.testCatalog.terminology.saved": "Terminology mappings saved.",
  "error.testCatalog.terminology.duplicate": "Duplicate {source} code {code} — this mapping already exists for this test.",
  "error.testCatalog.terminology.invalid": "The mappings could not be saved — check for a duplicate code, an unknown source, or an invalid relationship.",
  "label.testCatalog.terminology.rel.none": "— none —",
  "label.testCatalog.terminology.rel.SAME_AS": "Same as",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Broader than",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Narrower than",
  "label.testCatalog.panels.intro": "Manage which panels this test belongs to, and its position within each.",
  "label.testCatalog.panels.addToPanel": "Add to panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Position",
  "label.testCatalog.panels.col.actions": "Actions",
  "label.testCatalog.panels.position": "Position",
  "label.testCatalog.panels.remove": "Remove from panel",
  "label.testCatalog.panels.remove.confirm.heading": "Remove test from panel?",
  "label.testCatalog.panels.remove.confirm.body": "This test will be removed from {panel}. It stays in the catalog and any other panels. You can re-add it later.",
  "label.testCatalog.panels.moveUp": "Move earlier",
  "label.testCatalog.panels.moveDown": "Move later",
  "label.testCatalog.panels.viewOrder": "View this panel's test order",
  "label.testCatalog.panels.orderContext": "Tests in this panel (in order):",
  "label.testCatalog.panels.empty": "This test is not in any panel yet.",
  "label.testCatalog.panels.loadError": "Could not load panel memberships.",
  "label.testCatalog.panels.saved": "Panel memberships saved.",
  "label.testCatalog.panels.createPanel": "Create new panel",
  "label.testCatalog.panels.createPanelHint": "Enter a name to create a panel and add this test to it. Its sample type, ordering modules and other settings are configured later in the Panel Editor.",
  "notification.testCatalog.panels.created": "Panel '{name}' created and this test added. Configure it further in the Panel Editor.",
  "label.search": "Caută",
  "label.testCatalog.list": "Catalog teste",
  "label.testCatalog.list.search": "Search by test name",
  "label.testCatalog.list.col.status": "Stare",
  "label.testCatalog.list.filter.allDomains": "All domains",
  "label.testCatalog.list.filter.allStatus": "All statuses",
  "label.testCatalog.list.filter.inactive": "Inactive",
  "label.testCatalog.list.coverageIncomplete": "Coverage incomplete",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": "Oricare",
  "label.testCatalog.list.filter.amrOnly": "AMR only",
  "label.testCatalog.list.filter.nonAmr": "Non-AMR",
  "label.testCatalog.list.filter.sampleType": "Tip probă",
  "label.testCatalog.list.filter.allSampleTypes": "All sample types",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "No LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Only tests with issues",
  "label.testCatalog.list.health.banner": "{count} tests have configuration issues ({errors} errors · {warnings} warnings)",
  "label.testCatalog.list.health.show": "Show",
  "label.testCatalog.activation.incomplete.heading": "Test cannot be activated yet",
  "label.testCatalog.activation.incomplete.body": "Resolve the following before this test can be activated:",
  "label.testCatalog.list.col.sampleType": "Tip probă",
  "button.testCatalog.newTest": "New test",
  "button.testCatalog.editRelated": "Edit related tests together",
  "button.testCatalog.editRelatedFromEditor": "Edit related tests…",
  "label.testCatalog.editor.noRelated": "No related tests share this test's name.",
  "label.testCatalog.editor.createSaveFirst.title": "Save the test first",
  "label.testCatalog.editor.createSaveFirst": "Complete Basic Info and save. This section becomes available once the test is created.",
  "label.testCatalog.editingNTests": "Editing {count} tests",
  "label.testCatalog.perTestIdentity": "Identity & LOINC (per test)",
  "state.testCatalog.differsAcrossTests": "Differs across tests",
  "button.testCatalog.setAllTo": "Set all to these values",
  "label.testCatalog.group.rangesSaved": "Reference ranges saved to {count} tests.",
  "label.testCatalog.group.storageIntro": "Edit storage & handling once; saving applies it to every selected test.",
  "button.testCatalog.removeFromSet": "Remove from this set",
  "label.testCatalog.group.rangesIntro": "Edit the reference ranges once; saving applies them to every selected test. Identity and LOINC stay per test.",
  "label.testCatalog.group.rangesDiffer": "The selected tests' current ranges are not identical. Saving will set all of them to the values below.",
  "label.testCatalog.ranges.table.sex": "Applies to",
  "label.testCatalog.ranges.table.age": "Interval de vârstă",
  "label.testCatalog.ranges.table.normal": "Normal (low / high)",
  "label.testCatalog.list.filters": "Filtre",
  "label.testCatalog.list.filters.count": "Filters ({count})",
  "label.testCatalog.list.error": "Couldn't load the test catalog. Adjust the filters or reload to try again.",
  "label.testCatalog.list.empty": "No tests match the current filters.",
  "sidenav.label.admin.testmgt.ManageMethod": "Gestionare metode",
  "sidenav.label.admin.testmgt.reflex": "Management teste reflex",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Vezi catalogul de teste",
  "sidenav.label.admin.usermgt": "Management utilizatori",
  "sideNav.label.arvfollowup1": "ARV Urmărire Versiunea 1",
  "sideNav.label.arvfollowup2": "ARV Urmărire Versiunea 2",
  "sideNav.label.arvreports1": "ARV Versiunea inițială 1",
  "sideNav.label.arvreports2": "ARV Versiunea inițială 2",
  "sideNav.label.arvversion1": "ARV - Versiunea 1",
  "sideNav.label.associatedpatientreport": "Raport pacient asociat",
  "sideNav.label.audittrail": "Jurnal audit",
  "sidenav.label.barcode": "Cod de bare",
  "sidenav.label.batchorder": "Comandă în lot",
  "sideNav.label.bypaneltype": "După tip panel",
  "sideNav.label.bytesttype": "După tip test",
  "sideNav.label.byunit": "După unitate",
  "sideNav.label.collectedarvpatientreports": "Raport pacienți ARV colectați",
  "sidenav.label.cytology": "Citologie",
  "sidenav.label.cytology.dashboard": "Tablou de bord",
  "sideNav.label.delayedvalidation": "Validare întârziată",
  "sidenav.label.editorder": "Editează comandă",
  "sideNav.label.eidreports1": "EID Versiunea 1",
  "sideNav.label.eidreports2": "EID Versiunea 2",
  "sideNav.label.exportcsvfile": "Export fișier CSV rutină",
  "sideNav.label.followuprequired": "Urmărire necesară",
  "sideNav.label.generalreport": "Raport general",
  "sideNav.label.hivtestsummary": "Sumar teste HIV",
  "sidenav.label.immunochem": "Imunohistochimie",
  "sidenav.label.immunochem.dashboard": "Tablou de bord",
  "sidenav.label.incomingorder": "Comenzi electronice",
  "sideNav.label.intermediatebyservice": "Intermediar pe serviciu",
  "sideNav.label.intermediatereport1": "Intermediar Versiunea 1",
  "sideNav.label.intermediatereport2": "Intermediar Versiunea 2",
  "sidenav.label.inventory": "Inventory",
  "sidenav.label.inventory.management": "Inventory Management",
  "sidenav.label.inventory.management.tooltip": "Manage inventory items, lots, and stock levels",
  "sidenav.label.inventory.tooltip": "Inventory management for reagents, kits, and supplies",
  "sideNav.label.laporanHasil": "Compliance Report",
  "sideNav.label.noncomformitynotification": "Notificare neconformitate",
  "sideNav.label.noncomformityreportsbydate": "După dată",
  "sideNav.label.noncomformityreportsbylabno": "După număr laborator",
  "sideNav.label.noncomformityreportsbyunit": "După unitate și motiv",
  "sidenav.label.notebook": "NoteBook",
  "sidenav.label.add.order": "Adaugă comandă",
  "sidenav.label.clinical.order": "Add Clinical Order",
  "sidenav.label.environmental.compliance": "Compliance Dashboard",
  "sidenav.label.environmental.order": "Add Environmental Order",
  "sidenav.label.vector.order": "Add Vector Order",
  "sidenav.label.order": "Comandă",
  "sidenav.label.order.collect": "Collect Sample",
  "sidenav.label.order.dashboard": "Tablou de bord",
  "sidenav.label.order.enter": "Introduceți comanda",
  "sidenav.label.order.label": "Label & Store",
  "sidenav.label.order.qa": "QA Review",
  "sidenav.label.pathology": "Patologie",
  "sidenav.label.pathology.dashboard": "Tablou de bord",
  "sideNav.label.referredtestreport": "Raport teste trimise",
  "sideNav.label.rejectionreport": "Raport respingeri",
  "sidenav.label.reports": "Rapoarte",
  "sidenav.label.reports.routine": "Rutină",
  "sidenav.label.reports.study": "Studiu",
  "sidenav.label.results": "Rezultate",
  "sidenav.label.results.byrange": "După intervalul numerelor de laborator",
  "sidenav.label.results.order": "După comandă",
  "sidenav.label.results.patient": "După pacient",
  "sidenav.label.results.testdate": "După data testului",
  "sidenav.label.results.unit": "După unitate",
  "sideNav.label.sectionperformance": "Performanță secțiune",
  "sideNav.label.specialrequest": "Cerere specială",
  "sidenav.label.statisticsreport": "Raport statistic",
  "sidenav.label.statusreport": "Raport stare pacient",
  "sidenav.label.storage.coldstorage": "Cold Storage Monitoring",
  "sidenav.label.storage.coldstorage.tooltip": "Monitor temperature and humidity of freezers and refrigerators",
  "sidenav.label.storage.management": "Storage Management",
  "sidenav.label.storage.management.tooltip": "Manage storage locations and devices",
  "sidenav.label.testsummary": "Sumar teste",
  "sidenav.label.validation": "Validare",
  "sidenav.label.validation.order": "Caută după comandă",
  "sidenav.label.validation.routine": "Rutină",
  "sidenav.label.validation.study": "Studiu",
  "sidenav.label.validation.testdate": "Caută după data testului",
  "sideNav.label.viralloaddataexport": "Export date încărcătură virală",
  "sideNav.label.vlversionnational": "VL versiune națională",
  "sidenav.label.workplan": "Plan de lucru",
  "sidenav.label.workplan.panel": "După tip panel",
  "sidenav.label.workplan.priority": "După prioritate",
  "sidenav.label.workplan.test": "După tip test",
  "sidenav.label.workplan.unit": "Pe unitate",
  "sideNav.title.activityreport": "Raport activitate",
  "sidenav.title.aggregatereport": "Rapoarte agregate",
  "sideNav.title.arvreports": "Rapoarte ARV",
  "sideNav.title.associatedpatientreport": "Raport pacient asociat",
  "sideNav.title.audittrail": "Jurnal audit",
  "sideNav.title.collectedarvpatientreports": "Raport pacienți ARV colectați",
  "sideNav.title.delayedvalidation": "Validare întârziată",
  "sideNav.title.eidreports": "Rapoarte EID",
  "sideNav.title.environmentalReports": "Environmental Reports",
  "sideNav.title.exportbydate": "Export după dată",
  "sideNav.title.exportcsvfile": "Export fișier CSV rutină",
  "sideNav.title.indicator": "Indicator",
  "sideNav.title.intermediatereport": "Raport intermediar",
  "sideNav.title.noncomformityreports": "Rapoarte neconformitate",
  "sideNav.title.referredtestreport": "Raport teste trimise",
  "sideNav.title.rejectionreport": "Raport respingeri",
  "sideNav.title.specialrequest": "Cerere specială",
  "sideNav.title.tatreport": "Turn Around Time",
  "sideNav.title.vectorIdentification": "Vector Identification",
  "sideNav.title.vlreport": "Raport VL",
  "sideNav.label.audittrail.orderEvents": "Order Events",
  "sideNav.label.audittrail.systemEvents": "System Events",
  "sidenav.label.addorder": "Adaugă comandă",
  "sidenav.label.admin.sampleTypeManagement": "Sample Type Editor",
  "sidenav.title.statusreport": "Raport stare pacient",
  "systemAudit.filter.startDate": "Data de început",
  "systemAudit.filter.endDate": "Data de sfârșit",
  "systemAudit.filter.entityType": "Entity Type",
  "systemAudit.filter.action": "Acțiune",
  "systemAudit.filter.search": "Caută",
  "systemAudit.filter.export": "Export CSV",
  "systemAudit.table.heading.time": "Oră",
  "systemAudit.table.heading.entityType": "Entity Type",
  "systemAudit.table.heading.entityId": "Entity ID",
  "systemAudit.table.heading.action": "Acțiune",
  "systemAudit.table.heading.user": "Utilizator",
  "systemAudit.table.heading.changes": "Changes",
  "systemAudit.noResults": "No system events found for the given filters.",
  "systemAudit.filter.all": "Toate",
  "systemAudit.filter.user": "Utilizator",
  "systemAudit.filter.searchText": "Caută",
  "systemAudit.filter.searchText.placeholder": "Search by entity ID...",
  "systemAudit.filter.exportPdf": "Export PDF",
  "systemAudit.filter.selectedPatient": "Selected Patient",
  "systemAudit.filter.selectedPatient.none": "Niciuna",
  "systemAudit.filter.selectPatient": "Select Patient",
  "systemAudit.filter.selectAnotherPatient": "Select Another Patient",
  "systemAudit.action.insert": "Insert",
  "systemAudit.action.update": "Update",
  "systemAudit.action.delete": "Delete",
  "site.branding.cancel": "Anulează",
  "site.branding.color.format.error": "Invalid color format. Please use a valid CSS color (e.g., #0f62fe)",
  "site.branding.color.hex.label": "Hex Color Code",
  "site.branding.colorPicker.helperText": "Enter any CSS color (e.g., #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe or blue",
  "site.branding.confirm.remove": "Remove Logo",
  "site.branding.confirm.remove.message": "Are you sure you want to remove this logo and revert to the default OpenELIS logo?",
  "site.branding.current.logo": "Current Logo",
  "site.branding.description": "Customize your organization's visual branding including logos and colors",
  "site.branding.error.remove": "Error removing logo file.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Icon displayed in browser tabs and bookmarks",
  "site.branding.file.format.error": "Unsupported file format. Please use PNG, SVG, or JPG/JPEG",
  "site.branding.file.pending": "File selected - click Save Changes to upload",
  "site.branding.file.size.error": "File size exceeds 2MB limit",
  "site.branding.formats": "Formats: PNG, SVG, JPG (max 2MB)",
  "site.branding.header.color": "Header Color",
  "site.branding.header.color.description": "Background color for the application header bar",
  "site.branding.header.logo": "Header Logo",
  "site.branding.header.logo.description": "Logo displayed in the top-left of the application header",
  "site.branding.login.logo": "Login Page Logo",
  "site.branding.login.logo.description": "Logo displayed on the login page",
  "site.branding.login.using.header.logo": "Using header logo for login page",
  "site.branding.logo.upload.success": "Logo uploaded successfully",
  "site.branding.no.logo": "No custom logo (using default)",
  "site.branding.preview": "Preview",
  "site.branding.primary.color": "Primary Color",
  "site.branding.primary.color.description": "Color for primary buttons, active menu items, and links",
  "site.branding.remove.favicon": "Remove Favicon",
  "site.branding.remove.header.logo": "Remove Header Logo",
  "site.branding.remove.login.logo": "Remove Login Logo",
  "site.branding.remove.logo": "Remove Logo",
  "site.branding.reset.confirmation": "Are you sure you want to reset all branding to OpenELIS defaults? This will remove all custom logos and colors.",
  "site.branding.reset.error": "Error resetting branding to defaults.",
  "site.branding.reset.success": "Branding reset to default values successfully.",
  "site.branding.reset.to.defaults": "Reset to Default Branding",
  "site.branding.save": "Save Changes",
  "site.branding.save.error": "Error saving branding configuration",
  "site.branding.save.success": "Branding configuration saved successfully",
  "site.branding.secondary.color": "Secondary Color",
  "site.branding.secondary.color.description": "Color for secondary buttons, borders, and inactive states",
  "site.branding.section.colors": "Colors",
  "site.branding.section.logos": "Logos",
  "site.branding.title": "Site Branding",
  "site.branding.unsaved.changes": "You have unsaved changes. Do you want to save, discard, or cancel?",
  "site.branding.unsaved.changes.warning": "You have unsaved changes. Click Save to apply them.",
  "site.branding.upload.favicon": "Upload Favicon",
  "site.branding.upload.header.logo": "Upload Header Logo",
  "site.branding.upload.login.logo": "Upload Login Logo",
  "site.branding.upload.logo": "Upload Logo",
  "site.branding.use.header.logo.for.login": "Use same logo as header",
  "siteInfo.description.default.barcode": "Indică numărul implicit de etichete cod de bare care ar trebui tipărite cu fiecare comandă și specimen.",
  "siteInfo.description.dimensions": "Indică dimensiunile la care trebuie să se conformeze etichetele cod de bare la tipărire.",
  "siteInfo.description.elements": "Bifează elementele opționale ce trebuie să apară pe etichetele cod de bare pentru comandă și eșantion.",
  "siteInfo.description.max.barcode": "Indică numărul maxim de etichete cod de bare ce pot fi tipărite pentru fiecare comandă sau specimen. După atingerea maximului, nu se vor mai putea tipări etichete suplimentare.",
  "siteInfo.elements.mandatory": "Elemente obligatorii",
  "siteInfo.elements.optional": "Elemente opționale",
  "siteInfo.section.altAccession": "Număr accesare preimprimat",
  "siteInfo.section.elements": "Elemente etichetă cod de bare",
  "siteInfo.section.number": "Număr etichete cod de bare",
  "siteInfo.section.size": "Dimensiuni etichetă cod de bare",
  "siteInfo.title.default.barcode": "Etichete cod de bare implicite",
  "siteInfo.title.default.barcode.block": "Bloc",
  "siteInfo.title.default.barcode.height": "Înălțime",
  "siteInfo.title.default.barcode.order": "Comandă",
  "siteInfo.title.default.barcode.order.none": "Niciuna",
  "siteInfo.title.default.barcode.slide": "Lamă",
  "siteInfo.title.default.barcode.specimen": "Specimen",
  "siteInfo.title.default.barcode.freezer": "Freezer",
  "siteInfo.title.default.barcode.width": "Lățime",
  "siteInfo.title.max.barcode": "Număr maxim etichete cod de bare",
  "started.date": "Started Date",
  "status": "Stare",
  "status.in.progress": "În desfășurare",
  "status.unknown": "Unknown",
  "stillThere.message": "Sesiunea ta este pe cale să expire. Apasă oriunde pentru a rămâne autentificat.",
  "stillThere.title": "Încă ești acolo?",
  "stock.available": "Available",
  "stock.level": "Stock Level",
  "stock.status": "Stock Status",
  "stock.status.expired": "Expired",
  "stock.status.expiring": "Expiring",
  "stock.status.inStock": "In Stock",
  "stock.status.lowStock": "Low Stock",
  "stock.status.outOfStock": "Out of Stock",
  "storage.active": "Activ",
  "storage.add.device": "Add Device",
  "storage.add.location": "Locație",
  "storage.add.location.option": "Add Location...",
  "storage.add.new.device": "Add new device",
  "storage.add.rack": "Add Rack",
  "storage.add.box": "Add Box",
  "storage.add.room": "Add Room",
  "storage.add.shelf": "Add Shelf",
  "storage.allAssigned.title": "All Samples Assigned",
  "storage.assign.button": "Assign Location",
  "storage.assign.title": "Assign Storage Location",
  "storage.assigned": "Assigned",
  "storage.assigned.by": "Assigned By",
  "storage.assigned.date": "Assigned Date",
  "storage.barcode.scan.placeholder": "Scan barcode or enter manually",
  "storage.bulk.move.auto.assigned": "Auto-assigned positions (editable)",
  "storage.bulk.move.preview": "Bulk Move Preview",
  "storage.cannotDelete.hasAssignments": "Cannot delete {entityType} '{name}': has {count} assigned sample(s)",
  "storage.cannotDelete.hasChildren": "Cannot delete {entityType} '{name}': contains {count} {childType}(s)",
  "storage.capacity.calculated": "Calculated",
  "storage.capacity.manual": "Manual Limit",
  "storage.capacity.undetermined.tooltip": "Capacity cannot be calculated: some child locations lack defined capacities",
  "storage.capacity.warning": "{location} is {percentage}% full. Consider using alternative storage.",
  "storage.code.change.acknowledge": "I understand and want to proceed with the code change",
  "storage.code.change.warning": "Warning",
  "storage.code.change.warning.message": "Changing the code will invalidate any previously printed labels for this location.",
  "storage.confirm.add.device": "Do you want to create a new device '{name}'?",
  "storage.conditionNotes": "Condition Notes",
  "storage.conditionNotes.placeholder": "Enter any notes about storage conditions...",
  "storage.confirm.delete": "Confirmă ștergerea",
  "storage.create.room.error": "Failed to create room: {error}",
  "storage.create.room.success": "Room \"{name}\" created successfully",
  "storage.current.location": "Current Location",
  "storage.currentLocation": "Current Location",
  "storage.delete.admin.only": "Only Global Administrators can delete locations",
  "storage.delete.are.you.sure": "Are you sure you want to delete",
  "storage.delete.cannot.be.undone": "This action cannot be undone.",
  "storage.delete.cascade.confirm": "Confirm Cascade Delete",
  "storage.delete.cascade.confirmation.checkbox": "I confirm that I want to delete this location and all its child locations. All samples will be unassigned. This action cannot be undone.",
  "storage.delete.cascade.summary": "This will delete {childCount} {childType}(s) and unassign {sampleCount} sample(s). Are you sure you want to proceed?",
  "storage.delete.cascade.warning": "Cascade Delete Warning",
  "storage.delete.checking": "Checking constraints...",
  "storage.delete.confirmation.checkbox": "I confirm that I want to delete this location. This action cannot be undone.",
  "storage.delete.constraints.title": "Cannot Delete",
  "storage.delete.device": "Delete Device",
  "storage.delete.error": "Failed to delete location",
  "storage.delete.location": "Delete Location",
  "storage.delete.rack": "Delete Rack",
  "storage.delete.room": "Delete Room",
  "storage.delete.shelf": "Delete Shelf",
  "storage.device.code": "Code",
  "storage.device.communicationProtocol": "Communication Protocol",
  "storage.device.communicationProtocol.helper": "Protocol used for device communication (e.g., BACnet)",
  "storage.device.ipAddress": "IP Address",
  "storage.device.ipAddress.helper": "IPv4 or IPv6 address for network-connected equipment",
  "storage.device.label": "Device",
  "storage.device.name": "Nume",
  "storage.device.placeholder": "Select or type to create device...",
  "storage.device.port": "Port",
  "storage.device.port.helper": "Port number (1-65535) for communication",
  "storage.device.room": "Room",
  "storage.device.type": "Type",
  "storage.edit.device": "Edit Device",
  "storage.edit.error.loadLocation": "Failed to load location",
  "storage.edit.error.saveFailed": "Salvarea a eșuat",
  "storage.edit.error.saveHttp": "Save failed (HTTP {status})",
  "storage.edit.rack": "Edit Rack",
  "storage.edit.room": "Edit Room",
  "storage.edit.shelf": "Edit Shelf",
  "storage.edit.selectParent": "Select {parent}",
  "storage.editbox.error.loadBox": "Failed to load box",
  "storage.editbox.selectRack": "Select rack",
  "storage.box.capacity": "Capacity",
  "storage.box.rows": "Rows",
  "storage.box.columns": "Columns",
  "storage.box.preset": "Dimension preset",
  "storage.box.preset.select": "Select dimensions",
  "storage.error.location.inactive": "Cannot assign to inactive location",
  "storage.error.name.duplicate": "A {entityType} with this name already exists in the selected parent location",
  "storage.error.position.occupied": "Position is already occupied",
  "storage.expanded.capacityLimit": "Capacity Limit",
  "storage.expanded.createdBy": "Created By",
  "storage.expanded.createdDate": "Created Date",
  "storage.expanded.description": "Descriere",
  "storage.expanded.lastModifiedBy": "Last Modified By",
  "storage.expanded.lastModifiedDate": "Last Modified Date",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Position Schema Hint",
  "storage.expanded.temperatureSetting": "Temperature Setting",
  "storage.filter.by.locations": "Filter by locations",
  "storage.filter.by.locations.placeholder": "Filter by locations...",
  "storage.filter.device": "Filter by Device",
  "storage.filter.room": "Filter by Room",
  "storage.filter.status": "Filter by Status",
  "storage.hierarchical.path": "Location Path",
  "storage.inline.add.device": "Add New Device",
  "storage.inline.add.rack": "Add New Rack",
  "storage.inline.add.room": "Add New Room",
  "storage.inline.add.shelf": "Add New Shelf",
  "storage.location": "Locație",
  "storage.location.active": "Activ",
  "storage.location.add.button": "Add Location",
  "storage.location.add.title": "Add Storage Location",
  "storage.location.current": "Storage location",
  "storage.location.code": "Code",
  "storage.location.code.helper": "Max 10 characters, alphanumeric with hyphens/underscores",
  "storage.location.description": "Descriere",
  "storage.location.label": "Storage Location",
  "storage.location.name": "Location Name",
  "storage.location.skipped": "Storage Skipped",
  "storage.location.tempMax": "Max Temperature",
  "storage.location.tempMin": "Min Temperature",
  "storage.location.type": "Location Type",
  "storage.location.unassigned": "Unassigned",
  "storage.manageLocation.error.saveFailed": "Salvarea a eșuat",
  "storage.manageLocation.error.selectTarget": "Select a device, shelf, rack, or box before saving",
  "storage.nav.device": "Device",
  "storage.nav.room": "Room",
  "storage.nav.shelf": "Shelf",
  "storage.picker.backToSearch": "Back to search",
  "storage.picker.createNewLocation": "Create new location",
  "storage.picker.currentLocation": "Current location",
  "storage.picker.heading.assignLocation": "Assign Storage Location",
  "storage.picker.heading.moveSample": "Move Sample",
  "storage.picker.newLocation": "New location",
  "storage.picker.notes": "Note",
  "storage.picker.position.optional": "Position (optional)",
  "storage.picker.select": "Select {level}",
  "storage.picker.addNewLevel": "Add new {level}",
  "storage.picker.inlineCreate.heading": "Create new {level}",
  "storage.picker.inlineCreate.error.title": "Could not create location",
  "storage.picker.inlineCreate.error": "Failed to create location",
  "storage.picker.sample.accession": "Accession",
  "storage.picker.sample.heading": "Probă",
  "storage.picker.sample.status": "Stare",
  "storage.picker.sample.type": "Type",
  "storage.picker.storageLocation": "Storage location",
  "storage.metrics.active": "Activ",
  "storage.metrics.disposed": "Disposed",
  "storage.metrics.storage.locations": "Storage Locations",
  "storage.metrics.total.samples": "Total Sample Items",
  "storage.mode.autocomplete": "Type-Ahead Search",
  "storage.mode.barcode": "Barcode Scan",
  "storage.mode.cascading": "Cascading Dropdowns",
  "storage.move.button": "Move Sample",
  "storage.move.reason.label": "Reason for Move",
  "storage.nav.boxes": "Boxes",
  "storage.nav.boxes.tooltip": "Manage storage boxes",
  "storage.nav.dashboard": "Storage Dashboard",
  "storage.nav.devices": "Devices",
  "storage.nav.devices.tooltip": "Manage storage devices",
  "storage.nav.locations": "Locations",
  "storage.nav.locations.tooltip": "Manage storage locations",
  "storage.nav.racks": "Racks",
  "storage.nav.racks.tooltip": "Manage storage racks",
  "storage.nav.rooms": "Rooms",
  "storage.nav.rooms.tooltip": "Manage storage rooms",
  "storage.nav.sample.items": "Sample Items",
  "storage.nav.sample.items.tooltip": "View and manage stored samples",
  "storage.nav.samples": "Sample Items",
  "storage.nav.samples.tooltip": "View and manage stored samples",
  "storage.nav.shelves": "Shelves",
  "storage.nav.shelves.tooltip": "Manage storage shelves",
  "storage.no.data": "No data available",
  "storage.occupancy": "Occupancy",
  "storage.position.label": "Position",
  "storage.rack.device": "Device",
  "storage.rack.dimensions": "Dimensions",
  "storage.rack.label": "Rack",
  "storage.rack.placeholder": "Select or type to create rack...",
  "storage.rack.room": "Room",
  "storage.rack.shelf": "Shelf",
  "storage.room.code": "Code",
  "storage.room.devices": "Devices",
  "storage.room.label": "Room",
  "storage.room.name": "Nume",
  "storage.room.placeholder": "Select or type to create room...",
  "storage.room.samples": "Samples",
  "storage.sampleitem.id": "SampleItem ID",
  "storage.search.devices.placeholder": "Search by device name or code...",
  "storage.search.placeholder": "Search by sample ID or location...",
  "storage.search.racks.placeholder": "Search by rack label...",
  "storage.search.rooms.placeholder": "Search by room name or code...",
  "storage.search.samples.placeholder": "Search by sample ID or location...",
  "storage.search.shelves.placeholder": "Search by shelf label...",
  "storage.select.location": "Select Location",
  "storage.selectSample": "Selectează probă",
  "storage.shelf.device": "Device",
  "storage.shelf.label": "Shelf",
  "storage.shelf.placeholder": "Select or type to create shelf...",
  "storage.shelf.room": "Room",
  "storage.status": "Stare",
  "storage.status.disposed": "Disposed",
  "storage.success.assigned": "Sample assigned to storage location successfully",
  "storage.success.moved": "Sample moved to new location successfully",
  "storage.tab.devices": "Devices",
  "storage.tab.racks": "Racks",
  "storage.tab.rooms": "Rooms",
  "storage.tab.samples": "Sample Items",
  "storage.tab.shelves": "Shelves",
  "storage.target.location": "Target Location",
  "storage.unassigned.title": "Unassigned Samples",
  "storage.skipAssignment": "No storage required - samples will be processed immediately",
  "success.add.edited.msg": "Adăugat/Modificat cu succes",
  "success.delete.msg": "Șters cu succes",
  "success.import.patient": "Pacient importat cu succes",
  "success.report.status": "Raport generat cu succes",
  "success.save.msg": "Salvat cu succes",
  "success.save.patient": "Pacient salvat cu succes",
  "systemuser.firstName": "Prenume utilizator sistem",
  "systemuser.isActive": "Este activ",
  "systemuser.lastName": "Nume de familie utilizator sistem",
  "systemuser.loginName": "Nume utilizator sistem",
  "systemuser.role": "Roluri",
  "systemuserrole.apply": "Aplică",
  "systemuserrole.copypermissions": "Copiază permisiuni de la utilizator",
  "systemuserrole.copypermissions.placeholder": "Copiază permisiuni utilizator",
  "systemuserrole.instruction.1": "Există două tipuri de roluri: Roluri globale, care se aplică întregii aplicații, și roluri pe unități de laborator, care pot fi setate pentru toate sau doar pentru unele unități.",
  "systemuserrole.instruction.2": "Rolurile globale disponibile sunt: Administrator Global (acces la toate funcțiile de administrare), Jurnal Audit (acces la toate logurile), Administrator Conturi (acces doar la administrarea utilizatorilor, fără celelalte funcții de admin).",
  "systemuserrole.instruction.3": "Rolurile pe unitate de laborator sunt: Recepție (acces la ordine, pacienți și neconformități), Rezultate (acces la plan lucru, rezultate și neconformități), Validare (acces la validare și neconformități), Rapoarte (acces la rapoarte, exportul CSV doar pentru Admini Globali).",
  "systemuserrole.instruction.4": "Pentru a aloca roluri, selectați toate unitățile sau una anume și bifați rolurile dorite.",
  "systemuserrole.instruction.5": "Puteți folosi funcția de copiere permisiuni introducând numele unui utilizator existent și apăsând aplică.",
  "systemuserrole.newpermissions": "Adaugă permisiune nouă",
  "systemuserrole.rmpermissions": "Șterge permisiune",
  "systemuserrole.roles.global": "Roluri globale",
  "systemuserrole.roles.labunit": "Roluri unitate laborator",
  "test.add.copy.name": "Copiază din numele testului",
  "test.antimicrobialResistance": "Rezistență antimicrobiană",
  "test.description.active": "Dacă testul este activ, poate fi comandat în formularul de comandă sau ca parte a unui algoritm de testare. Dacă nu este activ, nu poate fi comandat și nu poate face parte dintr-un algoritm de testare.\n \n\n \n ",
  "test.description.name": "Numele testului așa cum va apărea în OpenELIS. Sunt necesare versiunile atât în engleză, cât și în franceză.",
  "test.description.orderable": "Daca un test este activ si comandabil, atunci poate fi comandat in formularul de comanda. Daca este activ, dar nu este comandabil, va fi efectuat doar daca este declansat reflex dintr-un alt test.",
  "test.description.panel": "Dacă acest test face parte dintr-un panel de teste, panoul poate fi adăugat aici. Este posibil, dar neobișnuit, ca un test să aparțină mai multor paneluri.",
  "test.description.reportName": "Numele testului așa cum va apărea în rapoarte. Este necesar să fie completat atât în engleză, cât și în franceză. Dacă numele și numele pentru raportare sunt aceleași, apasă pe buton pentru a copia numele.",
  "test.description.testSection": "Secțiunea de testare în care va fi efectuat testul",
  "test.description.uom": "Unitatea de măsură pentru test. Aceasta se aplică, de obicei, numai tipurilor de rezultate numerice sau alfanumerice.",
  "test.field.active": "Activ",
  "test.field.orderable": "Comandabil",
  "test.inLabOnly": "Doar în laborator",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "Selectați analiza de modificat!",
  "test.modify.header.test": "Analiză",
  "test.name": "Nume test",
  "test.notifyResults": "Notifică pacientul despre rezultate",
  "test.section": "Secțiune test",
  "test.section.label": "Secțiune test",
  "test.show.guide": "Show Guide",
  "testcalculation.label.calculation": "Calcul",
  "testcalculation.label.finalresult": "Rezultat final",
  "testcalculation.label.insertOperation": "Inserează operație",
  "testcalculation.label.integer": "Întreg",
  "testcalculation.label.mathFucntion": "Funcție matematică",
  "testcalculation.label.name": "Nume calcul",
  "testcalculation.label.patientAttribute": "Atribut pacient",
  "testcalculation.label.searchNumericTest": "Caută test numeric",
  "testcalculation.label.selectDictionaryValue": "Selectează valoare dicționar",
  "testcalculation.label.testResult": "Rezultat test",
  "testcalculation.label.textValue": "Valoare text",
  "testCatalog.header.ageRange": "Age Range",
  "testCatalog.header.criticalRange": "Critical Range",
  "testCatalog.header.field": "Field",
  "testCatalog.header.gender": "Gen",
  "testCatalog.header.normalRange": "Interval normal",
  "testCatalog.header.reportingRange": "Reporting Range",
  "testCatalog.header.validRange": "Valid Range",
  "testCatalog.header.value": "Valoare",
  "admin.testCatalog.methods.title": "Metode",
  "admin.testCatalog.methods.column.name": "Nume metodă",
  "admin.testCatalog.methods.column.code": "Code",
  "admin.testCatalog.methods.column.default": "Default",
  "admin.testCatalog.methods.column.effectiveDate": "Effective Date",
  "admin.testCatalog.methods.column.actions": "Actions",
  "admin.testCatalog.methods.action.edit": "Editează",
  "admin.testCatalog.methods.action.remove": "Șterge",
  "admin.testCatalog.methods.btn.linkMethod": "+ Link Method",
  "admin.testCatalog.methods.btn.createMethod": "+ Create New Method",
  "admin.testCatalog.methods.btn.copyFromTest": "Copy from Test",
  "admin.testCatalog.methods.modal.link.title": "Link Method",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Select a method to link",
  "admin.testCatalog.methods.modal.link.noAvailable": "All active methods are already linked",
  "admin.testCatalog.methods.inline.nameEnglish": "Method Name (English)",
  "admin.testCatalog.methods.inline.nameFrench": "Method Name (French)",
  "admin.testCatalog.methods.inline.code": "Shortcode",
  "admin.testCatalog.methods.inline.codeHint": "3–10 uppercase alphanumeric characters, no spaces",
  "admin.testCatalog.methods.inline.createAndLink": "Create & Link",
  "admin.testCatalog.methods.copyFromTest.label": "Copy methods from test",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Select source test",
  "admin.testCatalog.methods.effectiveDate.label": "Effective Date",
  "admin.testCatalog.methods.default.label": "Set as default",
  "admin.testCatalog.methods.error.duplicateLink": "This method is already linked to the test",
  "admin.testCatalog.methods.error.codeFormat": "Code must be 3–10 uppercase alphanumeric characters with no spaces",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Effective date is required",
  "admin.testCatalog.methods.empty": "No methods linked. Use '+ Link Method' or '+ Create New Method' to add one.",
  "testnotification.bcc": "BCC",
  "testnotification.instructionis.variables.body": "[testName] : Numele testului",
  "testnotification.instructionis.variables.body.0": "[testResult] : Rezultatul testului",
  "testnotification.instructionis.variables.body.1": "[patientFirstName] : Prenumele pacientului",
  "testnotification.instructionis.variables.body.2": "[patientLastNameInitial] : Inițiala numelui de familie al pacientului",
  "testnotification.instructionis.variables.header": "Listă de variabile:",
  "testnotification.instructions.body": "Când este creată o notificare, va verifica mai întâi dacă există un șablon de mesaj definit pentru destinatar/tipul mesajului.",
  "testnotification.instructions.body.0": "Dacă nu există, se va folosi mesajul implicit al testului.",
  "testnotification.instructions.body.1": "Dacă nici acesta nu există, se va folosi mesajul implicit al sistemului.",
  "testnotification.instructions.body.2": "Variabilele vor fi înlocuite cu valorile corespunzătoare în corpul și subiectul mesajului.",
  "testnotification.instructions.body.3": "Variabilele trebuie să includă întotdeauna parantezele pătrate și să nu conțină spații.",
  "testnotification.instructions.header": "Instrucțiuni:",
  "testnotification.messagetemplate": "Mesaj",
  "testnotification.options": "Mesaje individuale",
  "testnotification.patient.email": "Email pacient",
  "testnotification.patient.sms": "SMS pacient",
  "testnotification.patiententry.header": "Raportare rezultate",
  "testnotification.patiententry.info": "Dacă OpenELIS nu poate transmite rezultatele, acestea vor fi puse în coadă. O coadă mare sau în creștere indică o problemă ce necesită investigații și contactarea părții receptoare.",
  "testnotification.provider.email": "Email medic",
  "testnotification.provider.sms": "SMS medic",
  "testnotification.subjecttemplate": "Subiect",
  "testnotification.systemdefault.template": "Mesaj implicit al sistemului",
  "testnotification.testdefault.editIcon": "Editează notificarea testului",
  "testnotification.testdefault.template": "Mesaj implicit pentru test",
  "testnotificationconfig.browse.title": "Configurare notificări test",
  "tests.not.assigned": "Tests not assigned",
  "testsection.testSectionName": "Nume secțiune test",
  "testUnit.existing": "Unități de test existente",
  "testUnit.existing.inactive": "Unități de test inactive. Atribuie teste pentru activare.",
  "testUnit.new": "Unitate de test nouă",
  "text.length.max": "Textul nu trebuie să depășească 200 caractere",
  "title.notestfoundmatching": "Nu s-a găsit niciun test corespunzător",
  "to.title": "Până la",
  "tooltip.banner.menu.generic.sample.results": "Enter test results for generic samples",
  "total.quantity": "Total Quantity",
  "transaction.date": "Date",
  "transaction.quantity": "Quantity",
  "transaction.type": "Type",
  "transaction.user": "Utilizator",
  "true.label": "Adevărat",
  "unifiedSystemUser.add.user": "Adaugă utilizator",
  "unifiedSystemUser.browser.button.add": "Adaugă utilizator nou",
  "unifiedSystemUser.browser.search": "Caută după nume utilizatori",
  "unifiedSystemUser.browser.search.placeholder": "Caută după nume utilizatori...",
  "unifiedSystemUser.browser.title": "Management utilizatori",
  "unifiedSystemUser.edit.user": "Modifică utilizator",
  "unifiedSystemUser.select": "Selectează",
  "unknown.section": "Unknown Section",
  "unknown.test": "Unknown Test",
  "uom.browse.title": "Unitate de măsură",
  "uom.create.heading.confirmation": "Confirmare",
  "uom.existing": "Unitate de măsură existentă",
  "uom.existing.inactive": "Unitate de măsură inactivă. Atribuie teste pentru a o activa.",
  "uom.new": "Creează o nouă unitate de măsură",
  "uom.new.added": "Noua unitate de măsură va fi adăugată",
  "uom.notification.duplicate": "Unitatea de măsură există deja",
  "uom.notification.save": "Noua unitate de măsură a fost salvată.",
  "uom.uomName": "Nume unitate de măsură",
  "training.installation.message": "Training Installation",
  "translation.edit.title": "Edit Translations",
  "translation.export": "Export CSV",
  "translation.export.success": "Translations exported successfully",
  "translation.fallback": "Fallback (English)",
  "translation.management.description": "View and edit translations for metadata.",
  "translation.management.title": "Translation Management",
  "translation.missing": "Missing",
  "translation.search": "Search translations...",
  "translation.selectLocale": "Select Language",
  "translation.showMissing": "Show Missing Only",
  "translation.stats.title": "Translation Progress",
  "translation.stats.total": "Total entries: {count}",
  "translation.update.error": "Failed to update translation",
  "translation.update.success": "Translation updated successfully",
  "translation.value": "Translation",
  "usage.analysisId": "Analysis ID",
  "usage.date": "Date Used",
  "usage.notes": "Note",
  "usage.notes.placeholder": "Add any notes about this usage",
  "usage.quantityUsed": "Quantity Used",
  "usage.quantityUsed.helper": "Enter the number of units consumed",
  "usage.record.button": "Record Usage",
  "usage.record.success": "Usage recorded successfully",
  "usage.record.title": "Record Inventory Usage",
  "usage.testResultId": "Test Result ID (Optional)",
  "usage.testResultId.placeholder": "Link to test result for traceability",
  "user.select.instruction": "Selectează un utilizator pentru modificare sau dezactivare. Poți seta un filtru, căuta utilizatori sau adăuga un utilizator folosind controalele de sus.",
  "validation.accept.all": "Salvează toate rezultatele",
  "validation.accept.normal": "Salvează toate valorile normale",
  "validation.field.required": "Acest câmp este obligatoriu",
  "validation.ignore.all": "Ignoră toate rezultatele",
  "validation.label.nonconform": "= Proba sau comanda este neconformă sau testul a fost respins",
  "validation.password.match": "Passwords must match",
  "validation.password.minLength": "Password must be at least 7 characters",
  "validation.password.notSameAsOld": "New password must not be the same as the old password",
  "validation.password.specialChar": "Password must contain at least one special character (*, $, #, !) and only letters, numbers or those characters",
  "validation.no.records.display": "There are no records to display",
  "validation.reject.all": "Retestează toate testele",
  "validation.save.error": "Rezultatele au fost validate cu succes",
  "validation.save.success": "Rezultatele au fost validate cu succes",
  "validation.search.noresult": "Nu s-au găsit rezultate pentru validare",
  "validation.search.noresult.analyser": "Nu s-au găsit rezultate de la: ",
  "vl.arvRegimen": "ARV Regimen",
  "vl.durationOnARV": "Duration on ARV (months)",
  "vl.durationOnARV.placeholder": "Enter months on treatment",
  "vl.indication": "Indication for VL Test",
  "vl.lastVLDate": "Date of Last VL Result",
  "vl.lastVLResult": "Last VL Result (copies/mL)",
  "vl.lastVLResult.placeholder": "e.g., 150",
  "vl.pregnancyStatus": "Pregnancy / Breastfeeding Status",
  "workplan.page.title": "Plan de lucru {0}",
  "workplan.panel.selection.error.msg": "Acesta este un mesaj de eroare invalid.",
  "workplan.panel.title": "Plan de lucru după panel",
  "workplan.panel.types": "Tip Panel",
  "workplan.print": "Tipărește plan de lucru",
  "workplan.priority.list": "Prioritate",
  "workplan.priority.title": "Plan de lucru după prioritate",
  "workplan.run": "Obține plan de lucru",
  "workplan.test.title": "Plan de lucru după test",
  "workplan.test.types": "Tip test",
  "workplan.title": "Plan de lucru",
  "workplan.unit.title": "Plan de lucru după unitate",
  "workplan.unit.types": "Tip unitate",
  "yes.option": "Da",
  "shipment.module.title": "Shipment Management",
  "shipment.breadcrumb": "Sample Shipment",
  "shipment.nav.dashboard": "Tablou de bord",
  "shipment.nav.createBox": "Create Box",
  "shipment.nav.receiveBox": "Receive Box",
  "shipment.dashboard.title": "Shipment Dashboard",
  "shipment.dashboard.description": "Manage shipment boxes and track referred samples",
  "shipment.dashboard.tabs.shipments": "Shipments",
  "shipment.dashboard.tabs.unassigned": "Unassigned Tests",
  "shipment.tab.boxes": "Shipment Boxes",
  "shipment.tab.unassignedSamples": "Unassigned Samples",
  "shipment.label.boxId": "Box ID",
  "shipment.label.createdDate": "Created Date",
  "shipment.label.daysUnassigned": "Days Unassigned",
  "shipment.label.destination": "Destination",
  "shipment.label.priority": "Prioritate",
  "shipment.label.referralTest": "Referral Test",
  "shipment.label.sampleCount": "Sample Count",
  "shipment.label.state": "State",
  "shipment.label.tests": "Teste",
  "shipment.filter.state": "Filter by State",
  "shipment.filter.facility": "Filter by Facility",
  "shipment.action.addSelected": "Add selected",
  "shipment.action.addToBox": "Add to Box",
  "shipment.action.cancelReferral": "Cancel Referral",
  "shipment.action.confirmRejection": "Confirm Rejection",
  "shipment.action.createBox": "Create New Box",
  "shipment.action.markAsLost": "Mark as Lost",
  "shipment.action.printManifest": "Print Manifest",
  "shipment.action.rejectSample": "Respinge proba",
  "shipment.action.saveAndMarkReady": "Save & Mark Ready to Send",
  "shipment.action.saveBox": "Save Box",
  "shipment.action.saveDraft": "Save as Draft",
  "shipment.action.scanSample": "Scan Sample",
  "shipment.box.addSample": "Adaugă probă",
  "shipment.box.addSampleDescription": "Select samples to add to this shipping box",
  "shipment.box.addSamples": "Add Samples",
  "shipment.box.details": "Box Details",
  "shipment.box.autoGenerate": "Auto-generate",
  "shipment.box.capacity": "Capacity",
  "shipment.box.capacityValue": "{capacity} samples",
  "shipment.box.create": "Create Box",
  "shipment.box.createDescription": "Create a new shipping box for referred samples",
  "shipment.box.created": "Created Date: ",
  "shipment.box.createdBy": "Created By :",
  "shipment.box.createdDate": "Created Date",
  "shipment.box.destination": "Destination",
  "shipment.box.downloadLabel": "Download Label",
  "shipment.box.downloadManifest": "Download Manifest",
  "shipment.box.generateLabel": "Generate Label",
  "shipment.box.generateManifest": "Generate Manifest",
  "shipment.box.id": "Box ID: ",
  "shipment.box.labelDownloaded": "Label downloaded successfully",
  "shipment.box.labelPrefix": "Label Prefix",
  "shipment.box.labelPrefixHelper": "Configured by administrator in Site Settings",
  "shipment.box.manifest": "Manifest",
  "shipment.box.manifestDownloaded": "Manifest downloaded successfully",
  "shipment.box.noSamples": "This box does not contain any samples yet",
  "shipment.box.noUnassignedSamples": "No unassigned samples found for this facility",
  "shipment.box.notes": "Note",
  "shipment.box.notesPlaceholder": "Enter any special handling instructions or notes...",
  "shipment.box.number": "Box Number",
  "shipment.box.readyConfirmation": "Are you sure you want to mark this box as ready to send?",
  "shipment.box.readySampleCount": "This box contains {count} sample(s)",
  "shipment.box.readyToSend": "Mark Ready to Send",
  "shipment.box.reconcile": "Reconcile",
  "shipment.box.removeSample": "Șterge probă",
  "shipment.box.removeSampleConfirmation": "Are you sure you want to remove this sample from the box?",
  "shipment.box.resendManifest": "Resend Manifest",
  "shipment.box.sampleCount": "Sample Count",
  "shipment.box.sampleProgress": "{added} / {capacity} ({remaining} remaining)",
  "shipment.box.samplesAdded": "Samples Added",
  "shipment.box.samplesSelected": "{count} sample(s) selected",
  "shipment.box.scanExisting": "Scan existing",
  "shipment.box.scanExistingId": "Scan or enter existing Box ID",
  "shipment.box.scanExistingIdPlaceholder": "Scan barcode or type box ID",
  "shipment.box.sendBox": "Send Box",
  "shipment.box.sendConfirmation": "Are you sure you want to send this box?",
  "shipment.box.sendSampleCount": "This box contains {count} sample(s) that will be marked as sent",
  "shipment.box.state": "State",
  "shipment.box.summary": "Summary",
  "shipment.box.temperature": "Temperature Requirement",
  "shipment.box.title": "Box {boxId}",
  "shipment.box.useExistingId": "Box ID Mode",
  "shipment.dashboard.boxNotFound": "No box found with ID \"{boxId}\". Try filtering the list instead.",
  "shipment.dashboard.scanBoxPlaceholder": "Search or scan Box ID (press Enter to navigate)",
  "shipment.error.addSample": "Failed to add sample to box",
  "shipment.error.assignToBox": "Failed to assign sample to box",
  "shipment.error.boxFull": "Box is full. Cannot add more samples.",
  "shipment.error.boxNotEmpty": "Box must have at least one sample",
  "shipment.error.boxNotFound": "Box not found",
  "shipment.error.cancelReferral": "Failed to cancel referral",
  "shipment.error.confirmReception": "Failed to confirm reception",
  "shipment.error.createBox": "Failed to create shipping box",
  "shipment.error.exceedsCapacity": "Cannot add {requested} sample(s). Only {available} slot(s) available.",
  "shipment.error.fetchBox": "Failed to fetch box information",
  "shipment.error.fetchBoxes": "Failed to fetch available boxes",
  "shipment.error.generateLabel": "Error generating shipping label",
  "shipment.error.generateManifest": "Error generating manifest",
  "shipment.error.invalidState": "Invalid box state for this operation",
  "shipment.error.markAsLost": "Failed to mark sample as lost",
  "shipment.error.markReady": "Failed to mark box as ready to send",
  "shipment.error.noDestinationFacility": "No destination facility specified for this sample",
  "shipment.error.noReferralId": "No referral ID available for this sample",
  "shipment.error.noSampleSelected": "Please select at least one sample",
  "shipment.error.partialReception": "Some sample status updates failed. Please try again.",
  "shipment.error.reasonRequired": "Please provide a reason",
  "shipment.error.reconcile": "Error reconciling box",
  "shipment.error.removeSample": "Failed to remove sample from box",
  "shipment.error.sampleAlreadyAssigned": "This sample is already assigned to a box",
  "shipment.error.sampleAlreadyInBox": "Sample already in box",
  "shipment.error.sampleNotFound": "Sample not found",
  "shipment.error.saveFailed": "Failed to save",
  "shipment.error.searchFailed": "Failed to search for sample. Please try again.",
  "shipment.error.selectBox": "Please select a box",
  "shipment.error.sendBox": "Failed to send box",
  "shipment.filter.clear": "Clear Filters",
  "shipment.filter.dateFrom": "From Date",
  "shipment.filter.dateTo": "To Date",
  "shipment.filter.referenceLab": "Laborator de referință",
  "shipment.label.addedDate": "Added Date",
  "shipment.label.position": "Position",
  "shipment.label.samples": "Samples",
  "shipment.label.shippingLabel": "SHIPPING LABEL",
  "shipment.manifest.generated": "Generated:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Manifest recall is no longer available (7-day limit exceeded since send)",
  "shipment.manifest.regenerationExpired": "Manifest regeneration is no longer available (24-hour limit exceeded since send)",
  "shipment.manifest.serviceLocation": "Service Location:",
  "shipment.manifest.specimenBarcodes": "Specimen Barcodes",
  "shipment.manifest.title": "Shipping Manifest",
  "shipment.manifest.totalSamples": "Total Samples:",
  "shipment.modal.addToBox.existingBox": "Add to existing box",
  "shipment.modal.addToBox.mode": "Select an option",
  "shipment.modal.addToBox.newBox": "Create new box",
  "shipment.modal.addToBox.newBoxInfo.message": "You will be redirected to create a new box for this sample",
  "shipment.modal.addToBox.newBoxInfo.title": "Create New Box",
  "shipment.modal.addToBox.noDraftBoxes.message": "No draft boxes found for this destination. A new box will be created.",
  "shipment.modal.addToBox.noDraftBoxes.title": "No Draft Boxes Available",
  "shipment.modal.addToBox.selectBox": "Select Box",
  "shipment.modal.addToBox.title": "Add Sample to Box",
  "shipment.modal.cancelReferral.reason": "Reason for cancellation",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Please explain why this referral is being cancelled...",
  "shipment.modal.cancelReferral.title": "Cancel Referral",
  "shipment.modal.cancelReferral.warning.message": "This action will permanently cancel the referral and cannot be undone.",
  "shipment.modal.cancelReferral.warning.title": "Warning",
  "shipment.modal.createBox.cancel": "Anulează",
  "shipment.modal.createBox.submit": "Create",
  "shipment.modal.createBox.title": "Create New Box",
  "shipment.modal.markAsLost.reason": "Reason for marking as lost",
  "shipment.modal.markAsLost.reasonPlaceholder": "Please explain why this sample is being marked as lost...",
  "shipment.modal.markAsLost.title": "Mark Sample as Lost",
  "shipment.modal.markAsLost.warning.message": "This action will permanently mark the sample as lost and cannot be undone.",
  "shipment.modal.markAsLost.warning.title": "Warning",
  "shipment.modal.rejectSample": "Respinge proba",
  "shipment.modal.rejectSampleMessage": "Are you sure you want to reject sample {accession}?",
  "shipment.nav.referenceLabResults": "Reference Lab Results",
  "shipment.nav.reports": "Rapoarte",
  "shipment.nav.settings": "Settings",
  "shipment.notification.boxCreated": "Box created successfully",
  "shipment.notification.boxReadyToSend": "Box marked as Ready to Send",
  "shipment.notification.boxReconciled": "Box has been reconciled successfully",
  "shipment.notification.boxSent": "Box sent successfully",
  "shipment.notification.error": "An error occurred: {message}",
  "shipment.notification.partialSamplesAdded": "Only {added} of {total} samples added. Box capacity reached ({notAdded} not added).",
  "shipment.notification.receptionComplete": "Shipment received successfully",
  "shipment.notification.referralCancelled": "Referral cancelled successfully",
  "shipment.notification.sampleAdded": "Sample {accessionNumber} added with {testCount, plural, one {# test} other {# tests}}",
  "shipment.notification.sampleAssignedToBox": "Sample assigned to box successfully",
  "shipment.notification.sampleMarkedAsLost": "Sample marked as lost",
  "shipment.notification.sampleRejected": "Sample {accession} rejected: {reason}",
  "shipment.notification.sampleRemoved": "Sample removed from box",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} other {# samples added to box}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} sample(s) removed due to capacity reduction.",
  "shipment.reception.acceptSample": "Accept Sample",
  "shipment.reception.applyToAll": "Apply status to all...",
  "shipment.reception.awaitingAcceptance": "Awaiting acceptance",
  "shipment.reception.confirmMessage": "Confirm reception of {count} sample(s)?",
  "shipment.reception.confirmReception": "Confirm Reception",
  "shipment.reception.damaged": "Damaged",
  "shipment.reception.description": "Scan box barcode to receive and verify samples",
  "shipment.reception.enterBoxId": "Please enter a box ID",
  "shipment.reception.generalNotes": "General Notes",
  "shipment.reception.generalNotesPlaceholder": "Enter general reception notes",
  "shipment.reception.importError": "Error importing shipments from remote server",
  "shipment.reception.importFromFhir": "Import from FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No new shipments found} one {1 shipment imported} other {{count} shipments imported}}",
  "shipment.reception.incomingBoxes": "Incoming Shipments",
  "shipment.reception.leaked": "Leaked",
  "shipment.reception.markAllMissing": "Mark All Missing",
  "shipment.reception.markAllReceived": "Mark All Received",
  "shipment.reception.missing": "Missing",
  "shipment.reception.noIncomingBoxes": "No incoming shipments. Click 'Import from FHIR' to check for new shipments.",
  "shipment.reception.notes": "Note",
  "shipment.reception.notesPlaceholder": "Enter notes if needed",
  "shipment.reception.notesRequired": "Notes are required for samples not received in good condition",
  "shipment.reception.notesRequiredPlaceholder": "Required: describe the issue",
  "shipment.reception.openBox": "Open",
  "shipment.reception.originFacility": "De la",
  "shipment.reception.pending": "Pending",
  "shipment.reception.pendingAcceptance": "Specimens Awaiting Acceptance",
  "shipment.reception.received": "Received",
  "shipment.reception.referralOrder": "Referral Order",
  "shipment.reception.rejected": "Rejected",
  "shipment.reception.sampleCountSummary": "{accepted} accepted / {expected} expected",
  "shipment.reception.sampleNotFound": "Sample {accessionNumber} not found in this box",
  "shipment.reception.sampleScanned": "Sample {accessionNumber} checked in as received",
  "shipment.reception.sampleVerification": "Sample Verification",
  "shipment.reception.scanBox": "Box ID / Barcode",
  "shipment.reception.scanBoxPlaceholder": "Scan or enter box barcode",
  "shipment.reception.scanButton": "Scan Box",
  "shipment.reception.scanSample": "Scan Sample ID",
  "shipment.reception.scanSampleButton": "Check In Sample",
  "shipment.reception.scanSamplePlaceholder": "Scan or type sample accession number",
  "shipment.reception.shipped": "Shipped",
  "shipment.reception.specimen": "Specimen",
  "shipment.reception.status": "Reception Status",
  "shipment.reception.title": "Receive Shipment",
  "shipment.reception.unresolved": "No matching order",
  "shipment.rejection.damaged": "Damaged",
  "shipment.rejection.expired": "Expired",
  "shipment.rejection.insufficientVolume": "Insufficient Volume",
  "shipment.rejection.other": "Other",
  "shipment.rejection.reason": "Rejection Reason",
  "shipment.rejection.wrongType": "Wrong Sample Type",
  "shipment.report.contents": "Contents",
  "shipment.report.description": "Generate and export shipment reports by box, date, destination, or reference lab",
  "shipment.report.export.excel": "Export Excel",
  "shipment.report.export.pdf": "Export PDF",
  "shipment.report.generate": "Generează raport",
  "shipment.report.noResults": "No shipment records found for the selected filters",
  "shipment.report.receivedDate": "Dată primire",
  "shipment.report.receivedStatus": "Received Status",
  "shipment.report.receiver": "Receiver",
  "shipment.report.receivingUser": "Receiving User",
  "shipment.report.sender": "Sender",
  "shipment.report.sentDate": "Dată trimitere",
  "shipment.report.title": "Shipment Reports",
  "shipment.report.totalBoxes": "Total Boxes",
  "shipment.report.totalSamples": "Total Samples",
  "shipment.sample.accessionNumber": "Număr accesare",
  "shipment.sample.multipleMatches": "Multiple samples match — select which to add",
  "shipment.sample.remove": "Șterge",
  "shipment.sample.search": "Search sample by accession number",
  "shipment.sample.searchPlaceholder": "Scan or enter accession number",
  "shipment.sample.status": "Stare",
  "shipment.sample.type": "Tip probă",
  "shipment.settings.administration": "Administration",
  "shipment.settings.boxLabelSection": "Box Label Configuration",
  "shipment.settings.description": "Configure shipment module settings",
  "shipment.settings.fhirConfig": "FHIR Mapping Options",
  "shipment.settings.fhirConfigDesc": "Configure SupplyDelivery mapping and specimen container types for FHIR interoperability",
  "shipment.settings.fhirConfigNote": "FHIR mapping is configured via application properties. Contact your system administrator for changes.",
  "shipment.settings.fhirConfigSaveError": "Error saving FHIR mapping configuration",
  "shipment.settings.fhirConfigSaved": "FHIR mapping configuration saved",
  "shipment.settings.fhirContainerType": "Specimen Container Type (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Display Name",
  "shipment.settings.fhirNonConformity": "Non-Conformity Codes (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "SNOMED CT Code",
  "shipment.settings.manageFacilities": "Manage Facility Registry",
  "shipment.settings.manageFacilitiesDesc": "Add, edit, or remove reference laboratory destinations",
  "shipment.settings.manageUsers": "Manage Users",
  "shipment.settings.manageUsersDesc": "Configure user accounts and roles for the shipment module",
  "shipment.settings.prefixHelperText": "Prefix used when generating new box IDs (e.g. BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Preview: {preview}",
  "shipment.settings.prefixRequired": "Box label prefix is required",
  "shipment.settings.prefixSaveError": "Error saving box label prefix",
  "shipment.settings.prefixSaved": "Box label prefix saved successfully",
  "shipment.settings.siteOrgDescription": "Select the organization that represents this laboratory. Only shipments destined for this organization will be imported from remote FHIR servers.",
  "shipment.settings.siteOrgLabel": "This Laboratory",
  "shipment.settings.siteOrgSaveError": "Error saving site organization",
  "workflow.clinical": "Clinical",
  "workflow.environmental": "Environmental / Other",
  "provider.name": "Provider Name",
  "provider.name.placeholder": "Enter provider name",
  "provider.phone": "Provider Phone",
  "provider.search.helper": "Enter provider name or phone number and press Search.",
  "site.search": "Site Search",
  "site.name": "Nume locație",
  "site.name.placeholder": "Enter site name",
  "site.location": "Locație",
  "site.type": "Type",
  "site.department": "Department / Ward / Unit",
  "site.department.selectFirst": "Select facility first...",
  "site.department.none": "No subunits available",
  "sample.filterByLabUnit": "Filter by Lab Unit",
  "sample.allLabUnits": "All Lab Units",
  "sample.orderPanels": "Comandă paneluri",
  "sample.orderTests": "Comandă teste",
  "sample.referToReferenceLab": "Trimite testul către un laborator de referință",
  "sample.optional.info": "Sample and test selection is optional at this step. Tests and sample type can be specified later during collection.",
  "panel.search.placeholder": "Alege panel disponibil",
  "test.search.placeholder": "Alege test disponibil",
  "test.timeHolding": "SOP Max Holding Time (minutes)",
  "select.regimen": "Select Regimen...",
  "select": "Select...",
  "generating": "Generating...",
  "label.order": "Order Label",
  "label.sample": "Sample Label",
  "label.slide": "Slide Label",
  "label.block": "Block Label",
  "label.freezer": "Freezer Label",
  "environmental.coming.soon": "Environmental workflow",
  "environmental.location.info": "Location hierarchy fields (Region/District/Town-Village) and GPS capture will be available here.",
  "env.collectionConditions.title": "Default Collection Conditions",
  "env.collectionConditions.subtitle": "Defaults applied to all samples in this batch.",
  "env.collectionMethod": "Collection Method",
  "env.waterTemp": "Water Temp (°C)",
  "env.ambientTemp": "Ambient Temp (°C)",
  "env.weather": "Weather",
  "env.preservationMethod": "Preservation Method",
  "env.preservationMethod.placeholder": "e.g., HNO3 acidification, 4°C cooler",
  "env.fieldNotes": "Field Notes",
  "env.fieldNotes.placeholder": "Enter field observations...",
  "env.sample.manifest.title": "Per-Sample Manifest",
  "env.sample.manifest.subtitle": "one row = one physical sample",
  "env.sample.container": "Container",
  "env.sample.gpsLat": "GPS Lat",
  "env.sample.gpsLat.placeholder": "e.g. -6.2088",
  "env.sample.gpsLng": "GPS Lng",
  "env.sample.gpsLng.placeholder": "e.g. 106.8456",
  "env.sample.locationDetails": "Location Details",
  "env.sample.locationDetails.placeholder": "e.g., Inlet, Bank...",
  "env.sample.collected": "Collected",
  "env.sample.duplicate": "Duplicate sample",
  "env.sample.addRow": "+ Add sample row",
  "env.sample.total": "Total: {count} {count, plural, one {sample} other {samples}} in this batch",
  "env.sample.testsAndPanels": "Tests & Panels",
  "env.sample.tests.required": "required",
  "env.complianceStandards.title": "Applicable Compliance Standards",
  "env.complianceStandards.subtitle": "Select the regulatory standards that apply to this order.",
  "env.complianceStandards.label": "Compliance Standards",
  "env.complianceStandards.placeholder": "Select standards...",
  "env.complianceStandards.empty": "No active compliance standards configured. Add them in Administration → Compliance Standards.",
  "order.dashboard.samplingSite": "Sampling Site",
  "order.search.placeholder.env": "Search by site name or lab number...",
  "order.filter.dateFrom": "De la",
  "order.filter.dateTo": "Până la",
  "program.placeholder": "Type to filter or select from the list",
  "program.helper": "Type to filter or select from the list. Selecting a program displays its specific Additional Order Information fields below.",
  "patient.externalSearch": "Căutare externă",
  "patient.results": "Patient Results",
  "patient.id.helper": "Enter subject number, national ID, or ST number.",
  "patient.id.placeholder": "Introduceți ID pacient",
  "patient.lastName.placeholder": "Introduceți numele de familie al pacientului",
  "patient.firstName.placeholder": "Introduceți prenumele pacientului",
  "patient.natId": "Unique Health ID",
  "patient.dataSource": "Data Source",
  "patient.noResults": "0-0 of 0 items",
  "patient.new.info": "Enter new patient information below. The patient will be created when the order is saved.",
  "pagination.showing": "Showing {start}-{end} of {total} tests",
  "results.found.for": "results found for \"{term}\"",
  "selected": "Selected",
  "shipment.settings.siteOrgSaved": "Site organization saved (FHIR UUID: {uuid})",
  "shipment.settings.siteOrgSection": "Site Organization (FHIR)",
  "shipment.settings.title": "Shipment Settings",
  "shipment.state.cancelled": "Cancelled",
  "shipment.state.draft": "Draft",
  "shipment.state.inTransit": "In Transit",
  "shipment.state.lostInTransit": "Lost in Transit",
  "shipment.state.partiallyReceived": "Partially Received",
  "shipment.state.readyToSend": "Ready to Send",
  "shipment.state.received": "Received",
  "shipment.state.reconciled": "Reconciled",
  "shipment.state.sent": "Sent",
  "shipment.stats.delivered": "Delivered",
  "shipment.stats.inTransit": "In Transit",
  "shipment.stats.reconciled": "Reconciled",
  "shipment.stats.totalSamples": "Total Samples",
  "shipment.temperature.ambient": "Ambient (Room Temperature)",
  "shipment.temperature.deepFrozen": "Deep Frozen (-80°C)",
  "shipment.temperature.dryIce": "Dry Ice",
  "shipment.temperature.frozen": "Frozen (-20°C)",
  "shipment.temperature.refrigerated": "Refrigerated (2-8°C)",
  "shipment.validation.addSample": "Add at least one sample",
  "shipment.validation.selectDestination": "Select a destination facility",
  "qc.dashboard.title": "Quality Control Dashboard",
  "qc.dashboard.lastUpdate": "Last Updated",
  "qc.dashboard.complianceStatus": "Compliance Status",
  "qc.dashboard.compliant": "Compliant",
  "qc.dashboard.warning": "Warning",
  "qc.dashboard.nonCompliant": "Non-Compliant",
  "qc.dashboard.violationsCount": "{count} violations",
  "qc.dashboard.lastResult": "Last Result",
  "qc.dashboard.noInstruments": "No instruments configured",
  "qc.dashboard.subtitle": "Monitor instrument QC status and alerts",
  "qc.dashboard.loading": "Loading dashboard data...",
  "qc.dashboard.refresh": "Refresh",
  "qc.dashboard.lastUpdated": "Last Updated",
  "qc.dashboard.error.title": "Error",
  "qc.dashboard.error.loadFailed": "Failed to load dashboard data. Please try again.",
  "qc.dashboard.tab.instruments": "Instruments",
  "qc.dashboard.tab.alerts": "Alerts",
  "qc.dashboard.summary.inControl": "Instruments In Control",
  "qc.dashboard.summary.warningStatus": "Warning Status",
  "qc.dashboard.summary.outOfControl": "Out of Control",
  "qc.dashboard.summary.passRate": "Overall QC Pass Rate",
  "qc.dashboard.summary.ofTotal": "{percentage}% of total instruments",
  "qc.dashboard.instruments.title": "Instrument Quality Control Status",
  "qc.dashboard.instruments.subtitle": "Monitor compliance status and QC performance for all laboratory instruments",
  "qc.dashboard.instruments.search": "Search instruments...",
  "qc.dashboard.instruments.col.id": "Instrument ID",
  "qc.dashboard.instruments.col.name": "Instrument Name",
  "qc.dashboard.instruments.col.type": "Type",
  "qc.dashboard.instruments.col.location": "Locație",
  "qc.dashboard.instruments.col.status": "Stare",
  "qc.dashboard.instruments.col.analytes": "Analytes",
  "qc.dashboard.instruments.col.violations": "Recent Violations",
  "qc.dashboard.instruments.col.lastUpdate": "Last Update",
  "qc.dashboard.instruments.col.actions": "Actions",
  "qc.dashboard.instruments.view": "Vizualizează",
  "qc.dashboard.instruments.status.green": "In Control",
  "qc.dashboard.instruments.status.yellow": "Warning",
  "qc.dashboard.instruments.status.red": "Out of Control",
  "qc.dashboard.instruments.noViolations": "No violations",
  "qc.dashboard.instruments.empty": "No instruments found",
  "qc.dashboard.alerts.title": "QC Violations & Alerts",
  "qc.dashboard.alerts.subtitle": "Showing violations from last {period}",
  "qc.dashboard.alerts.timePeriod": "Time Period",
  "qc.dashboard.alerts.timePeriod.24h": "Last 24 Hours",
  "qc.dashboard.alerts.timePeriod.72h": "Last 72 Hours",
  "qc.dashboard.alerts.timePeriod.7d": "Last 7 Days",
  "qc.dashboard.alerts.timePeriod.30d": "Last 30 Days",
  "qc.dashboard.alerts.timePeriod.all": "All Time",
  "qc.dashboard.alerts.active": "Active QC Violations",
  "qc.dashboard.alerts.active.count": "{count} unacknowledged violation(s) requiring attention",
  "qc.dashboard.alerts.active.empty": "No active violations",
  "qc.dashboard.alerts.acknowledge": "Acknowledge",
  "qc.dashboard.alerts.acknowledged": "Acknowledged Violations",
  "qc.dashboard.alerts.acknowledged.count": "{count} violation(s) have been acknowledged",
  "qc.dashboard.alerts.acknowledged.empty": "No acknowledged violations",
  "qc.dashboard.alerts.col.severity": "Severitate",
  "qc.dashboard.alerts.col.time": "Oră",
  "qc.dashboard.alerts.col.instrument": "Instrument",
  "qc.dashboard.alerts.col.analyte": "Analyte",
  "qc.dashboard.alerts.col.rule": "Regulă",
  "qc.dashboard.alerts.col.acknowledgedBy": "Acknowledged By",
  "qc.dashboard.alerts.col.acknowledgedDate": "Acknowledged Date",
  "qc.chart.axis.date": "Date/Time",
  "qc.chart.axis.value": "Standard Deviations (σ)",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Violation",
  "qc.chart.mean": "Mean",
  "qc.chart.noData": "No QC data available",
  "qc.chart.tooltip.date": "Date",
  "qc.chart.tooltip.value": "Valoare",
  "qc.chart.tooltip.violations": "Violations",
  "qc.chart.tooltip.zScore": "Z-Score",
  "qc.charts.title": "Control Charts",
  "qc.charts.leveyJennings": "Levey-Jennings Chart",
  "qc.charts.dateRange": "Date Range",
  "qc.charts.controlLevel": "Control Level",
  "qc.charts.export": "Export Chart",
  "qc.charts.noData": "No QC data available",
  "qc.violations.title": "QC Violations",
  "qc.violations.severity": "Severitate",
  "qc.violations.rule": "Regulă",
  "qc.violations.date": "Date",
  "qc.violations.status": "Stare",
  "qc.violations.unresolved": "Unresolved",
  "qc.violations.resolved": "Resolved",
  "qc.violations.acknowledged": "Acknowledged",
  "qc.correctiveActions.title": "Corrective Actions",
  "qc.correctiveActions.create": "Create Corrective Action",
  "qc.correctiveActions.type": "Tip acțiune",
  "qc.correctiveActions.description": "Descriere",
  "qc.correctiveActions.assignedTo": "Assigned To",
  "qc.correctiveActions.status": "Stare",
  "qc.correctiveActions.pending": "Pending",
  "qc.correctiveActions.inProgress": "În desfășurare",
  "qc.correctiveActions.completed": "Completed",
  "qc.correctiveActions.resolutionNotes": "Resolution Notes",
  "qc.alerts.title": "QC Alerts",
  "qc.alerts.markAsRead": "Marchează ca citit",
  "qc.alerts.viewDetails": "View Details",
  "qc.rules.title": "Westgard Rules Configuration",
  "qc.rules.enable": "Enable",
  "qc.rules.disable": "Disable",
  "qc.rules.preset": "Preset Configuration",
  "qc.rules.basic": "Basic",
  "qc.rules.standard": "Standard",
  "qc.rules.comprehensive": "Comprehensive",
  "qc.rules.1₂ₛ.description": "One control exceeds ±2SD",
  "qc.rules.1₃ₛ.description": "One control exceeds ±3SD",
  "qc.rules.2₂ₛ.description": "Two consecutive controls exceed ±2SD in same direction",
  "qc.rules.R₄ₛ.description": "Range between two controls exceeds 4SD",
  "qc.rules.4₁ₛ.description": "Four consecutive controls exceed ±1SD in same direction",
  "qc.rules.10ₓ.description": "Ten consecutive controls on same side of mean",
  "qc.rules.3₁ₛ.description": "Three consecutive controls exceed ±1SD in same direction",
  "qc.rules.7ₜ.description": "Seven consecutive controls trending in same direction",
  "qc.ruleConfig.title": "Rule Configuration",
  "qc.ruleConfig.subtitle": "Configure Westgard rules per analyzer and test combination",
  "qc.ruleConfig.field.analyzer": "Analizor",
  "qc.ruleConfig.field.selectAnalyzer": "Select an analyzer",
  "qc.ruleConfig.field.test": "Analiză",
  "qc.ruleConfig.field.selectTest": "Select a test",
  "qc.ruleConfig.field.severity": "Severitate",
  "qc.ruleConfig.severity.warning": "Warning",
  "qc.ruleConfig.severity.rejection": "Rejection",
  "qc.ruleConfig.category.rejection": "Rejection Rules",
  "qc.ruleConfig.category.warning": "Warning Rules",
  "qc.ruleConfig.action.reset": "Reset to Defaults",
  "qc.ruleConfig.loading": "Loading rule configuration...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Select an analyzer and test to configure Westgard rules.",
  "qc.ruleConfig.error.title": "Error",
  "qc.ruleConfig.error.selectAnalyzerTest": "Please select both an analyzer and a test.",
  "qc.ruleConfig.error.saveFailed": "Failed to save rule configuration.",
  "qc.ruleConfig.success.title": "Success",
  "qc.ruleConfig.success.saved": "Rule configuration saved successfully.",
  "qc.ruleConfig.table.title": "Configured Rule Sets",
  "qc.ruleConfig.table.empty": "No rule configurations found.",
  "qc.ruleConfig.field.enabledRules": "Enabled Rules",
  "qc.ruleConfig.unconfigured.title": "Unconfigured Control Mappings",
  "qc.ruleConfig.unconfigured.subtitle": "Control lots without Westgard rule configurations",
  "qc.ruleConfig.unconfigured.configure": "Configure",
  "qc.ruleConfig.unconfigured.activeLots": "Active Lots",
  "qc.ruleConfig.modal.title.edit": "Edit Rule Configuration",
  "qc.ruleConfig.modal.title.create": "Create Rule Configuration",
  "button.saving": "Saving...",
  "qc.controlLots.title": "Control Lots",
  "qc.controlLots.create": "Create Control Lot",
  "qc.controlLots.productName": "Product Name",
  "qc.controlLots.lotNumber": "Lot Number",
  "qc.controlLots.level": "Control Level",
  "qc.controlLots.statisticsMethod": "Statistics Calculation Method",
  "qc.controlLots.initialRuns": "Initial Runs",
  "qc.controlLots.rolling": "Rolling Window",
  "qc.controlLots.manufacturerFixed": "Manufacturer Fixed",
  "qc.controlLots.activationDate": "Activation Date",
  "qc.controlLots.expirationDate": "Expiration Date",
  "qc.controlLots.status.active": "Activ",
  "qc.controlLots.status.establishment": "Establishment",
  "qc.controlLots.status.expired": "Expired",
  "qc.controlLots.subtitle": "Manage QC control lots for Westgard rule evaluation",
  "qc.controlLots.empty": "No control lots found",
  "qc.controlLot.filter.allStatuses": "All Statuses",
  "qc.controlLot.status.establishment": "Establishment",
  "qc.controlLot.status.active": "Activ",
  "qc.controlLot.status.expired": "Expired",
  "qc.controlLot.field.lotNumber": "Lot Number",
  "qc.controlLot.field.lotNumberPlaceholder": "Enter lot number",
  "qc.controlLot.field.material": "Control Material",
  "qc.controlLot.field.materialPlaceholder": "Enter material name",
  "qc.controlLot.field.manufacturer": "Manufacturer",
  "qc.controlLot.field.level": "Control Level",
  "qc.controlLot.field.selectLevel": "Select level",
  "qc.controlLot.field.expiration": "Expiration Date",
  "qc.controlLot.field.analyzer": "Analizor",
  "qc.controlLot.field.selectAnalyzer": "Select analyzer",
  "qc.controlLot.field.test": "Analiză",
  "qc.controlLot.field.selectTest": "Select test",
  "qc.controlLot.field.isActive": "Stare",
  "qc.controlLot.field.inactive": "Inactive",
  "qc.controlLot.field.active": "Activ",
  "qc.controlLot.field.status": "Stare",
  "qc.controlLot.loading": "Se încarcă...",
  "qc.controlLot.error.title": "Error",
  "qc.controlLot.error.saveFailed": "Failed to save control lot",
  "qc.controlLot.new.title": "New Control Lot",
  "qc.controlLot.new.subtitle": "Create a new QC control lot",
  "qc.controlLot.edit.title": "Edit Control Lot",
  "qc.controlLot.edit.subtitle": "Update control lot configuration",
  "qc.controlLot.validation.lotNumberRequired": "Lot number is required",
  "qc.controlLot.validation.materialRequired": "Material is required",
  "qc.controlLot.validation.levelRequired": "Control level is required",
  "qc.controlLot.validation.expirationRequired": "Expiration date is required",
  "qc.controlLot.validation.analyzerRequired": "Analyzer is required",
  "qc.controlLot.validation.testRequired": "Test is required",
  "qc.controlLot.level.low": "Low",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "High",
  "qc.controlLot.statistics.title": "Statistics Configuration",
  "qc.controlLot.statistics.configure": "Configure",
  "qc.controlLot.statistics.method": "Calculation Method",
  "qc.controlLot.statistics.mean": "Mean",
  "qc.controlLot.statistics.sd": "Standard Deviation",
  "qc.controlLot.statistics.config.title": "Statistics Configuration",
  "qc.controlLot.statistics.config.label": "Configure statistics method",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Manufacturer Fixed",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Use manufacturer-provided mean and SD values",
  "qc.controlLot.statistics.method.rolling": "Rolling Window",
  "qc.controlLot.statistics.method.rolling.description": "Recalculate from the most recent N results",
  "qc.controlLot.statistics.method.initial_runs": "Initial Runs",
  "qc.controlLot.statistics.method.initial_runs.description": "Calculate once from the first N establishment runs",
  "qc.controlLot.statistics.manufacturerValues": "Manufacturer Values",
  "qc.controlLot.statistics.rollingConfig": "Rolling Configuration",
  "qc.controlLot.statistics.windowSize": "Window Size",
  "qc.controlLot.statistics.windowSize.helper": "Number of recent results to include in calculation",
  "qc.controlLot.statistics.initialRunsConfig": "Initial Runs Configuration",
  "qc.controlLot.statistics.initialRunsRequired": "Runs Required",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Number of establishment runs before statistics are calculated",
  "qc.instrumentDetail.analytesMonitored": "Analytes Monitored",
  "qc.instrumentDetail.analyte.cv": "CV: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} other {# violations}}",
  "qc.instrumentDetail.tab.activityTimeline": "Activity Timeline",
  "qc.instrumentDetail.tab.controlChart": "Control Chart",
  "qc.instrumentDetail.timeline.empty": "No alerts or corrective actions recorded for the selected time period",
  "qc.instrumentDetail.timeline.violation": "Violation",
  "qc.instrumentDetail.timeline.correctiveAction": "Corrective Action",
  "qc.instrumentDetail.timeline.loading": "Loading activity timeline...",
  "qc.instrumentDetail.chart.selectAnalyte": "Select Analyte",
  "qc.instrumentDetail.chart.loading": "Loading control chart...",
  "qc.instrumentDetail.chart.noData": "No QC data available for this analyte",
  "qc.instrumentDetail.chart.activeRules": "Active QC Rules",
  "qc.instrumentDetail.chart.noRules": "No active rules configured",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Mean (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Std Dev (s)",
  "qc.instrumentDetail.error.loadFailed": "Failed to load instrument details",
  "question.text.required": "Question text is required",
  "compliance.legend.limitTypes": "LIMIT TYPES:",
  "compliance.limitType.borderlineShort": "Borderline ⚑",
  "compliance.limitType.descriptiveShort": "Qualitative",
  "compliance.limitType.MAXIMUM": "High Limit ≤",
  "compliance.limitType.MINIMUM": "Low Limit ≥",
  "compliance.limitType.RANGE": "Interval normal",
  "compliance.limitType.BORDERLINE": "Borderline 🚩",
  "compliance.limitType.DESCRIPTIVE": "Qualitative",
  "compliance.limitType.EXACT": "Exact",
  "compliance.limitType.SELECT_MAP": "Value Mapping",
  "compliance.status.ACTIVE": "Activ",
  "compliance.status.DRAFT": "Draft",
  "compliance.status.SUPERSEDED": "Superseded",
  "compliance.status.ARCHIVED": "Archived",
  "compliance.standard.placeholder.name": "e.g., PP No. 22/2021 — Water Quality",
  "compliance.standard.placeholder.issuingBody": "e.g., Government of Indonesia",
  "compliance.standard.placeholder.regulationNumber": "e.g., PP 22/2021",
  "compliance.standard.placeholder.version": "e.g., 2021",
  "compliance.standard.placeholder.countryRegion": "e.g., Indonesia",
  "compliance.standard.placeholder.description": "Optional. Full description of the standard's scope.",
  "compliance.standard.placeholder.date": "yyyy-mm-dd",
  "compliance.threshold.placeholder.lower": "Lower / Min",
  "compliance.threshold.placeholder.upper": "Upper / Max",
  "compliance.threshold.placeholder.unit": "Unit",
  "compliance.standard.archive": "Archive",
  "compliance.standard.archiveHeading": "Archive Compliance Standard",
  "compliance.standard.archivePrompt": "Archive this standard? Existing evaluated results stay linked to it for audit, but the standard will be hidden from active selection lists. This action can be reverted by editing the standard's status back to Active.",
  "compliance.standard.archived": "Compliance standard archived.",
  "compliance.standard.archiveError": "Could not archive this standard.",
  "button.complianceStandard.copy": "Copy Standard",
  "compliance.standard.copied": "Compliance standard copied as a new Draft.",
  "compliance.standard.copyError": "Could not copy this standard.",
  "compliance.standard.viewLinkedTests": "View Linked Tests",
  "compliance.testEditor.groupBy": "Group by",
  "compliance.testEditor.section.configuration": "Configuration",
  "compliance.testEditor.section.organization": "Organization",
  "compliance.testEditor.section.resources": "Resources",
  "compliance.testEditor.section.automation": "Automation",
  "compliance.testEditor.section.compliance": "Compliance",
  "compliance.testEditor.tab.compliance": "Compliance",
  "compliance.testEditor.tabPlaceholder": "Coming with the Test Editor surface — manage this from the Modify Test page for now.",
  "compliance.parameterGroup.editBtn": "Editează",
  "compliance.parameterGroup.moveUp": "Move up",
  "compliance.parameterGroup.moveDown": "Move down",
  "compliance.parameterGroup.updateError": "Could not update parameter group.",
  "compliance.testEditor.standardInactiveBanner": "This test has thresholds linked to {name} which is now {status}. Results will no longer be evaluated against this standard.",
  "compliance.standard.viewLinkedTests.heading": "Linked Tests — {name}",
  "compliance.standard.viewLinkedTests.empty": "No tests are currently linked to this standard.",
  "compliance.filter.status": "Stare",
  "compliance.filter.region": "Regiune",
  "compliance.filter.allStatuses": "All Statuses",
  "compliance.filter.allRegions": "All Regions",
  "compliance.filter.sampleType": "Tip probă",
  "compliance.filter.allSampleTypes": "All Sample Types",
  "compliance.sampleTypes.addLabel": "Add sample type",
  "compliance.sampleTypes.noneConfigured": "None configured",
  "compliance.sampleTypes.noneTitle": "No sample types configured yet.",
  "compliance.sampleTypes.noneSubtitle": "Add at least one sample type before linking tests.",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} other {# sample types configured}}",
  "compliance.standard.default": "Default",
  "compliance.standard.groups": "Groups",
  "compliance.standard.tests": "Teste",
  "compliance.standard.expiryDate": "Expiry Date",
  "compliance.parameterGroups.heading": "Parameter Groups & Linked Tests",
  "compliance.parameterGroups.requireSampleTypes": "Configure the standard's fields and sample types first, then link tests.",
  "compliance.button.save": "Salvează",
  "compliance.button.saving": "Saving…",
  "compliance.parameterGroup.createError": "Could not add parameter group.",
  "compliance.parameterGroup.deleteHeading": "Delete Parameter Group",
  "compliance.parameterGroup.deletePrompt": "Delete the parameter group {name} and all of its thresholds? This cannot be undone.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} other {# tests are}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "Could not save this row.",
  "compliance.threshold.deleteError": "Could not remove this row.",
  "compliance.validation.required": "This field is required.",
  "compliance.validation.expiryAfterEffective": "Expiry date must be on or after the effective date.",
  "compliance.validation.missingUpper": "Upper limit is required.",
  "compliance.validation.missingLower": "Lower limit is required.",
  "compliance.validation.missingBounds": "Both lower and upper bounds are required.",
  "compliance.validation.lowerGtUpper": "Lower bound must be less than or equal to upper bound.",
  "compliance.validation.missingDescriptive": "Qualitative value is required.",
  "compliance.linkTest.selectNoOptions": "This test is select-list but has no options configured in the test catalog. Add result options in test management before linking it to a compliance standard.",
  "compliance.linkTest.resultTypeLegend": "Tip rezultat",
  "compliance.linkTest.resultType.numeric": "Numeric (use limit values)",
  "compliance.linkTest.resultType.select": "Select list (map options to status)",
  "compliance.linkTest.optionsHint": "Add the result options for this test (e.g. 'Absent', 'Present'). The next step lets you map each one to a compliance status.",
  "compliance.linkTest.optionLabel": "Option value",
  "compliance.linkTest.optionPlaceholder": "e.g. Absent",
  "compliance.linkTest.optionsRequired": "Add at least one option above before mapping statuses.",
  "compliance.admin.title": "Compliance Standards Administration",
  "compliance.admin.tile.explain": "Manage compliance standards, parameter groups, and per-test thresholds (e.g. PP 22/2021, WHO Drinking Water).",
  "compliance.tabs.standardsAdmin": "Compliance Standards List",
  "compliance.tabs.testThresholds": "Compliance Tab (Test Editor)",
  "compliance.testEditor.back": "Înapoi",
  "compliance.testEditor.editTest": "Edit Test:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Sample Type:",
  "compliance.testEditor.resultType": "Result Type:",
  "compliance.testEditor.saveTest": "Save Test",
  "compliance.testEditor.saveDisabledHint": "Other test-editor tabs are not yet wired in this iteration.",
  "compliance.testEditor.thresholdsHeading": "Compliance Thresholds for",
  "compliance.testEditor.addThreshold": "Add Threshold",
  "compliance.testEditor.addThresholdHeading": "Link {name} to a compliance standard",
  "compliance.testEditor.pickStandard": "Compliance standard",
  "compliance.testEditor.pickStandardPlaceholder": "-- Select a standard --",
  "compliance.testEditor.pickGroup": "Parameter group",
  "compliance.testEditor.pickGroupPlaceholder": "-- Select a parameter group --",
  "compliance.testEditor.pickGroupHint": "Pick a standard and parameter group above to configure the threshold.",
  "compliance.testEditor.unlink": "Unlink",
  "compliance.testEditor.unlinkHeading": "Unlink Threshold",
  "compliance.testEditor.unlinkPrompt": "Remove this threshold from {test}? The threshold itself stays on the standard's parameter group; only the link to this specific test is removed.",
  "compliance.testEditor.linkedBanner": "This test is linked to {count, plural, one {# compliance standard} other {# compliance standards}}. Thresholds are evaluated at validation time.",
  "compliance.testEditor.expandRow": "Expand row",
  "compliance.testEditor.col.standard": "Standard",
  "compliance.testEditor.col.parameterGroup": "Parameter Group",
  "compliance.testEditor.col.limitType": "Limit Type",
  "compliance.testEditor.col.thresholdRange": "Threshold / Range",
  "compliance.testEditor.col.unit": "Unit",
  "compliance.testEditor.col.effective": "Effective",
  "compliance.testEditor.col.status": "Stare",
  "compliance.testThresholds.selectHint": "Select a test to view its compliance thresholds linked across standards.",
  "compliance.testThresholds.overviewHeading": "Tests linked to compliance standards",
  "compliance.testThresholds.overviewCount": "{filtered} of {total} test{total, plural, one {} other {s}}",
  "compliance.testThresholds.overviewEmpty": "No tests are linked to compliance standards yet.",
  "compliance.testThresholds.overviewEmptyHint": "CSV-seeded thresholds at parameter-group level appear in Tab 1 (Compliance Standards Admin), not here. Search above to pick a test from the catalog and link it to a standard.",
  "compliance.testThresholds.noLinkedMatches": "No linked tests match \"{q}\".",
  "compliance.testThresholds.addSection": "Add a test to compliance",
  "compliance.testThresholds.col.test": "Analiză",
  "compliance.testThresholds.col.code": "Code",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Sample Types",
  "compliance.testThresholds.col.thresholdCount": "# Thresholds",
  "compliance.testThresholds.col.standardCount": "# Standards",
  "compliance.testThresholds.openEditor": "Open",
  "compliance.testThresholds.title": "Test Compliance Thresholds",
  "compliance.testThresholds.tile.explain": "View compliance thresholds linked to a specific test, grouped by standard and parameter group.",
  "compliance.testThresholds.searchLabel": "Search test",
  "compliance.testThresholds.searchPlaceholder": "Filter test list…",
  "compliance.testThresholds.test": "Analiză",
  "compliance.testThresholds.selectPlaceholder": "-- Select a test --",
  "compliance.testThresholds.empty": "No compliance thresholds are linked to this test yet. Click + Add Threshold above to link it to a compliance standard's parameter group.",
  "compliance.testThresholds.parameter": "Parameter",
  "compliance.testThresholds.type": "Limit Type",
  "compliance.testThresholds.value": "Valoare",
  "compliance.testThresholds.note": "Notă",
  "compliance.testThresholds.unknownStandard": "Unknown standard",
  "compliance.button.openAdmin": "Open Compliance Standards Admin",
  "compliance.button.addStandard": "Add Standard",
  "compliance.button.saveStandard": "Save Standard",
  "compliance.button.linkTest": "Link Test to Group",
  "compliance.button.saveLimits": "Save Limits",
  "compliance.button.saveMapping": "Save Mapping",
  "compliance.search": "Search standards",
  "compliance.search.placeholder": "Search by name, issuing body, regulation, country…",
  "compliance.list.empty": "No compliance standards yet.",
  "compliance.standard.name": "Standard Name",
  "compliance.standard.issuingBody": "Issuing Body",
  "compliance.standard.regulationNumber": "Regulation Number",
  "compliance.standard.version": "Version",
  "compliance.standard.countryRegion": "Country / Region",
  "compliance.standard.status": "Stare",
  "compliance.standard.effectiveDate": "Effective Date",
  "compliance.standard.description": "Descriere",
  "compliance.standard.addNew": "Add New Compliance Standard",
  "compliance.standard.edit": "Edit Compliance Standard",
  "compliance.standard.preSeeded": "Pre-seeded",
  "compliance.standard.saved": "Compliance standard saved.",
  "compliance.standard.saveError": "Could not save standard.",
  "compliance.standard.saveBeforeGroups": "Save the standard before adding parameter groups.",
  "compliance.standard.deleted": "Compliance standard deleted.",
  "compliance.standard.deleteError": "Could not delete standard (it may be pre-seeded or have linked thresholds).",
  "compliance.standard.deleteHeading": "Delete Compliance Standard",
  "compliance.standard.deletePrompt": "Are you sure you want to delete this standard? Pre-seeded standards and standards with linked thresholds cannot be deleted.",
  "compliance.sampleTypes.heading": "Applicable Sample Types",
  "compliance.sampleTypes.explicitHint": "Declare which sample type categories this standard applies to. These selections drive the test filter when linking tests.",
  "compliance.sampleTypes.empty": "No sample types declared yet.",
  "compliance.sampleTypes.selectPlaceholder": "Select sample type...",
  "compliance.sampleTypes.addBtn": "Add Sample Type",
  "compliance.sampleTypes.remove": "Șterge",
  "compliance.parameterGroups": "Parameter Groups",
  "compliance.parameterGroups.empty": "No parameter groups defined yet.",
  "compliance.parameterGroups.add": "Add Parameter Group",
  "compliance.parameterGroup.name": "Group name",
  "compliance.parameterGroup.description": "Descriere",
  "compliance.parameterGroup.deleteBtn": "Delete",
  "compliance.label.tests": "tests",
  "compliance.linkedTest.name": "Analiză",
  "compliance.linkedTest.sampleTypes": "Sample Types",
  "compliance.linkedTest.limits": "Limits Configured",
  "compliance.linkedTest.editLimits": "Edit limits",
  "compliance.linkedTest.unlink": "Remove from group",
  "compliance.linkedTest.unlinkHeading": "Remove Test from Group",
  "compliance.linkedTest.unlinkConfirm": "Șterge",
  "compliance.linkedTest.unlinkPrompt": "Remove this test from the group? All threshold definitions for this test in this group will be deleted.",
  "compliance.group.noTests": "No tests linked to this group yet. Link tests to define compliance thresholds for evaluation.",
  "compliance.linkTest.heading": "Link Test to Group",
  "compliance.linkTest.step1": "Step 1 — Filter by Sample Type",
  "compliance.linkTest.step2": "Step 2 — Search & Select Test",
  "compliance.linkTest.step3Numeric": "Step 3 — Configure Limits",
  "compliance.linkTest.step3Select": "Step 3 — Compliance Value Mapping",
  "compliance.linkTest.filterByST": "Filter by sample type:",
  "compliance.linkTest.searchTest": "Search test catalog",
  "compliance.linkTest.searchPlaceholder": "Type to search by name or code...",
  "compliance.linkTest.noResults": "No matching tests found.",
  "compliance.linkTest.selectListBadge": "Select List",
  "compliance.linkTest.clearSelection": "Clear selection",
  "compliance.multiLimit.editHeading": "Configure Limits",
  "compliance.multiLimit.hint": "Enable one or more limit types for this test. At least one limit type must be enabled.",
  "compliance.multiLimit.type": "Limit Type",
  "compliance.multiLimit.lower": "Lower",
  "compliance.multiLimit.upper": "Upper",
  "compliance.multiLimit.unit": "Unit",
  "compliance.multiLimit.note": "Note / Advisory",
  "compliance.multiLimit.descriptive.placeholder": "e.g., No odor, Absent, Clear",
  "compliance.multiLimit.note.placeholder": "Optional note",
  "compliance.limitType.high": "High Limit ≤",
  "compliance.limitType.high.hint": "Non-compliant if result exceeds upper limit",
  "compliance.limitType.low": "Low Limit ≥",
  "compliance.limitType.low.hint": "Non-compliant if result is below lower limit",
  "compliance.limitType.range": "Interval normal",
  "compliance.limitType.range.hint": "Compliant within lower–upper range",
  "compliance.limitType.borderline": "Borderline (Advisory)",
  "compliance.limitType.borderline.hint": "Advisory zone — triggers review flag, not fail",
  "compliance.limitType.descriptive": "Qualitative / Descriptive",
  "compliance.limitType.descriptive.hint": "Text value evaluated by analyst",
  "compliance.selectMap.editHeading": "Compliance Mapping",
  "compliance.selectMap.hint": "Map each result option to its compliance status. Options come from the test catalog.",
  "compliance.selectMap.option": "Result Option",
  "compliance.selectMap.status": "Compliance Status",
  "compliance.selectMap.preview": "Preview",
  "compliance.selectMap.badge": "Value Mapping",
  "compliance.selectMap.optionsLabel": "options mapped",
  "compliance.selectMap.statusForOption": "Compliance status for {option}",
  "compliance.status.compliant": "Compliant",
  "compliance.status.borderline": "Borderline",
  "compliance.status.nonCompliant": "Non-Compliant",
  "compliance.status.compliantWithIcon": "Compliant ✓",
  "compliance.status.borderlineWithIcon": "Borderline ⚑",
  "compliance.status.nonCompliantWithIcon": "Non-Compliant ✗",
  "compliance.linkedTest.noLimits": "No limits configured",
  "compliance.threshold.savedThresholds": "Compliance thresholds linked to the test.",
  "compliance.threshold.savedValueMap": "Value-mapping threshold saved.",
  "compliance.threshold.savedPartialError": "Some thresholds could not be saved. Review the highlighted rows.",
  "compliance.threshold.unlinked": "Threshold unlinked from the test.",
  "compliance.threshold.unlinkError": "Could not unlink this threshold.",
  "notification.title.success": "Success",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Vector Surveillance",
  "vector.admin.title": "Vector Surveillance Setup",
  "vector.admin.groups": "Organism Groups",
  "vector.admin.group.code": "Code",
  "vector.admin.group.label": "Label",
  "vector.admin.group.colorTag": "Color Tag",
  "vector.admin.group.description": "Descriere",
  "vector.admin.active": "Activ",
  "vector.admin.system": "System",
  "vector.admin.trapTypes": "Trap Types",
  "vector.admin.trapType.name": "Nume",
  "vector.admin.trapType.description": "Descriere",
  "vector.admin.species": "Species",
  "vector.admin.selectGroup": "Select a group on the left to manage its trap types and species.",
  "vector.admin.newGroup": "New group (unsaved)",
  "vector.admin.newTrapType": "New trap type",
  "vector.admin.newSpecies": "New species",
  "vector.admin.saveGroup": "Save group",
  "vector.admin.saveTrap": "Save trap",
  "vector.admin.saveSpecies": "Save species",
  "vector.admin.addGroup": "+ Add group",
  "vector.admin.addTrapType": "+ Add trap type",
  "vector.admin.addSpecies": "+ Add species",
  "vector.admin.locked": "locked",
  "vector.admin.systemGroup": "System-protected group",
  "vector.admin.systemGroup.desc": "The code is locked because this group is referenced by core reports and seed data. You may still edit the label, color, and description.",
  "vector.admin.usedBy": "Used by",
  "vector.admin.status": "Stare",
  "vector.admin.status.active": "Activ",
  "vector.admin.status.inactive": "Inactive",
  "vector.admin.group": "Organism group",
  "vector.admin.trapType.group": "Target organism group",
  "vector.admin.trapType.groups": "Organism groups",
  "vector.admin.trapType.sampleTypes": "Sample types",
  "vector.admin.sampleType": "Sample type",
  "vector.admin.search.groups": "Search by code or label...",
  "vector.admin.search.traps": "Search trap name or description...",
  "vector.admin.search.species": "Search genus or species...",
  "vector.admin.samplingSites": "Sampling Sites",
  "vector.admin.samplingSite.newSite": "New site",
  "vector.admin.samplingSite.allSites": "All Sites",
  "vector.admin.samplingSite.code": "Code",
  "vector.admin.samplingSite.name": "Nume locație",
  "vector.admin.samplingSite.type": "Site Type",
  "vector.admin.samplingSite.region": "Regiune",
  "vector.admin.samplingSite.district": "District",
  "vector.admin.samplingSite.contactName": "Contact Person",
  "vector.admin.samplingSite.contactPhone": "Contact Phone",
  "vector.admin.samplingSite.gpsLatitude": "GPS Latitude",
  "vector.admin.samplingSite.gpsLongitude": "GPS Longitude",
  "vector.admin.samplingSite.environmentalZone": "Environmental Zone",
  "vector.admin.samplingSite.address": "Address",
  "vector.admin.samplingSite.description": "Descriere",
  "vector.admin.samplingSite.source": "Source",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Last Collection",
  "vector.admin.samplingSite.search": "Search by code, name, region...",
  "vector.admin.samplingSite.saveSite": "Save site",
  "vector.admin.samplingSites.registry": "Sampling Site Registry",
  "vector.admin.samplingSite.deactivate": "Dezactivează",
  "vector.admin.samplingSite.activate": "Activate",
  "vector.admin.samplingSite.location": "Locație",
  "vector.admin.samplingSite.allTypes": "All types",
  "vector.admin.samplingSite.subtype": "Subtype",
  "vector.admin.samplingSite.subtype.placeholder": "e.g. River, Well, BG-Sentinel, Fixed Station",
  "vector.admin.samplingSite.city": "Oraș",
  "vector.admin.samplingSite.addressLocation": "Address Location",
  "vector.admin.samplingSite.addressSearch.placeholder": "Search location to auto-fill dropdowns...",
  "vector.admin.samplingSite.gpsCoordinates": "GPS Coordinates",
  "vector.admin.samplingSite.lastModified": "Last Modified",
  "label.noResults": "Niciun rezultat găsit",
  "vector.admin.addSite": "+ New Site",
  "vector.order.title": "New Vector Order",
  "vector.order.subtitle": "Lab unit: Vector Surveillance Lab — Vector domain active.",
  "vector.order.samplingSite": "Sampling Site",
  "vector.order.site.code": "Site Code",
  "vector.order.site.helper": "Only active surveillance sites appear in results. GPS coordinates are pre-filled from the site record.",
  "vector.order.site.name": "Nume locație",
  "vector.order.site.placeholder": "Search by site name or code...",
  "vector.order.site.type": "Site Type",
  "vector.order.specimen": "Specimen",
  "vector.order.organism": "Animal / Organism",
  "vector.order.organism.hint": "Common name — e.g., Mosquito, Tick, Rodent, Sandfly.",
  "vector.order.organism.placeholder": "Search organism or species...",
  "vector.order.quantity": "Quantity",
  "vector.order.quantity.hint": "Number of organisms in this pool.",
  "vector.order.requester.section": "Requester / Ordering Programme",
  "vector.order.requester": "Solicitant",
  "vector.order.requester.placeholder": "Search by organisation name or code...",
  "vector.order.panels": "Comandă paneluri",
  "vector.order.panels.search": "Choose available panel",
  "vector.order.tests": "Comandă teste",
  "vector.order.tests.search": "Choose available test",
  "vector.order.collectionContext": "Collection Context (optional — bionomics capture)",
  "vector.order.timeOfDay": "Time of Day",
  "vector.order.timeOfDay.dawn": "Dawn",
  "vector.order.timeOfDay.day": "Day",
  "vector.order.timeOfDay.dusk": "Dusk",
  "vector.order.timeOfDay.night": "Night",
  "vector.order.restingContext": "Resting Context",
  "vector.order.restingContext.outdoor": "Outdoor (exophilic)",
  "vector.order.restingContext.indoor": "Indoor (endophilic)",
  "vector.order.restingContext.peridomestic": "Peridomestic",
  "vector.order.humanBitingCatch": "Human-Biting Catch",
  "vector.order.humanBitingCatch.hint": "specimen came from a human-landing collection",
  "vector.order.collectionNotes": "Collection Notes",
  "vector.order.collectionNotes.placeholder": "Weather, trap conditions, anomalies...",
  "vector.admin.group.code.placeholder": "e.g., SANDFLY",
  "vector.admin.group.label.placeholder": "e.g., Sandfly",
  "vector.species.genus.placeholder": "e.g., Mansonia",
  "vector.species.species.placeholder": "e.g., uniformis",
  "vector.species.subspecies.placeholder": "e.g., diardii",
  "vector.species.genus": "Genus",
  "vector.species.species": "Species",
  "vector.species.subspecies": "Subspecies",
  "vector.species.pathogensOfInterest": "Pathogens of Interest",
  "vector.species.lifecycleStages": "Lifecycle Stages",
  "vector.species.pathogenCategory": "Pathogen category",
  "vector.species.lifecycleCategory": "Lifecycle category",
  "workflow.vector": "Vector Surveillance",
  "vector.sampleType": "Tip probă",
  "vector.organismGroup": "Organism Group",
  "vector.species": "Species",
  "vector.animalOrganism": "Animal/Organism",
  "vector.animalOrganism.add": "Add Animal/Organism",
  "vector.animalOrganism.remove": "Remove Animal/Organism",
  "vector.collectedVolume": "Quantity in Pool",
  "vector.lifecycleStage": "Lifecycle Stage",
  "vector.trapCount": "Traps Deployed",
  "vector.trapNights": "Nights Deployed",
  "vector.trapType": "Trap Type",
  "vector.poolingMethod": "Pooling Method",
  "vector.poolCount": "Number of Pools",
  "vector.samplesPerPool": "Specimens per Pool",
  "vector.totalSpecimens": "Total Specimens",
  "vector.pathogensOfInterest": "Pathogens of Interest",
  "vector.homogeneous": "Homogeneous",
  "vector.random": "Random",
  "vector.collectionSite": "Collection Site",
  "vector.collectionSiteName": "Collection Site Name",
  "vector.gpsLatitude": "GPS Latitude",
  "vector.gpsLongitude": "GPS Longitude",
  "patient.search.merged.tag": "Merged",
  "patient.merged.banner.title": "This patient record was merged",
  "patient.merged.banner.subtitle": "Active records are kept on Patient {target}.",
  "patient.merged.banner.subtitle.noTarget": "This record has been merged into another patient.",
  "admin.testCatalog.tabs.ariaLabel": "Test details tabs",
  "admin.testCatalog.tabs.details": "Details",
  "admin.testCatalog.tabs.labels": "Labels",
  "admin.testCatalog.labels.masterOverride.label": "Allow Order Entry Override",
  "admin.testCatalog.labels.masterOverride.on": "On",
  "admin.testCatalog.labels.masterOverride.off": "Off",
  "admin.testCatalog.labels.linkedPresets.title": "Linked Label Presets",
  "admin.testCatalog.labels.linkedPresets.empty": "No label presets linked. Use the dropdown below to add one.",
  "admin.testCatalog.labels.col.presetName": "Preset Name",
  "admin.testCatalog.labels.col.defaultQty": "Default Qty",
  "admin.testCatalog.labels.col.maxQty": "Max Qty",
  "admin.testCatalog.labels.col.allowOverride": "Allow Override",
  "admin.testCatalog.labels.col.actions": "Actions",
  "admin.testCatalog.labels.action.remove": "Remove preset link",
  "admin.testCatalog.labels.addPreset.label": "Add Label Type",
  "admin.testCatalog.labels.addPreset.placeholder": "Select a label preset",
  "admin.testCatalog.labels.preview.title": "Order Entry Preview",
  "admin.testCatalog.labels.preview.col.locked": "Locked",
  "admin.testCatalog.labels.preview.locked": "Locked",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Label configuration saved.",
  "admin.testCatalog.labels.save.error": "Failed to save label configuration.",
  "orderEntry.labels.orderTable.title": "Order Labels",
  "orderEntry.labels.sampleTable.title": "Sample Labels",
  "orderEntry.labels.col.row": "Row",
  "orderEntry.labels.col.sample": "Probă",
  "orderEntry.labels.col.quantity": "Quantity",
  "orderEntry.labels.orderRow.header": "Comandă",
  "orderEntry.labels.sampleRow.header": "Sample {number}",
  "orderEntry.labels.input.sample": "Sample {number} {column} quantity",
  "orderEntry.labels.source.test": "From test",
  "orderEntry.labels.source.presetDefault": "Preset default",
  "orderEntry.labels.locked.tooltipFor": "{label} is locked by the test configuration and cannot be changed.",
  "orderEntry.labels.total": "Total labels: {total}",
  "orderEntry.labels.heading": "LABELS",
  "label.patientHistory.filterByCategory": "Filter by test category",
  "label.patientHistory.testCategories": "Test categories",
  "label.patientHistory.tree": "Tree",
  "label.patientHistory.showTree": "Show tree",
  "label.patientHistory.resetTree": "Reset tree",
  "label.patientHistory.viewResults": "View {count} results",
  "label.patientHistory.emptyState": "There are no {displayText} to display for this patient",
  "label.patientHistory.record": "Record {displayText}",
  "label.patientHistory.dataLoadError": "Data Load Error",
  "label.patientHistory.errorCopy": "Sorry, there was a problem displaying this information. You can try to reload this page, or contact the site administrator and quote the error code above.",
  "label.patientHistory.backToTimeline": "Back to timeline",
  "label.patientHistory.returnToTimeline": "Return to timeline",
  "label.patientHistory.timeOfTest": "Time of Test",
  "label.patientHistory.observations": "observations",
  "label.patientHistory.range.oneDay": "1 day",
  "label.patientHistory.range.fiveDays": "5 days",
  "label.patientHistory.range.oneMonth": "1 month",
  "label.patientHistory.range.sixMonths": "6 months",
  "label.patientHistory.range.oneYear": "1 year",
  "label.patientHistory.range.fiveYears": "5 years",
  "label.patientHistory.range.all": "Toate",
  "label.patientHistory.date": "Date",
  "address.search.no.results": "No addresses found for '{term}'",
  "address.search.placeholder": "Search for address (type at least 2 characters)...",
  "address.search.results.count": "{count} results found",
  "alert.error": "Error",
  "alert.warning": "Warning",
  "analyzer.copyMappings.warnings": "Warnings",
  "analyzer.errorDetails.noLogsAvailable": "No logs available",
  "analyzer.fieldMapping.panel.testValidation.button": "Test Validation",
  "analyzer.fieldMapping.panel.testValue.analyzerIdMissing": "Analyzer ID not available",
  "analyzer.fieldMapping.panel.testValue.error": "Error validating value",
  "analyzer.fieldMapping.panel.testValue.invalid": "Value fails validation",
  "analyzer.fieldMapping.panel.testValue.invalid.title": "Validation Failed",
  "analyzer.fieldMapping.panel.testValue.label": "Test Value",
  "analyzer.fieldMapping.panel.testValue.placeholder": "Enter a value to test against validation rules",
  "analyzer.fieldMapping.panel.testValue.required": "Please enter a test value",
  "analyzer.fieldMapping.panel.testValue.valid": "Value passes validation",
  "analyzer.fieldMapping.panel.testValue.valid.title": "Validation Passed",
  "analyzer.fieldMapping.panel.validationRules.title": "Validation Rules",
  "analyzer.fieldSelector.placeholder": "Search and select field...",
  "analyzer.fieldSelector.title": "Select OpenELIS Field",
  "analyzer.form.columnMappings": "Column Mappings (JSON)",
  "analyzer.form.columnMappings.helperText": "Maps file column names to internal field names",
  "analyzer.form.delimiter": "Delimiter",
  "analyzer.form.fileFormat": "File Format",
  "analyzer.form.fileImport.title": "File Import Settings",
  "analyzer.form.filePattern": "File Pattern",
  "analyzer.form.filePattern.helperText": "Glob pattern to match result files",
  "analyzer.form.hasHeader": "File has header row",
  "analyzer.form.importDirectory": "Import Directory",
  "analyzer.form.importDirectory.helperText": "Directory the bridge watches for incoming result files",
  "analyzer.form.validation.columnMappings.invalid": "Column mappings must be valid JSON",
  "analyzer.form.validation.importDirectory.required": "Import directory is required for file-based analyzers",
  "analyzer.form.validation.port.invalid": "Port must be a number between 1 and 65535",
  "analyzer.qc.batch.failure.subtitle": "QC controls in this batch have failures. Review QC results below before accepting patient results.",
  "analyzer.qc.batch.failure.title": "QC Controls Failed",
  "analyzer.qc.controls.hidden": "QC controls hidden from patient view",
  "analyzer.qc.controls.section.title": "QC Controls ({count})",
  "audittrail.table.heading": "Order Information",
  "barcode.label.info.labnumber": "Număr accesare",
  "button.close": "Close",
  "button.collapse": "Collapse",
  "button.expand": "Expand",
  "button.home": "Acasă",
  "button.new.search": "New Search",
  "column.name.labNo": "Lab #",
  "customFieldType.action.add": "Add Custom Field Type",
  "customFieldType.action.delete": "Delete",
  "customFieldType.action.edit": "Editează",
  "customFieldType.actions.ariaLabel": "Actions",
  "customFieldType.error.deleteFailed": "Failed to delete custom field type",
  "customFieldType.error.displayNameRequired": "Display name is required",
  "customFieldType.error.invalidRegex": "Invalid regex pattern",
  "customFieldType.error.rangeInvalid": "Minimum cannot be greater than maximum",
  "customFieldType.error.saveFailed": "Failed to save custom field type",
  "customFieldType.error.typeNameRequired": "Type name is required",
  "customFieldType.form.allowedCharacters": "Allowed Characters",
  "customFieldType.form.allowedCharactersHelper": "Optional: Character set restriction",
  "customFieldType.form.allowedCharactersPlaceholder": "e.g., ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  "customFieldType.form.displayName": "Display Name",
  "customFieldType.form.displayNamePlaceholder": "e.g., Custom Numeric Field",
  "customFieldType.form.isActive": "Active Status",
  "customFieldType.form.typeName": "Type Name",
  "customFieldType.form.typeNamePlaceholder": "e.g., CUSTOM_NUMERIC",
  "customFieldType.form.validationPattern": "Validation Pattern (Regex)",
  "customFieldType.form.validationPatternHelper": "Optional: Regular expression pattern for validation",
  "customFieldType.form.validationPatternPlaceholder": "e.g., ^[0-9]+$",
  "customFieldType.form.valueRangeMax": "Value Range Max",
  "customFieldType.form.valueRangeMaxHelper": "Optional: Maximum value for numeric types",
  "customFieldType.form.valueRangeMin": "Value Range Min",
  "customFieldType.form.valueRangeMinHelper": "Optional: Minimum value for numeric types",
  "customFieldType.modal.addTitle": "Add Custom Field Type",
  "customFieldType.modal.cancel": "Anulează",
  "customFieldType.modal.delete": "Delete",
  "customFieldType.modal.deleteMessage": "Are you sure you want to delete {typeName}? This action cannot be undone.",
  "customFieldType.modal.deleteTitle": "Delete Custom Field Type",
  "customFieldType.modal.editTitle": "Edit Custom Field Type",
  "customFieldType.modal.save": "Salvează",
  "customFieldType.page.subtitle": "Manage custom field types for analyzer field mapping",
  "customFieldType.search.label": "Search custom field types",
  "customFieldType.search.placeholder": "Search by type name or display name...",
  "customFieldType.success.deleted": "Custom field type deleted successfully",
  "customFieldType.success.saved": "Custom field type saved successfully",
  "customFieldType.table.header.displayName": "Display Name",
  "customFieldType.table.header.status": "Stare",
  "customFieldType.table.header.typeName": "Type Name",
  "customFieldType.table.header.validationPattern": "Validation Pattern",
  "customFieldType.table.header.valueRange": "Value Range",
  "env.collectionConditions.helper": "Search for an existing sampling site or create a new one. Sites are reusable across orders — like patients in clinical workflows.",
  "env.collectionMethod.placeholder": "e.g., Grab sample, Composite 24h",
  "env.conditions": "Environmental Conditions",
  "env.conditions.placeholder": "e.g., 20°C, clear weather, dry season",
  "env.regulatoryReference": "Regulatory Reference",
  "env.regulatoryReference.placeholder": "e.g., PP No. 22/2021 Batu Mutu Air",
  "env.samplingSite.title": "Subject — Sampling Site",
  "env.site.address": "Address",
  "env.site.addressSearch.placeholder": "Search for location to auto-fill dropdowns below...",
  "env.site.code": "Site Code",
  "env.site.code.placeholder": "Auto-generated (or enter manually)",
  "env.site.contactPerson": "Contact Person",
  "env.site.contactPerson.placeholder": "Name of site custodian or contact",
  "env.site.contactPhone": "Contact Phone",
  "env.site.description": "Site Description",
  "env.site.description.placeholder": "e.g., Downstream monitoring point near floodgate",
  "env.site.helperText": "Register a new sampling site. The site will be saved to the Site Registry and can be reused for future orders.",
  "env.site.name": "Nume locație",
  "env.site.name.placeholder": "e.g., Sungai Ciliwung — Manggarai",
  "env.site.newTab": "New Site",
  "env.site.saveAndSelect": "Save & Select Site",
  "env.site.searchLabel": "Nume locație",
  "env.site.searchPlaceholder": "e.g., Sungai Ciliwung - Manggarai",
  "env.site.searchTab": "Search for Site",
  "env.site.streetAddress": "Address",
  "env.site.streetAddress.placeholder": "Street address or location reference",
  "env.site.subtype": "Subtype",
  "env.site.subtype.placeholder": "e.g., River, Well, BG-Sentinel, Fixed Station",
  "env.site.type": "Site Type",
  "env.site.type.select": "Select Type...",
  "env.site.zone": "Environmental Zone",
  "env.site.zone.select": "Select Zone...",
  "error.dateRange.start": "Please select Start and end date.",
  "error.loading.metrics": "Error loading metrics",
  "error.nonconform.report.data.found": "No data found",
  "error.report.csv.dateType": "Selectați tipul datei.",
  "error.required.fields": "Please fill in all required fields",
  "error.save.sample": "Error saving sample",
  "error.validation.failed": "Validation failed",
  "error.value": "Please select a value.",
  "esig.context.saveResults": "Save {count} result(s) for accession {accession}",
  "esig.context.saveResultsMulti": "Save {count} result(s) across {accessionCount} accessions",
  "esig.context.validateResults": "Validate {count} result(s) for accession {accession}",
  "esig.context.validateResultsMulti": "Validate {count} result(s) across {accessionCount} accessions",
  "fhir.questionnaire.title": "Informații suplimentare",
  "freezer.alert.detail.acknowledge": "Acknowledge",
  "freezer.alert.detail.acknowledgedAt": "Acknowledged At",
  "freezer.alert.detail.acknowledgedBy": "Acknowledged By",
  "freezer.alert.detail.actions": "Actions Taken",
  "freezer.alert.detail.close": "Close",
  "freezer.alert.detail.correctiveAction": "Corrective Action",
  "freezer.alert.detail.freezer": "Freezer",
  "freezer.alert.detail.id": "Alert ID",
  "freezer.alert.detail.message": "Mesaj",
  "freezer.alert.detail.notes": "Note",
  "freezer.alert.detail.notesPlaceholder": "Add notes about this alert...",
  "freezer.alert.detail.notifications": "Notifications Sent",
  "freezer.alert.detail.overview": "Alert Overview",
  "freezer.alert.detail.resolutionNotes": "Resolution Notes",
  "freezer.alert.detail.resolve": "Resolve",
  "freezer.alert.detail.resolvedAt": "Resolved At",
  "freezer.alert.detail.resolvedBy": "Resolved By",
  "freezer.alert.detail.severity": "Severitate",
  "freezer.alert.detail.startTime": "Start Time",
  "freezer.alert.detail.status": "Stare",
  "freezer.alert.detail.title": "Alert Details",
  "genericSample.default.fields.title": "Sample Information",
  "genericSample.import.success": "Import successful",
  "genericSample.notebook.label": "Select Notebook",
  "genericSample.order.newOrder": "Create Another Sample",
  "genericSample.search.title": "Search by Accession Number",
  "http.success": "Success!",
  "label.button.assign": "Asignează",
  "label.button.create": "Create",
  "label.button.saving": "Saving...",
  "label.button.view": "Vezi raportul",
  "label.code": "Code",
  "label.editing": "Editing",
  "label.label": "Label",
  "label.name": "Nume",
  "label.panel": "Panel",
  "label.tests": "tests",
  "loading.label": "Se încarcă...",
  "loading.metrics": "Loading metrics...",
  "locale.save.error": "Failed to save language",
  "logging.management.tail.clear": "Curăță",
  "logging.management.tail.disconnected": "Stream disconnected. Toggle off and on to reconnect.",
  "logging.management.tail.label": "Live application log",
  "logging.management.tail.off": "Off",
  "logging.management.tail.on": "On",
  "logging.management.tail.stream": "Live stream",
  "nationalID.title": "CNP",
  "nce.button.linkSelected": "Link Selected Samples",
  "nce.button.submit": "Submit NCE",
  "nce.error.numberGeneration": "Failed to generate NCE number. Please try again.",
  "nce.field.dateOfEvent": "Dată eveniment",
  "nce.field.description": "Descriere",
  "nce.field.nceNumber": "Număr NCE",
  "nce.field.proposedAction.helper": "Separate from CAPA actions assigned during corrective action workflow",
  "nce.field.proposedAction.placeholder": "Recommended next steps...",
  "nce.field.reporterName": "Reporter Name",
  "nce.field.reportingUnit": "Unitate raportare",
  "nce.field.subcategory": "Subcategory",
  "nce.field.suspectedCauses.helper": "Initial assessment only - formal root cause determined during investigation",
  "nce.field.suspectedCauses.placeholder": "Reporter",
  "nce.form.subtitle": "Document a quality event and link to affected samples and results",
  "nce.form.title": "Report Non-Conformity Event",
  "nce.linkSamples.helper": "Search for orders above to link samples to this NCE. This step is optional.",
  "nce.section.attachments": "Attachments",
  "nce.section.classification": "Classification",
  "nce.section.details": "Details",
  "nce.section.linkSamples": "Link to Samples / Results (Optional)",
  "nce.section.reporterContext": "Reporter & Event Context",
  "nce.select.subcategory": "Select subcategory...",
  "nce.severity.critical.desc": "Patient safety risk, regulatory violation",
  "nce.severity.major.desc": "Significant quality or operational impact",
  "nce.severity.minor.desc": "Limited impact, easily corrected",
  "nonconform.corrective.requiredFields": "Fill all corrective-action fields (action, person responsible, date completed, and at least one action type), or leave the row entirely empty.",
  "nonconform.view.requiredFields": "Lab component, NCE category, NCE type, severity consequence and recurrence are all required.",
  "notebook.sample.create": "Create",
  "notebook.sample.create.title": "Create New Sample",
  "notebook.sample.edit": "Editează",
  "notebook.sample.edit.title": "Edit Sample",
  "notebook.sample.import": "Import",
  "notebook.sample.import.title": "Import Samples",
  "notebook.sample.order.info": "This sample will be associated with the current notebook.",
  "notification.success": "Success",
  "notification.warning": "Warning",
  "order.entry.setup.batch": "Comandă în lot",
  "order.legend.patient1": "Informații pacient",
  "pagination.next": "Next page",
  "pagination.previous": "Previous page",
  "patient.fetch.error": "Could not load patient. The id may be invalid or the server is unreachable.",
  "patient.firstName": "Prenume",
  "patient.lastName": "Nume",
  "print.barcode.all": "Print All Barcodes ({count})",
  "program.name.program": "Program",
  "sample.item.id": "Sample Item ID",
  "sample.label": "Probă",
  "sample.noPanels": "No panels available for this sample type",
  "sample.noTests": "No tests available for this sample type",
  "sample.selectType.first": "Select a sample type above to see available panels and tests",
  "sample.testsCount": "{count} tests available",
  "sample.types": "Samples",
  "save.error.msg": "Error saving",
  "saving.label": "Saving...",
  "select.label.analyzer": "Selectați analizorul",
  "site.code": "Code",
  "steps.complete": "steps",
  "storage.audit.empty": "No movements recorded for this sample yet.",
  "storage.audit.empty.title": "No movements",
  "storage.audit.fetch.error": "Could not load audit trail.",
  "storage.audit.fetch.error.title": "Error",
  "storage.audit.from": "De la",
  "storage.audit.movedBy": "Moved By",
  "storage.audit.movementDate": "Movement Date",
  "storage.audit.reason": "Reason",
  "storage.audit.to": "Până la",
  "storage.box.code.helper": "Up to 10 characters",
  "storage.breadcrumb.sampleitems": "Sample Items",
  "storage.breadcrumb.storage": "Storage",
  "storage.confirm.disposal": "Confirm Disposal",
  "storage.dashboard.title": "Storage",
  "storage.disposal.method": "Disposal Method",
  "storage.disposal.method.placeholder": "Select method...",
  "storage.disposal.notes": "Additional Notes (optional)",
  "storage.disposal.notes.placeholder": "Enter any additional notes...",
  "storage.disposal.reason": "Disposal Reason",
  "storage.disposal.reason.placeholder": "Select reason...",
  "storage.dispose.confirmation": "I confirm that I want to permanently dispose of this sample. This action cannot be undone.",
  "storage.dispose.instructions.subtitle": "Please ensure proper disposal procedures are followed according to laboratory safety protocols.",
  "storage.dispose.instructions.title": "Disposal Instructions",
  "storage.dispose.location.note": "Sample will be removed from this location upon disposal",
  "storage.dispose.sample": "Dispose Sample",
  "storage.dispose.sample.subtitle": "Permanently dispose of sample {sampleId}",
  "storage.dispose.warning.subtitle": "The sample will be marked as disposed and removed from storage.",
  "storage.dispose.warning.title": "This action cannot be undone",
  "storage.edit.heading": "Edit {type}",
  "storage.edit.title": "Editează",
  "storage.editbox.heading": "Edit Box",
  "storage.error": "Error",
  "storage.error.save": "Failed to save location",
  "storage.filter.select.location": "Select location...",
  "storage.filter.selected": "Selected:",
  "storage.location.assigned.error": "Failed to assign location",
  "storage.location.assigned.success": "Location assigned successfully",
  "storage.location.no.results": "No locations found",
  "storage.location.type.devices": "devices",
  "storage.location.type.racks": "racks",
  "storage.location.type.rooms": "rooms",
  "storage.location.type.shelves": "shelves",
  "storage.manage.location": "Manage Location",
  "storage.nav.rack": "Rack",
  "storage.sample.actions": "Sample actions",
  "storage.sampleitem.accession": "Sample Accession",
  "storage.sampleitem.location": "Storage location",
  "storage.sampleitem.status": "Stare",
  "storage.sampleitem.type": "Type",
  "storage.search.location.label": "Search for a storage location",
  "storage.search.location.placeholder": "Type 2+ characters to search…",
  "storage.skipRemaining": "Skip storage for unassigned samples ({count}) - will be processed immediately",
  "storage.view.audit": "View Audit",
  "storage.view.audit.subtitle": "Movement history for sample {sampleId}",
  "storage.view.audit.title": "Storage Audit Trail",
  "systemDefaultPayloadTemplate.messageTemplate": "Message template",
  "systemDefaultPayloadTemplate.subjectTemplate": "Subject template",
  "tests.count": "{count, plural, one {test} other {tests}}",
  "validation.invalid.ip": "Invalid IP address format (IPv4 or IPv6)",
  "validation.invalid.port": "Port must be between 1 and 65535",
  "validation.required": "Acest câmp este obligatoriu",
  "validationRule.action.addValue": "Adaugă",
  "validationRule.action.cancel": "Anulează",
  "validationRule.action.save": "Save Rule",
  "validationRule.error.enumValuesRequired": "At least one enum value is required",
  "validationRule.error.invalidPattern": "Invalid regex pattern",
  "validationRule.error.minGreaterThanMax": "Minimum cannot be greater than maximum",
  "validationRule.error.minLengthGreaterThanMax": "Minimum length cannot be greater than maximum length",
  "validationRule.error.patternRequired": "Regex pattern is required",
  "validationRule.error.ruleNameRequired": "Rule name is required",
  "validationRule.error.saveFailed": "Failed to save validation rule",
  "validationRule.form.enumInputPlaceholder": "Enter value and press Enter",
  "validationRule.form.enumValues": "Allowed Values",
  "validationRule.form.errorMessage": "Error Message (Optional)",
  "validationRule.form.errorMessagePlaceholder": "Custom error message to display when validation fails",
  "validationRule.form.lengthMax": "Maximum Length",
  "validationRule.form.lengthMin": "Minimum Length",
  "validationRule.form.rangeMax": "Maximum",
  "validationRule.form.rangeMin": "Minimum",
  "validationRule.form.regexPattern": "Regex Pattern",
  "validationRule.form.regexPatternPlaceholder": "e.g., ^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]",
  "validationRule.form.ruleName": "Nume regulă",
  "validationRule.form.ruleNamePlaceholder": "e.g., Email Pattern",
  "validationRule.form.ruleType": "Rule Type",
  "validationRule.success.saved": "Validation rule saved successfully",
  "validationRule.test.invalid": "Value fails validation",
  "validationRule.test.section": "Test Validation",
  "validationRule.test.testButton": "Test Rule",
  "validationRule.test.testValue": "Test Value",
  "validationRule.test.testValuePlaceholder": "Enter a value to test",
  "validationRule.test.valid": "Value passes validation",
  "validationRule.test.valueRequired": "Please enter a test value",
  "common.accept": "Acceptă",
  "common.accessionNumber": "Număr accesare",
  "common.action": "Acțiune",
  "common.actions": "Actions",
  "common.active": "Activ",
  "common.addTests": "Add Tests",
  "common.aliquots": "aliquots",
  "common.all": "Toate",
  "common.allStatuses": "All Statuses",
  "common.analyzer": "Analizor",
  "common.analyzers": "Analyzers",
  "common.auditTrail": "Jurnal audit",
  "common.back": "Înapoi",
  "common.boxId": "Box ID",
  "common.byUnit": "Pe unitate",
  "common.cancel": "Anulează",
  "common.category": "Categorie",
  "common.clinical": "Clinical",
  "common.code": "Code",
  "common.collected": "Collected",
  "common.collectionDate": "Data recoltării",
  "common.complete": "Complet",
  "common.completed": "Completed",
  "common.confirm": "Confirmă",
  "common.correctiveActions": "Corrective Actions",
  "common.createAliquot": "Create Aliquot",
  "common.critical": "Critical",
  "common.dashboard": "Tablou de bord",
  "common.date": "Date",
  "common.dateRange": "Date Range",
  "common.deactivate": "Dezactivează",
  "common.delete": "Delete",
  "common.description": "Descriere",
  "common.draft": "Draft",
  "common.edit": "Editează",
  "common.editOrder": "Editați comanda",
  "common.email": "Email",
  "common.enterResults": "Enter Results",
  "common.error": "Error",
  "common.expired": "Expired",
  "common.exportPdf": "Export PDF",
  "common.failed": "Failed",
  "common.filterByStatus": "Filter by Status",
  "common.firstName": "Prenume",
  "common.from": "De la",
  "common.generateReport": "Generează raport",
  "common.home": "Acasă",
  "common.inProgress": "În desfășurare",
  "common.inactive": "Inactive",
  "common.labNumber": "Număr laborator",
  "common.lastName": "Nume",
  "common.loading": "Se încarcă...",
  "common.location": "Locație",
  "common.mean": "Mean",
  "common.name": "Nume",
  "common.nationalId": "CNP",
  "common.new": "New",
  "common.none": "Niciuna",
  "common.normal": "Normal",
  "common.normalRange": "Interval normal",
  "common.notes": "Note",
  "common.order": "Comandă",
  "common.overdue": "Overdue",
  "common.panels": "Paneluri",
  "common.participants": "Participants",
  "common.patient": "Pacient",
  "common.pending": "Pending",
  "common.position": "Position",
  "common.printLabel": "Tipărește etichetă",
  "common.priority": "Prioritate",
  "common.program": "Program",
  "common.programName": "Nume program",
  "common.provider": "Furnizor",
  "common.quantity": "Quantity",
  "common.received": "Received",
  "common.referenceLab": "Laborator de referință",
  "common.reject": "Respinge",
  "common.remove": "Șterge",
  "common.reports": "Rapoarte",
  "common.requester": "Solicitant",
  "common.result": "Rezultat",
  "common.results": "Rezultate",
  "common.room": "Room",
  "common.routine": "Rutină",
  "common.sample": "Probă",
  "common.sampleId": "Sample ID",
  "common.sampleManagement": "Sample Management",
  "common.sampleType": "Tip probă",
  "common.samples": "Samples",
  "common.samplingSite": "Sampling Site",
  "common.save": "Salvează",
  "common.saveFailed": "Salvarea a eșuat",
  "common.saving": "Saving...",
  "common.search": "Caută",
  "common.select": "Selectează",
  "common.severity": "Severitate",
  "common.siteName": "Nume locație",
  "common.species": "Species",
  "common.standard": "Standard",
  "common.status": "Stare",
  "common.storageLocation": "Storage Location",
  "common.study": "Studiu",
  "common.test": "Analiză",
  "common.testName": "Nume test",
  "common.tests": "Teste",
  "common.type": "Type",
  "common.unit": "Unit",
  "common.user": "Utilizator",
  "common.value": "Valoare",
  "common.view": "Vizualizează",
  "common.warning": "Warning",
  "label.testCatalog.alerts.field.component": "Result component",
  "label.testCatalog.alerts.field.componentHelp": "Which result this alert watches. Leave unset to watch every component of this test.",
  "label.testCatalog.alerts.field.sampleType": "Sample type",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Which specimen this alert watches. Leave unset to watch every sample type this test runs on.",
  "label.testCatalog.alerts.scope.anyComponent": "Any component",
  "label.testCatalog.alerts.scope.anySampleType": "Any sample type",
  "label.testCatalog.alerts.col.scope": "Applies to",
  "label.testCatalog.alerts.scope.wholeTest": "Whole test",
  "rulebuilder.label.selectComponent": "Select Component",
  "testcalculation.label.selectComponent": "Select Component",
  "testcalculation.label.finalComponent": "Result Component"
}
